'use strict';

var R = require('ramda');
var bezierJs = require('bezier-js');

function _interopNamespaceDefault(e) {
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () { return e[k]; }
        });
      }
    });
  }
  n.default = e;
  return Object.freeze(n);
}

var R__namespace = /*#__PURE__*/_interopNamespaceDefault(R);

var niceErrors = {
  0: "Invalid value for configuration 'enforceActions', expected 'never', 'always' or 'observed'",
  1: function _(annotationType, key) {
    return "Cannot apply '" + annotationType + "' to '" + key.toString() + "': Field not found.";
  },
  /*
  2(prop) {
      return `invalid decorator for '${prop.toString()}'`
  },
  3(prop) {
      return `Cannot decorate '${prop.toString()}': action can only be used on properties with a function value.`
  },
  4(prop) {
      return `Cannot decorate '${prop.toString()}': computed can only be used on getter properties.`
  },
  */
  5: "'keys()' can only be used on observable objects, arrays, sets and maps",
  6: "'values()' can only be used on observable objects, arrays, sets and maps",
  7: "'entries()' can only be used on observable objects, arrays and maps",
  8: "'set()' can only be used on observable objects, arrays and maps",
  9: "'remove()' can only be used on observable objects, arrays and maps",
  10: "'has()' can only be used on observable objects, arrays and maps",
  11: "'get()' can only be used on observable objects, arrays and maps",
  12: "Invalid annotation",
  13: "Dynamic observable objects cannot be frozen. If you're passing observables to 3rd party component/function that calls Object.freeze, pass copy instead: toJS(observable)",
  14: "Intercept handlers should return nothing or a change object",
  15: "Observable arrays cannot be frozen. If you're passing observables to 3rd party component/function that calls Object.freeze, pass copy instead: toJS(observable)",
  16: "Modification exception: the internal structure of an observable array was changed.",
  17: function _(index, length) {
    return "[mobx.array] Index out of bounds, " + index + " is larger than " + length;
  },
  18: "mobx.map requires Map polyfill for the current browser. Check babel-polyfill or core-js/es6/map.js",
  19: function _(other) {
    return "Cannot initialize from classes that inherit from Map: " + other.constructor.name;
  },
  20: function _(other) {
    return "Cannot initialize map from " + other;
  },
  21: function _(dataStructure) {
    return "Cannot convert to map from '" + dataStructure + "'";
  },
  22: "mobx.set requires Set polyfill for the current browser. Check babel-polyfill or core-js/es6/set.js",
  23: "It is not possible to get index atoms from arrays",
  24: function _(thing) {
    return "Cannot obtain administration from " + thing;
  },
  25: function _(property, name) {
    return "the entry '" + property + "' does not exist in the observable map '" + name + "'";
  },
  26: "please specify a property",
  27: function _(property, name) {
    return "no observable property '" + property.toString() + "' found on the observable object '" + name + "'";
  },
  28: function _(thing) {
    return "Cannot obtain atom from " + thing;
  },
  29: "Expecting some object",
  30: "invalid action stack. did you forget to finish an action?",
  31: "missing option for computed: get",
  32: function _(name, derivation) {
    return "Cycle detected in computation " + name + ": " + derivation;
  },
  33: function _(name) {
    return "The setter of computed value '" + name + "' is trying to update itself. Did you intend to update an _observable_ value, instead of the computed property?";
  },
  34: function _(name) {
    return "[ComputedValue '" + name + "'] It is not possible to assign a new value to a computed value.";
  },
  35: "There are multiple, different versions of MobX active. Make sure MobX is loaded only once or use `configure({ isolateGlobalState: true })`",
  36: "isolateGlobalState should be called before MobX is running any reactions",
  37: function _(method) {
    return "[mobx] `observableArray." + method + "()` mutates the array in-place, which is not allowed inside a derivation. Use `array.slice()." + method + "()` instead";
  },
  38: "'ownKeys()' can only be used on observable objects",
  39: "'defineProperty()' can only be used on observable objects"
};
var errors = process.env.NODE_ENV !== "production" ? niceErrors : {};
function die(error) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }
  if (process.env.NODE_ENV !== "production") {
    var e = typeof error === "string" ? error : errors[error];
    if (typeof e === "function") e = e.apply(null, args);
    throw new Error("[MobX] " + e);
  }
  throw new Error(typeof error === "number" ? "[MobX] minified error nr: " + error + (args.length ? " " + args.map(String).join(",") : "") + ". Find the full error at: https://github.com/mobxjs/mobx/blob/main/packages/mobx/src/errors.ts" : "[MobX] " + error);
}

var mockGlobal = {};
function getGlobal() {
  if (typeof globalThis !== "undefined") {
    return globalThis;
  }
  if (typeof window !== "undefined") {
    return window;
  }
  if (typeof global !== "undefined") {
    return global;
  }
  if (typeof self !== "undefined") {
    return self;
  }
  return mockGlobal;
}

// We shorten anything used > 5 times
var assign = Object.assign;
var getDescriptor = Object.getOwnPropertyDescriptor;
var defineProperty$1 = Object.defineProperty;
var objectPrototype = Object.prototype;
var EMPTY_ARRAY$1 = [];
Object.freeze(EMPTY_ARRAY$1);
var EMPTY_OBJECT$1 = {};
Object.freeze(EMPTY_OBJECT$1);
var hasProxy = typeof Proxy !== "undefined";
var plainObjectString$1 = /*#__PURE__*/Object.toString();
function assertProxies() {
  if (!hasProxy) {
    die(process.env.NODE_ENV !== "production" ? "`Proxy` objects are not available in the current environment. Please configure MobX to enable a fallback implementation.`" : "Proxy not available");
  }
}
function warnAboutProxyRequirement(msg) {
  if (process.env.NODE_ENV !== "production" && globalState.verifyProxies) {
    die("MobX is currently configured to be able to run in ES5 mode, but in ES5 MobX won't be able to " + msg);
  }
}
function getNextId() {
  return ++globalState.mobxGuid;
}
/**
 * Makes sure that the provided function is invoked at most once.
 */
function once(func) {
  var invoked = false;
  return function () {
    if (invoked) {
      return;
    }
    invoked = true;
    return func.apply(this, arguments);
  };
}
var noop = function noop() {};
function isFunction(fn) {
  return typeof fn === "function";
}
function isStringish(value) {
  var t = typeof value;
  switch (t) {
    case "string":
    case "symbol":
    case "number":
      return true;
  }
  return false;
}
function isObject(value) {
  return value !== null && typeof value === "object";
}
function isPlainObject$1(value) {
  if (!isObject(value)) {
    return false;
  }
  var proto = Object.getPrototypeOf(value);
  if (proto == null) {
    return true;
  }
  var protoConstructor = Object.hasOwnProperty.call(proto, "constructor") && proto.constructor;
  return typeof protoConstructor === "function" && protoConstructor.toString() === plainObjectString$1;
}
// https://stackoverflow.com/a/37865170
function isGenerator(obj) {
  var constructor = obj == null ? void 0 : obj.constructor;
  if (!constructor) {
    return false;
  }
  if ("GeneratorFunction" === constructor.name || "GeneratorFunction" === constructor.displayName) {
    return true;
  }
  return false;
}
function addHiddenProp(object, propName, value) {
  defineProperty$1(object, propName, {
    enumerable: false,
    writable: true,
    configurable: true,
    value: value
  });
}
function addHiddenFinalProp$1(object, propName, value) {
  defineProperty$1(object, propName, {
    enumerable: false,
    writable: false,
    configurable: true,
    value: value
  });
}
function createInstanceofPredicate(name, theClass) {
  var propName = "isMobX" + name;
  theClass.prototype[propName] = true;
  return function (x) {
    return isObject(x) && x[propName] === true;
  };
}
/**
 * Yields true for both native and observable Map, even across different windows.
 */
function isES6Map(thing) {
  return thing != null && Object.prototype.toString.call(thing) === "[object Map]";
}
/**
 * Makes sure a Map is an instance of non-inherited native or observable Map.
 */
function isPlainES6Map(thing) {
  var mapProto = Object.getPrototypeOf(thing);
  var objectProto = Object.getPrototypeOf(mapProto);
  var nullProto = Object.getPrototypeOf(objectProto);
  return nullProto === null;
}
/**
 * Yields true for both native and observable Set, even across different windows.
 */
function isES6Set(thing) {
  return thing != null && Object.prototype.toString.call(thing) === "[object Set]";
}
var hasGetOwnPropertySymbols = typeof Object.getOwnPropertySymbols !== "undefined";
/**
 * Returns the following: own enumerable keys and symbols.
 */
function getPlainObjectKeys(object) {
  var keys = Object.keys(object);
  // Not supported in IE, so there are not going to be symbol props anyway...
  if (!hasGetOwnPropertySymbols) {
    return keys;
  }
  var symbols = Object.getOwnPropertySymbols(object);
  if (!symbols.length) {
    return keys;
  }
  return [].concat(keys, symbols.filter(function (s) {
    return objectPrototype.propertyIsEnumerable.call(object, s);
  }));
}
// From Immer utils
// Returns all own keys, including non-enumerable and symbolic
var ownKeys = typeof Reflect !== "undefined" && Reflect.ownKeys ? Reflect.ownKeys : hasGetOwnPropertySymbols ? function (obj) {
  return Object.getOwnPropertyNames(obj).concat(Object.getOwnPropertySymbols(obj));
} : /* istanbul ignore next */Object.getOwnPropertyNames;
function stringifyKey(key) {
  if (typeof key === "string") {
    return key;
  }
  if (typeof key === "symbol") {
    return key.toString();
  }
  return new String(key).toString();
}
function toPrimitive(value) {
  return value === null ? null : typeof value === "object" ? "" + value : value;
}
function hasProp(target, prop) {
  return objectPrototype.hasOwnProperty.call(target, prop);
}
// From Immer utils
var getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors || function getOwnPropertyDescriptors(target) {
  // Polyfill needed for Hermes and IE, see https://github.com/facebook/hermes/issues/274
  var res = {};
  // Note: without polyfill for ownKeys, symbols won't be picked up
  ownKeys(target).forEach(function (key) {
    res[key] = getDescriptor(target, key);
  });
  return res;
};
function getFlag(flags, mask) {
  return !!(flags & mask);
}
function setFlag(flags, mask, newValue) {
  if (newValue) {
    flags |= mask;
  } else {
    flags &= ~mask;
  }
  return flags;
}

function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _createForOfIteratorHelperLoose(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (t) return (t = t.call(r)).next.bind(t);
  if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e) {
    t && (r = t);
    var o = 0;
    return function () {
      return o >= r.length ? {
        done: !0
      } : {
        done: !1,
        value: r[o++]
      };
    };
  }
  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _inheritsLoose(t, o) {
  t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o);
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r);
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (String )(t);
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}

var storedAnnotationsSymbol = /*#__PURE__*/Symbol("mobx-stored-annotations");
/**
 * Creates a function that acts as
 * - decorator
 * - annotation object
 */
function createDecoratorAnnotation(annotation) {
  function decorator(target, property) {
    if (is20223Decorator(property)) {
      return annotation.decorate_20223_(target, property);
    } else {
      storeAnnotation(target, property, annotation);
    }
  }
  return Object.assign(decorator, annotation);
}
/**
 * Stores annotation to prototype,
 * so it can be inspected later by `makeObservable` called from constructor
 */
function storeAnnotation(prototype, key, annotation) {
  if (!hasProp(prototype, storedAnnotationsSymbol)) {
    addHiddenProp(prototype, storedAnnotationsSymbol, _extends({}, prototype[storedAnnotationsSymbol]));
  }
  // @override must override something
  if (process.env.NODE_ENV !== "production" && isOverride(annotation) && !hasProp(prototype[storedAnnotationsSymbol], key)) {
    var fieldName = prototype.constructor.name + ".prototype." + key.toString();
    die("'" + fieldName + "' is decorated with 'override', " + "but no such decorated member was found on prototype.");
  }
  // Cannot re-decorate
  assertNotDecorated(prototype, annotation, key);
  // Ignore override
  if (!isOverride(annotation)) {
    prototype[storedAnnotationsSymbol][key] = annotation;
  }
}
function assertNotDecorated(prototype, annotation, key) {
  if (process.env.NODE_ENV !== "production" && !isOverride(annotation) && hasProp(prototype[storedAnnotationsSymbol], key)) {
    var fieldName = prototype.constructor.name + ".prototype." + key.toString();
    var currentAnnotationType = prototype[storedAnnotationsSymbol][key].annotationType_;
    var requestedAnnotationType = annotation.annotationType_;
    die("Cannot apply '@" + requestedAnnotationType + "' to '" + fieldName + "':" + ("\nThe field is already decorated with '@" + currentAnnotationType + "'.") + "\nRe-decorating fields is not allowed." + "\nUse '@override' decorator for methods overridden by subclass.");
  }
}
/**
 * Collects annotations from prototypes and stores them on target (instance)
 */
function collectStoredAnnotations(target) {
  if (!hasProp(target, storedAnnotationsSymbol)) {
    // if (__DEV__ && !target[storedAnnotationsSymbol]) {
    //     die(
    //         `No annotations were passed to makeObservable, but no decorated members have been found either`
    //     )
    // }
    // We need a copy as we will remove annotation from the list once it's applied.
    addHiddenProp(target, storedAnnotationsSymbol, _extends({}, target[storedAnnotationsSymbol]));
  }
  return target[storedAnnotationsSymbol];
}
function is20223Decorator(context) {
  return typeof context == "object" && typeof context["kind"] == "string";
}
function assert20223DecoratorType(context, types) {
  if (process.env.NODE_ENV !== "production" && !types.includes(context.kind)) {
    die("The decorator applied to '" + String(context.name) + "' cannot be used on a " + context.kind + " element");
  }
}

var $mobx = /*#__PURE__*/Symbol("mobx administration");
var Atom = /*#__PURE__*/function () {
  /**
   * Create a new atom. For debugging purposes it is recommended to give it a name.
   * The onBecomeObserved and onBecomeUnobserved callbacks can be used for resource management.
   */
  function Atom(name_) {
    if (name_ === void 0) {
      name_ = process.env.NODE_ENV !== "production" ? "Atom@" + getNextId() : "Atom";
    }
    this.name_ = void 0;
    this.flags_ = 0;
    this.observers_ = new Set();
    this.lastAccessedBy_ = 0;
    this.lowestObserverState_ = IDerivationState_.NOT_TRACKING_;
    // onBecomeObservedListeners
    this.onBOL = void 0;
    // onBecomeUnobservedListeners
    this.onBUOL = void 0;
    this.name_ = name_;
  }
  // for effective unobserving. BaseAtom has true, for extra optimization, so its onBecomeUnobserved never gets called, because it's not needed
  var _proto = Atom.prototype;
  _proto.onBO = function onBO() {
    if (this.onBOL) {
      this.onBOL.forEach(function (listener) {
        return listener();
      });
    }
  };
  _proto.onBUO = function onBUO() {
    if (this.onBUOL) {
      this.onBUOL.forEach(function (listener) {
        return listener();
      });
    }
  }
  /**
   * Invoke this method to notify mobx that your atom has been used somehow.
   * Returns true if there is currently a reactive context.
   */;
  _proto.reportObserved = function reportObserved$1() {
    return reportObserved(this);
  }
  /**
   * Invoke this method _after_ this method has changed to signal mobx that all its observers should invalidate.
   */;
  _proto.reportChanged = function reportChanged() {
    startBatch();
    propagateChanged(this);
    endBatch();
  };
  _proto.toString = function toString() {
    return this.name_;
  };
  return _createClass(Atom, [{
    key: "isBeingObserved",
    get: function get() {
      return getFlag(this.flags_, Atom.isBeingObservedMask_);
    },
    set: function set(newValue) {
      this.flags_ = setFlag(this.flags_, Atom.isBeingObservedMask_, newValue);
    }
  }, {
    key: "isPendingUnobservation",
    get: function get() {
      return getFlag(this.flags_, Atom.isPendingUnobservationMask_);
    },
    set: function set(newValue) {
      this.flags_ = setFlag(this.flags_, Atom.isPendingUnobservationMask_, newValue);
    }
  }, {
    key: "diffValue",
    get: function get() {
      return getFlag(this.flags_, Atom.diffValueMask_) ? 1 : 0;
    },
    set: function set(newValue) {
      this.flags_ = setFlag(this.flags_, Atom.diffValueMask_, newValue === 1 ? true : false);
    }
  }]);
}();
Atom.isBeingObservedMask_ = 1;
Atom.isPendingUnobservationMask_ = 2;
Atom.diffValueMask_ = 4;
var isAtom = /*#__PURE__*/createInstanceofPredicate("Atom", Atom);
function createAtom(name, onBecomeObservedHandler, onBecomeUnobservedHandler) {
  if (onBecomeObservedHandler === void 0) {
    onBecomeObservedHandler = noop;
  }
  if (onBecomeUnobservedHandler === void 0) {
    onBecomeUnobservedHandler = noop;
  }
  var atom = new Atom(name);
  // default `noop` listener will not initialize the hook Set
  if (onBecomeObservedHandler !== noop) {
    onBecomeObserved(atom, onBecomeObservedHandler);
  }
  if (onBecomeUnobservedHandler !== noop) {
    onBecomeUnobserved(atom, onBecomeUnobservedHandler);
  }
  return atom;
}

function identityComparer(a, b) {
  return a === b;
}
function structuralComparer(a, b) {
  return deepEqual(a, b);
}
function shallowComparer(a, b) {
  return deepEqual(a, b, 1);
}
function defaultComparer(a, b) {
  if (Object.is) {
    return Object.is(a, b);
  }
  return a === b ? a !== 0 || 1 / a === 1 / b : a !== a && b !== b;
}
var comparer = {
  identity: identityComparer,
  structural: structuralComparer,
  "default": defaultComparer,
  shallow: shallowComparer
};

function deepEnhancer(v, _, name) {
  // it is an observable already, done
  if (isObservable(v)) {
    return v;
  }
  // something that can be converted and mutated?
  if (Array.isArray(v)) {
    return observable.array(v, {
      name: name
    });
  }
  if (isPlainObject$1(v)) {
    return observable.object(v, undefined, {
      name: name
    });
  }
  if (isES6Map(v)) {
    return observable.map(v, {
      name: name
    });
  }
  if (isES6Set(v)) {
    return observable.set(v, {
      name: name
    });
  }
  if (typeof v === "function" && !isAction(v) && !isFlow(v)) {
    if (isGenerator(v)) {
      return flow(v);
    } else {
      return autoAction(name, v);
    }
  }
  return v;
}
function shallowEnhancer(v, _, name) {
  if (v === undefined || v === null) {
    return v;
  }
  if (isObservableObject(v) || isObservableArray(v) || isObservableMap(v) || isObservableSet(v)) {
    return v;
  }
  if (Array.isArray(v)) {
    return observable.array(v, {
      name: name,
      deep: false
    });
  }
  if (isPlainObject$1(v)) {
    return observable.object(v, undefined, {
      name: name,
      deep: false
    });
  }
  if (isES6Map(v)) {
    return observable.map(v, {
      name: name,
      deep: false
    });
  }
  if (isES6Set(v)) {
    return observable.set(v, {
      name: name,
      deep: false
    });
  }
  if (process.env.NODE_ENV !== "production") {
    die("The shallow modifier / decorator can only used in combination with arrays, objects, maps and sets");
  }
}
function referenceEnhancer(newValue) {
  // never turn into an observable
  return newValue;
}
function refStructEnhancer(v, oldValue) {
  if (process.env.NODE_ENV !== "production" && isObservable(v)) {
    die("observable.struct should not be used with observable values");
  }
  if (deepEqual(v, oldValue)) {
    return oldValue;
  }
  return v;
}

var OVERRIDE = "override";
function isOverride(annotation) {
  return annotation.annotationType_ === OVERRIDE;
}

function createActionAnnotation(name, options) {
  return {
    annotationType_: name,
    options_: options,
    make_: make_$1,
    extend_: extend_$1,
    decorate_20223_: decorate_20223_$1
  };
}
function make_$1(adm, key, descriptor, source) {
  var _this$options_;
  // bound
  if ((_this$options_ = this.options_) != null && _this$options_.bound) {
    return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */ : 1 /* MakeResult.Break */;
  }
  // own
  if (source === adm.target_) {
    return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */ : 2 /* MakeResult.Continue */;
  }
  // prototype
  if (isAction(descriptor.value)) {
    // A prototype could have been annotated already by other constructor,
    // rest of the proto chain must be annotated already
    return 1 /* MakeResult.Break */;
  }
  var actionDescriptor = createActionDescriptor(adm, this, key, descriptor, false);
  defineProperty$1(source, key, actionDescriptor);
  return 2 /* MakeResult.Continue */;
}
function extend_$1(adm, key, descriptor, proxyTrap) {
  var actionDescriptor = createActionDescriptor(adm, this, key, descriptor);
  return adm.defineProperty_(key, actionDescriptor, proxyTrap);
}
function decorate_20223_$1(mthd, context) {
  if (process.env.NODE_ENV !== "production") {
    assert20223DecoratorType(context, ["method", "field"]);
  }
  var kind = context.kind,
    name = context.name,
    addInitializer = context.addInitializer;
  var ann = this;
  var _createAction = function _createAction(m) {
    var _ann$options_$name, _ann$options_, _ann$options_$autoAct, _ann$options_2;
    return createAction((_ann$options_$name = (_ann$options_ = ann.options_) == null ? void 0 : _ann$options_.name) != null ? _ann$options_$name : name.toString(), m, (_ann$options_$autoAct = (_ann$options_2 = ann.options_) == null ? void 0 : _ann$options_2.autoAction) != null ? _ann$options_$autoAct : false);
  };
  if (kind == "field") {
    return function (initMthd) {
      var _ann$options_3;
      var mthd = initMthd;
      if (!isAction(mthd)) {
        mthd = _createAction(mthd);
      }
      if ((_ann$options_3 = ann.options_) != null && _ann$options_3.bound) {
        mthd = mthd.bind(this);
        mthd.isMobxAction = true;
      }
      return mthd;
    };
  }
  if (kind == "method") {
    var _this$options_2;
    if (!isAction(mthd)) {
      mthd = _createAction(mthd);
    }
    if ((_this$options_2 = this.options_) != null && _this$options_2.bound) {
      addInitializer(function () {
        var self = this;
        var bound = self[name].bind(self);
        bound.isMobxAction = true;
        self[name] = bound;
      });
    }
    return mthd;
  }
  die("Cannot apply '" + ann.annotationType_ + "' to '" + String(name) + "' (kind: " + kind + "):" + ("\n'" + ann.annotationType_ + "' can only be used on properties with a function value."));
}
function assertActionDescriptor(adm, _ref, key, _ref2) {
  var annotationType_ = _ref.annotationType_;
  var value = _ref2.value;
  if (process.env.NODE_ENV !== "production" && !isFunction(value)) {
    die("Cannot apply '" + annotationType_ + "' to '" + adm.name_ + "." + key.toString() + "':" + ("\n'" + annotationType_ + "' can only be used on properties with a function value."));
  }
}
function createActionDescriptor(adm, annotation, key, descriptor,
// provides ability to disable safeDescriptors for prototypes
safeDescriptors) {
  var _annotation$options_, _annotation$options_$, _annotation$options_2, _annotation$options_$2, _annotation$options_3, _annotation$options_4, _adm$proxy_2;
  if (safeDescriptors === void 0) {
    safeDescriptors = globalState.safeDescriptors;
  }
  assertActionDescriptor(adm, annotation, key, descriptor);
  var value = descriptor.value;
  if ((_annotation$options_ = annotation.options_) != null && _annotation$options_.bound) {
    var _adm$proxy_;
    value = value.bind((_adm$proxy_ = adm.proxy_) != null ? _adm$proxy_ : adm.target_);
  }
  return {
    value: createAction((_annotation$options_$ = (_annotation$options_2 = annotation.options_) == null ? void 0 : _annotation$options_2.name) != null ? _annotation$options_$ : key.toString(), value, (_annotation$options_$2 = (_annotation$options_3 = annotation.options_) == null ? void 0 : _annotation$options_3.autoAction) != null ? _annotation$options_$2 : false,
    // https://github.com/mobxjs/mobx/discussions/3140
    (_annotation$options_4 = annotation.options_) != null && _annotation$options_4.bound ? (_adm$proxy_2 = adm.proxy_) != null ? _adm$proxy_2 : adm.target_ : undefined),
    // Non-configurable for classes
    // prevents accidental field redefinition in subclass
    configurable: safeDescriptors ? adm.isPlainObject_ : true,
    // https://github.com/mobxjs/mobx/pull/2641#issuecomment-737292058
    enumerable: false,
    // Non-obsevable, therefore non-writable
    // Also prevents rewriting in subclass constructor
    writable: safeDescriptors ? false : true
  };
}

function createFlowAnnotation(name, options) {
  return {
    annotationType_: name,
    options_: options,
    make_: make_$2,
    extend_: extend_$2,
    decorate_20223_: decorate_20223_$2
  };
}
function make_$2(adm, key, descriptor, source) {
  var _this$options_;
  // own
  if (source === adm.target_) {
    return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */ : 2 /* MakeResult.Continue */;
  }
  // prototype
  // bound - must annotate protos to support super.flow()
  if ((_this$options_ = this.options_) != null && _this$options_.bound && (!hasProp(adm.target_, key) || !isFlow(adm.target_[key]))) {
    if (this.extend_(adm, key, descriptor, false) === null) {
      return 0 /* MakeResult.Cancel */;
    }
  }
  if (isFlow(descriptor.value)) {
    // A prototype could have been annotated already by other constructor,
    // rest of the proto chain must be annotated already
    return 1 /* MakeResult.Break */;
  }
  var flowDescriptor = createFlowDescriptor(adm, this, key, descriptor, false, false);
  defineProperty$1(source, key, flowDescriptor);
  return 2 /* MakeResult.Continue */;
}
function extend_$2(adm, key, descriptor, proxyTrap) {
  var _this$options_2;
  var flowDescriptor = createFlowDescriptor(adm, this, key, descriptor, (_this$options_2 = this.options_) == null ? void 0 : _this$options_2.bound);
  return adm.defineProperty_(key, flowDescriptor, proxyTrap);
}
function decorate_20223_$2(mthd, context) {
  var _this$options_3;
  if (process.env.NODE_ENV !== "production") {
    assert20223DecoratorType(context, ["method"]);
  }
  var name = context.name,
    addInitializer = context.addInitializer;
  if (!isFlow(mthd)) {
    mthd = flow(mthd);
  }
  if ((_this$options_3 = this.options_) != null && _this$options_3.bound) {
    addInitializer(function () {
      var self = this;
      var bound = self[name].bind(self);
      bound.isMobXFlow = true;
      self[name] = bound;
    });
  }
  return mthd;
}
function assertFlowDescriptor(adm, _ref, key, _ref2) {
  var annotationType_ = _ref.annotationType_;
  var value = _ref2.value;
  if (process.env.NODE_ENV !== "production" && !isFunction(value)) {
    die("Cannot apply '" + annotationType_ + "' to '" + adm.name_ + "." + key.toString() + "':" + ("\n'" + annotationType_ + "' can only be used on properties with a generator function value."));
  }
}
function createFlowDescriptor(adm, annotation, key, descriptor, bound,
// provides ability to disable safeDescriptors for prototypes
safeDescriptors) {
  if (safeDescriptors === void 0) {
    safeDescriptors = globalState.safeDescriptors;
  }
  assertFlowDescriptor(adm, annotation, key, descriptor);
  var value = descriptor.value;
  // In case of flow.bound, the descriptor can be from already annotated prototype
  if (!isFlow(value)) {
    value = flow(value);
  }
  if (bound) {
    var _adm$proxy_;
    // We do not keep original function around, so we bind the existing flow
    value = value.bind((_adm$proxy_ = adm.proxy_) != null ? _adm$proxy_ : adm.target_);
    // This is normally set by `flow`, but `bind` returns new function...
    value.isMobXFlow = true;
  }
  return {
    value: value,
    // Non-configurable for classes
    // prevents accidental field redefinition in subclass
    configurable: safeDescriptors ? adm.isPlainObject_ : true,
    // https://github.com/mobxjs/mobx/pull/2641#issuecomment-737292058
    enumerable: false,
    // Non-obsevable, therefore non-writable
    // Also prevents rewriting in subclass constructor
    writable: safeDescriptors ? false : true
  };
}

function createComputedAnnotation(name, options) {
  return {
    annotationType_: name,
    options_: options,
    make_: make_$3,
    extend_: extend_$3,
    decorate_20223_: decorate_20223_$3
  };
}
function make_$3(adm, key, descriptor) {
  return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */ : 1 /* MakeResult.Break */;
}
function extend_$3(adm, key, descriptor, proxyTrap) {
  assertComputedDescriptor(adm, this, key, descriptor);
  return adm.defineComputedProperty_(key, _extends({}, this.options_, {
    get: descriptor.get,
    set: descriptor.set
  }), proxyTrap);
}
function decorate_20223_$3(get, context) {
  if (process.env.NODE_ENV !== "production") {
    assert20223DecoratorType(context, ["getter"]);
  }
  var ann = this;
  var key = context.name,
    addInitializer = context.addInitializer;
  addInitializer(function () {
    var adm = asObservableObject(this)[$mobx];
    var options = _extends({}, ann.options_, {
      get: get,
      context: this
    });
    options.name || (options.name = process.env.NODE_ENV !== "production" ? adm.name_ + "." + key.toString() : "ObservableObject." + key.toString());
    adm.values_.set(key, new ComputedValue(options));
  });
  return function () {
    return this[$mobx].getObservablePropValue_(key);
  };
}
function assertComputedDescriptor(adm, _ref, key, _ref2) {
  var annotationType_ = _ref.annotationType_;
  var get = _ref2.get;
  if (process.env.NODE_ENV !== "production" && !get) {
    die("Cannot apply '" + annotationType_ + "' to '" + adm.name_ + "." + key.toString() + "':" + ("\n'" + annotationType_ + "' can only be used on getter(+setter) properties."));
  }
}

function createObservableAnnotation(name, options) {
  return {
    annotationType_: name,
    options_: options,
    make_: make_$4,
    extend_: extend_$4,
    decorate_20223_: decorate_20223_$4
  };
}
function make_$4(adm, key, descriptor) {
  return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */ : 1 /* MakeResult.Break */;
}
function extend_$4(adm, key, descriptor, proxyTrap) {
  var _this$options_$enhanc, _this$options_;
  assertObservableDescriptor(adm, this, key, descriptor);
  return adm.defineObservableProperty_(key, descriptor.value, (_this$options_$enhanc = (_this$options_ = this.options_) == null ? void 0 : _this$options_.enhancer) != null ? _this$options_$enhanc : deepEnhancer, proxyTrap);
}
function decorate_20223_$4(desc, context) {
  if (process.env.NODE_ENV !== "production") {
    if (context.kind === "field") {
      throw die("Please use `@observable accessor " + String(context.name) + "` instead of `@observable " + String(context.name) + "`");
    }
    assert20223DecoratorType(context, ["accessor"]);
  }
  var ann = this;
  var kind = context.kind,
    name = context.name;
  // The laziness here is not ideal... It's a workaround to how 2022.3 Decorators are implemented:
  //   `addInitializer` callbacks are executed _before_ any accessors are defined (instead of the ideal-for-us right after each).
  //   This means that, if we were to do our stuff in an `addInitializer`, we'd attempt to read a private slot
  //   before it has been initialized. The runtime doesn't like that and throws a `Cannot read private member
  //   from an object whose class did not declare it` error.
  // TODO: it seems that this will not be required anymore in the final version of the spec
  // See TODO: link
  var initializedObjects = new WeakSet();
  function initializeObservable(target, value) {
    var _ann$options_$enhance, _ann$options_;
    var adm = asObservableObject(target)[$mobx];
    var observable = new ObservableValue(value, (_ann$options_$enhance = (_ann$options_ = ann.options_) == null ? void 0 : _ann$options_.enhancer) != null ? _ann$options_$enhance : deepEnhancer, process.env.NODE_ENV !== "production" ? adm.name_ + "." + name.toString() : "ObservableObject." + name.toString(), false);
    adm.values_.set(name, observable);
    initializedObjects.add(target);
  }
  if (kind == "accessor") {
    return {
      get: function get() {
        if (!initializedObjects.has(this)) {
          initializeObservable(this, desc.get.call(this));
        }
        return this[$mobx].getObservablePropValue_(name);
      },
      set: function set(value) {
        if (!initializedObjects.has(this)) {
          initializeObservable(this, value);
        }
        return this[$mobx].setObservablePropValue_(name, value);
      },
      init: function init(value) {
        if (!initializedObjects.has(this)) {
          initializeObservable(this, value);
        }
        return value;
      }
    };
  }
  return;
}
function assertObservableDescriptor(adm, _ref, key, descriptor) {
  var annotationType_ = _ref.annotationType_;
  if (process.env.NODE_ENV !== "production" && !("value" in descriptor)) {
    die("Cannot apply '" + annotationType_ + "' to '" + adm.name_ + "." + key.toString() + "':" + ("\n'" + annotationType_ + "' cannot be used on getter/setter properties"));
  }
}

var AUTO = "true";
var autoAnnotation = /*#__PURE__*/createAutoAnnotation();
function createAutoAnnotation(options) {
  return {
    annotationType_: AUTO,
    options_: options,
    make_: make_$5,
    extend_: extend_$5,
    decorate_20223_: decorate_20223_$5
  };
}
function make_$5(adm, key, descriptor, source) {
  var _this$options_3, _this$options_4;
  // getter -> computed
  if (descriptor.get) {
    return computed.make_(adm, key, descriptor, source);
  }
  // lone setter -> action setter
  if (descriptor.set) {
    // TODO make action applicable to setter and delegate to action.make_
    var set = createAction(key.toString(), descriptor.set);
    // own
    if (source === adm.target_) {
      return adm.defineProperty_(key, {
        configurable: globalState.safeDescriptors ? adm.isPlainObject_ : true,
        set: set
      }) === null ? 0 /* MakeResult.Cancel */ : 2 /* MakeResult.Continue */;
    }
    // proto
    defineProperty$1(source, key, {
      configurable: true,
      set: set
    });
    return 2 /* MakeResult.Continue */;
  }
  // function on proto -> autoAction/flow
  if (source !== adm.target_ && typeof descriptor.value === "function") {
    var _this$options_2;
    if (isGenerator(descriptor.value)) {
      var _this$options_;
      var flowAnnotation = (_this$options_ = this.options_) != null && _this$options_.autoBind ? flow.bound : flow;
      return flowAnnotation.make_(adm, key, descriptor, source);
    }
    var actionAnnotation = (_this$options_2 = this.options_) != null && _this$options_2.autoBind ? autoAction.bound : autoAction;
    return actionAnnotation.make_(adm, key, descriptor, source);
  }
  // other -> observable
  // Copy props from proto as well, see test:
  // "decorate should work with Object.create"
  var observableAnnotation = ((_this$options_3 = this.options_) == null ? void 0 : _this$options_3.deep) === false ? observable.ref : observable;
  // if function respect autoBind option
  if (typeof descriptor.value === "function" && (_this$options_4 = this.options_) != null && _this$options_4.autoBind) {
    var _adm$proxy_;
    descriptor.value = descriptor.value.bind((_adm$proxy_ = adm.proxy_) != null ? _adm$proxy_ : adm.target_);
  }
  return observableAnnotation.make_(adm, key, descriptor, source);
}
function extend_$5(adm, key, descriptor, proxyTrap) {
  var _this$options_5, _this$options_6;
  // getter -> computed
  if (descriptor.get) {
    return computed.extend_(adm, key, descriptor, proxyTrap);
  }
  // lone setter -> action setter
  if (descriptor.set) {
    // TODO make action applicable to setter and delegate to action.extend_
    return adm.defineProperty_(key, {
      configurable: globalState.safeDescriptors ? adm.isPlainObject_ : true,
      set: createAction(key.toString(), descriptor.set)
    }, proxyTrap);
  }
  // other -> observable
  // if function respect autoBind option
  if (typeof descriptor.value === "function" && (_this$options_5 = this.options_) != null && _this$options_5.autoBind) {
    var _adm$proxy_2;
    descriptor.value = descriptor.value.bind((_adm$proxy_2 = adm.proxy_) != null ? _adm$proxy_2 : adm.target_);
  }
  var observableAnnotation = ((_this$options_6 = this.options_) == null ? void 0 : _this$options_6.deep) === false ? observable.ref : observable;
  return observableAnnotation.extend_(adm, key, descriptor, proxyTrap);
}
function decorate_20223_$5(desc, context) {
  die("'" + this.annotationType_ + "' cannot be used as a decorator");
}

var OBSERVABLE = "observable";
var OBSERVABLE_REF = "observable.ref";
var OBSERVABLE_SHALLOW = "observable.shallow";
var OBSERVABLE_STRUCT = "observable.struct";
// Predefined bags of create observable options, to avoid allocating temporarily option objects
// in the majority of cases
var defaultCreateObservableOptions = {
  deep: true,
  name: undefined,
  defaultDecorator: undefined,
  proxy: true
};
Object.freeze(defaultCreateObservableOptions);
function asCreateObservableOptions(thing) {
  return thing || defaultCreateObservableOptions;
}
var observableAnnotation = /*#__PURE__*/createObservableAnnotation(OBSERVABLE);
var observableRefAnnotation = /*#__PURE__*/createObservableAnnotation(OBSERVABLE_REF, {
  enhancer: referenceEnhancer
});
var observableShallowAnnotation = /*#__PURE__*/createObservableAnnotation(OBSERVABLE_SHALLOW, {
  enhancer: shallowEnhancer
});
var observableStructAnnotation = /*#__PURE__*/createObservableAnnotation(OBSERVABLE_STRUCT, {
  enhancer: refStructEnhancer
});
var observableDecoratorAnnotation = /*#__PURE__*/createDecoratorAnnotation(observableAnnotation);
function getEnhancerFromOptions(options) {
  return options.deep === true ? deepEnhancer : options.deep === false ? referenceEnhancer : getEnhancerFromAnnotation(options.defaultDecorator);
}
function getAnnotationFromOptions(options) {
  var _options$defaultDecor;
  return options ? (_options$defaultDecor = options.defaultDecorator) != null ? _options$defaultDecor : createAutoAnnotation(options) : undefined;
}
function getEnhancerFromAnnotation(annotation) {
  var _annotation$options_$, _annotation$options_;
  return !annotation ? deepEnhancer : (_annotation$options_$ = (_annotation$options_ = annotation.options_) == null ? void 0 : _annotation$options_.enhancer) != null ? _annotation$options_$ : deepEnhancer;
}
/**
 * Turns an object, array or function into a reactive structure.
 * @param v the value which should become observable.
 */
function createObservable(v, arg2, arg3) {
  // @observable someProp; (2022.3 Decorators)
  if (is20223Decorator(arg2)) {
    return observableAnnotation.decorate_20223_(v, arg2);
  }
  // @observable someProp;
  if (isStringish(arg2)) {
    storeAnnotation(v, arg2, observableAnnotation);
    return;
  }
  // already observable - ignore
  if (isObservable(v)) {
    return v;
  }
  // plain object
  if (isPlainObject$1(v)) {
    return observable.object(v, arg2, arg3);
  }
  // Array
  if (Array.isArray(v)) {
    return observable.array(v, arg2);
  }
  // Map
  if (isES6Map(v)) {
    return observable.map(v, arg2);
  }
  // Set
  if (isES6Set(v)) {
    return observable.set(v, arg2);
  }
  // other object - ignore
  if (typeof v === "object" && v !== null) {
    return v;
  }
  // anything else
  return observable.box(v, arg2);
}
assign(createObservable, observableDecoratorAnnotation);
var observableFactories = {
  box: function box(value, options) {
    var o = asCreateObservableOptions(options);
    return new ObservableValue(value, getEnhancerFromOptions(o), o.name, true, o.equals);
  },
  array: function array(initialValues, options) {
    var o = asCreateObservableOptions(options);
    return (globalState.useProxies === false || o.proxy === false ? createLegacyArray : createObservableArray)(initialValues, getEnhancerFromOptions(o), o.name);
  },
  map: function map(initialValues, options) {
    var o = asCreateObservableOptions(options);
    return new ObservableMap(initialValues, getEnhancerFromOptions(o), o.name);
  },
  set: function set(initialValues, options) {
    var o = asCreateObservableOptions(options);
    return new ObservableSet(initialValues, getEnhancerFromOptions(o), o.name);
  },
  object: function object(props, decorators, options) {
    return initObservable(function () {
      return extendObservable(globalState.useProxies === false || (options == null ? void 0 : options.proxy) === false ? asObservableObject({}, options) : asDynamicObservableObject({}, options), props, decorators);
    });
  },
  ref: /*#__PURE__*/createDecoratorAnnotation(observableRefAnnotation),
  shallow: /*#__PURE__*/createDecoratorAnnotation(observableShallowAnnotation),
  deep: observableDecoratorAnnotation,
  struct: /*#__PURE__*/createDecoratorAnnotation(observableStructAnnotation)
};
// eslint-disable-next-line
var observable = /*#__PURE__*/assign(createObservable, observableFactories);

var COMPUTED = "computed";
var COMPUTED_STRUCT = "computed.struct";
var computedAnnotation = /*#__PURE__*/createComputedAnnotation(COMPUTED);
var computedStructAnnotation = /*#__PURE__*/createComputedAnnotation(COMPUTED_STRUCT, {
  equals: comparer.structural
});
/**
 * Decorator for class properties: @computed get value() { return expr; }.
 * For legacy purposes also invokable as ES5 observable created: `computed(() => expr)`;
 */
var computed = function computed(arg1, arg2) {
  if (is20223Decorator(arg2)) {
    // @computed (2022.3 Decorators)
    return computedAnnotation.decorate_20223_(arg1, arg2);
  }
  if (isStringish(arg2)) {
    // @computed
    return storeAnnotation(arg1, arg2, computedAnnotation);
  }
  if (isPlainObject$1(arg1)) {
    // @computed({ options })
    return createDecoratorAnnotation(createComputedAnnotation(COMPUTED, arg1));
  }
  // computed(expr, options?)
  if (process.env.NODE_ENV !== "production") {
    if (!isFunction(arg1)) {
      die("First argument to `computed` should be an expression.");
    }
    if (isFunction(arg2)) {
      die("A setter as second argument is no longer supported, use `{ set: fn }` option instead");
    }
  }
  var opts = isPlainObject$1(arg2) ? arg2 : {};
  opts.get = arg1;
  opts.name || (opts.name = arg1.name || ""); /* for generated name */
  return new ComputedValue(opts);
};
Object.assign(computed, computedAnnotation);
computed.struct = /*#__PURE__*/createDecoratorAnnotation(computedStructAnnotation);

var _getDescriptor$config, _getDescriptor;
// we don't use globalState for these in order to avoid possible issues with multiple
// mobx versions
var currentActionId = 0;
var nextActionId$1 = 1;
var isFunctionNameConfigurable = (_getDescriptor$config = (_getDescriptor = /*#__PURE__*/getDescriptor(function () {}, "name")) == null ? void 0 : _getDescriptor.configurable) != null ? _getDescriptor$config : false;
// we can safely recycle this object
var tmpNameDescriptor = {
  value: "action",
  configurable: true,
  writable: false,
  enumerable: false
};
function createAction(actionName, fn, autoAction, ref) {
  if (autoAction === void 0) {
    autoAction = false;
  }
  if (process.env.NODE_ENV !== "production") {
    if (!isFunction(fn)) {
      die("`action` can only be invoked on functions");
    }
    if (typeof actionName !== "string" || !actionName) {
      die("actions should have valid names, got: '" + actionName + "'");
    }
  }
  function res() {
    return executeAction(actionName, autoAction, fn, ref || this, arguments);
  }
  res.isMobxAction = true;
  res.toString = function () {
    return fn.toString();
  };
  if (isFunctionNameConfigurable) {
    tmpNameDescriptor.value = actionName;
    defineProperty$1(res, "name", tmpNameDescriptor);
  }
  return res;
}
function executeAction(actionName, canRunAsDerivation, fn, scope, args) {
  var runInfo = _startAction(actionName, canRunAsDerivation, scope, args);
  try {
    return fn.apply(scope, args);
  } catch (err) {
    runInfo.error_ = err;
    throw err;
  } finally {
    _endAction(runInfo);
  }
}
function _startAction(actionName, canRunAsDerivation,
// true for autoAction
scope, args) {
  var notifySpy_ = process.env.NODE_ENV !== "production" && isSpyEnabled() && !!actionName;
  var startTime_ = 0;
  if (process.env.NODE_ENV !== "production" && notifySpy_) {
    startTime_ = Date.now();
    var flattenedArgs = args ? Array.from(args) : EMPTY_ARRAY$1;
    spyReportStart({
      type: ACTION,
      name: actionName,
      object: scope,
      arguments: flattenedArgs
    });
  }
  var prevDerivation_ = globalState.trackingDerivation;
  var runAsAction = !canRunAsDerivation || !prevDerivation_;
  startBatch();
  var prevAllowStateChanges_ = globalState.allowStateChanges; // by default preserve previous allow
  if (runAsAction) {
    untrackedStart();
    prevAllowStateChanges_ = allowStateChangesStart(true);
  }
  var prevAllowStateReads_ = allowStateReadsStart(true);
  var runInfo = {
    runAsAction_: runAsAction,
    prevDerivation_: prevDerivation_,
    prevAllowStateChanges_: prevAllowStateChanges_,
    prevAllowStateReads_: prevAllowStateReads_,
    notifySpy_: notifySpy_,
    startTime_: startTime_,
    actionId_: nextActionId$1++,
    parentActionId_: currentActionId
  };
  currentActionId = runInfo.actionId_;
  return runInfo;
}
function _endAction(runInfo) {
  if (currentActionId !== runInfo.actionId_) {
    die(30);
  }
  currentActionId = runInfo.parentActionId_;
  if (runInfo.error_ !== undefined) {
    globalState.suppressReactionErrors = true;
  }
  allowStateChangesEnd(runInfo.prevAllowStateChanges_);
  allowStateReadsEnd(runInfo.prevAllowStateReads_);
  endBatch();
  if (runInfo.runAsAction_) {
    untrackedEnd(runInfo.prevDerivation_);
  }
  if (process.env.NODE_ENV !== "production" && runInfo.notifySpy_) {
    spyReportEnd({
      time: Date.now() - runInfo.startTime_
    });
  }
  globalState.suppressReactionErrors = false;
}
function allowStateChanges(allowStateChanges, func) {
  var prev = allowStateChangesStart(allowStateChanges);
  try {
    return func();
  } finally {
    allowStateChangesEnd(prev);
  }
}
function allowStateChangesStart(allowStateChanges) {
  var prev = globalState.allowStateChanges;
  globalState.allowStateChanges = allowStateChanges;
  return prev;
}
function allowStateChangesEnd(prev) {
  globalState.allowStateChanges = prev;
}

var CREATE = "create";
var ObservableValue = /*#__PURE__*/function (_Atom) {
  function ObservableValue(value, enhancer, name_, notifySpy, equals) {
    var _this;
    if (name_ === void 0) {
      name_ = process.env.NODE_ENV !== "production" ? "ObservableValue@" + getNextId() : "ObservableValue";
    }
    if (notifySpy === void 0) {
      notifySpy = true;
    }
    if (equals === void 0) {
      equals = comparer["default"];
    }
    _this = _Atom.call(this, name_) || this;
    _this.enhancer = void 0;
    _this.name_ = void 0;
    _this.equals = void 0;
    _this.hasUnreportedChange_ = false;
    _this.interceptors_ = void 0;
    _this.changeListeners_ = void 0;
    _this.value_ = void 0;
    _this.dehancer = void 0;
    _this.enhancer = enhancer;
    _this.name_ = name_;
    _this.equals = equals;
    _this.value_ = enhancer(value, undefined, name_);
    if (process.env.NODE_ENV !== "production" && notifySpy && isSpyEnabled()) {
      // only notify spy if this is a stand-alone observable
      spyReport({
        type: CREATE,
        object: _this,
        observableKind: "value",
        debugObjectName: _this.name_,
        newValue: "" + _this.value_
      });
    }
    return _this;
  }
  _inheritsLoose(ObservableValue, _Atom);
  var _proto = ObservableValue.prototype;
  _proto.dehanceValue = function dehanceValue(value) {
    if (this.dehancer !== undefined) {
      return this.dehancer(value);
    }
    return value;
  };
  _proto.set = function set(newValue) {
    var oldValue = this.value_;
    newValue = this.prepareNewValue_(newValue);
    if (newValue !== globalState.UNCHANGED) {
      var notifySpy = isSpyEnabled();
      if (process.env.NODE_ENV !== "production" && notifySpy) {
        spyReportStart({
          type: UPDATE,
          object: this,
          observableKind: "value",
          debugObjectName: this.name_,
          newValue: newValue,
          oldValue: oldValue
        });
      }
      this.setNewValue_(newValue);
      if (process.env.NODE_ENV !== "production" && notifySpy) {
        spyReportEnd();
      }
    }
  };
  _proto.prepareNewValue_ = function prepareNewValue_(newValue) {
    checkIfStateModificationsAreAllowed(this);
    if (hasInterceptors(this)) {
      var change = interceptChange(this, {
        object: this,
        type: UPDATE,
        newValue: newValue
      });
      if (!change) {
        return globalState.UNCHANGED;
      }
      newValue = change.newValue;
    }
    // apply modifier
    newValue = this.enhancer(newValue, this.value_, this.name_);
    return this.equals(this.value_, newValue) ? globalState.UNCHANGED : newValue;
  };
  _proto.setNewValue_ = function setNewValue_(newValue) {
    var oldValue = this.value_;
    this.value_ = newValue;
    this.reportChanged();
    if (hasListeners(this)) {
      notifyListeners(this, {
        type: UPDATE,
        object: this,
        newValue: newValue,
        oldValue: oldValue
      });
    }
  };
  _proto.get = function get() {
    this.reportObserved();
    return this.dehanceValue(this.value_);
  };
  _proto.intercept_ = function intercept_(handler) {
    return registerInterceptor(this, handler);
  };
  _proto.observe_ = function observe_(listener, fireImmediately) {
    if (fireImmediately) {
      listener({
        observableKind: "value",
        debugObjectName: this.name_,
        object: this,
        type: UPDATE,
        newValue: this.value_,
        oldValue: undefined
      });
    }
    return registerListener(this, listener);
  };
  _proto.raw = function raw() {
    // used by MST ot get undehanced value
    return this.value_;
  };
  _proto.toJSON = function toJSON() {
    return this.get();
  };
  _proto.toString = function toString() {
    return this.name_ + "[" + this.value_ + "]";
  };
  _proto.valueOf = function valueOf() {
    return toPrimitive(this.get());
  };
  _proto[Symbol.toPrimitive] = function () {
    return this.valueOf();
  };
  return ObservableValue;
}(Atom);
var isObservableValue = /*#__PURE__*/createInstanceofPredicate("ObservableValue", ObservableValue);

/**
 * A node in the state dependency root that observes other nodes, and can be observed itself.
 *
 * ComputedValue will remember the result of the computation for the duration of the batch, or
 * while being observed.
 *
 * During this time it will recompute only when one of its direct dependencies changed,
 * but only when it is being accessed with `ComputedValue.get()`.
 *
 * Implementation description:
 * 1. First time it's being accessed it will compute and remember result
 *    give back remembered result until 2. happens
 * 2. First time any deep dependency change, propagate POSSIBLY_STALE to all observers, wait for 3.
 * 3. When it's being accessed, recompute if any shallow dependency changed.
 *    if result changed: propagate STALE to all observers, that were POSSIBLY_STALE from the last step.
 *    go to step 2. either way
 *
 * If at any point it's outside batch and it isn't observed: reset everything and go to 1.
 */
var ComputedValue = /*#__PURE__*/function () {
  /**
   * Create a new computed value based on a function expression.
   *
   * The `name` property is for debug purposes only.
   *
   * The `equals` property specifies the comparer function to use to determine if a newly produced
   * value differs from the previous value. Two comparers are provided in the library; `defaultComparer`
   * compares based on identity comparison (===), and `structuralComparer` deeply compares the structure.
   * Structural comparison can be convenient if you always produce a new aggregated object and
   * don't want to notify observers if it is structurally the same.
   * This is useful for working with vectors, mouse coordinates etc.
   */
  function ComputedValue(options) {
    this.dependenciesState_ = IDerivationState_.NOT_TRACKING_;
    this.observing_ = [];
    // nodes we are looking at. Our value depends on these nodes
    this.newObserving_ = null;
    // during tracking it's an array with new observed observers
    this.observers_ = new Set();
    this.runId_ = 0;
    this.lastAccessedBy_ = 0;
    this.lowestObserverState_ = IDerivationState_.UP_TO_DATE_;
    this.unboundDepsCount_ = 0;
    this.value_ = new CaughtException(null);
    this.name_ = void 0;
    this.triggeredBy_ = void 0;
    this.flags_ = 0;
    this.derivation = void 0;
    // N.B: unminified as it is used by MST
    this.setter_ = void 0;
    this.isTracing_ = TraceMode.NONE;
    this.scope_ = void 0;
    this.equals_ = void 0;
    this.requiresReaction_ = void 0;
    this.keepAlive_ = void 0;
    this.onBOL = void 0;
    this.onBUOL = void 0;
    if (!options.get) {
      die(31);
    }
    this.derivation = options.get;
    this.name_ = options.name || (process.env.NODE_ENV !== "production" ? "ComputedValue@" + getNextId() : "ComputedValue");
    if (options.set) {
      this.setter_ = createAction(process.env.NODE_ENV !== "production" ? this.name_ + "-setter" : "ComputedValue-setter", options.set);
    }
    this.equals_ = options.equals || (options.compareStructural || options.struct ? comparer.structural : comparer["default"]);
    this.scope_ = options.context;
    this.requiresReaction_ = options.requiresReaction;
    this.keepAlive_ = !!options.keepAlive;
  }
  var _proto = ComputedValue.prototype;
  _proto.onBecomeStale_ = function onBecomeStale_() {
    propagateMaybeChanged(this);
  };
  _proto.onBO = function onBO() {
    if (this.onBOL) {
      this.onBOL.forEach(function (listener) {
        return listener();
      });
    }
  };
  _proto.onBUO = function onBUO() {
    if (this.onBUOL) {
      this.onBUOL.forEach(function (listener) {
        return listener();
      });
    }
  }
  // to check for cycles
  ;
  /**
   * Returns the current value of this computed value.
   * Will evaluate its computation first if needed.
   */
  _proto.get = function get() {
    if (this.isComputing) {
      die(32, this.name_, this.derivation);
    }
    if (globalState.inBatch === 0 &&
    // !globalState.trackingDerivatpion &&
    this.observers_.size === 0 && !this.keepAlive_) {
      if (shouldCompute(this)) {
        this.warnAboutUntrackedRead_();
        startBatch(); // See perf test 'computed memoization'
        this.value_ = this.computeValue_(false);
        endBatch();
      }
    } else {
      reportObserved(this);
      if (shouldCompute(this)) {
        var prevTrackingContext = globalState.trackingContext;
        if (this.keepAlive_ && !prevTrackingContext) {
          globalState.trackingContext = this;
        }
        if (this.trackAndCompute()) {
          propagateChangeConfirmed(this);
        }
        globalState.trackingContext = prevTrackingContext;
      }
    }
    var result = this.value_;
    if (isCaughtException(result)) {
      throw result.cause;
    }
    return result;
  };
  _proto.set = function set(value) {
    if (this.setter_) {
      if (this.isRunningSetter) {
        die(33, this.name_);
      }
      this.isRunningSetter = true;
      try {
        this.setter_.call(this.scope_, value);
      } finally {
        this.isRunningSetter = false;
      }
    } else {
      die(34, this.name_);
    }
  };
  _proto.trackAndCompute = function trackAndCompute() {
    // N.B: unminified as it is used by MST
    var oldValue = this.value_;
    var wasSuspended = /* see #1208 */this.dependenciesState_ === IDerivationState_.NOT_TRACKING_;
    var newValue = this.computeValue_(true);
    var changed = wasSuspended || isCaughtException(oldValue) || isCaughtException(newValue) || !this.equals_(oldValue, newValue);
    if (changed) {
      this.value_ = newValue;
      if (process.env.NODE_ENV !== "production" && isSpyEnabled()) {
        spyReport({
          observableKind: "computed",
          debugObjectName: this.name_,
          object: this.scope_,
          type: "update",
          oldValue: oldValue,
          newValue: newValue
        });
      }
    }
    return changed;
  };
  _proto.computeValue_ = function computeValue_(track) {
    this.isComputing = true;
    // don't allow state changes during computation
    var prev = allowStateChangesStart(false);
    var res;
    if (track) {
      res = trackDerivedFunction(this, this.derivation, this.scope_);
    } else {
      if (globalState.disableErrorBoundaries === true) {
        res = this.derivation.call(this.scope_);
      } else {
        try {
          res = this.derivation.call(this.scope_);
        } catch (e) {
          res = new CaughtException(e);
        }
      }
    }
    allowStateChangesEnd(prev);
    this.isComputing = false;
    return res;
  };
  _proto.suspend_ = function suspend_() {
    if (!this.keepAlive_) {
      clearObserving(this);
      this.value_ = undefined; // don't hold on to computed value!
      if (process.env.NODE_ENV !== "production" && this.isTracing_ !== TraceMode.NONE) {
        console.log("[mobx.trace] Computed value '" + this.name_ + "' was suspended and it will recompute on the next access.");
      }
    }
  };
  _proto.observe_ = function observe_(listener, fireImmediately) {
    var _this = this;
    var firstTime = true;
    var prevValue = undefined;
    return autorun(function () {
      // TODO: why is this in a different place than the spyReport() function? in all other observables it's called in the same place
      var newValue = _this.get();
      if (!firstTime || fireImmediately) {
        var prevU = untrackedStart();
        listener({
          observableKind: "computed",
          debugObjectName: _this.name_,
          type: UPDATE,
          object: _this,
          newValue: newValue,
          oldValue: prevValue
        });
        untrackedEnd(prevU);
      }
      firstTime = false;
      prevValue = newValue;
    });
  };
  _proto.warnAboutUntrackedRead_ = function warnAboutUntrackedRead_() {
    if (!(process.env.NODE_ENV !== "production")) {
      return;
    }
    if (this.isTracing_ !== TraceMode.NONE) {
      console.log("[mobx.trace] Computed value '" + this.name_ + "' is being read outside a reactive context. Doing a full recompute.");
    }
    if (typeof this.requiresReaction_ === "boolean" ? this.requiresReaction_ : globalState.computedRequiresReaction) {
      console.warn("[mobx] Computed value '" + this.name_ + "' is being read outside a reactive context. Doing a full recompute.");
    }
  };
  _proto.toString = function toString() {
    return this.name_ + "[" + this.derivation.toString() + "]";
  };
  _proto.valueOf = function valueOf() {
    return toPrimitive(this.get());
  };
  _proto[Symbol.toPrimitive] = function () {
    return this.valueOf();
  };
  return _createClass(ComputedValue, [{
    key: "isComputing",
    get: function get() {
      return getFlag(this.flags_, ComputedValue.isComputingMask_);
    },
    set: function set(newValue) {
      this.flags_ = setFlag(this.flags_, ComputedValue.isComputingMask_, newValue);
    }
  }, {
    key: "isRunningSetter",
    get: function get() {
      return getFlag(this.flags_, ComputedValue.isRunningSetterMask_);
    },
    set: function set(newValue) {
      this.flags_ = setFlag(this.flags_, ComputedValue.isRunningSetterMask_, newValue);
    }
  }, {
    key: "isBeingObserved",
    get: function get() {
      return getFlag(this.flags_, ComputedValue.isBeingObservedMask_);
    },
    set: function set(newValue) {
      this.flags_ = setFlag(this.flags_, ComputedValue.isBeingObservedMask_, newValue);
    }
  }, {
    key: "isPendingUnobservation",
    get: function get() {
      return getFlag(this.flags_, ComputedValue.isPendingUnobservationMask_);
    },
    set: function set(newValue) {
      this.flags_ = setFlag(this.flags_, ComputedValue.isPendingUnobservationMask_, newValue);
    }
  }, {
    key: "diffValue",
    get: function get() {
      return getFlag(this.flags_, ComputedValue.diffValueMask_) ? 1 : 0;
    },
    set: function set(newValue) {
      this.flags_ = setFlag(this.flags_, ComputedValue.diffValueMask_, newValue === 1 ? true : false);
    }
  }]);
}();
ComputedValue.isComputingMask_ = 1;
ComputedValue.isRunningSetterMask_ = 2;
ComputedValue.isBeingObservedMask_ = 4;
ComputedValue.isPendingUnobservationMask_ = 8;
ComputedValue.diffValueMask_ = 16;
var isComputedValue = /*#__PURE__*/createInstanceofPredicate("ComputedValue", ComputedValue);

var IDerivationState_;
(function (IDerivationState_) {
  // before being run or (outside batch and not being observed)
  // at this point derivation is not holding any data about dependency tree
  IDerivationState_[IDerivationState_["NOT_TRACKING_"] = -1] = "NOT_TRACKING_";
  // no shallow dependency changed since last computation
  // won't recalculate derivation
  // this is what makes mobx fast
  IDerivationState_[IDerivationState_["UP_TO_DATE_"] = 0] = "UP_TO_DATE_";
  // some deep dependency changed, but don't know if shallow dependency changed
  // will require to check first if UP_TO_DATE or POSSIBLY_STALE
  // currently only ComputedValue will propagate POSSIBLY_STALE
  //
  // having this state is second big optimization:
  // don't have to recompute on every dependency change, but only when it's needed
  IDerivationState_[IDerivationState_["POSSIBLY_STALE_"] = 1] = "POSSIBLY_STALE_";
  // A shallow dependency has changed since last computation and the derivation
  // will need to recompute when it's needed next.
  IDerivationState_[IDerivationState_["STALE_"] = 2] = "STALE_";
})(IDerivationState_ || (IDerivationState_ = {}));
var TraceMode;
(function (TraceMode) {
  TraceMode[TraceMode["NONE"] = 0] = "NONE";
  TraceMode[TraceMode["LOG"] = 1] = "LOG";
  TraceMode[TraceMode["BREAK"] = 2] = "BREAK";
})(TraceMode || (TraceMode = {}));
var CaughtException = function CaughtException(cause) {
  this.cause = void 0;
  this.cause = cause;
  // Empty
};
function isCaughtException(e) {
  return e instanceof CaughtException;
}
/**
 * Finds out whether any dependency of the derivation has actually changed.
 * If dependenciesState is 1 then it will recalculate dependencies,
 * if any dependency changed it will propagate it by changing dependenciesState to 2.
 *
 * By iterating over the dependencies in the same order that they were reported and
 * stopping on the first change, all the recalculations are only called for ComputedValues
 * that will be tracked by derivation. That is because we assume that if the first x
 * dependencies of the derivation doesn't change then the derivation should run the same way
 * up until accessing x-th dependency.
 */
function shouldCompute(derivation) {
  switch (derivation.dependenciesState_) {
    case IDerivationState_.UP_TO_DATE_:
      return false;
    case IDerivationState_.NOT_TRACKING_:
    case IDerivationState_.STALE_:
      return true;
    case IDerivationState_.POSSIBLY_STALE_:
      {
        // state propagation can occur outside of action/reactive context #2195
        var prevAllowStateReads = allowStateReadsStart(true);
        var prevUntracked = untrackedStart(); // no need for those computeds to be reported, they will be picked up in trackDerivedFunction.
        var obs = derivation.observing_,
          l = obs.length;
        for (var i = 0; i < l; i++) {
          var obj = obs[i];
          if (isComputedValue(obj)) {
            if (globalState.disableErrorBoundaries) {
              obj.get();
            } else {
              try {
                obj.get();
              } catch (e) {
                // we are not interested in the value *or* exception at this moment, but if there is one, notify all
                untrackedEnd(prevUntracked);
                allowStateReadsEnd(prevAllowStateReads);
                return true;
              }
            }
            // if ComputedValue `obj` actually changed it will be computed and propagated to its observers.
            // and `derivation` is an observer of `obj`
            // invariantShouldCompute(derivation)
            if (derivation.dependenciesState_ === IDerivationState_.STALE_) {
              untrackedEnd(prevUntracked);
              allowStateReadsEnd(prevAllowStateReads);
              return true;
            }
          }
        }
        changeDependenciesStateTo0(derivation);
        untrackedEnd(prevUntracked);
        allowStateReadsEnd(prevAllowStateReads);
        return false;
      }
  }
}
function checkIfStateModificationsAreAllowed(atom) {
  if (!(process.env.NODE_ENV !== "production")) {
    return;
  }
  var hasObservers = atom.observers_.size > 0;
  // Should not be possible to change observed state outside strict mode, except during initialization, see #563
  if (!globalState.allowStateChanges && (hasObservers || globalState.enforceActions === "always")) {
    console.warn("[MobX] " + (globalState.enforceActions ? "Since strict-mode is enabled, changing (observed) observable values without using an action is not allowed. Tried to modify: " : "Side effects like changing state are not allowed at this point. Are you trying to modify state from, for example, a computed value or the render function of a React component? You can wrap side effects in 'runInAction' (or decorate functions with 'action') if needed. Tried to modify: ") + atom.name_);
  }
}
function checkIfStateReadsAreAllowed(observable) {
  if (process.env.NODE_ENV !== "production" && !globalState.allowStateReads && globalState.observableRequiresReaction) {
    console.warn("[mobx] Observable '" + observable.name_ + "' being read outside a reactive context.");
  }
}
/**
 * Executes the provided function `f` and tracks which observables are being accessed.
 * The tracking information is stored on the `derivation` object and the derivation is registered
 * as observer of any of the accessed observables.
 */
function trackDerivedFunction(derivation, f, context) {
  var prevAllowStateReads = allowStateReadsStart(true);
  changeDependenciesStateTo0(derivation);
  // Preallocate array; will be trimmed by bindDependencies.
  derivation.newObserving_ = new Array(
  // Reserve constant space for initial dependencies, dynamic space otherwise.
  // See https://github.com/mobxjs/mobx/pull/3833
  derivation.runId_ === 0 ? 100 : derivation.observing_.length);
  derivation.unboundDepsCount_ = 0;
  derivation.runId_ = ++globalState.runId;
  var prevTracking = globalState.trackingDerivation;
  globalState.trackingDerivation = derivation;
  globalState.inBatch++;
  var result;
  if (globalState.disableErrorBoundaries === true) {
    result = f.call(context);
  } else {
    try {
      result = f.call(context);
    } catch (e) {
      result = new CaughtException(e);
    }
  }
  globalState.inBatch--;
  globalState.trackingDerivation = prevTracking;
  bindDependencies(derivation);
  warnAboutDerivationWithoutDependencies(derivation);
  allowStateReadsEnd(prevAllowStateReads);
  return result;
}
function warnAboutDerivationWithoutDependencies(derivation) {
  if (!(process.env.NODE_ENV !== "production")) {
    return;
  }
  if (derivation.observing_.length !== 0) {
    return;
  }
  if (typeof derivation.requiresObservable_ === "boolean" ? derivation.requiresObservable_ : globalState.reactionRequiresObservable) {
    console.warn("[mobx] Derivation '" + derivation.name_ + "' is created/updated without reading any observable value.");
  }
}
/**
 * diffs newObserving with observing.
 * update observing to be newObserving with unique observables
 * notify observers that become observed/unobserved
 */
function bindDependencies(derivation) {
  // invariant(derivation.dependenciesState !== IDerivationState.NOT_TRACKING, "INTERNAL ERROR bindDependencies expects derivation.dependenciesState !== -1");
  var prevObserving = derivation.observing_;
  var observing = derivation.observing_ = derivation.newObserving_;
  var lowestNewObservingDerivationState = IDerivationState_.UP_TO_DATE_;
  // Go through all new observables and check diffValue: (this list can contain duplicates):
  //   0: first occurrence, change to 1 and keep it
  //   1: extra occurrence, drop it
  var i0 = 0,
    l = derivation.unboundDepsCount_;
  for (var i = 0; i < l; i++) {
    var dep = observing[i];
    if (dep.diffValue === 0) {
      dep.diffValue = 1;
      if (i0 !== i) {
        observing[i0] = dep;
      }
      i0++;
    }
    // Upcast is 'safe' here, because if dep is IObservable, `dependenciesState` will be undefined,
    // not hitting the condition
    if (dep.dependenciesState_ > lowestNewObservingDerivationState) {
      lowestNewObservingDerivationState = dep.dependenciesState_;
    }
  }
  observing.length = i0;
  derivation.newObserving_ = null; // newObserving shouldn't be needed outside tracking (statement moved down to work around FF bug, see #614)
  // Go through all old observables and check diffValue: (it is unique after last bindDependencies)
  //   0: it's not in new observables, unobserve it
  //   1: it keeps being observed, don't want to notify it. change to 0
  l = prevObserving.length;
  while (l--) {
    var _dep = prevObserving[l];
    if (_dep.diffValue === 0) {
      removeObserver(_dep, derivation);
    }
    _dep.diffValue = 0;
  }
  // Go through all new observables and check diffValue: (now it should be unique)
  //   0: it was set to 0 in last loop. don't need to do anything.
  //   1: it wasn't observed, let's observe it. set back to 0
  while (i0--) {
    var _dep2 = observing[i0];
    if (_dep2.diffValue === 1) {
      _dep2.diffValue = 0;
      addObserver(_dep2, derivation);
    }
  }
  // Some new observed derivations may become stale during this derivation computation
  // so they have had no chance to propagate staleness (#916)
  if (lowestNewObservingDerivationState !== IDerivationState_.UP_TO_DATE_) {
    derivation.dependenciesState_ = lowestNewObservingDerivationState;
    derivation.onBecomeStale_();
  }
}
function clearObserving(derivation) {
  // invariant(globalState.inBatch > 0, "INTERNAL ERROR clearObserving should be called only inside batch");
  var obs = derivation.observing_;
  derivation.observing_ = [];
  var i = obs.length;
  while (i--) {
    removeObserver(obs[i], derivation);
  }
  derivation.dependenciesState_ = IDerivationState_.NOT_TRACKING_;
}
function untracked(action) {
  var prev = untrackedStart();
  try {
    return action();
  } finally {
    untrackedEnd(prev);
  }
}
function untrackedStart() {
  var prev = globalState.trackingDerivation;
  globalState.trackingDerivation = null;
  return prev;
}
function untrackedEnd(prev) {
  globalState.trackingDerivation = prev;
}
function allowStateReadsStart(allowStateReads) {
  var prev = globalState.allowStateReads;
  globalState.allowStateReads = allowStateReads;
  return prev;
}
function allowStateReadsEnd(prev) {
  globalState.allowStateReads = prev;
}
/**
 * needed to keep `lowestObserverState` correct. when changing from (2 or 1) to 0
 *
 */
function changeDependenciesStateTo0(derivation) {
  if (derivation.dependenciesState_ === IDerivationState_.UP_TO_DATE_) {
    return;
  }
  derivation.dependenciesState_ = IDerivationState_.UP_TO_DATE_;
  var obs = derivation.observing_;
  var i = obs.length;
  while (i--) {
    obs[i].lowestObserverState_ = IDerivationState_.UP_TO_DATE_;
  }
}
var MobXGlobals = function MobXGlobals() {
  /**
   * MobXGlobals version.
   * MobX compatiblity with other versions loaded in memory as long as this version matches.
   * It indicates that the global state still stores similar information
   *
   * N.B: this version is unrelated to the package version of MobX, and is only the version of the
   * internal state storage of MobX, and can be the same across many different package versions
   */
  this.version = 6;
  /**
   * globally unique token to signal unchanged
   */
  this.UNCHANGED = {};
  /**
   * Currently running derivation
   */
  this.trackingDerivation = null;
  /**
   * Currently running reaction. This determines if we currently have a reactive context.
   * (Tracking derivation is also set for temporal tracking of computed values inside actions,
   * but trackingReaction can only be set by a form of Reaction)
   */
  this.trackingContext = null;
  /**
   * Each time a derivation is tracked, it is assigned a unique run-id
   */
  this.runId = 0;
  /**
   * 'guid' for general purpose. Will be persisted amongst resets.
   */
  this.mobxGuid = 0;
  /**
   * Are we in a batch block? (and how many of them)
   */
  this.inBatch = 0;
  /**
   * Observables that don't have observers anymore, and are about to be
   * suspended, unless somebody else accesses it in the same batch
   *
   * @type {IObservable[]}
   */
  this.pendingUnobservations = [];
  /**
   * List of scheduled, not yet executed, reactions.
   */
  this.pendingReactions = [];
  /**
   * Are we currently processing reactions?
   */
  this.isRunningReactions = false;
  /**
   * Is it allowed to change observables at this point?
   * In general, MobX doesn't allow that when running computations and React.render.
   * To ensure that those functions stay pure.
   */
  this.allowStateChanges = false;
  /**
   * Is it allowed to read observables at this point?
   * Used to hold the state needed for `observableRequiresReaction`
   */
  this.allowStateReads = true;
  /**
   * If strict mode is enabled, state changes are by default not allowed
   */
  this.enforceActions = true;
  /**
   * Spy callbacks
   */
  this.spyListeners = [];
  /**
   * Globally attached error handlers that react specifically to errors in reactions
   */
  this.globalReactionErrorHandlers = [];
  /**
   * Warn if computed values are accessed outside a reactive context
   */
  this.computedRequiresReaction = false;
  /**
   * (Experimental)
   * Warn if you try to create to derivation / reactive context without accessing any observable.
   */
  this.reactionRequiresObservable = false;
  /**
   * (Experimental)
   * Warn if observables are accessed outside a reactive context
   */
  this.observableRequiresReaction = false;
  /*
   * Don't catch and rethrow exceptions. This is useful for inspecting the state of
   * the stack when an exception occurs while debugging.
   */
  this.disableErrorBoundaries = false;
  /*
   * If true, we are already handling an exception in an action. Any errors in reactions should be suppressed, as
   * they are not the cause, see: https://github.com/mobxjs/mobx/issues/1836
   */
  this.suppressReactionErrors = false;
  this.useProxies = true;
  /*
   * print warnings about code that would fail if proxies weren't available
   */
  this.verifyProxies = false;
  /**
   * False forces all object's descriptors to
   * writable: true
   * configurable: true
   */
  this.safeDescriptors = true;
};
var canMergeGlobalState = true;
var globalState = /*#__PURE__*/function () {
  var global = /*#__PURE__*/getGlobal();
  if (global.__mobxInstanceCount > 0 && !global.__mobxGlobals) {
    canMergeGlobalState = false;
  }
  if (global.__mobxGlobals && global.__mobxGlobals.version !== new MobXGlobals().version) {
    canMergeGlobalState = false;
  }
  if (!canMergeGlobalState) {
    // Because this is a IIFE we need to let isolateCalled a chance to change
    // so we run it after the event loop completed at least 1 iteration
    setTimeout(function () {
      {
        die(35);
      }
    }, 1);
    return new MobXGlobals();
  } else if (global.__mobxGlobals) {
    global.__mobxInstanceCount += 1;
    if (!global.__mobxGlobals.UNCHANGED) {
      global.__mobxGlobals.UNCHANGED = {};
    } // make merge backward compatible
    return global.__mobxGlobals;
  } else {
    global.__mobxInstanceCount = 1;
    return global.__mobxGlobals = /*#__PURE__*/new MobXGlobals();
  }
}();
function getGlobalState() {
  return globalState;
}
// function invariantObservers(observable: IObservable) {
//     const list = observable.observers
//     const map = observable.observersIndexes
//     const l = list.length
//     for (let i = 0; i < l; i++) {
//         const id = list[i].__mapid
//         if (i) {
//             invariant(map[id] === i, "INTERNAL ERROR maps derivation.__mapid to index in list") // for performance
//         } else {
//             invariant(!(id in map), "INTERNAL ERROR observer on index 0 shouldn't be held in map.") // for performance
//         }
//     }
//     invariant(
//         list.length === 0 || Object.keys(map).length === list.length - 1,
//         "INTERNAL ERROR there is no junk in map"
//     )
// }
function addObserver(observable, node) {
  // invariant(node.dependenciesState !== -1, "INTERNAL ERROR, can add only dependenciesState !== -1");
  // invariant(observable._observers.indexOf(node) === -1, "INTERNAL ERROR add already added node");
  // invariantObservers(observable);
  observable.observers_.add(node);
  if (observable.lowestObserverState_ > node.dependenciesState_) {
    observable.lowestObserverState_ = node.dependenciesState_;
  }
  // invariantObservers(observable);
  // invariant(observable._observers.indexOf(node) !== -1, "INTERNAL ERROR didn't add node");
}
function removeObserver(observable, node) {
  // invariant(globalState.inBatch > 0, "INTERNAL ERROR, remove should be called only inside batch");
  // invariant(observable._observers.indexOf(node) !== -1, "INTERNAL ERROR remove already removed node");
  // invariantObservers(observable);
  observable.observers_["delete"](node);
  if (observable.observers_.size === 0) {
    // deleting last observer
    queueForUnobservation(observable);
  }
  // invariantObservers(observable);
  // invariant(observable._observers.indexOf(node) === -1, "INTERNAL ERROR remove already removed node2");
}
function queueForUnobservation(observable) {
  if (observable.isPendingUnobservation === false) {
    // invariant(observable._observers.length === 0, "INTERNAL ERROR, should only queue for unobservation unobserved observables");
    observable.isPendingUnobservation = true;
    globalState.pendingUnobservations.push(observable);
  }
}
/**
 * Batch starts a transaction, at least for purposes of memoizing ComputedValues when nothing else does.
 * During a batch `onBecomeUnobserved` will be called at most once per observable.
 * Avoids unnecessary recalculations.
 */
function startBatch() {
  globalState.inBatch++;
}
function endBatch() {
  if (--globalState.inBatch === 0) {
    runReactions();
    // the batch is actually about to finish, all unobserving should happen here.
    var list = globalState.pendingUnobservations;
    for (var i = 0; i < list.length; i++) {
      var observable = list[i];
      observable.isPendingUnobservation = false;
      if (observable.observers_.size === 0) {
        if (observable.isBeingObserved) {
          // if this observable had reactive observers, trigger the hooks
          observable.isBeingObserved = false;
          observable.onBUO();
        }
        if (observable instanceof ComputedValue) {
          // computed values are automatically teared down when the last observer leaves
          // this process happens recursively, this computed might be the last observabe of another, etc..
          observable.suspend_();
        }
      }
    }
    globalState.pendingUnobservations = [];
  }
}
function reportObserved(observable) {
  checkIfStateReadsAreAllowed(observable);
  var derivation = globalState.trackingDerivation;
  if (derivation !== null) {
    /**
     * Simple optimization, give each derivation run an unique id (runId)
     * Check if last time this observable was accessed the same runId is used
     * if this is the case, the relation is already known
     */
    if (derivation.runId_ !== observable.lastAccessedBy_) {
      observable.lastAccessedBy_ = derivation.runId_;
      // Tried storing newObserving, or observing, or both as Set, but performance didn't come close...
      derivation.newObserving_[derivation.unboundDepsCount_++] = observable;
      if (!observable.isBeingObserved && globalState.trackingContext) {
        observable.isBeingObserved = true;
        observable.onBO();
      }
    }
    return observable.isBeingObserved;
  } else if (observable.observers_.size === 0 && globalState.inBatch > 0) {
    queueForUnobservation(observable);
  }
  return false;
}
// function invariantLOS(observable: IObservable, msg: string) {
//     // it's expensive so better not run it in produciton. but temporarily helpful for testing
//     const min = getObservers(observable).reduce((a, b) => Math.min(a, b.dependenciesState), 2)
//     if (min >= observable.lowestObserverState) return // <- the only assumption about `lowestObserverState`
//     throw new Error(
//         "lowestObserverState is wrong for " +
//             msg +
//             " because " +
//             min +
//             " < " +
//             observable.lowestObserverState
//     )
// }
/**
 * NOTE: current propagation mechanism will in case of self reruning autoruns behave unexpectedly
 * It will propagate changes to observers from previous run
 * It's hard or maybe impossible (with reasonable perf) to get it right with current approach
 * Hopefully self reruning autoruns aren't a feature people should depend on
 * Also most basic use cases should be ok
 */
// Called by Atom when its value changes
function propagateChanged(observable) {
  // invariantLOS(observable, "changed start");
  if (observable.lowestObserverState_ === IDerivationState_.STALE_) {
    return;
  }
  observable.lowestObserverState_ = IDerivationState_.STALE_;
  // Ideally we use for..of here, but the downcompiled version is really slow...
  observable.observers_.forEach(function (d) {
    if (d.dependenciesState_ === IDerivationState_.UP_TO_DATE_) {
      if (process.env.NODE_ENV !== "production" && d.isTracing_ !== TraceMode.NONE) {
        logTraceInfo(d, observable);
      }
      d.onBecomeStale_();
    }
    d.dependenciesState_ = IDerivationState_.STALE_;
  });
  // invariantLOS(observable, "changed end");
}
// Called by ComputedValue when it recalculate and its value changed
function propagateChangeConfirmed(observable) {
  // invariantLOS(observable, "confirmed start");
  if (observable.lowestObserverState_ === IDerivationState_.STALE_) {
    return;
  }
  observable.lowestObserverState_ = IDerivationState_.STALE_;
  observable.observers_.forEach(function (d) {
    if (d.dependenciesState_ === IDerivationState_.POSSIBLY_STALE_) {
      d.dependenciesState_ = IDerivationState_.STALE_;
      if (process.env.NODE_ENV !== "production" && d.isTracing_ !== TraceMode.NONE) {
        logTraceInfo(d, observable);
      }
    } else if (d.dependenciesState_ === IDerivationState_.UP_TO_DATE_ // this happens during computing of `d`, just keep lowestObserverState up to date.
    ) {
      observable.lowestObserverState_ = IDerivationState_.UP_TO_DATE_;
    }
  });
  // invariantLOS(observable, "confirmed end");
}
// Used by computed when its dependency changed, but we don't wan't to immediately recompute.
function propagateMaybeChanged(observable) {
  // invariantLOS(observable, "maybe start");
  if (observable.lowestObserverState_ !== IDerivationState_.UP_TO_DATE_) {
    return;
  }
  observable.lowestObserverState_ = IDerivationState_.POSSIBLY_STALE_;
  observable.observers_.forEach(function (d) {
    if (d.dependenciesState_ === IDerivationState_.UP_TO_DATE_) {
      d.dependenciesState_ = IDerivationState_.POSSIBLY_STALE_;
      d.onBecomeStale_();
    }
  });
  // invariantLOS(observable, "maybe end");
}
function logTraceInfo(derivation, observable) {
  console.log("[mobx.trace] '" + derivation.name_ + "' is invalidated due to a change in: '" + observable.name_ + "'");
  if (derivation.isTracing_ === TraceMode.BREAK) {
    var lines = [];
    printDepTree(getDependencyTree(derivation), lines, 1);
    // prettier-ignore
    new Function("debugger;\n/*\nTracing '" + derivation.name_ + "'\n\nYou are entering this break point because derivation '" + derivation.name_ + "' is being traced and '" + observable.name_ + "' is now forcing it to update.\nJust follow the stacktrace you should now see in the devtools to see precisely what piece of your code is causing this update\nThe stackframe you are looking for is at least ~6-8 stack-frames up.\n\n" + (derivation instanceof ComputedValue ? derivation.derivation.toString().replace(/[*]\//g, "/") : "") + "\n\nThe dependencies for this derivation are:\n\n" + lines.join("\n") + "\n*/\n    ")();
  }
}
function printDepTree(tree, lines, depth) {
  if (lines.length >= 1000) {
    lines.push("(and many more)");
    return;
  }
  lines.push("" + "\t".repeat(depth - 1) + tree.name);
  if (tree.dependencies) {
    tree.dependencies.forEach(function (child) {
      return printDepTree(child, lines, depth + 1);
    });
  }
}

var Reaction = /*#__PURE__*/function () {
  function Reaction(name_, onInvalidate_, errorHandler_, requiresObservable_) {
    if (name_ === void 0) {
      name_ = process.env.NODE_ENV !== "production" ? "Reaction@" + getNextId() : "Reaction";
    }
    this.name_ = void 0;
    this.onInvalidate_ = void 0;
    this.errorHandler_ = void 0;
    this.requiresObservable_ = void 0;
    this.observing_ = [];
    // nodes we are looking at. Our value depends on these nodes
    this.newObserving_ = [];
    this.dependenciesState_ = IDerivationState_.NOT_TRACKING_;
    this.runId_ = 0;
    this.unboundDepsCount_ = 0;
    this.flags_ = 0;
    this.isTracing_ = TraceMode.NONE;
    this.name_ = name_;
    this.onInvalidate_ = onInvalidate_;
    this.errorHandler_ = errorHandler_;
    this.requiresObservable_ = requiresObservable_;
  }
  var _proto = Reaction.prototype;
  _proto.onBecomeStale_ = function onBecomeStale_() {
    this.schedule_();
  };
  _proto.schedule_ = function schedule_() {
    if (!this.isScheduled) {
      this.isScheduled = true;
      globalState.pendingReactions.push(this);
      runReactions();
    }
  }
  /**
   * internal, use schedule() if you intend to kick off a reaction
   */;
  _proto.runReaction_ = function runReaction_() {
    if (!this.isDisposed) {
      startBatch();
      this.isScheduled = false;
      var prev = globalState.trackingContext;
      globalState.trackingContext = this;
      if (shouldCompute(this)) {
        this.isTrackPending = true;
        try {
          this.onInvalidate_();
          if (process.env.NODE_ENV !== "production" && this.isTrackPending && isSpyEnabled()) {
            // onInvalidate didn't trigger track right away..
            spyReport({
              name: this.name_,
              type: "scheduled-reaction"
            });
          }
        } catch (e) {
          this.reportExceptionInDerivation_(e);
        }
      }
      globalState.trackingContext = prev;
      endBatch();
    }
  };
  _proto.track = function track(fn) {
    if (this.isDisposed) {
      return;
      // console.warn("Reaction already disposed") // Note: Not a warning / error in mobx 4 either
    }
    startBatch();
    var notify = isSpyEnabled();
    var startTime;
    if (process.env.NODE_ENV !== "production" && notify) {
      startTime = Date.now();
      spyReportStart({
        name: this.name_,
        type: "reaction"
      });
    }
    this.isRunning = true;
    var prevReaction = globalState.trackingContext; // reactions could create reactions...
    globalState.trackingContext = this;
    var result = trackDerivedFunction(this, fn, undefined);
    globalState.trackingContext = prevReaction;
    this.isRunning = false;
    this.isTrackPending = false;
    if (this.isDisposed) {
      // disposed during last run. Clean up everything that was bound after the dispose call.
      clearObserving(this);
    }
    if (isCaughtException(result)) {
      this.reportExceptionInDerivation_(result.cause);
    }
    if (process.env.NODE_ENV !== "production" && notify) {
      spyReportEnd({
        time: Date.now() - startTime
      });
    }
    endBatch();
  };
  _proto.reportExceptionInDerivation_ = function reportExceptionInDerivation_(error) {
    var _this = this;
    if (this.errorHandler_) {
      this.errorHandler_(error, this);
      return;
    }
    if (globalState.disableErrorBoundaries) {
      throw error;
    }
    var message = process.env.NODE_ENV !== "production" ? "[mobx] Encountered an uncaught exception that was thrown by a reaction or observer component, in: '" + this + "'" : "[mobx] uncaught error in '" + this + "'";
    if (!globalState.suppressReactionErrors) {
      console.error(message, error);
      /** If debugging brought you here, please, read the above message :-). Tnx! */
    } else if (process.env.NODE_ENV !== "production") {
      console.warn("[mobx] (error in reaction '" + this.name_ + "' suppressed, fix error of causing action below)");
    } // prettier-ignore
    if (process.env.NODE_ENV !== "production" && isSpyEnabled()) {
      spyReport({
        type: "error",
        name: this.name_,
        message: message,
        error: "" + error
      });
    }
    globalState.globalReactionErrorHandlers.forEach(function (f) {
      return f(error, _this);
    });
  };
  _proto.dispose = function dispose() {
    if (!this.isDisposed) {
      this.isDisposed = true;
      if (!this.isRunning) {
        // if disposed while running, clean up later. Maybe not optimal, but rare case
        startBatch();
        clearObserving(this);
        endBatch();
      }
    }
  };
  _proto.getDisposer_ = function getDisposer_(abortSignal) {
    var _this2 = this;
    var dispose = function dispose() {
      _this2.dispose();
      abortSignal == null || abortSignal.removeEventListener == null || abortSignal.removeEventListener("abort", dispose);
    };
    abortSignal == null || abortSignal.addEventListener == null || abortSignal.addEventListener("abort", dispose);
    dispose[$mobx] = this;
    return dispose;
  };
  _proto.toString = function toString() {
    return "Reaction[" + this.name_ + "]";
  };
  _proto.trace = function trace$1(enterBreakPoint) {
    if (enterBreakPoint === void 0) {
      enterBreakPoint = false;
    }
    trace(this, enterBreakPoint);
  };
  return _createClass(Reaction, [{
    key: "isDisposed",
    get: function get() {
      return getFlag(this.flags_, Reaction.isDisposedMask_);
    },
    set: function set(newValue) {
      this.flags_ = setFlag(this.flags_, Reaction.isDisposedMask_, newValue);
    }
  }, {
    key: "isScheduled",
    get: function get() {
      return getFlag(this.flags_, Reaction.isScheduledMask_);
    },
    set: function set(newValue) {
      this.flags_ = setFlag(this.flags_, Reaction.isScheduledMask_, newValue);
    }
  }, {
    key: "isTrackPending",
    get: function get() {
      return getFlag(this.flags_, Reaction.isTrackPendingMask_);
    },
    set: function set(newValue) {
      this.flags_ = setFlag(this.flags_, Reaction.isTrackPendingMask_, newValue);
    }
  }, {
    key: "isRunning",
    get: function get() {
      return getFlag(this.flags_, Reaction.isRunningMask_);
    },
    set: function set(newValue) {
      this.flags_ = setFlag(this.flags_, Reaction.isRunningMask_, newValue);
    }
  }, {
    key: "diffValue",
    get: function get() {
      return getFlag(this.flags_, Reaction.diffValueMask_) ? 1 : 0;
    },
    set: function set(newValue) {
      this.flags_ = setFlag(this.flags_, Reaction.diffValueMask_, newValue === 1 ? true : false);
    }
  }]);
}();
Reaction.isDisposedMask_ = 1;
Reaction.isScheduledMask_ = 2;
Reaction.isTrackPendingMask_ = 4;
Reaction.isRunningMask_ = 8;
Reaction.diffValueMask_ = 16;
/**
 * Magic number alert!
 * Defines within how many times a reaction is allowed to re-trigger itself
 * until it is assumed that this is gonna be a never ending loop...
 */
var MAX_REACTION_ITERATIONS = 100;
var reactionScheduler = function reactionScheduler(f) {
  return f();
};
function runReactions() {
  // Trampolining, if runReactions are already running, new reactions will be picked up
  if (globalState.inBatch > 0 || globalState.isRunningReactions) {
    return;
  }
  reactionScheduler(runReactionsHelper);
}
function runReactionsHelper() {
  globalState.isRunningReactions = true;
  var allReactions = globalState.pendingReactions;
  var iterations = 0;
  // While running reactions, new reactions might be triggered.
  // Hence we work with two variables and check whether
  // we converge to no remaining reactions after a while.
  while (allReactions.length > 0) {
    if (++iterations === MAX_REACTION_ITERATIONS) {
      console.error(process.env.NODE_ENV !== "production" ? "Reaction doesn't converge to a stable state after " + MAX_REACTION_ITERATIONS + " iterations." + (" Probably there is a cycle in the reactive function: " + allReactions[0]) : "[mobx] cycle in reaction: " + allReactions[0]);
      allReactions.splice(0); // clear reactions
    }
    var remainingReactions = allReactions.splice(0);
    for (var i = 0, l = remainingReactions.length; i < l; i++) {
      remainingReactions[i].runReaction_();
    }
  }
  globalState.isRunningReactions = false;
}
var isReaction = /*#__PURE__*/createInstanceofPredicate("Reaction", Reaction);

function isSpyEnabled() {
  return process.env.NODE_ENV !== "production" && !!globalState.spyListeners.length;
}
function spyReport(event) {
  if (!(process.env.NODE_ENV !== "production")) {
    return;
  } // dead code elimination can do the rest
  if (!globalState.spyListeners.length) {
    return;
  }
  var listeners = globalState.spyListeners;
  for (var i = 0, l = listeners.length; i < l; i++) {
    listeners[i](event);
  }
}
function spyReportStart(event) {
  if (!(process.env.NODE_ENV !== "production")) {
    return;
  }
  var change = _extends({}, event, {
    spyReportStart: true
  });
  spyReport(change);
}
var END_EVENT = {
  type: "report-end",
  spyReportEnd: true
};
function spyReportEnd(change) {
  if (!(process.env.NODE_ENV !== "production")) {
    return;
  }
  if (change) {
    spyReport(_extends({}, change, {
      type: "report-end",
      spyReportEnd: true
    }));
  } else {
    spyReport(END_EVENT);
  }
}
function spy(listener) {
  if (!(process.env.NODE_ENV !== "production")) {
    console.warn("[mobx.spy] Is a no-op in production builds");
    return function () {};
  } else {
    globalState.spyListeners.push(listener);
    return once(function () {
      globalState.spyListeners = globalState.spyListeners.filter(function (l) {
        return l !== listener;
      });
    });
  }
}

var ACTION = "action";
var ACTION_BOUND = "action.bound";
var AUTOACTION = "autoAction";
var AUTOACTION_BOUND = "autoAction.bound";
var DEFAULT_ACTION_NAME = "<unnamed action>";
var actionAnnotation = /*#__PURE__*/createActionAnnotation(ACTION);
var actionBoundAnnotation = /*#__PURE__*/createActionAnnotation(ACTION_BOUND, {
  bound: true
});
var autoActionAnnotation = /*#__PURE__*/createActionAnnotation(AUTOACTION, {
  autoAction: true
});
var autoActionBoundAnnotation = /*#__PURE__*/createActionAnnotation(AUTOACTION_BOUND, {
  autoAction: true,
  bound: true
});
function createActionFactory(autoAction) {
  var res = function action(arg1, arg2) {
    // action(fn() {})
    if (isFunction(arg1)) {
      return createAction(arg1.name || DEFAULT_ACTION_NAME, arg1, autoAction);
    }
    // action("name", fn() {})
    if (isFunction(arg2)) {
      return createAction(arg1, arg2, autoAction);
    }
    // @action (2022.3 Decorators)
    if (is20223Decorator(arg2)) {
      return (autoAction ? autoActionAnnotation : actionAnnotation).decorate_20223_(arg1, arg2);
    }
    // @action
    if (isStringish(arg2)) {
      return storeAnnotation(arg1, arg2, autoAction ? autoActionAnnotation : actionAnnotation);
    }
    // action("name") & @action("name")
    if (isStringish(arg1)) {
      return createDecoratorAnnotation(createActionAnnotation(autoAction ? AUTOACTION : ACTION, {
        name: arg1,
        autoAction: autoAction
      }));
    }
    if (process.env.NODE_ENV !== "production") {
      die("Invalid arguments for `action`");
    }
  };
  return res;
}
var action = /*#__PURE__*/createActionFactory(false);
Object.assign(action, actionAnnotation);
var autoAction = /*#__PURE__*/createActionFactory(true);
Object.assign(autoAction, autoActionAnnotation);
action.bound = /*#__PURE__*/createDecoratorAnnotation(actionBoundAnnotation);
autoAction.bound = /*#__PURE__*/createDecoratorAnnotation(autoActionBoundAnnotation);
function runInAction(fn) {
  return executeAction(fn.name || DEFAULT_ACTION_NAME, false, fn, this, undefined);
}
function isAction(thing) {
  return isFunction(thing) && thing.isMobxAction === true;
}

/**
 * Creates a named reactive view and keeps it alive, so that the view is always
 * updated if one of the dependencies changes, even when the view is not further used by something else.
 * @param view The reactive view
 * @returns disposer function, which can be used to stop the view from being updated in the future.
 */
function autorun(view, opts) {
  var _opts$name, _opts, _opts2, _opts3;
  if (opts === void 0) {
    opts = EMPTY_OBJECT$1;
  }
  if (process.env.NODE_ENV !== "production") {
    if (!isFunction(view)) {
      die("Autorun expects a function as first argument");
    }
    if (isAction(view)) {
      die("Autorun does not accept actions since actions are untrackable");
    }
  }
  var name = (_opts$name = (_opts = opts) == null ? void 0 : _opts.name) != null ? _opts$name : process.env.NODE_ENV !== "production" ? view.name || "Autorun@" + getNextId() : "Autorun";
  var runSync = !opts.scheduler && !opts.delay;
  var reaction;
  if (runSync) {
    // normal autorun
    reaction = new Reaction(name, function () {
      this.track(reactionRunner);
    }, opts.onError, opts.requiresObservable);
  } else {
    var scheduler = createSchedulerFromOptions(opts);
    // debounced autorun
    var isScheduled = false;
    reaction = new Reaction(name, function () {
      if (!isScheduled) {
        isScheduled = true;
        scheduler(function () {
          isScheduled = false;
          if (!reaction.isDisposed) {
            reaction.track(reactionRunner);
          }
        });
      }
    }, opts.onError, opts.requiresObservable);
  }
  function reactionRunner() {
    view(reaction);
  }
  if (!((_opts2 = opts) != null && (_opts2 = _opts2.signal) != null && _opts2.aborted)) {
    reaction.schedule_();
  }
  return reaction.getDisposer_((_opts3 = opts) == null ? void 0 : _opts3.signal);
}
var run = function run(f) {
  return f();
};
function createSchedulerFromOptions(opts) {
  return opts.scheduler ? opts.scheduler : opts.delay ? function (f) {
    return setTimeout(f, opts.delay);
  } : run;
}
function reaction(expression, effect, opts) {
  var _opts$name2, _opts4, _opts5;
  if (opts === void 0) {
    opts = EMPTY_OBJECT$1;
  }
  if (process.env.NODE_ENV !== "production") {
    if (!isFunction(expression) || !isFunction(effect)) {
      die("First and second argument to reaction should be functions");
    }
    if (!isPlainObject$1(opts)) {
      die("Third argument of reactions should be an object");
    }
  }
  var name = (_opts$name2 = opts.name) != null ? _opts$name2 : process.env.NODE_ENV !== "production" ? "Reaction@" + getNextId() : "Reaction";
  var effectAction = action(name, opts.onError ? wrapErrorHandler(opts.onError, effect) : effect);
  var runSync = !opts.scheduler && !opts.delay;
  var scheduler = createSchedulerFromOptions(opts);
  var firstTime = true;
  var isScheduled = false;
  var value;
  var equals = opts.compareStructural ? comparer.structural : opts.equals || comparer["default"];
  var r = new Reaction(name, function () {
    if (firstTime || runSync) {
      reactionRunner();
    } else if (!isScheduled) {
      isScheduled = true;
      scheduler(reactionRunner);
    }
  }, opts.onError, opts.requiresObservable);
  function reactionRunner() {
    isScheduled = false;
    if (r.isDisposed) {
      return;
    }
    var changed = false;
    var oldValue = value;
    r.track(function () {
      var nextValue = allowStateChanges(false, function () {
        return expression(r);
      });
      changed = firstTime || !equals(value, nextValue);
      value = nextValue;
    });
    if (firstTime && opts.fireImmediately) {
      effectAction(value, oldValue, r);
    } else if (!firstTime && changed) {
      effectAction(value, oldValue, r);
    }
    firstTime = false;
  }
  if (!((_opts4 = opts) != null && (_opts4 = _opts4.signal) != null && _opts4.aborted)) {
    r.schedule_();
  }
  return r.getDisposer_((_opts5 = opts) == null ? void 0 : _opts5.signal);
}
function wrapErrorHandler(errorHandler, baseFn) {
  return function () {
    try {
      return baseFn.apply(this, arguments);
    } catch (e) {
      errorHandler.call(this, e);
    }
  };
}

var ON_BECOME_OBSERVED = "onBO";
var ON_BECOME_UNOBSERVED = "onBUO";
function onBecomeObserved(thing, arg2, arg3) {
  return interceptHook(ON_BECOME_OBSERVED, thing, arg2, arg3);
}
function onBecomeUnobserved(thing, arg2, arg3) {
  return interceptHook(ON_BECOME_UNOBSERVED, thing, arg2, arg3);
}
function interceptHook(hook, thing, arg2, arg3) {
  var atom = getAtom(thing);
  var cb = isFunction(arg3) ? arg3 : arg2;
  var listenersKey = hook + "L";
  if (atom[listenersKey]) {
    atom[listenersKey].add(cb);
  } else {
    atom[listenersKey] = new Set([cb]);
  }
  return function () {
    var hookListeners = atom[listenersKey];
    if (hookListeners) {
      hookListeners["delete"](cb);
      if (hookListeners.size === 0) {
        delete atom[listenersKey];
      }
    }
  };
}

function extendObservable(target, properties, annotations, options) {
  if (process.env.NODE_ENV !== "production") {
    if (arguments.length > 4) {
      die("'extendObservable' expected 2-4 arguments");
    }
    if (typeof target !== "object") {
      die("'extendObservable' expects an object as first argument");
    }
    if (isObservableMap(target)) {
      die("'extendObservable' should not be used on maps, use map.merge instead");
    }
    if (!isPlainObject$1(properties)) {
      die("'extendObservable' only accepts plain objects as second argument");
    }
    if (isObservable(properties) || isObservable(annotations)) {
      die("Extending an object with another observable (object) is not supported");
    }
  }
  // Pull descriptors first, so we don't have to deal with props added by administration ($mobx)
  var descriptors = getOwnPropertyDescriptors(properties);
  initObservable(function () {
    var adm = asObservableObject(target, options)[$mobx];
    ownKeys(descriptors).forEach(function (key) {
      adm.extend_(key, descriptors[key],
      // must pass "undefined" for { key: undefined }
      !annotations ? true : key in annotations ? annotations[key] : true);
    });
  });
  return target;
}

function getDependencyTree(thing, property) {
  return nodeToDependencyTree(getAtom(thing, property));
}
function nodeToDependencyTree(node) {
  var result = {
    name: node.name_
  };
  if (node.observing_ && node.observing_.length > 0) {
    result.dependencies = unique(node.observing_).map(nodeToDependencyTree);
  }
  return result;
}
function unique(list) {
  return Array.from(new Set(list));
}

var generatorId = 0;
function FlowCancellationError() {
  this.message = "FLOW_CANCELLED";
}
FlowCancellationError.prototype = /*#__PURE__*/Object.create(Error.prototype);
var flowAnnotation = /*#__PURE__*/createFlowAnnotation("flow");
var flowBoundAnnotation = /*#__PURE__*/createFlowAnnotation("flow.bound", {
  bound: true
});
var flow = /*#__PURE__*/Object.assign(function flow(arg1, arg2) {
  // @flow (2022.3 Decorators)
  if (is20223Decorator(arg2)) {
    return flowAnnotation.decorate_20223_(arg1, arg2);
  }
  // @flow
  if (isStringish(arg2)) {
    return storeAnnotation(arg1, arg2, flowAnnotation);
  }
  // flow(fn)
  if (process.env.NODE_ENV !== "production" && arguments.length !== 1) {
    die("Flow expects single argument with generator function");
  }
  var generator = arg1;
  var name = generator.name || "<unnamed flow>";
  // Implementation based on https://github.com/tj/co/blob/master/index.js
  var res = function res() {
    var ctx = this;
    var args = arguments;
    var runId = ++generatorId;
    var gen = action(name + " - runid: " + runId + " - init", generator).apply(ctx, args);
    var rejector;
    var pendingPromise = undefined;
    var promise = new Promise(function (resolve, reject) {
      var stepId = 0;
      rejector = reject;
      function onFulfilled(res) {
        pendingPromise = undefined;
        var ret;
        try {
          ret = action(name + " - runid: " + runId + " - yield " + stepId++, gen.next).call(gen, res);
        } catch (e) {
          return reject(e);
        }
        next(ret);
      }
      function onRejected(err) {
        pendingPromise = undefined;
        var ret;
        try {
          ret = action(name + " - runid: " + runId + " - yield " + stepId++, gen["throw"]).call(gen, err);
        } catch (e) {
          return reject(e);
        }
        next(ret);
      }
      function next(ret) {
        if (isFunction(ret == null ? void 0 : ret.then)) {
          // an async iterator
          ret.then(next, reject);
          return;
        }
        if (ret.done) {
          return resolve(ret.value);
        }
        pendingPromise = Promise.resolve(ret.value);
        return pendingPromise.then(onFulfilled, onRejected);
      }
      onFulfilled(undefined); // kick off the process
    });
    promise.cancel = action(name + " - runid: " + runId + " - cancel", function () {
      try {
        if (pendingPromise) {
          cancelPromise(pendingPromise);
        }
        // Finally block can return (or yield) stuff..
        var _res = gen["return"](undefined);
        // eat anything that promise would do, it's cancelled!
        var yieldedPromise = Promise.resolve(_res.value);
        yieldedPromise.then(noop, noop);
        cancelPromise(yieldedPromise); // maybe it can be cancelled :)
        // reject our original promise
        rejector(new FlowCancellationError());
      } catch (e) {
        rejector(e); // there could be a throwing finally block
      }
    });
    return promise;
  };
  res.isMobXFlow = true;
  return res;
}, flowAnnotation);
flow.bound = /*#__PURE__*/createDecoratorAnnotation(flowBoundAnnotation);
function cancelPromise(promise) {
  if (isFunction(promise.cancel)) {
    promise.cancel();
  }
}
function isFlow(fn) {
  return (fn == null ? void 0 : fn.isMobXFlow) === true;
}

function interceptReads(thing, propOrHandler, handler) {
  var target;
  if (isObservableMap(thing) || isObservableArray(thing) || isObservableValue(thing)) {
    target = getAdministration(thing);
  } else if (isObservableObject(thing)) {
    if (process.env.NODE_ENV !== "production" && !isStringish(propOrHandler)) {
      return die("InterceptReads can only be used with a specific property, not with an object in general");
    }
    target = getAdministration(thing, propOrHandler);
  } else if (process.env.NODE_ENV !== "production") {
    return die("Expected observable map, object or array as first array");
  }
  if (process.env.NODE_ENV !== "production" && target.dehancer !== undefined) {
    return die("An intercept reader was already established");
  }
  target.dehancer = typeof propOrHandler === "function" ? propOrHandler : handler;
  return function () {
    target.dehancer = undefined;
  };
}

function intercept(thing, propOrHandler, handler) {
  if (isFunction(handler)) {
    return interceptProperty(thing, propOrHandler, handler);
  } else {
    return interceptInterceptable(thing, propOrHandler);
  }
}
function interceptInterceptable(thing, handler) {
  return getAdministration(thing).intercept_(handler);
}
function interceptProperty(thing, property, handler) {
  return getAdministration(thing, property).intercept_(handler);
}

function _isObservable(value, property) {
  if (!value) {
    return false;
  }
  // For first check, see #701
  return isObservableObject(value) || !!value[$mobx] || isAtom(value) || isReaction(value) || isComputedValue(value);
}
function isObservable(value) {
  if (process.env.NODE_ENV !== "production" && arguments.length !== 1) {
    die("isObservable expects only 1 argument. Use isObservableProp to inspect the observability of a property");
  }
  return _isObservable(value);
}

function keys(obj) {
  if (isObservableObject(obj)) {
    return obj[$mobx].keys_();
  }
  if (isObservableMap(obj) || isObservableSet(obj)) {
    return Array.from(obj.keys());
  }
  if (isObservableArray(obj)) {
    return obj.map(function (_, index) {
      return index;
    });
  }
  die(5);
}
function values(obj) {
  if (isObservableObject(obj)) {
    return keys(obj).map(function (key) {
      return obj[key];
    });
  }
  if (isObservableMap(obj)) {
    return keys(obj).map(function (key) {
      return obj.get(key);
    });
  }
  if (isObservableSet(obj)) {
    return Array.from(obj.values());
  }
  if (isObservableArray(obj)) {
    return obj.slice();
  }
  die(6);
}
function entries(obj) {
  if (isObservableObject(obj)) {
    return keys(obj).map(function (key) {
      return [key, obj[key]];
    });
  }
  if (isObservableMap(obj)) {
    return keys(obj).map(function (key) {
      return [key, obj.get(key)];
    });
  }
  if (isObservableSet(obj)) {
    return Array.from(obj.entries());
  }
  if (isObservableArray(obj)) {
    return obj.map(function (key, index) {
      return [index, key];
    });
  }
  die(7);
}
function set(obj, key, value) {
  if (arguments.length === 2 && !isObservableSet(obj)) {
    startBatch();
    var _values = key;
    try {
      for (var _key in _values) {
        set(obj, _key, _values[_key]);
      }
    } finally {
      endBatch();
    }
    return;
  }
  if (isObservableObject(obj)) {
    obj[$mobx].set_(key, value);
  } else if (isObservableMap(obj)) {
    obj.set(key, value);
  } else if (isObservableSet(obj)) {
    obj.add(key);
  } else if (isObservableArray(obj)) {
    if (typeof key !== "number") {
      key = parseInt(key, 10);
    }
    if (key < 0) {
      die("Invalid index: '" + key + "'");
    }
    startBatch();
    if (key >= obj.length) {
      obj.length = key + 1;
    }
    obj[key] = value;
    endBatch();
  } else {
    die(8);
  }
}
function apiDefineProperty(obj, key, descriptor) {
  if (isObservableObject(obj)) {
    return obj[$mobx].defineProperty_(key, descriptor);
  }
  die(39);
}

function observe(thing, propOrCb, cbOrFire, fireImmediately) {
  if (isFunction(cbOrFire)) {
    return observeObservableProperty(thing, propOrCb, cbOrFire, fireImmediately);
  } else {
    return observeObservable(thing, propOrCb, cbOrFire);
  }
}
function observeObservable(thing, listener, fireImmediately) {
  return getAdministration(thing).observe_(listener, fireImmediately);
}
function observeObservableProperty(thing, property, listener, fireImmediately) {
  return getAdministration(thing, property).observe_(listener, fireImmediately);
}

function trace() {
  if (!(process.env.NODE_ENV !== "production")) {
    return;
  }
  var enterBreakPoint = false;
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  if (typeof args[args.length - 1] === "boolean") {
    enterBreakPoint = args.pop();
  }
  var derivation = getAtomFromArgs(args);
  if (!derivation) {
    return die("'trace(break?)' can only be used inside a tracked computed value or a Reaction. Consider passing in the computed value or reaction explicitly");
  }
  if (derivation.isTracing_ === TraceMode.NONE) {
    console.log("[mobx.trace] '" + derivation.name_ + "' tracing enabled");
  }
  derivation.isTracing_ = enterBreakPoint ? TraceMode.BREAK : TraceMode.LOG;
}
function getAtomFromArgs(args) {
  switch (args.length) {
    case 0:
      return globalState.trackingDerivation;
    case 1:
      return getAtom(args[0]);
    case 2:
      return getAtom(args[0], args[1]);
  }
}

/**
 * During a transaction no views are updated until the end of the transaction.
 * The transaction will be run synchronously nonetheless.
 *
 * @param action a function that updates some reactive state
 * @returns any value that was returned by the 'action' parameter.
 */
function transaction(action, thisArg) {
  if (thisArg === void 0) {
    thisArg = undefined;
  }
  startBatch();
  try {
    return action.apply(thisArg);
  } finally {
    endBatch();
  }
}

function when(predicate, arg1, arg2) {
  if (arguments.length === 1 || arg1 && typeof arg1 === "object") {
    return whenPromise(predicate, arg1);
  }
  return _when(predicate, arg1, {});
}
function _when(predicate, effect, opts) {
  var timeoutHandle;
  if (typeof opts.timeout === "number") {
    var error = new Error("WHEN_TIMEOUT");
    timeoutHandle = setTimeout(function () {
      if (!disposer[$mobx].isDisposed) {
        disposer();
        if (opts.onError) {
          opts.onError(error);
        } else {
          throw error;
        }
      }
    }, opts.timeout);
  }
  opts.name = process.env.NODE_ENV !== "production" ? opts.name || "When@" + getNextId() : "When";
  var effectAction = createAction(process.env.NODE_ENV !== "production" ? opts.name + "-effect" : "When-effect", effect);
  // eslint-disable-next-line
  var disposer = autorun(function (r) {
    // predicate should not change state
    var cond = allowStateChanges(false, predicate);
    if (cond) {
      r.dispose();
      if (timeoutHandle) {
        clearTimeout(timeoutHandle);
      }
      effectAction();
    }
  }, opts);
  return disposer;
}
function whenPromise(predicate, opts) {
  var _opts$signal;
  if (process.env.NODE_ENV !== "production" && opts && opts.onError) {
    return die("the options 'onError' and 'promise' cannot be combined");
  }
  if (opts != null && (_opts$signal = opts.signal) != null && _opts$signal.aborted) {
    return Object.assign(Promise.reject(new Error("WHEN_ABORTED")), {
      cancel: function cancel() {
        return null;
      }
    });
  }
  var cancel;
  var abort;
  var res = new Promise(function (resolve, reject) {
    var _opts$signal2;
    var disposer = _when(predicate, resolve, _extends({}, opts, {
      onError: reject
    }));
    cancel = function cancel() {
      disposer();
      reject(new Error("WHEN_CANCELLED"));
    };
    abort = function abort() {
      disposer();
      reject(new Error("WHEN_ABORTED"));
    };
    opts == null || (_opts$signal2 = opts.signal) == null || _opts$signal2.addEventListener == null || _opts$signal2.addEventListener("abort", abort);
  })["finally"](function () {
    var _opts$signal3;
    return opts == null || (_opts$signal3 = opts.signal) == null || _opts$signal3.removeEventListener == null ? void 0 : _opts$signal3.removeEventListener("abort", abort);
  });
  res.cancel = cancel;
  return res;
}

function getAdm(target) {
  return target[$mobx];
}
// Optimization: we don't need the intermediate objects and could have a completely custom administration for DynamicObjects,
// and skip either the internal values map, or the base object with its property descriptors!
var objectProxyTraps = {
  has: function has(target, name) {
    if (process.env.NODE_ENV !== "production" && globalState.trackingDerivation) {
      warnAboutProxyRequirement("detect new properties using the 'in' operator. Use 'has' from 'mobx' instead.");
    }
    return getAdm(target).has_(name);
  },
  get: function get(target, name) {
    return getAdm(target).get_(name);
  },
  set: function set(target, name, value) {
    var _getAdm$set_;
    if (!isStringish(name)) {
      return false;
    }
    if (process.env.NODE_ENV !== "production" && !getAdm(target).values_.has(name)) {
      warnAboutProxyRequirement("add a new observable property through direct assignment. Use 'set' from 'mobx' instead.");
    }
    // null (intercepted) -> true (success)
    return (_getAdm$set_ = getAdm(target).set_(name, value, true)) != null ? _getAdm$set_ : true;
  },
  deleteProperty: function deleteProperty(target, name) {
    var _getAdm$delete_;
    if (process.env.NODE_ENV !== "production") {
      warnAboutProxyRequirement("delete properties from an observable object. Use 'remove' from 'mobx' instead.");
    }
    if (!isStringish(name)) {
      return false;
    }
    // null (intercepted) -> true (success)
    return (_getAdm$delete_ = getAdm(target).delete_(name, true)) != null ? _getAdm$delete_ : true;
  },
  defineProperty: function defineProperty(target, name, descriptor) {
    var _getAdm$definePropert;
    if (process.env.NODE_ENV !== "production") {
      warnAboutProxyRequirement("define property on an observable object. Use 'defineProperty' from 'mobx' instead.");
    }
    // null (intercepted) -> true (success)
    return (_getAdm$definePropert = getAdm(target).defineProperty_(name, descriptor)) != null ? _getAdm$definePropert : true;
  },
  ownKeys: function ownKeys(target) {
    if (process.env.NODE_ENV !== "production" && globalState.trackingDerivation) {
      warnAboutProxyRequirement("iterate keys to detect added / removed properties. Use 'keys' from 'mobx' instead.");
    }
    return getAdm(target).ownKeys_();
  },
  preventExtensions: function preventExtensions(target) {
    die(13);
  }
};
function asDynamicObservableObject(target, options) {
  var _target$$mobx, _target$$mobx$proxy_;
  assertProxies();
  target = asObservableObject(target, options);
  return (_target$$mobx$proxy_ = (_target$$mobx = target[$mobx]).proxy_) != null ? _target$$mobx$proxy_ : _target$$mobx.proxy_ = new Proxy(target, objectProxyTraps);
}

function hasInterceptors(interceptable) {
  return interceptable.interceptors_ !== undefined && interceptable.interceptors_.length > 0;
}
function registerInterceptor(interceptable, handler) {
  var interceptors = interceptable.interceptors_ || (interceptable.interceptors_ = []);
  interceptors.push(handler);
  return once(function () {
    var idx = interceptors.indexOf(handler);
    if (idx !== -1) {
      interceptors.splice(idx, 1);
    }
  });
}
function interceptChange(interceptable, change) {
  var prevU = untrackedStart();
  try {
    // Interceptor can modify the array, copy it to avoid concurrent modification, see #1950
    var interceptors = [].concat(interceptable.interceptors_ || []);
    for (var i = 0, l = interceptors.length; i < l; i++) {
      change = interceptors[i](change);
      if (change && !change.type) {
        die(14);
      }
      if (!change) {
        break;
      }
    }
    return change;
  } finally {
    untrackedEnd(prevU);
  }
}

function hasListeners(listenable) {
  return listenable.changeListeners_ !== undefined && listenable.changeListeners_.length > 0;
}
function registerListener(listenable, handler) {
  var listeners = listenable.changeListeners_ || (listenable.changeListeners_ = []);
  listeners.push(handler);
  return once(function () {
    var idx = listeners.indexOf(handler);
    if (idx !== -1) {
      listeners.splice(idx, 1);
    }
  });
}
function notifyListeners(listenable, change) {
  var prevU = untrackedStart();
  var listeners = listenable.changeListeners_;
  if (!listeners) {
    return;
  }
  listeners = listeners.slice();
  for (var i = 0, l = listeners.length; i < l; i++) {
    listeners[i](change);
  }
  untrackedEnd(prevU);
}

function makeObservable(target, annotations, options) {
  initObservable(function () {
    var _annotations;
    var adm = asObservableObject(target, options)[$mobx];
    if (process.env.NODE_ENV !== "production" && annotations && target[storedAnnotationsSymbol]) {
      die("makeObservable second arg must be nullish when using decorators. Mixing @decorator syntax with annotations is not supported.");
    }
    // Default to decorators
    (_annotations = annotations) != null ? _annotations : annotations = collectStoredAnnotations(target);
    // Annotate
    ownKeys(annotations).forEach(function (key) {
      return adm.make_(key, annotations[key]);
    });
  });
  return target;
}

var SPLICE = "splice";
var UPDATE = "update";
var MAX_SPLICE_SIZE = 10000; // See e.g. https://github.com/mobxjs/mobx/issues/859
var arrayTraps = {
  get: function get(target, name) {
    var adm = target[$mobx];
    if (name === $mobx) {
      return adm;
    }
    if (name === "length") {
      return adm.getArrayLength_();
    }
    if (typeof name === "string" && !isNaN(name)) {
      return adm.get_(parseInt(name));
    }
    if (hasProp(arrayExtensions, name)) {
      return arrayExtensions[name];
    }
    return target[name];
  },
  set: function set(target, name, value) {
    var adm = target[$mobx];
    if (name === "length") {
      adm.setArrayLength_(value);
    }
    if (typeof name === "symbol" || isNaN(name)) {
      target[name] = value;
    } else {
      // numeric string
      adm.set_(parseInt(name), value);
    }
    return true;
  },
  preventExtensions: function preventExtensions() {
    die(15);
  }
};
var ObservableArrayAdministration = /*#__PURE__*/function () {
  function ObservableArrayAdministration(name, enhancer, owned_, legacyMode_) {
    if (name === void 0) {
      name = process.env.NODE_ENV !== "production" ? "ObservableArray@" + getNextId() : "ObservableArray";
    }
    this.owned_ = void 0;
    this.legacyMode_ = void 0;
    this.atom_ = void 0;
    this.values_ = [];
    // this is the prop that gets proxied, so can't replace it!
    this.interceptors_ = void 0;
    this.changeListeners_ = void 0;
    this.enhancer_ = void 0;
    this.dehancer = void 0;
    this.proxy_ = void 0;
    this.lastKnownLength_ = 0;
    this.owned_ = owned_;
    this.legacyMode_ = legacyMode_;
    this.atom_ = new Atom(name);
    this.enhancer_ = function (newV, oldV) {
      return enhancer(newV, oldV, process.env.NODE_ENV !== "production" ? name + "[..]" : "ObservableArray[..]");
    };
  }
  var _proto = ObservableArrayAdministration.prototype;
  _proto.dehanceValue_ = function dehanceValue_(value) {
    if (this.dehancer !== undefined) {
      return this.dehancer(value);
    }
    return value;
  };
  _proto.dehanceValues_ = function dehanceValues_(values) {
    if (this.dehancer !== undefined && values.length > 0) {
      return values.map(this.dehancer);
    }
    return values;
  };
  _proto.intercept_ = function intercept_(handler) {
    return registerInterceptor(this, handler);
  };
  _proto.observe_ = function observe_(listener, fireImmediately) {
    if (fireImmediately === void 0) {
      fireImmediately = false;
    }
    if (fireImmediately) {
      listener({
        observableKind: "array",
        object: this.proxy_,
        debugObjectName: this.atom_.name_,
        type: "splice",
        index: 0,
        added: this.values_.slice(),
        addedCount: this.values_.length,
        removed: [],
        removedCount: 0
      });
    }
    return registerListener(this, listener);
  };
  _proto.getArrayLength_ = function getArrayLength_() {
    this.atom_.reportObserved();
    return this.values_.length;
  };
  _proto.setArrayLength_ = function setArrayLength_(newLength) {
    if (typeof newLength !== "number" || isNaN(newLength) || newLength < 0) {
      die("Out of range: " + newLength);
    }
    var currentLength = this.values_.length;
    if (newLength === currentLength) {
      return;
    } else if (newLength > currentLength) {
      var newItems = new Array(newLength - currentLength);
      for (var i = 0; i < newLength - currentLength; i++) {
        newItems[i] = undefined;
      } // No Array.fill everywhere...
      this.spliceWithArray_(currentLength, 0, newItems);
    } else {
      this.spliceWithArray_(newLength, currentLength - newLength);
    }
  };
  _proto.updateArrayLength_ = function updateArrayLength_(oldLength, delta) {
    if (oldLength !== this.lastKnownLength_) {
      die(16);
    }
    this.lastKnownLength_ += delta;
    if (this.legacyMode_ && delta > 0) {
      reserveArrayBuffer(oldLength + delta + 1);
    }
  };
  _proto.spliceWithArray_ = function spliceWithArray_(index, deleteCount, newItems) {
    var _this = this;
    checkIfStateModificationsAreAllowed(this.atom_);
    var length = this.values_.length;
    if (index === undefined) {
      index = 0;
    } else if (index > length) {
      index = length;
    } else if (index < 0) {
      index = Math.max(0, length + index);
    }
    if (arguments.length === 1) {
      deleteCount = length - index;
    } else if (deleteCount === undefined || deleteCount === null) {
      deleteCount = 0;
    } else {
      deleteCount = Math.max(0, Math.min(deleteCount, length - index));
    }
    if (newItems === undefined) {
      newItems = EMPTY_ARRAY$1;
    }
    if (hasInterceptors(this)) {
      var change = interceptChange(this, {
        object: this.proxy_,
        type: SPLICE,
        index: index,
        removedCount: deleteCount,
        added: newItems
      });
      if (!change) {
        return EMPTY_ARRAY$1;
      }
      deleteCount = change.removedCount;
      newItems = change.added;
    }
    newItems = newItems.length === 0 ? newItems : newItems.map(function (v) {
      return _this.enhancer_(v, undefined);
    });
    if (this.legacyMode_ || process.env.NODE_ENV !== "production") {
      var lengthDelta = newItems.length - deleteCount;
      this.updateArrayLength_(length, lengthDelta); // checks if internal array wasn't modified
    }
    var res = this.spliceItemsIntoValues_(index, deleteCount, newItems);
    if (deleteCount !== 0 || newItems.length !== 0) {
      this.notifyArraySplice_(index, newItems, res);
    }
    return this.dehanceValues_(res);
  };
  _proto.spliceItemsIntoValues_ = function spliceItemsIntoValues_(index, deleteCount, newItems) {
    if (newItems.length < MAX_SPLICE_SIZE) {
      var _this$values_;
      return (_this$values_ = this.values_).splice.apply(_this$values_, [index, deleteCount].concat(newItems));
    } else {
      // The items removed by the splice
      var res = this.values_.slice(index, index + deleteCount);
      // The items that that should remain at the end of the array
      var oldItems = this.values_.slice(index + deleteCount);
      // New length is the previous length + addition count - deletion count
      this.values_.length += newItems.length - deleteCount;
      for (var i = 0; i < newItems.length; i++) {
        this.values_[index + i] = newItems[i];
      }
      for (var _i = 0; _i < oldItems.length; _i++) {
        this.values_[index + newItems.length + _i] = oldItems[_i];
      }
      return res;
    }
  };
  _proto.notifyArrayChildUpdate_ = function notifyArrayChildUpdate_(index, newValue, oldValue) {
    var notifySpy = !this.owned_ && isSpyEnabled();
    var notify = hasListeners(this);
    var change = notify || notifySpy ? {
      observableKind: "array",
      object: this.proxy_,
      type: UPDATE,
      debugObjectName: this.atom_.name_,
      index: index,
      newValue: newValue,
      oldValue: oldValue
    } : null;
    // The reason why this is on right hand side here (and not above), is this way the uglifier will drop it, but it won't
    // cause any runtime overhead in development mode without NODE_ENV set, unless spying is enabled
    if (process.env.NODE_ENV !== "production" && notifySpy) {
      spyReportStart(change);
    }
    this.atom_.reportChanged();
    if (notify) {
      notifyListeners(this, change);
    }
    if (process.env.NODE_ENV !== "production" && notifySpy) {
      spyReportEnd();
    }
  };
  _proto.notifyArraySplice_ = function notifyArraySplice_(index, added, removed) {
    var notifySpy = !this.owned_ && isSpyEnabled();
    var notify = hasListeners(this);
    var change = notify || notifySpy ? {
      observableKind: "array",
      object: this.proxy_,
      debugObjectName: this.atom_.name_,
      type: SPLICE,
      index: index,
      removed: removed,
      added: added,
      removedCount: removed.length,
      addedCount: added.length
    } : null;
    if (process.env.NODE_ENV !== "production" && notifySpy) {
      spyReportStart(change);
    }
    this.atom_.reportChanged();
    // conform: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/observe
    if (notify) {
      notifyListeners(this, change);
    }
    if (process.env.NODE_ENV !== "production" && notifySpy) {
      spyReportEnd();
    }
  };
  _proto.get_ = function get_(index) {
    if (this.legacyMode_ && index >= this.values_.length) {
      console.warn(process.env.NODE_ENV !== "production" ? "[mobx.array] Attempt to read an array index (" + index + ") that is out of bounds (" + this.values_.length + "). Please check length first. Out of bound indices will not be tracked by MobX" : "[mobx] Out of bounds read: " + index);
      return undefined;
    }
    this.atom_.reportObserved();
    return this.dehanceValue_(this.values_[index]);
  };
  _proto.set_ = function set_(index, newValue) {
    var values = this.values_;
    if (this.legacyMode_ && index > values.length) {
      // out of bounds
      die(17, index, values.length);
    }
    if (index < values.length) {
      // update at index in range
      checkIfStateModificationsAreAllowed(this.atom_);
      var oldValue = values[index];
      if (hasInterceptors(this)) {
        var change = interceptChange(this, {
          type: UPDATE,
          object: this.proxy_,
          // since "this" is the real array we need to pass its proxy
          index: index,
          newValue: newValue
        });
        if (!change) {
          return;
        }
        newValue = change.newValue;
      }
      newValue = this.enhancer_(newValue, oldValue);
      var changed = newValue !== oldValue;
      if (changed) {
        values[index] = newValue;
        this.notifyArrayChildUpdate_(index, newValue, oldValue);
      }
    } else {
      // For out of bound index, we don't create an actual sparse array,
      // but rather fill the holes with undefined (same as setArrayLength_).
      // This could be considered a bug.
      var newItems = new Array(index + 1 - values.length);
      for (var i = 0; i < newItems.length - 1; i++) {
        newItems[i] = undefined;
      } // No Array.fill everywhere...
      newItems[newItems.length - 1] = newValue;
      this.spliceWithArray_(values.length, 0, newItems);
    }
  };
  return ObservableArrayAdministration;
}();
function createObservableArray(initialValues, enhancer, name, owned) {
  if (name === void 0) {
    name = process.env.NODE_ENV !== "production" ? "ObservableArray@" + getNextId() : "ObservableArray";
  }
  if (owned === void 0) {
    owned = false;
  }
  assertProxies();
  return initObservable(function () {
    var adm = new ObservableArrayAdministration(name, enhancer, owned, false);
    addHiddenFinalProp$1(adm.values_, $mobx, adm);
    var proxy = new Proxy(adm.values_, arrayTraps);
    adm.proxy_ = proxy;
    if (initialValues && initialValues.length) {
      adm.spliceWithArray_(0, 0, initialValues);
    }
    return proxy;
  });
}
// eslint-disable-next-line
var arrayExtensions = {
  clear: function clear() {
    return this.splice(0);
  },
  replace: function replace(newItems) {
    var adm = this[$mobx];
    return adm.spliceWithArray_(0, adm.values_.length, newItems);
  },
  // Used by JSON.stringify
  toJSON: function toJSON() {
    return this.slice();
  },
  /*
   * functions that do alter the internal structure of the array, (based on lib.es6.d.ts)
   * since these functions alter the inner structure of the array, the have side effects.
   * Because the have side effects, they should not be used in computed function,
   * and for that reason the do not call dependencyState.notifyObserved
   */
  splice: function splice(index, deleteCount) {
    for (var _len = arguments.length, newItems = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
      newItems[_key - 2] = arguments[_key];
    }
    var adm = this[$mobx];
    switch (arguments.length) {
      case 0:
        return [];
      case 1:
        return adm.spliceWithArray_(index);
      case 2:
        return adm.spliceWithArray_(index, deleteCount);
    }
    return adm.spliceWithArray_(index, deleteCount, newItems);
  },
  spliceWithArray: function spliceWithArray(index, deleteCount, newItems) {
    return this[$mobx].spliceWithArray_(index, deleteCount, newItems);
  },
  push: function push() {
    var adm = this[$mobx];
    for (var _len2 = arguments.length, items = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      items[_key2] = arguments[_key2];
    }
    adm.spliceWithArray_(adm.values_.length, 0, items);
    return adm.values_.length;
  },
  pop: function pop() {
    return this.splice(Math.max(this[$mobx].values_.length - 1, 0), 1)[0];
  },
  shift: function shift() {
    return this.splice(0, 1)[0];
  },
  unshift: function unshift() {
    var adm = this[$mobx];
    for (var _len3 = arguments.length, items = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      items[_key3] = arguments[_key3];
    }
    adm.spliceWithArray_(0, 0, items);
    return adm.values_.length;
  },
  reverse: function reverse() {
    // reverse by default mutates in place before returning the result
    // which makes it both a 'derivation' and a 'mutation'.
    if (globalState.trackingDerivation) {
      die(37, "reverse");
    }
    this.replace(this.slice().reverse());
    return this;
  },
  sort: function sort() {
    // sort by default mutates in place before returning the result
    // which goes against all good practices. Let's not change the array in place!
    if (globalState.trackingDerivation) {
      die(37, "sort");
    }
    var copy = this.slice();
    copy.sort.apply(copy, arguments);
    this.replace(copy);
    return this;
  },
  remove: function remove(value) {
    var adm = this[$mobx];
    var idx = adm.dehanceValues_(adm.values_).indexOf(value);
    if (idx > -1) {
      this.splice(idx, 1);
      return true;
    }
    return false;
  }
};
/**
 * Wrap function from prototype
 * Without this, everything works as well, but this works
 * faster as everything works on unproxied values
 */
addArrayExtension("at", simpleFunc);
addArrayExtension("concat", simpleFunc);
addArrayExtension("flat", simpleFunc);
addArrayExtension("includes", simpleFunc);
addArrayExtension("indexOf", simpleFunc);
addArrayExtension("join", simpleFunc);
addArrayExtension("lastIndexOf", simpleFunc);
addArrayExtension("slice", simpleFunc);
addArrayExtension("toString", simpleFunc);
addArrayExtension("toLocaleString", simpleFunc);
addArrayExtension("toSorted", simpleFunc);
addArrayExtension("toSpliced", simpleFunc);
addArrayExtension("with", simpleFunc);
// map
addArrayExtension("every", mapLikeFunc);
addArrayExtension("filter", mapLikeFunc);
addArrayExtension("find", mapLikeFunc);
addArrayExtension("findIndex", mapLikeFunc);
addArrayExtension("findLast", mapLikeFunc);
addArrayExtension("findLastIndex", mapLikeFunc);
addArrayExtension("flatMap", mapLikeFunc);
addArrayExtension("forEach", mapLikeFunc);
addArrayExtension("map", mapLikeFunc);
addArrayExtension("some", mapLikeFunc);
addArrayExtension("toReversed", mapLikeFunc);
// reduce
addArrayExtension("reduce", reduceLikeFunc);
addArrayExtension("reduceRight", reduceLikeFunc);
function addArrayExtension(funcName, funcFactory) {
  if (typeof Array.prototype[funcName] === "function") {
    arrayExtensions[funcName] = funcFactory(funcName);
  }
}
// Report and delegate to dehanced array
function simpleFunc(funcName) {
  return function () {
    var adm = this[$mobx];
    adm.atom_.reportObserved();
    var dehancedValues = adm.dehanceValues_(adm.values_);
    return dehancedValues[funcName].apply(dehancedValues, arguments);
  };
}
// Make sure callbacks receive correct array arg #2326
function mapLikeFunc(funcName) {
  return function (callback, thisArg) {
    var _this2 = this;
    var adm = this[$mobx];
    adm.atom_.reportObserved();
    var dehancedValues = adm.dehanceValues_(adm.values_);
    return dehancedValues[funcName](function (element, index) {
      return callback.call(thisArg, element, index, _this2);
    });
  };
}
// Make sure callbacks receive correct array arg #2326
function reduceLikeFunc(funcName) {
  return function () {
    var _this3 = this;
    var adm = this[$mobx];
    adm.atom_.reportObserved();
    var dehancedValues = adm.dehanceValues_(adm.values_);
    // #2432 - reduce behavior depends on arguments.length
    var callback = arguments[0];
    arguments[0] = function (accumulator, currentValue, index) {
      return callback(accumulator, currentValue, index, _this3);
    };
    return dehancedValues[funcName].apply(dehancedValues, arguments);
  };
}
var isObservableArrayAdministration = /*#__PURE__*/createInstanceofPredicate("ObservableArrayAdministration", ObservableArrayAdministration);
function isObservableArray(thing) {
  return isObject(thing) && isObservableArrayAdministration(thing[$mobx]);
}

var ObservableMapMarker = {};
var ADD = "add";
var DELETE = "delete";
// just extend Map? See also https://gist.github.com/nestharus/13b4d74f2ef4a2f4357dbd3fc23c1e54
// But: https://github.com/mobxjs/mobx/issues/1556
var ObservableMap = /*#__PURE__*/function () {
  function ObservableMap(initialData, enhancer_, name_) {
    var _this = this;
    if (enhancer_ === void 0) {
      enhancer_ = deepEnhancer;
    }
    if (name_ === void 0) {
      name_ = process.env.NODE_ENV !== "production" ? "ObservableMap@" + getNextId() : "ObservableMap";
    }
    this.enhancer_ = void 0;
    this.name_ = void 0;
    this[$mobx] = ObservableMapMarker;
    this.data_ = void 0;
    this.hasMap_ = void 0;
    // hasMap, not hashMap >-).
    this.keysAtom_ = void 0;
    this.interceptors_ = void 0;
    this.changeListeners_ = void 0;
    this.dehancer = void 0;
    this.enhancer_ = enhancer_;
    this.name_ = name_;
    if (!isFunction(Map)) {
      die(18);
    }
    initObservable(function () {
      _this.keysAtom_ = createAtom(process.env.NODE_ENV !== "production" ? _this.name_ + ".keys()" : "ObservableMap.keys()");
      _this.data_ = new Map();
      _this.hasMap_ = new Map();
      if (initialData) {
        _this.merge(initialData);
      }
    });
  }
  var _proto = ObservableMap.prototype;
  _proto.has_ = function has_(key) {
    return this.data_.has(key);
  };
  _proto.has = function has(key) {
    var _this2 = this;
    if (!globalState.trackingDerivation) {
      return this.has_(key);
    }
    var entry = this.hasMap_.get(key);
    if (!entry) {
      var newEntry = entry = new ObservableValue(this.has_(key), referenceEnhancer, process.env.NODE_ENV !== "production" ? this.name_ + "." + stringifyKey(key) + "?" : "ObservableMap.key?", false);
      this.hasMap_.set(key, newEntry);
      onBecomeUnobserved(newEntry, function () {
        return _this2.hasMap_["delete"](key);
      });
    }
    return entry.get();
  };
  _proto.set = function set(key, value) {
    var hasKey = this.has_(key);
    if (hasInterceptors(this)) {
      var change = interceptChange(this, {
        type: hasKey ? UPDATE : ADD,
        object: this,
        newValue: value,
        name: key
      });
      if (!change) {
        return this;
      }
      value = change.newValue;
    }
    if (hasKey) {
      this.updateValue_(key, value);
    } else {
      this.addValue_(key, value);
    }
    return this;
  };
  _proto["delete"] = function _delete(key) {
    var _this3 = this;
    checkIfStateModificationsAreAllowed(this.keysAtom_);
    if (hasInterceptors(this)) {
      var change = interceptChange(this, {
        type: DELETE,
        object: this,
        name: key
      });
      if (!change) {
        return false;
      }
    }
    if (this.has_(key)) {
      var notifySpy = isSpyEnabled();
      var notify = hasListeners(this);
      var _change = notify || notifySpy ? {
        observableKind: "map",
        debugObjectName: this.name_,
        type: DELETE,
        object: this,
        oldValue: this.data_.get(key).value_,
        name: key
      } : null;
      if (process.env.NODE_ENV !== "production" && notifySpy) {
        spyReportStart(_change);
      } // TODO fix type
      transaction(function () {
        var _this3$hasMap_$get;
        _this3.keysAtom_.reportChanged();
        (_this3$hasMap_$get = _this3.hasMap_.get(key)) == null || _this3$hasMap_$get.setNewValue_(false);
        var observable = _this3.data_.get(key);
        observable.setNewValue_(undefined);
        _this3.data_["delete"](key);
      });
      if (notify) {
        notifyListeners(this, _change);
      }
      if (process.env.NODE_ENV !== "production" && notifySpy) {
        spyReportEnd();
      }
      return true;
    }
    return false;
  };
  _proto.updateValue_ = function updateValue_(key, newValue) {
    var observable = this.data_.get(key);
    newValue = observable.prepareNewValue_(newValue);
    if (newValue !== globalState.UNCHANGED) {
      var notifySpy = isSpyEnabled();
      var notify = hasListeners(this);
      var change = notify || notifySpy ? {
        observableKind: "map",
        debugObjectName: this.name_,
        type: UPDATE,
        object: this,
        oldValue: observable.value_,
        name: key,
        newValue: newValue
      } : null;
      if (process.env.NODE_ENV !== "production" && notifySpy) {
        spyReportStart(change);
      } // TODO fix type
      observable.setNewValue_(newValue);
      if (notify) {
        notifyListeners(this, change);
      }
      if (process.env.NODE_ENV !== "production" && notifySpy) {
        spyReportEnd();
      }
    }
  };
  _proto.addValue_ = function addValue_(key, newValue) {
    var _this4 = this;
    checkIfStateModificationsAreAllowed(this.keysAtom_);
    transaction(function () {
      var _this4$hasMap_$get;
      var observable = new ObservableValue(newValue, _this4.enhancer_, process.env.NODE_ENV !== "production" ? _this4.name_ + "." + stringifyKey(key) : "ObservableMap.key", false);
      _this4.data_.set(key, observable);
      newValue = observable.value_; // value might have been changed
      (_this4$hasMap_$get = _this4.hasMap_.get(key)) == null || _this4$hasMap_$get.setNewValue_(true);
      _this4.keysAtom_.reportChanged();
    });
    var notifySpy = isSpyEnabled();
    var notify = hasListeners(this);
    var change = notify || notifySpy ? {
      observableKind: "map",
      debugObjectName: this.name_,
      type: ADD,
      object: this,
      name: key,
      newValue: newValue
    } : null;
    if (process.env.NODE_ENV !== "production" && notifySpy) {
      spyReportStart(change);
    } // TODO fix type
    if (notify) {
      notifyListeners(this, change);
    }
    if (process.env.NODE_ENV !== "production" && notifySpy) {
      spyReportEnd();
    }
  };
  _proto.get = function get(key) {
    if (this.has(key)) {
      return this.dehanceValue_(this.data_.get(key).get());
    }
    return this.dehanceValue_(undefined);
  };
  _proto.dehanceValue_ = function dehanceValue_(value) {
    if (this.dehancer !== undefined) {
      return this.dehancer(value);
    }
    return value;
  };
  _proto.keys = function keys() {
    this.keysAtom_.reportObserved();
    return this.data_.keys();
  };
  _proto.values = function values() {
    var self = this;
    var keys = this.keys();
    return makeIterableForMap({
      next: function next() {
        var _keys$next = keys.next(),
          done = _keys$next.done,
          value = _keys$next.value;
        return {
          done: done,
          value: done ? undefined : self.get(value)
        };
      }
    });
  };
  _proto.entries = function entries() {
    var self = this;
    var keys = this.keys();
    return makeIterableForMap({
      next: function next() {
        var _keys$next2 = keys.next(),
          done = _keys$next2.done,
          value = _keys$next2.value;
        return {
          done: done,
          value: done ? undefined : [value, self.get(value)]
        };
      }
    });
  };
  _proto[Symbol.iterator] = function () {
    return this.entries();
  };
  _proto.forEach = function forEach(callback, thisArg) {
    for (var _iterator = _createForOfIteratorHelperLoose(this), _step; !(_step = _iterator()).done;) {
      var _step$value = _step.value,
        key = _step$value[0],
        value = _step$value[1];
      callback.call(thisArg, value, key, this);
    }
  }
  /** Merge another object into this object, returns this. */;
  _proto.merge = function merge(other) {
    var _this5 = this;
    if (isObservableMap(other)) {
      other = new Map(other);
    }
    transaction(function () {
      if (isPlainObject$1(other)) {
        getPlainObjectKeys(other).forEach(function (key) {
          return _this5.set(key, other[key]);
        });
      } else if (Array.isArray(other)) {
        other.forEach(function (_ref) {
          var key = _ref[0],
            value = _ref[1];
          return _this5.set(key, value);
        });
      } else if (isES6Map(other)) {
        if (!isPlainES6Map(other)) {
          die(19, other);
        }
        other.forEach(function (value, key) {
          return _this5.set(key, value);
        });
      } else if (other !== null && other !== undefined) {
        die(20, other);
      }
    });
    return this;
  };
  _proto.clear = function clear() {
    var _this6 = this;
    transaction(function () {
      untracked(function () {
        for (var _iterator2 = _createForOfIteratorHelperLoose(_this6.keys()), _step2; !(_step2 = _iterator2()).done;) {
          var key = _step2.value;
          _this6["delete"](key);
        }
      });
    });
  };
  _proto.replace = function replace(values) {
    var _this7 = this;
    // Implementation requirements:
    // - respect ordering of replacement map
    // - allow interceptors to run and potentially prevent individual operations
    // - don't recreate observables that already exist in original map (so we don't destroy existing subscriptions)
    // - don't _keysAtom.reportChanged if the keys of resulting map are indentical (order matters!)
    // - note that result map may differ from replacement map due to the interceptors
    transaction(function () {
      // Convert to map so we can do quick key lookups
      var replacementMap = convertToMap(values);
      var orderedData = new Map();
      // Used for optimization
      var keysReportChangedCalled = false;
      // Delete keys that don't exist in replacement map
      // if the key deletion is prevented by interceptor
      // add entry at the beginning of the result map
      for (var _iterator3 = _createForOfIteratorHelperLoose(_this7.data_.keys()), _step3; !(_step3 = _iterator3()).done;) {
        var key = _step3.value;
        // Concurrently iterating/deleting keys
        // iterator should handle this correctly
        if (!replacementMap.has(key)) {
          var deleted = _this7["delete"](key);
          // Was the key removed?
          if (deleted) {
            // _keysAtom.reportChanged() was already called
            keysReportChangedCalled = true;
          } else {
            // Delete prevented by interceptor
            var value = _this7.data_.get(key);
            orderedData.set(key, value);
          }
        }
      }
      // Merge entries
      for (var _iterator4 = _createForOfIteratorHelperLoose(replacementMap.entries()), _step4; !(_step4 = _iterator4()).done;) {
        var _step4$value = _step4.value,
          _key = _step4$value[0],
          _value = _step4$value[1];
        // We will want to know whether a new key is added
        var keyExisted = _this7.data_.has(_key);
        // Add or update value
        _this7.set(_key, _value);
        // The addition could have been prevent by interceptor
        if (_this7.data_.has(_key)) {
          // The update could have been prevented by interceptor
          // and also we want to preserve existing values
          // so use value from _data map (instead of replacement map)
          var _value2 = _this7.data_.get(_key);
          orderedData.set(_key, _value2);
          // Was a new key added?
          if (!keyExisted) {
            // _keysAtom.reportChanged() was already called
            keysReportChangedCalled = true;
          }
        }
      }
      // Check for possible key order change
      if (!keysReportChangedCalled) {
        if (_this7.data_.size !== orderedData.size) {
          // If size differs, keys are definitely modified
          _this7.keysAtom_.reportChanged();
        } else {
          var iter1 = _this7.data_.keys();
          var iter2 = orderedData.keys();
          var next1 = iter1.next();
          var next2 = iter2.next();
          while (!next1.done) {
            if (next1.value !== next2.value) {
              _this7.keysAtom_.reportChanged();
              break;
            }
            next1 = iter1.next();
            next2 = iter2.next();
          }
        }
      }
      // Use correctly ordered map
      _this7.data_ = orderedData;
    });
    return this;
  };
  _proto.toString = function toString() {
    return "[object ObservableMap]";
  };
  _proto.toJSON = function toJSON() {
    return Array.from(this);
  };
  /**
   * Observes this object. Triggers for the events 'add', 'update' and 'delete'.
   * See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/observe
   * for callback details
   */
  _proto.observe_ = function observe_(listener, fireImmediately) {
    if (process.env.NODE_ENV !== "production" && fireImmediately === true) {
      die("`observe` doesn't support fireImmediately=true in combination with maps.");
    }
    return registerListener(this, listener);
  };
  _proto.intercept_ = function intercept_(handler) {
    return registerInterceptor(this, handler);
  };
  return _createClass(ObservableMap, [{
    key: "size",
    get: function get() {
      this.keysAtom_.reportObserved();
      return this.data_.size;
    }
  }, {
    key: Symbol.toStringTag,
    get: function get() {
      return "Map";
    }
  }]);
}();
// eslint-disable-next-line
var isObservableMap = /*#__PURE__*/createInstanceofPredicate("ObservableMap", ObservableMap);
function makeIterableForMap(iterator) {
  iterator[Symbol.toStringTag] = "MapIterator";
  return makeIterable(iterator);
}
function convertToMap(dataStructure) {
  if (isES6Map(dataStructure) || isObservableMap(dataStructure)) {
    return dataStructure;
  } else if (Array.isArray(dataStructure)) {
    return new Map(dataStructure);
  } else if (isPlainObject$1(dataStructure)) {
    var map = new Map();
    for (var key in dataStructure) {
      map.set(key, dataStructure[key]);
    }
    return map;
  } else {
    return die(21, dataStructure);
  }
}

var ObservableSetMarker = {};
var ObservableSet = /*#__PURE__*/function () {
  function ObservableSet(initialData, enhancer, name_) {
    var _this = this;
    if (enhancer === void 0) {
      enhancer = deepEnhancer;
    }
    if (name_ === void 0) {
      name_ = process.env.NODE_ENV !== "production" ? "ObservableSet@" + getNextId() : "ObservableSet";
    }
    this.name_ = void 0;
    this[$mobx] = ObservableSetMarker;
    this.data_ = new Set();
    this.atom_ = void 0;
    this.changeListeners_ = void 0;
    this.interceptors_ = void 0;
    this.dehancer = void 0;
    this.enhancer_ = void 0;
    this.name_ = name_;
    if (!isFunction(Set)) {
      die(22);
    }
    this.enhancer_ = function (newV, oldV) {
      return enhancer(newV, oldV, name_);
    };
    initObservable(function () {
      _this.atom_ = createAtom(_this.name_);
      if (initialData) {
        _this.replace(initialData);
      }
    });
  }
  var _proto = ObservableSet.prototype;
  _proto.dehanceValue_ = function dehanceValue_(value) {
    if (this.dehancer !== undefined) {
      return this.dehancer(value);
    }
    return value;
  };
  _proto.clear = function clear() {
    var _this2 = this;
    transaction(function () {
      untracked(function () {
        for (var _iterator = _createForOfIteratorHelperLoose(_this2.data_.values()), _step; !(_step = _iterator()).done;) {
          var value = _step.value;
          _this2["delete"](value);
        }
      });
    });
  };
  _proto.forEach = function forEach(callbackFn, thisArg) {
    for (var _iterator2 = _createForOfIteratorHelperLoose(this), _step2; !(_step2 = _iterator2()).done;) {
      var value = _step2.value;
      callbackFn.call(thisArg, value, value, this);
    }
  };
  _proto.add = function add(value) {
    var _this3 = this;
    checkIfStateModificationsAreAllowed(this.atom_);
    if (hasInterceptors(this)) {
      var change = interceptChange(this, {
        type: ADD,
        object: this,
        newValue: value
      });
      if (!change) {
        return this;
      }
      // ideally, value = change.value would be done here, so that values can be
      // changed by interceptor. Same applies for other Set and Map api's.
    }
    if (!this.has(value)) {
      transaction(function () {
        _this3.data_.add(_this3.enhancer_(value, undefined));
        _this3.atom_.reportChanged();
      });
      var notifySpy = process.env.NODE_ENV !== "production" && isSpyEnabled();
      var notify = hasListeners(this);
      var _change = notify || notifySpy ? {
        observableKind: "set",
        debugObjectName: this.name_,
        type: ADD,
        object: this,
        newValue: value
      } : null;
      if (notifySpy && process.env.NODE_ENV !== "production") {
        spyReportStart(_change);
      }
      if (notify) {
        notifyListeners(this, _change);
      }
      if (notifySpy && process.env.NODE_ENV !== "production") {
        spyReportEnd();
      }
    }
    return this;
  };
  _proto["delete"] = function _delete(value) {
    var _this4 = this;
    if (hasInterceptors(this)) {
      var change = interceptChange(this, {
        type: DELETE,
        object: this,
        oldValue: value
      });
      if (!change) {
        return false;
      }
    }
    if (this.has(value)) {
      var notifySpy = process.env.NODE_ENV !== "production" && isSpyEnabled();
      var notify = hasListeners(this);
      var _change2 = notify || notifySpy ? {
        observableKind: "set",
        debugObjectName: this.name_,
        type: DELETE,
        object: this,
        oldValue: value
      } : null;
      if (notifySpy && process.env.NODE_ENV !== "production") {
        spyReportStart(_change2);
      }
      transaction(function () {
        _this4.atom_.reportChanged();
        _this4.data_["delete"](value);
      });
      if (notify) {
        notifyListeners(this, _change2);
      }
      if (notifySpy && process.env.NODE_ENV !== "production") {
        spyReportEnd();
      }
      return true;
    }
    return false;
  };
  _proto.has = function has(value) {
    this.atom_.reportObserved();
    return this.data_.has(this.dehanceValue_(value));
  };
  _proto.entries = function entries() {
    var nextIndex = 0;
    var keys = Array.from(this.keys());
    var values = Array.from(this.values());
    return makeIterableForSet({
      next: function next() {
        var index = nextIndex;
        nextIndex += 1;
        return index < values.length ? {
          value: [keys[index], values[index]],
          done: false
        } : {
          value: undefined,
          done: true
        };
      }
    });
  };
  _proto.keys = function keys() {
    return this.values();
  };
  _proto.values = function values() {
    this.atom_.reportObserved();
    var self = this;
    var nextIndex = 0;
    var observableValues = Array.from(this.data_.values());
    return makeIterableForSet({
      next: function next() {
        return nextIndex < observableValues.length ? {
          value: self.dehanceValue_(observableValues[nextIndex++]),
          done: false
        } : {
          value: undefined,
          done: true
        };
      }
    });
  };
  _proto.intersection = function intersection(otherSet) {
    if (isES6Set(otherSet) && !isObservableSet(otherSet)) {
      return otherSet.intersection(this);
    } else {
      var dehancedSet = new Set(this);
      return dehancedSet.intersection(otherSet);
    }
  };
  _proto.union = function union(otherSet) {
    if (isES6Set(otherSet) && !isObservableSet(otherSet)) {
      return otherSet.union(this);
    } else {
      var dehancedSet = new Set(this);
      return dehancedSet.union(otherSet);
    }
  };
  _proto.difference = function difference(otherSet) {
    return new Set(this).difference(otherSet);
  };
  _proto.symmetricDifference = function symmetricDifference(otherSet) {
    if (isES6Set(otherSet) && !isObservableSet(otherSet)) {
      return otherSet.symmetricDifference(this);
    } else {
      var dehancedSet = new Set(this);
      return dehancedSet.symmetricDifference(otherSet);
    }
  };
  _proto.isSubsetOf = function isSubsetOf(otherSet) {
    return new Set(this).isSubsetOf(otherSet);
  };
  _proto.isSupersetOf = function isSupersetOf(otherSet) {
    return new Set(this).isSupersetOf(otherSet);
  };
  _proto.isDisjointFrom = function isDisjointFrom(otherSet) {
    if (isES6Set(otherSet) && !isObservableSet(otherSet)) {
      return otherSet.isDisjointFrom(this);
    } else {
      var dehancedSet = new Set(this);
      return dehancedSet.isDisjointFrom(otherSet);
    }
  };
  _proto.replace = function replace(other) {
    var _this5 = this;
    if (isObservableSet(other)) {
      other = new Set(other);
    }
    transaction(function () {
      if (Array.isArray(other)) {
        _this5.clear();
        other.forEach(function (value) {
          return _this5.add(value);
        });
      } else if (isES6Set(other)) {
        _this5.clear();
        other.forEach(function (value) {
          return _this5.add(value);
        });
      } else if (other !== null && other !== undefined) {
        die("Cannot initialize set from " + other);
      }
    });
    return this;
  };
  _proto.observe_ = function observe_(listener, fireImmediately) {
    // ... 'fireImmediately' could also be true?
    if (process.env.NODE_ENV !== "production" && fireImmediately === true) {
      die("`observe` doesn't support fireImmediately=true in combination with sets.");
    }
    return registerListener(this, listener);
  };
  _proto.intercept_ = function intercept_(handler) {
    return registerInterceptor(this, handler);
  };
  _proto.toJSON = function toJSON() {
    return Array.from(this);
  };
  _proto.toString = function toString() {
    return "[object ObservableSet]";
  };
  _proto[Symbol.iterator] = function () {
    return this.values();
  };
  return _createClass(ObservableSet, [{
    key: "size",
    get: function get() {
      this.atom_.reportObserved();
      return this.data_.size;
    }
  }, {
    key: Symbol.toStringTag,
    get: function get() {
      return "Set";
    }
  }]);
}();
// eslint-disable-next-line
var isObservableSet = /*#__PURE__*/createInstanceofPredicate("ObservableSet", ObservableSet);
function makeIterableForSet(iterator) {
  iterator[Symbol.toStringTag] = "SetIterator";
  return makeIterable(iterator);
}

var descriptorCache = /*#__PURE__*/Object.create(null);
var REMOVE = "remove";
var ObservableObjectAdministration = /*#__PURE__*/function () {
  function ObservableObjectAdministration(target_, values_, name_,
  // Used anytime annotation is not explicitely provided
  defaultAnnotation_) {
    if (values_ === void 0) {
      values_ = new Map();
    }
    if (defaultAnnotation_ === void 0) {
      defaultAnnotation_ = autoAnnotation;
    }
    this.target_ = void 0;
    this.values_ = void 0;
    this.name_ = void 0;
    this.defaultAnnotation_ = void 0;
    this.keysAtom_ = void 0;
    this.changeListeners_ = void 0;
    this.interceptors_ = void 0;
    this.proxy_ = void 0;
    this.isPlainObject_ = void 0;
    this.appliedAnnotations_ = void 0;
    this.pendingKeys_ = void 0;
    this.target_ = target_;
    this.values_ = values_;
    this.name_ = name_;
    this.defaultAnnotation_ = defaultAnnotation_;
    this.keysAtom_ = new Atom(process.env.NODE_ENV !== "production" ? this.name_ + ".keys" : "ObservableObject.keys");
    // Optimization: we use this frequently
    this.isPlainObject_ = isPlainObject$1(this.target_);
    if (process.env.NODE_ENV !== "production" && !isAnnotation(this.defaultAnnotation_)) {
      die("defaultAnnotation must be valid annotation");
    }
    if (process.env.NODE_ENV !== "production") {
      // Prepare structure for tracking which fields were already annotated
      this.appliedAnnotations_ = {};
    }
  }
  var _proto = ObservableObjectAdministration.prototype;
  _proto.getObservablePropValue_ = function getObservablePropValue_(key) {
    return this.values_.get(key).get();
  };
  _proto.setObservablePropValue_ = function setObservablePropValue_(key, newValue) {
    var observable = this.values_.get(key);
    if (observable instanceof ComputedValue) {
      observable.set(newValue);
      return true;
    }
    // intercept
    if (hasInterceptors(this)) {
      var change = interceptChange(this, {
        type: UPDATE,
        object: this.proxy_ || this.target_,
        name: key,
        newValue: newValue
      });
      if (!change) {
        return null;
      }
      newValue = change.newValue;
    }
    newValue = observable.prepareNewValue_(newValue);
    // notify spy & observers
    if (newValue !== globalState.UNCHANGED) {
      var notify = hasListeners(this);
      var notifySpy = process.env.NODE_ENV !== "production" && isSpyEnabled();
      var _change = notify || notifySpy ? {
        type: UPDATE,
        observableKind: "object",
        debugObjectName: this.name_,
        object: this.proxy_ || this.target_,
        oldValue: observable.value_,
        name: key,
        newValue: newValue
      } : null;
      if (process.env.NODE_ENV !== "production" && notifySpy) {
        spyReportStart(_change);
      }
      observable.setNewValue_(newValue);
      if (notify) {
        notifyListeners(this, _change);
      }
      if (process.env.NODE_ENV !== "production" && notifySpy) {
        spyReportEnd();
      }
    }
    return true;
  };
  _proto.get_ = function get_(key) {
    if (globalState.trackingDerivation && !hasProp(this.target_, key)) {
      // Key doesn't exist yet, subscribe for it in case it's added later
      this.has_(key);
    }
    return this.target_[key];
  }
  /**
   * @param {PropertyKey} key
   * @param {any} value
   * @param {Annotation|boolean} annotation true - use default annotation, false - copy as is
   * @param {boolean} proxyTrap whether it's called from proxy trap
   * @returns {boolean|null} true on success, false on failure (proxyTrap + non-configurable), null when cancelled by interceptor
   */;
  _proto.set_ = function set_(key, value, proxyTrap) {
    if (proxyTrap === void 0) {
      proxyTrap = false;
    }
    // Don't use .has(key) - we care about own
    if (hasProp(this.target_, key)) {
      // Existing prop
      if (this.values_.has(key)) {
        // Observable (can be intercepted)
        return this.setObservablePropValue_(key, value);
      } else if (proxyTrap) {
        // Non-observable - proxy
        return Reflect.set(this.target_, key, value);
      } else {
        // Non-observable
        this.target_[key] = value;
        return true;
      }
    } else {
      // New prop
      return this.extend_(key, {
        value: value,
        enumerable: true,
        writable: true,
        configurable: true
      }, this.defaultAnnotation_, proxyTrap);
    }
  }
  // Trap for "in"
  ;
  _proto.has_ = function has_(key) {
    if (!globalState.trackingDerivation) {
      // Skip key subscription outside derivation
      return key in this.target_;
    }
    this.pendingKeys_ || (this.pendingKeys_ = new Map());
    var entry = this.pendingKeys_.get(key);
    if (!entry) {
      entry = new ObservableValue(key in this.target_, referenceEnhancer, process.env.NODE_ENV !== "production" ? this.name_ + "." + stringifyKey(key) + "?" : "ObservableObject.key?", false);
      this.pendingKeys_.set(key, entry);
    }
    return entry.get();
  }
  /**
   * @param {PropertyKey} key
   * @param {Annotation|boolean} annotation true - use default annotation, false - ignore prop
   */;
  _proto.make_ = function make_(key, annotation) {
    if (annotation === true) {
      annotation = this.defaultAnnotation_;
    }
    if (annotation === false) {
      return;
    }
    assertAnnotable(this, annotation, key);
    if (!(key in this.target_)) {
      var _this$target_$storedA;
      // Throw on missing key, except for decorators:
      // Decorator annotations are collected from whole prototype chain.
      // When called from super() some props may not exist yet.
      // However we don't have to worry about missing prop,
      // because the decorator must have been applied to something.
      if ((_this$target_$storedA = this.target_[storedAnnotationsSymbol]) != null && _this$target_$storedA[key]) {
        return; // will be annotated by subclass constructor
      } else {
        die(1, annotation.annotationType_, this.name_ + "." + key.toString());
      }
    }
    var source = this.target_;
    while (source && source !== objectPrototype) {
      var descriptor = getDescriptor(source, key);
      if (descriptor) {
        var outcome = annotation.make_(this, key, descriptor, source);
        if (outcome === 0 /* MakeResult.Cancel */) {
          return;
        }
        if (outcome === 1 /* MakeResult.Break */) {
          break;
        }
      }
      source = Object.getPrototypeOf(source);
    }
    recordAnnotationApplied(this, annotation, key);
  }
  /**
   * @param {PropertyKey} key
   * @param {PropertyDescriptor} descriptor
   * @param {Annotation|boolean} annotation true - use default annotation, false - copy as is
   * @param {boolean} proxyTrap whether it's called from proxy trap
   * @returns {boolean|null} true on success, false on failure (proxyTrap + non-configurable), null when cancelled by interceptor
   */;
  _proto.extend_ = function extend_(key, descriptor, annotation, proxyTrap) {
    if (proxyTrap === void 0) {
      proxyTrap = false;
    }
    if (annotation === true) {
      annotation = this.defaultAnnotation_;
    }
    if (annotation === false) {
      return this.defineProperty_(key, descriptor, proxyTrap);
    }
    assertAnnotable(this, annotation, key);
    var outcome = annotation.extend_(this, key, descriptor, proxyTrap);
    if (outcome) {
      recordAnnotationApplied(this, annotation, key);
    }
    return outcome;
  }
  /**
   * @param {PropertyKey} key
   * @param {PropertyDescriptor} descriptor
   * @param {boolean} proxyTrap whether it's called from proxy trap
   * @returns {boolean|null} true on success, false on failure (proxyTrap + non-configurable), null when cancelled by interceptor
   */;
  _proto.defineProperty_ = function defineProperty_(key, descriptor, proxyTrap) {
    if (proxyTrap === void 0) {
      proxyTrap = false;
    }
    checkIfStateModificationsAreAllowed(this.keysAtom_);
    try {
      startBatch();
      // Delete
      var deleteOutcome = this.delete_(key);
      if (!deleteOutcome) {
        // Failure or intercepted
        return deleteOutcome;
      }
      // ADD interceptor
      if (hasInterceptors(this)) {
        var change = interceptChange(this, {
          object: this.proxy_ || this.target_,
          name: key,
          type: ADD,
          newValue: descriptor.value
        });
        if (!change) {
          return null;
        }
        var newValue = change.newValue;
        if (descriptor.value !== newValue) {
          descriptor = _extends({}, descriptor, {
            value: newValue
          });
        }
      }
      // Define
      if (proxyTrap) {
        if (!Reflect.defineProperty(this.target_, key, descriptor)) {
          return false;
        }
      } else {
        defineProperty$1(this.target_, key, descriptor);
      }
      // Notify
      this.notifyPropertyAddition_(key, descriptor.value);
    } finally {
      endBatch();
    }
    return true;
  }
  // If original descriptor becomes relevant, move this to annotation directly
  ;
  _proto.defineObservableProperty_ = function defineObservableProperty_(key, value, enhancer, proxyTrap) {
    if (proxyTrap === void 0) {
      proxyTrap = false;
    }
    checkIfStateModificationsAreAllowed(this.keysAtom_);
    try {
      startBatch();
      // Delete
      var deleteOutcome = this.delete_(key);
      if (!deleteOutcome) {
        // Failure or intercepted
        return deleteOutcome;
      }
      // ADD interceptor
      if (hasInterceptors(this)) {
        var change = interceptChange(this, {
          object: this.proxy_ || this.target_,
          name: key,
          type: ADD,
          newValue: value
        });
        if (!change) {
          return null;
        }
        value = change.newValue;
      }
      var cachedDescriptor = getCachedObservablePropDescriptor(key);
      var descriptor = {
        configurable: globalState.safeDescriptors ? this.isPlainObject_ : true,
        enumerable: true,
        get: cachedDescriptor.get,
        set: cachedDescriptor.set
      };
      // Define
      if (proxyTrap) {
        if (!Reflect.defineProperty(this.target_, key, descriptor)) {
          return false;
        }
      } else {
        defineProperty$1(this.target_, key, descriptor);
      }
      var observable = new ObservableValue(value, enhancer, process.env.NODE_ENV !== "production" ? this.name_ + "." + key.toString() : "ObservableObject.key", false);
      this.values_.set(key, observable);
      // Notify (value possibly changed by ObservableValue)
      this.notifyPropertyAddition_(key, observable.value_);
    } finally {
      endBatch();
    }
    return true;
  }
  // If original descriptor becomes relevant, move this to annotation directly
  ;
  _proto.defineComputedProperty_ = function defineComputedProperty_(key, options, proxyTrap) {
    if (proxyTrap === void 0) {
      proxyTrap = false;
    }
    checkIfStateModificationsAreAllowed(this.keysAtom_);
    try {
      startBatch();
      // Delete
      var deleteOutcome = this.delete_(key);
      if (!deleteOutcome) {
        // Failure or intercepted
        return deleteOutcome;
      }
      // ADD interceptor
      if (hasInterceptors(this)) {
        var change = interceptChange(this, {
          object: this.proxy_ || this.target_,
          name: key,
          type: ADD,
          newValue: undefined
        });
        if (!change) {
          return null;
        }
      }
      options.name || (options.name = process.env.NODE_ENV !== "production" ? this.name_ + "." + key.toString() : "ObservableObject.key");
      options.context = this.proxy_ || this.target_;
      var cachedDescriptor = getCachedObservablePropDescriptor(key);
      var descriptor = {
        configurable: globalState.safeDescriptors ? this.isPlainObject_ : true,
        enumerable: false,
        get: cachedDescriptor.get,
        set: cachedDescriptor.set
      };
      // Define
      if (proxyTrap) {
        if (!Reflect.defineProperty(this.target_, key, descriptor)) {
          return false;
        }
      } else {
        defineProperty$1(this.target_, key, descriptor);
      }
      this.values_.set(key, new ComputedValue(options));
      // Notify
      this.notifyPropertyAddition_(key, undefined);
    } finally {
      endBatch();
    }
    return true;
  }
  /**
   * @param {PropertyKey} key
   * @param {PropertyDescriptor} descriptor
   * @param {boolean} proxyTrap whether it's called from proxy trap
   * @returns {boolean|null} true on success, false on failure (proxyTrap + non-configurable), null when cancelled by interceptor
   */;
  _proto.delete_ = function delete_(key, proxyTrap) {
    if (proxyTrap === void 0) {
      proxyTrap = false;
    }
    checkIfStateModificationsAreAllowed(this.keysAtom_);
    // No such prop
    if (!hasProp(this.target_, key)) {
      return true;
    }
    // Intercept
    if (hasInterceptors(this)) {
      var change = interceptChange(this, {
        object: this.proxy_ || this.target_,
        name: key,
        type: REMOVE
      });
      // Cancelled
      if (!change) {
        return null;
      }
    }
    // Delete
    try {
      var _this$pendingKeys_;
      startBatch();
      var notify = hasListeners(this);
      var notifySpy = process.env.NODE_ENV !== "production" && isSpyEnabled();
      var observable = this.values_.get(key);
      // Value needed for spies/listeners
      var value = undefined;
      // Optimization: don't pull the value unless we will need it
      if (!observable && (notify || notifySpy)) {
        var _getDescriptor;
        value = (_getDescriptor = getDescriptor(this.target_, key)) == null ? void 0 : _getDescriptor.value;
      }
      // delete prop (do first, may fail)
      if (proxyTrap) {
        if (!Reflect.deleteProperty(this.target_, key)) {
          return false;
        }
      } else {
        delete this.target_[key];
      }
      // Allow re-annotating this field
      if (process.env.NODE_ENV !== "production") {
        delete this.appliedAnnotations_[key];
      }
      // Clear observable
      if (observable) {
        this.values_["delete"](key);
        // for computed, value is undefined
        if (observable instanceof ObservableValue) {
          value = observable.value_;
        }
        // Notify: autorun(() => obj[key]), see #1796
        propagateChanged(observable);
      }
      // Notify "keys/entries/values" observers
      this.keysAtom_.reportChanged();
      // Notify "has" observers
      // "in" as it may still exist in proto
      (_this$pendingKeys_ = this.pendingKeys_) == null || (_this$pendingKeys_ = _this$pendingKeys_.get(key)) == null || _this$pendingKeys_.set(key in this.target_);
      // Notify spies/listeners
      if (notify || notifySpy) {
        var _change2 = {
          type: REMOVE,
          observableKind: "object",
          object: this.proxy_ || this.target_,
          debugObjectName: this.name_,
          oldValue: value,
          name: key
        };
        if (process.env.NODE_ENV !== "production" && notifySpy) {
          spyReportStart(_change2);
        }
        if (notify) {
          notifyListeners(this, _change2);
        }
        if (process.env.NODE_ENV !== "production" && notifySpy) {
          spyReportEnd();
        }
      }
    } finally {
      endBatch();
    }
    return true;
  }
  /**
   * Observes this object. Triggers for the events 'add', 'update' and 'delete'.
   * See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/observe
   * for callback details
   */;
  _proto.observe_ = function observe_(callback, fireImmediately) {
    if (process.env.NODE_ENV !== "production" && fireImmediately === true) {
      die("`observe` doesn't support the fire immediately property for observable objects.");
    }
    return registerListener(this, callback);
  };
  _proto.intercept_ = function intercept_(handler) {
    return registerInterceptor(this, handler);
  };
  _proto.notifyPropertyAddition_ = function notifyPropertyAddition_(key, value) {
    var _this$pendingKeys_2;
    var notify = hasListeners(this);
    var notifySpy = process.env.NODE_ENV !== "production" && isSpyEnabled();
    if (notify || notifySpy) {
      var change = notify || notifySpy ? {
        type: ADD,
        observableKind: "object",
        debugObjectName: this.name_,
        object: this.proxy_ || this.target_,
        name: key,
        newValue: value
      } : null;
      if (process.env.NODE_ENV !== "production" && notifySpy) {
        spyReportStart(change);
      }
      if (notify) {
        notifyListeners(this, change);
      }
      if (process.env.NODE_ENV !== "production" && notifySpy) {
        spyReportEnd();
      }
    }
    (_this$pendingKeys_2 = this.pendingKeys_) == null || (_this$pendingKeys_2 = _this$pendingKeys_2.get(key)) == null || _this$pendingKeys_2.set(true);
    // Notify "keys/entries/values" observers
    this.keysAtom_.reportChanged();
  };
  _proto.ownKeys_ = function ownKeys_() {
    this.keysAtom_.reportObserved();
    return ownKeys(this.target_);
  };
  _proto.keys_ = function keys_() {
    // Returns enumerable && own, but unfortunately keysAtom will report on ANY key change.
    // There is no way to distinguish between Object.keys(object) and Reflect.ownKeys(object) - both are handled by ownKeys trap.
    // We can either over-report in Object.keys(object) or under-report in Reflect.ownKeys(object)
    // We choose to over-report in Object.keys(object), because:
    // - typically it's used with simple data objects
    // - when symbolic/non-enumerable keys are relevant Reflect.ownKeys works as expected
    this.keysAtom_.reportObserved();
    return Object.keys(this.target_);
  };
  return ObservableObjectAdministration;
}();
function asObservableObject(target, options) {
  var _options$name;
  if (process.env.NODE_ENV !== "production" && options && isObservableObject(target)) {
    die("Options can't be provided for already observable objects.");
  }
  if (hasProp(target, $mobx)) {
    if (process.env.NODE_ENV !== "production" && !(getAdministration(target) instanceof ObservableObjectAdministration)) {
      die("Cannot convert '" + getDebugName(target) + "' into observable object:" + "\nThe target is already observable of different type." + "\nExtending builtins is not supported.");
    }
    return target;
  }
  if (process.env.NODE_ENV !== "production" && !Object.isExtensible(target)) {
    die("Cannot make the designated object observable; it is not extensible");
  }
  var name = (_options$name = options == null ? void 0 : options.name) != null ? _options$name : process.env.NODE_ENV !== "production" ? (isPlainObject$1(target) ? "ObservableObject" : target.constructor.name) + "@" + getNextId() : "ObservableObject";
  var adm = new ObservableObjectAdministration(target, new Map(), String(name), getAnnotationFromOptions(options));
  addHiddenProp(target, $mobx, adm);
  return target;
}
var isObservableObjectAdministration = /*#__PURE__*/createInstanceofPredicate("ObservableObjectAdministration", ObservableObjectAdministration);
function getCachedObservablePropDescriptor(key) {
  return descriptorCache[key] || (descriptorCache[key] = {
    get: function get() {
      return this[$mobx].getObservablePropValue_(key);
    },
    set: function set(value) {
      return this[$mobx].setObservablePropValue_(key, value);
    }
  });
}
function isObservableObject(thing) {
  if (isObject(thing)) {
    return isObservableObjectAdministration(thing[$mobx]);
  }
  return false;
}
function recordAnnotationApplied(adm, annotation, key) {
  var _adm$target_$storedAn;
  if (process.env.NODE_ENV !== "production") {
    adm.appliedAnnotations_[key] = annotation;
  }
  // Remove applied decorator annotation so we don't try to apply it again in subclass constructor
  (_adm$target_$storedAn = adm.target_[storedAnnotationsSymbol]) == null || delete _adm$target_$storedAn[key];
}
function assertAnnotable(adm, annotation, key) {
  // Valid annotation
  if (process.env.NODE_ENV !== "production" && !isAnnotation(annotation)) {
    die("Cannot annotate '" + adm.name_ + "." + key.toString() + "': Invalid annotation.");
  }
  /*
  // Configurable, not sealed, not frozen
  // Possibly not needed, just a little better error then the one thrown by engine.
  // Cases where this would be useful the most (subclass field initializer) are not interceptable by this.
  if (__DEV__) {
      const configurable = getDescriptor(adm.target_, key)?.configurable
      const frozen = Object.isFrozen(adm.target_)
      const sealed = Object.isSealed(adm.target_)
      if (!configurable || frozen || sealed) {
          const fieldName = `${adm.name_}.${key.toString()}`
          const requestedAnnotationType = annotation.annotationType_
          let error = `Cannot apply '${requestedAnnotationType}' to '${fieldName}':`
          if (frozen) {
              error += `\nObject is frozen.`
          }
          if (sealed) {
              error += `\nObject is sealed.`
          }
          if (!configurable) {
              error += `\nproperty is not configurable.`
              // Mention only if caused by us to avoid confusion
              if (hasProp(adm.appliedAnnotations!, key)) {
                  error += `\nTo prevent accidental re-definition of a field by a subclass, `
                  error += `all annotated fields of non-plain objects (classes) are not configurable.`
              }
          }
          die(error)
      }
  }
  */
  // Not annotated
  if (process.env.NODE_ENV !== "production" && !isOverride(annotation) && hasProp(adm.appliedAnnotations_, key)) {
    var fieldName = adm.name_ + "." + key.toString();
    var currentAnnotationType = adm.appliedAnnotations_[key].annotationType_;
    var requestedAnnotationType = annotation.annotationType_;
    die("Cannot apply '" + requestedAnnotationType + "' to '" + fieldName + "':" + ("\nThe field is already annotated with '" + currentAnnotationType + "'.") + "\nRe-annotating fields is not allowed." + "\nUse 'override' annotation for methods overridden by subclass.");
  }
}

// Bug in safari 9.* (or iOS 9 safari mobile). See #364
var ENTRY_0 = /*#__PURE__*/createArrayEntryDescriptor(0);
var safariPrototypeSetterInheritanceBug = /*#__PURE__*/function () {
  var v = false;
  var p = {};
  Object.defineProperty(p, "0", {
    set: function set() {
      v = true;
    }
  });
  /*#__PURE__*/Object.create(p)["0"] = 1;
  return v === false;
}();
/**
 * This array buffer contains two lists of properties, so that all arrays
 * can recycle their property definitions, which significantly improves performance of creating
 * properties on the fly.
 */
var OBSERVABLE_ARRAY_BUFFER_SIZE = 0;
// Typescript workaround to make sure ObservableArray extends Array
var StubArray = function StubArray() {};
function inherit(ctor, proto) {
  if (Object.setPrototypeOf) {
    Object.setPrototypeOf(ctor.prototype, proto);
  } else if (ctor.prototype.__proto__ !== undefined) {
    ctor.prototype.__proto__ = proto;
  } else {
    ctor.prototype = proto;
  }
}
inherit(StubArray, Array.prototype);
// Weex proto freeze protection was here,
// but it is unclear why the hack is need as MobX never changed the prototype
// anyway, so removed it in V6
var LegacyObservableArray = /*#__PURE__*/function (_StubArray) {
  function LegacyObservableArray(initialValues, enhancer, name, owned) {
    var _this;
    if (name === void 0) {
      name = process.env.NODE_ENV !== "production" ? "ObservableArray@" + getNextId() : "ObservableArray";
    }
    if (owned === void 0) {
      owned = false;
    }
    _this = _StubArray.call(this) || this;
    initObservable(function () {
      var adm = new ObservableArrayAdministration(name, enhancer, owned, true);
      adm.proxy_ = _this;
      addHiddenFinalProp$1(_this, $mobx, adm);
      if (initialValues && initialValues.length) {
        // @ts-ignore
        _this.spliceWithArray(0, 0, initialValues);
      }
      if (safariPrototypeSetterInheritanceBug) {
        // Seems that Safari won't use numeric prototype setter until any * numeric property is
        // defined on the instance. After that it works fine, even if this property is deleted.
        Object.defineProperty(_this, "0", ENTRY_0);
      }
    });
    return _this;
  }
  _inheritsLoose(LegacyObservableArray, _StubArray);
  var _proto = LegacyObservableArray.prototype;
  _proto.concat = function concat() {
    this[$mobx].atom_.reportObserved();
    for (var _len = arguments.length, arrays = new Array(_len), _key = 0; _key < _len; _key++) {
      arrays[_key] = arguments[_key];
    }
    return Array.prototype.concat.apply(this.slice(),
    //@ts-ignore
    arrays.map(function (a) {
      return isObservableArray(a) ? a.slice() : a;
    }));
  };
  _proto[Symbol.iterator] = function () {
    var self = this;
    var nextIndex = 0;
    return makeIterable({
      next: function next() {
        return nextIndex < self.length ? {
          value: self[nextIndex++],
          done: false
        } : {
          done: true,
          value: undefined
        };
      }
    });
  };
  return _createClass(LegacyObservableArray, [{
    key: "length",
    get: function get() {
      return this[$mobx].getArrayLength_();
    },
    set: function set(newLength) {
      this[$mobx].setArrayLength_(newLength);
    }
  }, {
    key: Symbol.toStringTag,
    get: function get() {
      return "Array";
    }
  }]);
}(StubArray);
Object.entries(arrayExtensions).forEach(function (_ref) {
  var prop = _ref[0],
    fn = _ref[1];
  if (prop !== "concat") {
    addHiddenProp(LegacyObservableArray.prototype, prop, fn);
  }
});
function createArrayEntryDescriptor(index) {
  return {
    enumerable: false,
    configurable: true,
    get: function get() {
      return this[$mobx].get_(index);
    },
    set: function set(value) {
      this[$mobx].set_(index, value);
    }
  };
}
function createArrayBufferItem(index) {
  defineProperty$1(LegacyObservableArray.prototype, "" + index, createArrayEntryDescriptor(index));
}
function reserveArrayBuffer(max) {
  if (max > OBSERVABLE_ARRAY_BUFFER_SIZE) {
    for (var index = OBSERVABLE_ARRAY_BUFFER_SIZE; index < max + 100; index++) {
      createArrayBufferItem(index);
    }
    OBSERVABLE_ARRAY_BUFFER_SIZE = max;
  }
}
reserveArrayBuffer(1000);
function createLegacyArray(initialValues, enhancer, name) {
  return new LegacyObservableArray(initialValues, enhancer, name);
}

function getAtom(thing, property) {
  if (typeof thing === "object" && thing !== null) {
    if (isObservableArray(thing)) {
      if (property !== undefined) {
        die(23);
      }
      return thing[$mobx].atom_;
    }
    if (isObservableSet(thing)) {
      return thing.atom_;
    }
    if (isObservableMap(thing)) {
      if (property === undefined) {
        return thing.keysAtom_;
      }
      var observable = thing.data_.get(property) || thing.hasMap_.get(property);
      if (!observable) {
        die(25, property, getDebugName(thing));
      }
      return observable;
    }
    if (isObservableObject(thing)) {
      if (!property) {
        return die(26);
      }
      var _observable = thing[$mobx].values_.get(property);
      if (!_observable) {
        die(27, property, getDebugName(thing));
      }
      return _observable;
    }
    if (isAtom(thing) || isComputedValue(thing) || isReaction(thing)) {
      return thing;
    }
  } else if (isFunction(thing)) {
    if (isReaction(thing[$mobx])) {
      // disposer function
      return thing[$mobx];
    }
  }
  die(28);
}
function getAdministration(thing, property) {
  if (!thing) {
    die(29);
  }
  if (property !== undefined) {
    return getAdministration(getAtom(thing, property));
  }
  if (isAtom(thing) || isComputedValue(thing) || isReaction(thing)) {
    return thing;
  }
  if (isObservableMap(thing) || isObservableSet(thing)) {
    return thing;
  }
  if (thing[$mobx]) {
    return thing[$mobx];
  }
  die(24, thing);
}
function getDebugName(thing, property) {
  var named;
  if (property !== undefined) {
    named = getAtom(thing, property);
  } else if (isAction(thing)) {
    return thing.name;
  } else if (isObservableObject(thing) || isObservableMap(thing) || isObservableSet(thing)) {
    named = getAdministration(thing);
  } else {
    // valid for arrays as well
    named = getAtom(thing);
  }
  return named.name_;
}
/**
 * Helper function for initializing observable structures, it applies:
 * 1. allowStateChanges so we don't violate enforceActions.
 * 2. untracked so we don't accidentaly subscribe to anything observable accessed during init in case the observable is created inside derivation.
 * 3. batch to avoid state version updates
 */
function initObservable(cb) {
  var derivation = untrackedStart();
  var allowStateChanges = allowStateChangesStart(true);
  startBatch();
  try {
    return cb();
  } finally {
    endBatch();
    allowStateChangesEnd(allowStateChanges);
    untrackedEnd(derivation);
  }
}

var toString = objectPrototype.toString;
function deepEqual(a, b, depth) {
  if (depth === void 0) {
    depth = -1;
  }
  return eq(a, b, depth);
}
// Copied from https://github.com/jashkenas/underscore/blob/5c237a7c682fb68fd5378203f0bf22dce1624854/underscore.js#L1186-L1289
// Internal recursive comparison function for `isEqual`.
function eq(a, b, depth, aStack, bStack) {
  // Identical objects are equal. `0 === -0`, but they aren't identical.
  // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
  if (a === b) {
    return a !== 0 || 1 / a === 1 / b;
  }
  // `null` or `undefined` only equal to itself (strict comparison).
  if (a == null || b == null) {
    return false;
  }
  // `NaN`s are equivalent, but non-reflexive.
  if (a !== a) {
    return b !== b;
  }
  // Exhaust primitive checks
  var type = typeof a;
  if (type !== "function" && type !== "object" && typeof b != "object") {
    return false;
  }
  // Compare `[[Class]]` names.
  var className = toString.call(a);
  if (className !== toString.call(b)) {
    return false;
  }
  switch (className) {
    // Strings, numbers, regular expressions, dates, and booleans are compared by value.
    case "[object RegExp]":
    // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
    case "[object String]":
      // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
      // equivalent to `new String("5")`.
      return "" + a === "" + b;
    case "[object Number]":
      // `NaN`s are equivalent, but non-reflexive.
      // Object(NaN) is equivalent to NaN.
      if (+a !== +a) {
        return +b !== +b;
      }
      // An `egal` comparison is performed for other numeric values.
      return +a === 0 ? 1 / +a === 1 / b : +a === +b;
    case "[object Date]":
    case "[object Boolean]":
      // Coerce dates and booleans to numeric primitive values. Dates are compared by their
      // millisecond representations. Note that invalid dates with millisecond representations
      // of `NaN` are not equivalent.
      return +a === +b;
    case "[object Symbol]":
      return typeof Symbol !== "undefined" && Symbol.valueOf.call(a) === Symbol.valueOf.call(b);
    case "[object Map]":
    case "[object Set]":
      // Maps and Sets are unwrapped to arrays of entry-pairs, adding an incidental level.
      // Hide this extra level by increasing the depth.
      if (depth >= 0) {
        depth++;
      }
      break;
  }
  // Unwrap any wrapped objects.
  a = unwrap(a);
  b = unwrap(b);
  var areArrays = className === "[object Array]";
  if (!areArrays) {
    if (typeof a != "object" || typeof b != "object") {
      return false;
    }
    // Objects with different constructors are not equivalent, but `Object`s or `Array`s
    // from different frames are.
    var aCtor = a.constructor,
      bCtor = b.constructor;
    if (aCtor !== bCtor && !(isFunction(aCtor) && aCtor instanceof aCtor && isFunction(bCtor) && bCtor instanceof bCtor) && "constructor" in a && "constructor" in b) {
      return false;
    }
  }
  if (depth === 0) {
    return false;
  } else if (depth < 0) {
    depth = -1;
  }
  // Assume equality for cyclic structures. The algorithm for detecting cyclic
  // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.
  // Initializing stack of traversed objects.
  // It's done here since we only need them for objects and arrays comparison.
  aStack = aStack || [];
  bStack = bStack || [];
  var length = aStack.length;
  while (length--) {
    // Linear search. Performance is inversely proportional to the number of
    // unique nested structures.
    if (aStack[length] === a) {
      return bStack[length] === b;
    }
  }
  // Add the first object to the stack of traversed objects.
  aStack.push(a);
  bStack.push(b);
  // Recursively compare objects and arrays.
  if (areArrays) {
    // Compare array lengths to determine if a deep comparison is necessary.
    length = a.length;
    if (length !== b.length) {
      return false;
    }
    // Deep compare the contents, ignoring non-numeric properties.
    while (length--) {
      if (!eq(a[length], b[length], depth - 1, aStack, bStack)) {
        return false;
      }
    }
  } else {
    // Deep compare objects.
    var keys = Object.keys(a);
    var key;
    length = keys.length;
    // Ensure that both objects contain the same number of properties before comparing deep equality.
    if (Object.keys(b).length !== length) {
      return false;
    }
    while (length--) {
      // Deep compare each member
      key = keys[length];
      if (!(hasProp(b, key) && eq(a[key], b[key], depth - 1, aStack, bStack))) {
        return false;
      }
    }
  }
  // Remove the first object from the stack of traversed objects.
  aStack.pop();
  bStack.pop();
  return true;
}
function unwrap(a) {
  if (isObservableArray(a)) {
    return a.slice();
  }
  if (isES6Map(a) || isObservableMap(a)) {
    return Array.from(a.entries());
  }
  if (isES6Set(a) || isObservableSet(a)) {
    return Array.from(a.entries());
  }
  return a;
}

var _getGlobal$Iterator;
// safely get iterator prototype if available
var maybeIteratorPrototype = ((_getGlobal$Iterator = /*#__PURE__*/getGlobal().Iterator) == null ? void 0 : _getGlobal$Iterator.prototype) || {};
function makeIterable(iterator) {
  iterator[Symbol.iterator] = getSelf;
  return Object.assign(Object.create(maybeIteratorPrototype), iterator);
}
function getSelf() {
  return this;
}

function isAnnotation(thing) {
  return (
    // Can be function
    thing instanceof Object && typeof thing.annotationType_ === "string" && isFunction(thing.make_) && isFunction(thing.extend_)
  );
}

/**
 * (c) Michel Weststrate 2015 - 2020
 * MIT Licensed
 *
 * Welcome to the mobx sources! To get a global overview of how MobX internally works,
 * this is a good place to start:
 * https://medium.com/@mweststrate/becoming-fully-reactive-an-in-depth-explanation-of-mobservable-55995262a254#.xvbh6qd74
 *
 * Source folders:
 * ===============
 *
 * - api/     Most of the public static methods exposed by the module can be found here.
 * - core/    Implementation of the MobX algorithm; atoms, derivations, reactions, dependency trees, optimizations. Cool stuff can be found here.
 * - types/   All the magic that is need to have observable objects, arrays and values is in this folder. Including the modifiers like `asFlat`.
 * - utils/   Utility stuff.
 *
 */
["Symbol", "Map", "Set"].forEach(function (m) {
  var g = getGlobal();
  if (typeof g[m] === "undefined") {
    die("MobX requires global '" + m + "' to be available or polyfilled");
  }
});
if (typeof __MOBX_DEVTOOLS_GLOBAL_HOOK__ === "object") {
  // See: https://github.com/andykog/mobx-devtools/
  __MOBX_DEVTOOLS_GLOBAL_HOOK__.injectMobx({
    spy: spy,
    extras: {
      getDebugName: getDebugName
    },
    $mobx: $mobx
  });
}

var livelinessChecking = "warn";
/**
 * Defines what MST should do when running into reads / writes to objects that have died.
 * By default it will print a warning.
 * Use the `"error"` option to easy debugging to see where the error was thrown and when the offending read / write took place
 *
 * @param mode `"warn"`, `"error"` or `"ignore"`
 */
function setLivelinessChecking(mode) {
    livelinessChecking = mode;
}
/**
 * Returns the current liveliness checking mode.
 *
 * @returns `"warn"`, `"error"` or `"ignore"`
 */
function getLivelinessChecking() {
    return livelinessChecking;
}

/**
 * @hidden
 */
var Hook;
(function (Hook) {
    Hook["afterCreate"] = "afterCreate";
    Hook["afterAttach"] = "afterAttach";
    Hook["afterCreationFinalization"] = "afterCreationFinalization";
    Hook["beforeDetach"] = "beforeDetach";
    Hook["beforeDestroy"] = "beforeDestroy";
})(Hook || (Hook = {}));

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol, Iterator */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spreadArray(to, from, pack) {
    if (arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

/**
 * Returns the _actual_ type of the given tree node. (Or throws)
 *
 * @param object
 * @returns
 */
function getType(object) {
    assertIsStateTreeNode(object, 1);
    return getStateTreeNode(object).type;
}
/**
 * Applies a JSON-patch to the given model instance or bails out if the patch couldn't be applied
 * See [patches](https://github.com/mobxjs/mobx-state-tree#patches) for more details.
 *
 * Can apply a single past, or an array of patches.
 *
 * @param target
 * @param patch
 * @returns
 */
function applyPatch(target, patch) {
    // check all arguments
    assertIsStateTreeNode(target, 1);
    assertArg(patch, function (p) { return typeof p === "object"; }, "object or array", 2);
    getStateTreeNode(target).applyPatches(asArray(patch));
}
/**
 * Applies a snapshot to a given model instances. Patch and snapshot listeners will be invoked as usual.
 *
 * @param target
 * @param snapshot
 * @returns
 */
function applySnapshot(target, snapshot) {
    // check all arguments
    assertIsStateTreeNode(target, 1);
    return getStateTreeNode(target).applySnapshot(snapshot);
}
/**
 * Calculates a snapshot from the given model instance. The snapshot will always reflect the latest state but use
 * structural sharing where possible. Doesn't require MobX transactions to be completed.
 *
 * @param target
 * @param applyPostProcess If true (the default) then postProcessSnapshot gets applied.
 * @returns
 */
function getSnapshot(target, applyPostProcess) {
    if (applyPostProcess === void 0) { applyPostProcess = true; }
    // check all arguments
    assertIsStateTreeNode(target, 1);
    var node = getStateTreeNode(target);
    if (applyPostProcess)
        return node.snapshot;
    return freeze(node.type.getSnapshot(node, false));
}
/**
 * Returns the immediate parent of this object, or throws.
 *
 * Note that the immediate parent can be either an object, map or array, and
 * doesn't necessarily refer to the parent model.
 *
 * Please note that in child nodes access to the root is only possible
 * once the `afterAttach` hook has fired.
 *
 * @param target
 * @param depth How far should we look upward? 1 by default.
 * @returns
 */
function getParent(target, depth) {
    if (depth === void 0) { depth = 1; }
    // check all arguments
    assertIsStateTreeNode(target, 1);
    assertIsNumber(depth, 2, 0);
    var d = depth;
    var parent = getStateTreeNode(target).parent;
    while (parent) {
        if (--d === 0)
            return parent.storedValue;
        parent = parent.parent;
    }
    throw new MstError("Failed to find the parent of ".concat(getStateTreeNode(target), " at depth ").concat(depth));
}
/**
 * Given an object in a model tree, returns the root object of that tree.
 *
 * Please note that in child nodes access to the root is only possible
 * once the `afterAttach` hook has fired.
 *
 * @param target
 * @returns
 */
function getRoot(target) {
    // check all arguments
    assertIsStateTreeNode(target, 1);
    return getStateTreeNode(target).root.storedValue;
}
/**
 * Returns the path of the given object in the model tree
 *
 * @param target
 * @returns
 */
function getPath(target) {
    // check all arguments
    assertIsStateTreeNode(target, 1);
    return getStateTreeNode(target).path;
}
/**
 * Returns the identifier of the target node.
 * This is the *string normalized* identifier, which might not match the type of the identifier attribute
 *
 * @param target
 * @returns
 */
function getIdentifier(target) {
    // check all arguments
    assertIsStateTreeNode(target, 1);
    return getStateTreeNode(target).identifier;
}
/**
 * Returns a deep copy of the given state tree node as new tree.
 * Shorthand for `snapshot(x) = getType(x).create(getSnapshot(x))`
 *
 * _Tip: clone will create a literal copy, including the same identifiers. To modify identifiers etc. during cloning, don't use clone but take a snapshot of the tree, modify it, and create new instance_
 *
 * @param source
 * @param keepEnvironment indicates whether the clone should inherit the same environment (`true`, the default), or not have an environment (`false`). If an object is passed in as second argument, that will act as the environment for the cloned tree.
 * @returns
 */
function clone(source, keepEnvironment) {
    if (keepEnvironment === void 0) { keepEnvironment = true; }
    // check all arguments
    assertIsStateTreeNode(source, 1);
    var node = getStateTreeNode(source);
    return node.type.create(node.snapshot, keepEnvironment === true
        ? node.root.environment
        : keepEnvironment === false
            ? undefined
            : keepEnvironment); // it's an object or something else
}

/**
 * @internal
 * @hidden
 */
var BaseNode = /** @class */ (function () {
    function BaseNode(type, parent, subpath, environment) {
        Object.defineProperty(this, "type", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: type
        });
        Object.defineProperty(this, "environment", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: environment
        });
        Object.defineProperty(this, "_escapedSubpath", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_subpath", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_subpathUponDeath", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_pathUponDeath", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "storedValue", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        }); // usually the same type as the value, but not always (such as with references)
        Object.defineProperty(this, "aliveAtom", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_state", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: NodeLifeCycle.INITIALIZING
        });
        Object.defineProperty(this, "_hookSubscribers", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_parent", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "pathAtom", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.environment = environment;
        this.baseSetParent(parent, subpath);
    }
    Object.defineProperty(BaseNode.prototype, "subpath", {
        get: function () {
            return this._subpath;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseNode.prototype, "subpathUponDeath", {
        get: function () {
            return this._subpathUponDeath;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseNode.prototype, "pathUponDeath", {
        get: function () {
            return this._pathUponDeath;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseNode.prototype, "value", {
        get: function () {
            return this.type.getValue(this);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseNode.prototype, "state", {
        get: function () {
            return this._state;
        },
        set: function (val) {
            var wasAlive = this.isAlive;
            this._state = val;
            var isAlive = this.isAlive;
            if (this.aliveAtom && wasAlive !== isAlive) {
                this.aliveAtom.reportChanged();
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseNode.prototype, "fireInternalHook", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (name) {
            if (this._hookSubscribers) {
                this._hookSubscribers.emit(name, this, name);
            }
        }
    });
    Object.defineProperty(BaseNode.prototype, "registerHook", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (hook, hookHandler) {
            if (!this._hookSubscribers) {
                this._hookSubscribers = new EventHandlers();
            }
            return this._hookSubscribers.register(hook, hookHandler);
        }
    });
    Object.defineProperty(BaseNode.prototype, "parent", {
        get: function () {
            return this._parent;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseNode.prototype, "getReconciliationType", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return this.type;
        }
    });
    Object.defineProperty(BaseNode.prototype, "baseSetParent", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parent, subpath) {
            this._parent = parent;
            this._subpath = subpath;
            this._escapedSubpath = undefined; // regenerate when needed
            if (this.pathAtom) {
                this.pathAtom.reportChanged();
            }
        }
    });
    Object.defineProperty(BaseNode.prototype, "path", {
        /*
         * Returns (escaped) path representation as string
         */
        get: function () {
            return this.getEscapedPath(true);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseNode.prototype, "getEscapedPath", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (reportObserved) {
            if (reportObserved) {
                if (!this.pathAtom) {
                    this.pathAtom = createAtom("path");
                }
                this.pathAtom.reportObserved();
            }
            if (!this.parent)
                return "";
            // regenerate escaped subpath if needed
            if (this._escapedSubpath === undefined) {
                this._escapedSubpath = !this._subpath ? "" : escapeJsonPath(this._subpath);
            }
            return this.parent.getEscapedPath(reportObserved) + "/" + this._escapedSubpath;
        }
    });
    Object.defineProperty(BaseNode.prototype, "isRoot", {
        get: function () {
            return this.parent === null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseNode.prototype, "isAlive", {
        get: function () {
            return this.state !== NodeLifeCycle.DEAD;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseNode.prototype, "isDetaching", {
        get: function () {
            return this.state === NodeLifeCycle.DETACHING;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseNode.prototype, "observableIsAlive", {
        get: function () {
            if (!this.aliveAtom) {
                this.aliveAtom = createAtom("alive");
            }
            this.aliveAtom.reportObserved();
            return this.isAlive;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseNode.prototype, "baseFinalizeCreation", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (whenFinalized) {
            if (devMode()) {
                if (!this.isAlive) {
                    // istanbul ignore next
                    throw new MstError("assertion failed: cannot finalize the creation of a node that is already dead");
                }
            }
            // goal: afterCreate hooks runs depth-first. After attach runs parent first, so on afterAttach the parent has completed already
            if (this.state === NodeLifeCycle.CREATED) {
                if (this.parent) {
                    if (this.parent.state !== NodeLifeCycle.FINALIZED) {
                        // parent not ready yet, postpone
                        return;
                    }
                    this.fireHook(Hook.afterAttach);
                }
                this.state = NodeLifeCycle.FINALIZED;
                if (whenFinalized) {
                    whenFinalized();
                }
            }
        }
    });
    Object.defineProperty(BaseNode.prototype, "baseFinalizeDeath", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            if (this._hookSubscribers) {
                this._hookSubscribers.clearAll();
            }
            this._subpathUponDeath = this._subpath;
            this._pathUponDeath = this.getEscapedPath(false);
            this.baseSetParent(null, "");
            this.state = NodeLifeCycle.DEAD;
        }
    });
    Object.defineProperty(BaseNode.prototype, "baseAboutToDie", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            this.fireHook(Hook.beforeDestroy);
        }
    });
    return BaseNode;
}());

/**
 * @internal
 * @hidden
 */
var ScalarNode = /** @class */ (function (_super) {
    __extends(ScalarNode, _super);
    function ScalarNode(simpleType, parent, subpath, environment, initialSnapshot) {
        var _this = _super.call(this, simpleType, parent, subpath, environment) || this;
        try {
            _this.storedValue = simpleType.createNewInstance(initialSnapshot);
        }
        catch (e) {
            // short-cut to die the instance, to avoid the snapshot computed starting to throw...
            _this.state = NodeLifeCycle.DEAD;
            throw e;
        }
        _this.state = NodeLifeCycle.CREATED;
        // for scalar nodes there's no point in firing this event since it would fire on the constructor, before
        // anybody can actually register for/listen to it
        // this.fireHook(Hook.AfterCreate)
        _this.finalizeCreation();
        return _this;
    }
    Object.defineProperty(ScalarNode.prototype, "root", {
        get: function () {
            // future optimization: store root ref in the node and maintain it
            if (!this.parent)
                throw new MstError("This scalar node is not part of a tree");
            return this.parent.root;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ScalarNode.prototype, "setParent", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (newParent, subpath) {
            var parentChanged = this.parent !== newParent;
            var subpathChanged = this.subpath !== subpath;
            if (!parentChanged && !subpathChanged) {
                return;
            }
            if (devMode()) {
                if (!subpath) {
                    // istanbul ignore next
                    throw new MstError("assertion failed: subpath expected");
                }
                if (!newParent) {
                    // istanbul ignore next
                    throw new MstError("assertion failed: parent expected");
                }
                if (parentChanged) {
                    // istanbul ignore next
                    throw new MstError("assertion failed: scalar nodes cannot change their parent");
                }
            }
            this.environment = undefined; // use parent's
            this.baseSetParent(this.parent, subpath);
        }
    });
    Object.defineProperty(ScalarNode.prototype, "snapshot", {
        get: function () {
            return freeze(this.getSnapshot());
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ScalarNode.prototype, "getSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return this.type.getSnapshot(this);
        }
    });
    Object.defineProperty(ScalarNode.prototype, "toString", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var path = (this.isAlive ? this.path : this.pathUponDeath) || "<root>";
            return "".concat(this.type.name, "@").concat(path).concat(this.isAlive ? "" : " [dead]");
        }
    });
    Object.defineProperty(ScalarNode.prototype, "die", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            if (!this.isAlive || this.state === NodeLifeCycle.DETACHING)
                return;
            this.aboutToDie();
            this.finalizeDeath();
        }
    });
    Object.defineProperty(ScalarNode.prototype, "finalizeCreation", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            this.baseFinalizeCreation();
        }
    });
    Object.defineProperty(ScalarNode.prototype, "aboutToDie", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            this.baseAboutToDie();
        }
    });
    Object.defineProperty(ScalarNode.prototype, "finalizeDeath", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            this.baseFinalizeDeath();
        }
    });
    Object.defineProperty(ScalarNode.prototype, "fireHook", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (name) {
            this.fireInternalHook(name);
        }
    });
    return ScalarNode;
}(BaseNode));
ScalarNode.prototype.die = action(ScalarNode.prototype.die);

var nextNodeId = 1;
var ObservableInstanceLifecycle;
(function (ObservableInstanceLifecycle) {
    // the actual observable instance has not been created yet
    ObservableInstanceLifecycle[ObservableInstanceLifecycle["UNINITIALIZED"] = 0] = "UNINITIALIZED";
    // the actual observable instance is being created
    ObservableInstanceLifecycle[ObservableInstanceLifecycle["CREATING"] = 1] = "CREATING";
    // the actual observable instance has been created
    ObservableInstanceLifecycle[ObservableInstanceLifecycle["CREATED"] = 2] = "CREATED";
})(ObservableInstanceLifecycle || (ObservableInstanceLifecycle = {}));
var InternalEvents;
(function (InternalEvents) {
    InternalEvents["Dispose"] = "dispose";
    InternalEvents["Patch"] = "patch";
    InternalEvents["Snapshot"] = "snapshot";
})(InternalEvents || (InternalEvents = {}));
var snapshotReactionOptions = {
    onError: function (e) {
        throw e;
    }
};
/**
 * @internal
 * @hidden
 */
var ObjectNode = /** @class */ (function (_super) {
    __extends(ObjectNode, _super);
    function ObjectNode(complexType, parent, subpath, environment, initialValue) {
        var _this = _super.call(this, complexType, parent, subpath, environment) || this;
        Object.defineProperty(_this, "nodeId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ++nextNodeId
        });
        Object.defineProperty(_this, "identifierAttribute", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(_this, "identifier", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        }); // Identifier is always normalized to string, even if the identifier property isn't
        Object.defineProperty(_this, "unnormalizedIdentifier", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(_this, "identifierCache", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(_this, "isProtectionEnabled", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: true
        });
        Object.defineProperty(_this, "middlewares", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(_this, "hasSnapshotPostProcessor", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(_this, "_applyPatches", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(_this, "_applySnapshot", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(_this, "_autoUnbox", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: true
        }); // unboxing is disabled when reading child nodes
        Object.defineProperty(_this, "_isRunningAction", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        }); // only relevant for root
        Object.defineProperty(_this, "_hasSnapshotReaction", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(_this, "_observableInstanceState", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ObservableInstanceLifecycle.UNINITIALIZED
        });
        Object.defineProperty(_this, "_childNodes", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(_this, "_initialSnapshot", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(_this, "_cachedInitialSnapshot", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(_this, "_cachedInitialSnapshotCreated", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(_this, "_snapshotComputed", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(_this, "_snapshotUponDeath", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        // #region internal event handling
        Object.defineProperty(_this, "_internalEvents", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        _this._snapshotComputed = computed(function () { return freeze(_this.getSnapshot()); });
        _this.unbox = _this.unbox.bind(_this);
        _this._initialSnapshot = freeze(initialValue);
        _this.identifierAttribute = complexType.identifierAttribute;
        if (!parent) {
            _this.identifierCache = new IdentifierCache();
        }
        _this._childNodes = complexType.initializeChildNodes(_this, _this._initialSnapshot);
        // identifier can not be changed during lifecycle of a node
        // so we safely can read it from initial snapshot
        _this.identifier = null;
        _this.unnormalizedIdentifier = null;
        if (_this.identifierAttribute && _this._initialSnapshot) {
            var id = _this._initialSnapshot[_this.identifierAttribute];
            if (id === undefined) {
                // try with the actual node if not (for optional identifiers)
                var childNode = _this._childNodes[_this.identifierAttribute];
                if (childNode) {
                    id = childNode.value;
                }
            }
            if (typeof id !== "string" && typeof id !== "number") {
                throw new MstError("Instance identifier '".concat(_this.identifierAttribute, "' for type '").concat(_this.type.name, "' must be a string or a number"));
            }
            // normalize internal identifier to string
            _this.identifier = normalizeIdentifier(id);
            _this.unnormalizedIdentifier = id;
        }
        if (!parent) {
            _this.identifierCache.addNodeToCache(_this);
        }
        else {
            parent.root.identifierCache.addNodeToCache(_this);
        }
        return _this;
    }
    Object.defineProperty(ObjectNode.prototype, "applyPatches", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (patches) {
            this.createObservableInstanceIfNeeded();
            this._applyPatches(patches);
        }
    });
    Object.defineProperty(ObjectNode.prototype, "applySnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (snapshot) {
            this.createObservableInstanceIfNeeded();
            this._applySnapshot(snapshot);
        }
    });
    Object.defineProperty(ObjectNode.prototype, "createObservableInstanceIfNeeded", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (fireHooks) {
            if (fireHooks === void 0) { fireHooks = true; }
            if (this._observableInstanceState === ObservableInstanceLifecycle.UNINITIALIZED) {
                this.createObservableInstance(fireHooks);
            }
        }
    });
    Object.defineProperty(ObjectNode.prototype, "createObservableInstance", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (fireHooks) {
            var e_1, _a, e_2, _b;
            if (fireHooks === void 0) { fireHooks = true; }
            if (devMode()) {
                if (this.state !== NodeLifeCycle.INITIALIZING) {
                    // istanbul ignore next
                    throw new MstError("assertion failed: the creation of the observable instance must be done on the initializing phase");
                }
            }
            this._observableInstanceState = ObservableInstanceLifecycle.CREATING;
            // make sure the parent chain is created as well
            // array with parent chain from parent to child
            var parentChain = [];
            var parent = this.parent;
            // for performance reasons we never go back further than the most direct
            // uninitialized parent
            // this is done to avoid traversing the whole tree to the root when using
            // the same reference again
            while (parent &&
                parent._observableInstanceState === ObservableInstanceLifecycle.UNINITIALIZED) {
                parentChain.unshift(parent);
                parent = parent.parent;
            }
            try {
                // initialize the uninitialized parent chain from parent to child
                for (var parentChain_1 = __values(parentChain), parentChain_1_1 = parentChain_1.next(); !parentChain_1_1.done; parentChain_1_1 = parentChain_1.next()) {
                    var p = parentChain_1_1.value;
                    // delay firing hooks until after all parents have been created
                    p.createObservableInstanceIfNeeded(false);
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (parentChain_1_1 && !parentChain_1_1.done && (_a = parentChain_1.return)) _a.call(parentChain_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
            var type = this.type;
            try {
                this.storedValue = type.createNewInstance(this._childNodes);
                this.preboot();
                this._isRunningAction = true;
                type.finalizeNewInstance(this, this.storedValue);
            }
            catch (e) {
                // short-cut to die the instance, to avoid the snapshot computed starting to throw...
                this.state = NodeLifeCycle.DEAD;
                throw e;
            }
            finally {
                this._isRunningAction = false;
            }
            this._observableInstanceState = ObservableInstanceLifecycle.CREATED;
            this._snapshotComputed.trackAndCompute();
            if (this.isRoot)
                this._addSnapshotReaction();
            this._childNodes = EMPTY_OBJECT;
            this.state = NodeLifeCycle.CREATED;
            if (fireHooks) {
                this.fireHook(Hook.afterCreate);
                // Note that the parent might not be finalized at this point
                // so afterAttach won't be called until later in that case
                this.finalizeCreation();
                try {
                    // fire the hooks of the parents that we created
                    for (var _c = __values(parentChain.reverse()), _d = _c.next(); !_d.done; _d = _c.next()) {
                        var p = _d.value;
                        p.fireHook(Hook.afterCreate);
                        // This will call afterAttach on the child if necessary
                        p.finalizeCreation();
                    }
                }
                catch (e_2_1) { e_2 = { error: e_2_1 }; }
                finally {
                    try {
                        if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
                    }
                    finally { if (e_2) throw e_2.error; }
                }
            }
        }
    });
    Object.defineProperty(ObjectNode.prototype, "root", {
        get: function () {
            var parent = this.parent;
            return parent ? parent.root : this;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ObjectNode.prototype, "clearParent", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            if (!this.parent)
                return;
            // detach if attached
            this.fireHook(Hook.beforeDetach);
            var previousState = this.state;
            this.state = NodeLifeCycle.DETACHING;
            var root = this.root;
            var newEnv = root.environment;
            var newIdCache = root.identifierCache.splitCache(this);
            try {
                this.parent.removeChild(this.subpath);
                this.baseSetParent(null, "");
                this.environment = newEnv;
                this.identifierCache = newIdCache;
            }
            finally {
                this.state = previousState;
            }
        }
    });
    Object.defineProperty(ObjectNode.prototype, "setParent", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (newParent, subpath) {
            var parentChanged = newParent !== this.parent;
            var subpathChanged = subpath !== this.subpath;
            if (!parentChanged && !subpathChanged) {
                return;
            }
            if (devMode()) {
                if (!subpath) {
                    // istanbul ignore next
                    throw new MstError("assertion failed: subpath expected");
                }
                if (!newParent) {
                    // istanbul ignore next
                    throw new MstError("assertion failed: new parent expected");
                }
                if (this.parent && parentChanged) {
                    throw new MstError("A node cannot exists twice in the state tree. Failed to add ".concat(this, " to path '").concat(newParent.path, "/").concat(subpath, "'."));
                }
                if (!this.parent && newParent.root === this) {
                    throw new MstError("A state tree is not allowed to contain itself. Cannot assign ".concat(this, " to path '").concat(newParent.path, "/").concat(subpath, "'"));
                }
                if (!this.parent &&
                    !!this.environment &&
                    this.environment !== newParent.root.environment) {
                    throw new MstError("A state tree cannot be made part of another state tree as long as their environments are different.");
                }
            }
            if (parentChanged) {
                // attach to new parent
                this.environment = undefined; // will use root's
                newParent.root.identifierCache.mergeCache(this);
                this.baseSetParent(newParent, subpath);
                this.fireHook(Hook.afterAttach);
            }
            else if (subpathChanged) {
                // moving to a new subpath on the same parent
                this.baseSetParent(this.parent, subpath);
            }
        }
    });
    Object.defineProperty(ObjectNode.prototype, "fireHook", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (name) {
            var _this = this;
            this.fireInternalHook(name);
            var fn = this.storedValue &&
                typeof this.storedValue === "object" &&
                this.storedValue[name];
            if (typeof fn === "function") {
                // we check for it to allow old mobx peer dependencies that don't have the method to work (even when still bugged)
                {
                    runInAction(function () {
                        fn.apply(_this.storedValue);
                    });
                }
            }
        }
    });
    Object.defineProperty(ObjectNode.prototype, "snapshot", {
        // advantage of using computed for a snapshot is that nicely respects transactions etc.
        get: function () {
            if (this.hasSnapshotPostProcessor) {
                this.createObservableInstanceIfNeeded();
            }
            return this._snapshotComputed.get();
        },
        enumerable: false,
        configurable: true
    });
    // NOTE: we use this method to get snapshot without creating @computed overhead
    Object.defineProperty(ObjectNode.prototype, "getSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            if (!this.isAlive)
                return this._snapshotUponDeath;
            return this._observableInstanceState === ObservableInstanceLifecycle.CREATED
                ? this._getActualSnapshot()
                : this._getCachedInitialSnapshot();
        }
    });
    Object.defineProperty(ObjectNode.prototype, "_getActualSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return this.type.getSnapshot(this);
        }
    });
    Object.defineProperty(ObjectNode.prototype, "_getCachedInitialSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            if (!this._cachedInitialSnapshotCreated) {
                var type = this.type;
                var childNodes = this._childNodes;
                var snapshot = this._initialSnapshot;
                this._cachedInitialSnapshot = type.processInitialSnapshot(childNodes, snapshot);
                this._cachedInitialSnapshotCreated = true;
            }
            return this._cachedInitialSnapshot;
        }
    });
    Object.defineProperty(ObjectNode.prototype, "isRunningAction", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            if (this._isRunningAction)
                return true;
            if (this.isRoot)
                return false;
            return this.parent.isRunningAction();
        }
    });
    Object.defineProperty(ObjectNode.prototype, "assertAlive", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (context) {
            var livelinessChecking = getLivelinessChecking();
            if (!this.isAlive && livelinessChecking !== "ignore") {
                var error = this._getAssertAliveError(context);
                switch (livelinessChecking) {
                    case "error":
                        throw new MstError(error);
                    case "warn":
                        warnError(error);
                }
            }
        }
    });
    Object.defineProperty(ObjectNode.prototype, "_getAssertAliveError", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (context) {
            var escapedPath = this.getEscapedPath(false) || this.pathUponDeath || "";
            var subpath = (context.subpath && escapeJsonPath(context.subpath)) || "";
            var actionContext = context.actionContext || getCurrentActionContext();
            // try to use a real action context if possible since it includes the action name
            if (actionContext && actionContext.type !== "action" && actionContext.parentActionEvent) {
                actionContext = actionContext.parentActionEvent;
            }
            var actionFullPath = "";
            if (actionContext && actionContext.name != null) {
                // try to use the context, and if it not available use the node one
                var actionPath = (actionContext && actionContext.context && getPath(actionContext.context)) ||
                    escapedPath;
                actionFullPath = "".concat(actionPath, ".").concat(actionContext.name, "()");
            }
            return "You are trying to read or write to an object that is no longer part of a state tree. (Object type: '".concat(this.type.name, "', Path upon death: '").concat(escapedPath, "', Subpath: '").concat(subpath, "', Action: '").concat(actionFullPath, "'). Either detach nodes first, or don't use objects after removing / replacing them in the tree.");
        }
    });
    Object.defineProperty(ObjectNode.prototype, "getChildNode", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (subpath) {
            this.assertAlive({
                subpath: subpath
            });
            this._autoUnbox = false;
            try {
                return this._observableInstanceState === ObservableInstanceLifecycle.CREATED
                    ? this.type.getChildNode(this, subpath)
                    : this._childNodes[subpath];
            }
            finally {
                this._autoUnbox = true;
            }
        }
    });
    Object.defineProperty(ObjectNode.prototype, "getChildren", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            this.assertAlive(EMPTY_OBJECT);
            this._autoUnbox = false;
            try {
                return this._observableInstanceState === ObservableInstanceLifecycle.CREATED
                    ? this.type.getChildren(this)
                    : convertChildNodesToArray(this._childNodes);
            }
            finally {
                this._autoUnbox = true;
            }
        }
    });
    Object.defineProperty(ObjectNode.prototype, "getChildType", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (propertyName) {
            return this.type.getChildType(propertyName);
        }
    });
    Object.defineProperty(ObjectNode.prototype, "isProtected", {
        get: function () {
            return this.root.isProtectionEnabled;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ObjectNode.prototype, "assertWritable", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (context) {
            this.assertAlive(context);
            if (!this.isRunningAction() && this.isProtected) {
                throw new MstError("Cannot modify '".concat(this, "', the object is protected and can only be modified by using an action."));
            }
        }
    });
    Object.defineProperty(ObjectNode.prototype, "removeChild", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (subpath) {
            this.type.removeChild(this, subpath);
        }
    });
    // bound on the constructor
    Object.defineProperty(ObjectNode.prototype, "unbox", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (childNode) {
            if (!childNode)
                return childNode;
            this.assertAlive({
                subpath: childNode.subpath || childNode.subpathUponDeath
            });
            return this._autoUnbox ? childNode.value : childNode;
        }
    });
    Object.defineProperty(ObjectNode.prototype, "toString", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var path = (this.isAlive ? this.path : this.pathUponDeath) || "<root>";
            var identifier = this.identifier ? "(id: ".concat(this.identifier, ")") : "";
            return "".concat(this.type.name, "@").concat(path).concat(identifier).concat(this.isAlive ? "" : " [dead]");
        }
    });
    Object.defineProperty(ObjectNode.prototype, "finalizeCreation", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _this = this;
            this.baseFinalizeCreation(function () {
                var e_3, _a;
                try {
                    for (var _b = __values(_this.getChildren()), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var child = _c.value;
                        child.finalizeCreation();
                    }
                }
                catch (e_3_1) { e_3 = { error: e_3_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_3) throw e_3.error; }
                }
                _this.fireInternalHook(Hook.afterCreationFinalization);
            });
        }
    });
    Object.defineProperty(ObjectNode.prototype, "detach", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            if (!this.isAlive)
                throw new MstError("Error while detaching, node is not alive.");
            this.clearParent();
        }
    });
    Object.defineProperty(ObjectNode.prototype, "preboot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var self = this;
            this._applyPatches = createActionInvoker(this.storedValue, "@APPLY_PATCHES", function (patches) {
                patches.forEach(function (patch) {
                    if (!patch.path) {
                        self.type.applySnapshot(self, patch.value);
                        return;
                    }
                    var parts = splitJsonPath(patch.path);
                    var node = resolveNodeByPathParts(self, parts.slice(0, -1));
                    node.applyPatchLocally(parts[parts.length - 1], patch);
                });
            });
            this._applySnapshot = createActionInvoker(this.storedValue, "@APPLY_SNAPSHOT", function (snapshot) {
                // if the snapshot is the same as the current one, avoid performing a reconcile
                if (snapshot === self.snapshot)
                    return;
                // else, apply it by calling the type logic
                return self.type.applySnapshot(self, snapshot);
            });
            addHiddenFinalProp(this.storedValue, "$treenode", this);
            addHiddenFinalProp(this.storedValue, "toJSON", toJSON);
        }
    });
    Object.defineProperty(ObjectNode.prototype, "die", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            if (!this.isAlive || this.state === NodeLifeCycle.DETACHING)
                return;
            this.aboutToDie();
            this.finalizeDeath();
        }
    });
    Object.defineProperty(ObjectNode.prototype, "aboutToDie", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            if (this._observableInstanceState === ObservableInstanceLifecycle.UNINITIALIZED) {
                return;
            }
            this.getChildren().forEach(function (node) {
                node.aboutToDie();
            });
            // beforeDestroy should run before the disposers since else we could end up in a situation where
            // a disposer added with addDisposer at this stage (beforeDestroy) is actually never released
            this.baseAboutToDie();
            this._internalEventsEmit(InternalEvents.Dispose);
            this._internalEventsClear(InternalEvents.Dispose);
        }
    });
    Object.defineProperty(ObjectNode.prototype, "finalizeDeath", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            // invariant: not called directly but from "die"
            this.getChildren().forEach(function (node) {
                node.finalizeDeath();
            });
            this.root.identifierCache.notifyDied(this);
            // "kill" the computed prop and just store the last snapshot
            var snapshot = this.snapshot;
            this._snapshotUponDeath = snapshot;
            this._internalEventsClearAll();
            this.baseFinalizeDeath();
        }
    });
    Object.defineProperty(ObjectNode.prototype, "onSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (onChange) {
            this._addSnapshotReaction();
            return this._internalEventsRegister(InternalEvents.Snapshot, onChange);
        }
    });
    Object.defineProperty(ObjectNode.prototype, "emitSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (snapshot) {
            this._internalEventsEmit(InternalEvents.Snapshot, snapshot);
        }
    });
    Object.defineProperty(ObjectNode.prototype, "onPatch", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (handler) {
            return this._internalEventsRegister(InternalEvents.Patch, handler);
        }
    });
    Object.defineProperty(ObjectNode.prototype, "emitPatch", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (basePatch, source) {
            if (this._internalEventsHasSubscribers(InternalEvents.Patch)) {
                // calculate the relative path of the patch
                var path = source.path.substr(this.path.length) + (basePatch.path ? "/" + basePatch.path : "");
                var localizedPatch = extend({}, basePatch, { path: path });
                var _a = __read(splitPatch(localizedPatch), 2), patch = _a[0], reversePatch = _a[1];
                this._internalEventsEmit(InternalEvents.Patch, patch, reversePatch);
            }
            if (this.parent)
                this.parent.emitPatch(basePatch, source);
        }
    });
    Object.defineProperty(ObjectNode.prototype, "hasDisposer", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (disposer) {
            return this._internalEventsHas(InternalEvents.Dispose, disposer);
        }
    });
    Object.defineProperty(ObjectNode.prototype, "addDisposer", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (disposer) {
            if (!this.hasDisposer(disposer)) {
                this._internalEventsRegister(InternalEvents.Dispose, disposer, true);
                return;
            }
            throw new MstError("cannot add a disposer when it is already registered for execution");
        }
    });
    Object.defineProperty(ObjectNode.prototype, "removeDisposer", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (disposer) {
            if (!this._internalEventsHas(InternalEvents.Dispose, disposer)) {
                throw new MstError("cannot remove a disposer which was never registered for execution");
            }
            this._internalEventsUnregister(InternalEvents.Dispose, disposer);
        }
    });
    Object.defineProperty(ObjectNode.prototype, "removeMiddleware", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (middleware) {
            if (this.middlewares) {
                var index = this.middlewares.indexOf(middleware);
                if (index >= 0) {
                    this.middlewares.splice(index, 1);
                }
            }
        }
    });
    Object.defineProperty(ObjectNode.prototype, "addMiddleWare", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (handler, includeHooks) {
            var _this = this;
            if (includeHooks === void 0) { includeHooks = true; }
            var middleware = { handler: handler, includeHooks: includeHooks };
            if (!this.middlewares)
                this.middlewares = [middleware];
            else
                this.middlewares.push(middleware);
            return function () {
                _this.removeMiddleware(middleware);
            };
        }
    });
    Object.defineProperty(ObjectNode.prototype, "applyPatchLocally", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (subpath, patch) {
            this.assertWritable({
                subpath: subpath
            });
            this.createObservableInstanceIfNeeded();
            this.type.applyPatchLocally(this, subpath, patch);
        }
    });
    Object.defineProperty(ObjectNode.prototype, "_addSnapshotReaction", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _this = this;
            if (!this._hasSnapshotReaction) {
                var snapshotDisposer = reaction(function () { return _this.snapshot; }, function (snapshot) { return _this.emitSnapshot(snapshot); }, snapshotReactionOptions);
                this.addDisposer(snapshotDisposer);
                this._hasSnapshotReaction = true;
            }
        }
    });
    // we proxy the methods to avoid creating an EventHandlers instance when it is not needed
    Object.defineProperty(ObjectNode.prototype, "_internalEventsHasSubscribers", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (event) {
            return !!this._internalEvents && this._internalEvents.hasSubscribers(event);
        }
    });
    Object.defineProperty(ObjectNode.prototype, "_internalEventsRegister", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (event, eventHandler, atTheBeginning) {
            if (atTheBeginning === void 0) { atTheBeginning = false; }
            if (!this._internalEvents) {
                this._internalEvents = new EventHandlers();
            }
            return this._internalEvents.register(event, eventHandler, atTheBeginning);
        }
    });
    Object.defineProperty(ObjectNode.prototype, "_internalEventsHas", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (event, eventHandler) {
            return !!this._internalEvents && this._internalEvents.has(event, eventHandler);
        }
    });
    Object.defineProperty(ObjectNode.prototype, "_internalEventsUnregister", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (event, eventHandler) {
            if (this._internalEvents) {
                this._internalEvents.unregister(event, eventHandler);
            }
        }
    });
    Object.defineProperty(ObjectNode.prototype, "_internalEventsEmit", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (event) {
            var _a;
            var args = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args[_i - 1] = arguments[_i];
            }
            if (this._internalEvents) {
                (_a = this._internalEvents).emit.apply(_a, __spreadArray([event], __read(args), false));
            }
        }
    });
    Object.defineProperty(ObjectNode.prototype, "_internalEventsClear", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (event) {
            if (this._internalEvents) {
                this._internalEvents.clear(event);
            }
        }
    });
    Object.defineProperty(ObjectNode.prototype, "_internalEventsClearAll", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            if (this._internalEvents) {
                this._internalEvents.clearAll();
            }
        }
    });
    return ObjectNode;
}(BaseNode));
ObjectNode.prototype.createObservableInstance = action(ObjectNode.prototype.createObservableInstance);
ObjectNode.prototype.detach = action(ObjectNode.prototype.detach);
ObjectNode.prototype.die = action(ObjectNode.prototype.die);

var _a;
/**
 * @internal
 * @hidden
 */
var TypeFlags;
(function (TypeFlags) {
    TypeFlags[TypeFlags["String"] = 1] = "String";
    TypeFlags[TypeFlags["Number"] = 2] = "Number";
    TypeFlags[TypeFlags["Boolean"] = 4] = "Boolean";
    TypeFlags[TypeFlags["Date"] = 8] = "Date";
    TypeFlags[TypeFlags["Literal"] = 16] = "Literal";
    TypeFlags[TypeFlags["Array"] = 32] = "Array";
    TypeFlags[TypeFlags["Map"] = 64] = "Map";
    TypeFlags[TypeFlags["Object"] = 128] = "Object";
    TypeFlags[TypeFlags["Frozen"] = 256] = "Frozen";
    TypeFlags[TypeFlags["Optional"] = 512] = "Optional";
    TypeFlags[TypeFlags["Reference"] = 1024] = "Reference";
    TypeFlags[TypeFlags["Identifier"] = 2048] = "Identifier";
    TypeFlags[TypeFlags["Late"] = 4096] = "Late";
    TypeFlags[TypeFlags["Refinement"] = 8192] = "Refinement";
    TypeFlags[TypeFlags["Union"] = 16384] = "Union";
    TypeFlags[TypeFlags["Null"] = 32768] = "Null";
    TypeFlags[TypeFlags["Undefined"] = 65536] = "Undefined";
    TypeFlags[TypeFlags["Integer"] = 131072] = "Integer";
    TypeFlags[TypeFlags["Custom"] = 262144] = "Custom";
    TypeFlags[TypeFlags["SnapshotProcessor"] = 524288] = "SnapshotProcessor";
    TypeFlags[TypeFlags["Lazy"] = 1048576] = "Lazy";
    TypeFlags[TypeFlags["Finite"] = 2097152] = "Finite";
    TypeFlags[TypeFlags["Float"] = 4194304] = "Float";
})(TypeFlags || (TypeFlags = {}));
/**
 * @internal
 * @hidden
 */
var cannotDetermineSubtype = "cannotDetermine";
/** @hidden */
var $type = Symbol("$type");
/**
 * A base type produces a MST node (Node in the state tree)
 *
 * @internal
 * @hidden
 */
var BaseType = /** @class */ (function () {
    function BaseType(name) {
        Object.defineProperty(this, _a, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        // these are just to make inner types avaialable to inherited classes
        Object.defineProperty(this, "C", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "S", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "T", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "N", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "isType", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: true
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.name = name;
    }
    Object.defineProperty(BaseType.prototype, "create", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (snapshot, environment) {
            typecheckInternal(this, snapshot);
            return this.instantiate(null, "", environment, snapshot).value;
        }
    });
    Object.defineProperty(BaseType.prototype, "getSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (node, applyPostProcess) {
            // istanbul ignore next
            throw new MstError("unimplemented method");
        }
    });
    Object.defineProperty(BaseType.prototype, "isAssignableFrom", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (type) {
            return type === this;
        }
    });
    Object.defineProperty(BaseType.prototype, "validate", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (value, context) {
            var node = getStateTreeNodeSafe(value);
            if (node) {
                var valueType = getType(value);
                return this.isAssignableFrom(valueType)
                    ? typeCheckSuccess()
                    : typeCheckFailure(context, value);
                // it is tempting to compare snapshots, but in that case we should always clone on assignments...
            }
            return this.isValidSnapshot(value, context);
        }
    });
    Object.defineProperty(BaseType.prototype, "is", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (thing) {
            return this.validate(thing, [{ path: "", type: this }]).length === 0;
        }
    });
    Object.defineProperty(BaseType.prototype, "Type", {
        get: function () {
            // istanbul ignore next
            throw new MstError("Factory.Type should not be actually called. It is just a Type signature that can be used at compile time with Typescript, by using `typeof type.Type`");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseType.prototype, "TypeWithoutSTN", {
        get: function () {
            // istanbul ignore next
            throw new MstError("Factory.TypeWithoutSTN should not be actually called. It is just a Type signature that can be used at compile time with Typescript, by using `typeof type.TypeWithoutSTN`");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseType.prototype, "SnapshotType", {
        get: function () {
            // istanbul ignore next
            throw new MstError("Factory.SnapshotType should not be actually called. It is just a Type signature that can be used at compile time with Typescript, by using `typeof type.SnapshotType`");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseType.prototype, "CreationType", {
        get: function () {
            // istanbul ignore next
            throw new MstError("Factory.CreationType should not be actually called. It is just a Type signature that can be used at compile time with Typescript, by using `typeof type.CreationType`");
        },
        enumerable: false,
        configurable: true
    });
    return BaseType;
}());
_a = $type;
BaseType.prototype.create = action(BaseType.prototype.create);
/**
 * A complex type produces a MST node (Node in the state tree)
 *
 * @internal
 * @hidden
 */
var ComplexType = /** @class */ (function (_super) {
    __extends(ComplexType, _super);
    function ComplexType(name) {
        var _this = _super.call(this, name) || this;
        Object.defineProperty(_this, "identifierAttribute", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        return _this;
    }
    Object.defineProperty(ComplexType.prototype, "create", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (snapshot, environment) {
            if (snapshot === void 0) { snapshot = this.getDefaultSnapshot(); }
            return _super.prototype.create.call(this, snapshot, environment);
        }
    });
    Object.defineProperty(ComplexType.prototype, "getValue", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (node) {
            node.createObservableInstanceIfNeeded();
            return node.storedValue;
        }
    });
    Object.defineProperty(ComplexType.prototype, "isMatchingSnapshotId", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (current, snapshot) {
            return (!current.identifierAttribute ||
                current.identifier ===
                    normalizeIdentifier(snapshot[current.identifierAttribute]));
        }
    });
    Object.defineProperty(ComplexType.prototype, "tryToReconcileNode", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (current, newValue) {
            if (current.isDetaching)
                return false;
            if (current.snapshot === newValue) {
                // newValue is the current snapshot of the node, noop
                return true;
            }
            if (isStateTreeNode(newValue) && getStateTreeNode(newValue) === current) {
                // the current node is the same as the new one
                return true;
            }
            if (current.type === this &&
                isMutable(newValue) &&
                !isStateTreeNode(newValue) &&
                this.isMatchingSnapshotId(current, newValue)) {
                // the newValue has no node, so can be treated like a snapshot
                // we can reconcile
                current.applySnapshot(newValue);
                return true;
            }
            return false;
        }
    });
    Object.defineProperty(ComplexType.prototype, "reconcile", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (current, newValue, parent, subpath) {
            var nodeReconciled = this.tryToReconcileNode(current, newValue);
            if (nodeReconciled) {
                current.setParent(parent, subpath);
                return current;
            }
            // current node cannot be recycled in any way
            current.die(); // noop if detaching
            // attempt to reuse the new one
            if (isStateTreeNode(newValue) && this.isAssignableFrom(getType(newValue))) {
                // newValue is a Node as well, move it here..
                var newNode = getStateTreeNode(newValue);
                newNode.setParent(parent, subpath);
                return newNode;
            }
            // nothing to do, we have to create a new node
            return this.instantiate(parent, subpath, undefined, newValue);
        }
    });
    Object.defineProperty(ComplexType.prototype, "getSubTypes", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return null;
        }
    });
    return ComplexType;
}(BaseType));
ComplexType.prototype.create = action(ComplexType.prototype.create);
/**
 * @internal
 * @hidden
 */
var SimpleType = /** @class */ (function (_super) {
    __extends(SimpleType, _super);
    function SimpleType() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(SimpleType.prototype, "createNewInstance", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (snapshot) {
            return snapshot;
        }
    });
    Object.defineProperty(SimpleType.prototype, "getValue", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (node) {
            // if we ever find a case where scalar nodes can be accessed without iterating through its parent
            // uncomment this to make sure the parent chain is created when this is accessed
            // if (node.parent) {
            //     node.parent.createObservableInstanceIfNeeded()
            // }
            return node.storedValue;
        }
    });
    Object.defineProperty(SimpleType.prototype, "getSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (node) {
            return node.storedValue;
        }
    });
    Object.defineProperty(SimpleType.prototype, "reconcile", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (current, newValue, parent, subpath) {
            // reconcile only if type and value are still the same, and only if the node is not detaching
            if (!current.isDetaching && current.type === this && current.storedValue === newValue) {
                return current;
            }
            var res = this.instantiate(parent, subpath, undefined, newValue);
            current.die(); // noop if detaching
            return res;
        }
    });
    Object.defineProperty(SimpleType.prototype, "getSubTypes", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return null;
        }
    });
    return SimpleType;
}(BaseType));
/**
 * Returns if a given value represents a type.
 *
 * @param value Value to check.
 * @returns `true` if the value is a type.
 */
function isType(value) {
    return typeof value === "object" && value && value.isType === true;
}
/**
 * @internal
 * @hidden
 */
function assertIsType(type, argNumber) {
    assertArg(type, isType, "mobx-state-tree type", argNumber);
}

var nextActionId = 1;
var currentActionContext;
/**
 * @internal
 * @hidden
 */
function getCurrentActionContext() {
    return currentActionContext;
}
/**
 * @internal
 * @hidden
 */
function getNextActionId() {
    return nextActionId++;
}
// TODO: optimize away entire action context if there is no middleware in tree?
/**
 * @internal
 * @hidden
 */
function runWithActionContext(context, fn) {
    var node = getStateTreeNode(context.context);
    if (context.type === "action") {
        node.assertAlive({
            actionContext: context
        });
    }
    var baseIsRunningAction = node._isRunningAction;
    node._isRunningAction = true;
    var previousContext = currentActionContext;
    currentActionContext = context;
    try {
        return runMiddleWares(node, context, fn);
    }
    finally {
        currentActionContext = previousContext;
        node._isRunningAction = baseIsRunningAction;
    }
}
/**
 * @internal
 * @hidden
 */
function getParentActionContext(parentContext) {
    if (!parentContext)
        return undefined;
    if (parentContext.type === "action")
        return parentContext;
    return parentContext.parentActionEvent;
}
/**
 * @internal
 * @hidden
 */
function createActionInvoker(target, name, fn) {
    var res = function () {
        var id = getNextActionId();
        var parentContext = currentActionContext;
        var parentActionContext = getParentActionContext(parentContext);
        return runWithActionContext({
            type: "action",
            name: name,
            id: id,
            args: argsToArray(arguments),
            context: target,
            tree: getRoot(target),
            rootId: parentContext ? parentContext.rootId : id,
            parentId: parentContext ? parentContext.id : 0,
            allParentIds: parentContext
                ? __spreadArray(__spreadArray([], __read(parentContext.allParentIds), false), [parentContext.id], false) : [],
            parentEvent: parentContext,
            parentActionEvent: parentActionContext
        }, fn);
    };
    res._isMSTAction = true;
    res._isFlowAction = fn._isFlowAction;
    return res;
}
/**
 * Middleware can be used to intercept any action is invoked on the subtree where it is attached.
 * If a tree is protected (by default), this means that any mutation of the tree will pass through your middleware.
 *
 * For more details, see the [middleware docs](concepts/middleware.md)
 *
 * @param target Node to apply the middleware to.
 * @param middleware Middleware to apply.
 * @returns A callable function to dispose the middleware.
 */
function addMiddleware(target, handler, includeHooks) {
    if (includeHooks === void 0) { includeHooks = true; }
    var node = getStateTreeNode(target);
    if (devMode()) {
        if (!node.isProtectionEnabled) {
            warnError("It is recommended to protect the state tree before attaching action middleware, as otherwise it cannot be guaranteed that all changes are passed through middleware. See `protect`");
        }
    }
    return node.addMiddleWare(handler, includeHooks);
}
var CollectedMiddlewares = /** @class */ (function () {
    function CollectedMiddlewares(node, fn) {
        Object.defineProperty(this, "arrayIndex", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 0
        });
        Object.defineProperty(this, "inArrayIndex", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 0
        });
        Object.defineProperty(this, "middlewares", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        // we just push middleware arrays into an array of arrays to avoid making copies
        if (fn.$mst_middleware) {
            this.middlewares.push(fn.$mst_middleware);
        }
        var n = node;
        // Find all middlewares. Optimization: cache this?
        while (n) {
            if (n.middlewares)
                this.middlewares.push(n.middlewares);
            n = n.parent;
        }
    }
    Object.defineProperty(CollectedMiddlewares.prototype, "isEmpty", {
        get: function () {
            return this.middlewares.length <= 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectedMiddlewares.prototype, "getNextMiddleware", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var array = this.middlewares[this.arrayIndex];
            if (!array)
                return undefined;
            var item = array[this.inArrayIndex++];
            if (!item) {
                this.arrayIndex++;
                this.inArrayIndex = 0;
                return this.getNextMiddleware();
            }
            return item;
        }
    });
    return CollectedMiddlewares;
}());
function runMiddleWares(node, baseCall, originalFn) {
    var middlewares = new CollectedMiddlewares(node, originalFn);
    // Short circuit
    if (middlewares.isEmpty)
        return action(originalFn).apply(null, baseCall.args);
    var result = null;
    function runNextMiddleware(call) {
        var middleware = middlewares.getNextMiddleware();
        var handler = middleware && middleware.handler;
        if (!handler) {
            return action(originalFn).apply(null, call.args);
        }
        // skip hooks if asked to
        if (!middleware.includeHooks && Hook[call.name]) {
            return runNextMiddleware(call);
        }
        var nextInvoked = false;
        function next(call2, callback) {
            nextInvoked = true;
            // the result can contain
            // - the non manipulated return value from an action
            // - the non manipulated abort value
            // - one of the above but manipulated through the callback function
            result = runNextMiddleware(call2);
            if (callback) {
                result = callback(result);
            }
        }
        var abortInvoked = false;
        function abort(value) {
            abortInvoked = true;
            // overwrite the result
            // can be manipulated through middlewares earlier in the queue using the callback fn
            result = value;
        }
        handler(call, next, abort);
        if (devMode()) {
            if (!nextInvoked && !abortInvoked) {
                var node2 = getStateTreeNode(call.tree);
                throw new MstError("Neither the next() nor the abort() callback within the middleware ".concat(handler.name, " for the action: \"").concat(call.name, "\" on the node: ").concat(node2.type.name, " was invoked."));
            }
            else if (nextInvoked && abortInvoked) {
                var node2 = getStateTreeNode(call.tree);
                throw new MstError("The next() and abort() callback within the middleware ".concat(handler.name, " for the action: \"").concat(call.name, "\" on the node: ").concat(node2.type.name, " were invoked."));
            }
        }
        return result;
    }
    return runNextMiddleware(baseCall);
}

function safeStringify(value) {
    try {
        return JSON.stringify(value);
    }
    catch (e) {
        // istanbul ignore next
        return "<Unserializable: ".concat(e, ">");
    }
}
/**
 * @internal
 * @hidden
 */
function prettyPrintValue(value) {
    return typeof value === "function"
        ? "<function".concat(value.name ? " " + value.name : "", ">")
        : isStateTreeNode(value)
            ? "<".concat(value, ">")
            : "`".concat(safeStringify(value), "`");
}
function shortenPrintValue(valueInString) {
    return valueInString.length < 280
        ? valueInString
        : "".concat(valueInString.substring(0, 272), "......").concat(valueInString.substring(valueInString.length - 8));
}
function toErrorString(error) {
    var value = error.value;
    var type = error.context[error.context.length - 1].type;
    var fullPath = error.context
        .map(function (_a) {
        var path = _a.path;
        return path;
    })
        .filter(function (path) { return path.length > 0; })
        .join("/");
    var pathPrefix = fullPath.length > 0 ? "at path \"/".concat(fullPath, "\" ") : "";
    var currentTypename = isStateTreeNode(value)
        ? "value of type ".concat(getStateTreeNode(value).type.name, ":")
        : isPrimitive(value)
            ? "value"
            : "snapshot";
    var isSnapshotCompatible = type && isStateTreeNode(value) && type.is(getStateTreeNode(value).snapshot);
    return ("".concat(pathPrefix).concat(currentTypename, " ").concat(prettyPrintValue(value), " is not assignable ").concat(type ? "to type: `".concat(type.name, "`") : "") +
        (error.message ? " (".concat(error.message, ")") : "") +
        (type
            ? isPrimitiveType(type) || isPrimitive(value)
                ? "."
                : ", expected an instance of `".concat(type.name, "` or a snapshot like `").concat(type.describe(), "` instead.") +
                    (isSnapshotCompatible
                        ? " (Note that a snapshot of the provided value is compatible with the targeted type)"
                        : "")
            : "."));
}
/**
 * @internal
 * @hidden
 */
function getContextForPath(context, path, type) {
    return context.concat([{ path: path, type: type }]);
}
/**
 * @internal
 * @hidden
 */
function typeCheckSuccess() {
    return EMPTY_ARRAY;
}
/**
 * @internal
 * @hidden
 */
function typeCheckFailure(context, value, message) {
    return [{ context: context, value: value, message: message }];
}
/**
 * @internal
 * @hidden
 */
function flattenTypeErrors(errors) {
    return errors.reduce(function (a, i) { return a.concat(i); }, []);
}
// TODO; doublecheck: typecheck should only needed to be invoked from: type.create and array / map / value.property will change
/**
 * @internal
 * @hidden
 */
function typecheckInternal(type, value) {
    // runs typeChecking if it is in dev-mode or through a process.env.ENABLE_TYPE_CHECK flag
    if (isTypeCheckingEnabled()) {
        typecheck(type, value);
    }
}
/**
 * Run's the typechecker for the given type on the given value, which can be a snapshot or an instance.
 * Throws if the given value is not according the provided type specification.
 * Use this if you need typechecks even in a production build (by default all automatic runtime type checks will be skipped in production builds)
 *
 * @param type Type to check against.
 * @param value Value to be checked, either a snapshot or an instance.
 */
function typecheck(type, value) {
    var errors = type.validate(value, [{ path: "", type: type }]);
    if (errors.length > 0) {
        throw new MstError(validationErrorsToString(type, value, errors));
    }
}
function validationErrorsToString(type, value, errors) {
    if (errors.length === 0) {
        return undefined;
    }
    return ("Error while converting ".concat(shortenPrintValue(prettyPrintValue(value)), " to `").concat(type.name, "`:\n\n    ") + errors.map(toErrorString).join("\n    "));
}

var identifierCacheId = 0;
/**
 * @internal
 * @hidden
 */
var IdentifierCache = /** @class */ (function () {
    function IdentifierCache() {
        Object.defineProperty(this, "cacheId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: identifierCacheId++
        });
        // n.b. in cache all identifiers are normalized to strings
        Object.defineProperty(this, "cache", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: observable.map()
        });
        // last time the cache (array) for a given time changed
        // n.b. it is not really the time, but just an integer that gets increased after each modification to the array
        Object.defineProperty(this, "lastCacheModificationPerId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: observable.map()
        });
    }
    Object.defineProperty(IdentifierCache.prototype, "updateLastCacheModificationPerId", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (identifier) {
            var lcm = this.lastCacheModificationPerId.get(identifier);
            // we start at 1 since 0 means no update since cache creation
            this.lastCacheModificationPerId.set(identifier, lcm === undefined ? 1 : lcm + 1);
        }
    });
    Object.defineProperty(IdentifierCache.prototype, "getLastCacheModificationPerId", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (identifier) {
            var modificationId = this.lastCacheModificationPerId.get(identifier) || 0;
            return "".concat(this.cacheId, "-").concat(modificationId);
        }
    });
    Object.defineProperty(IdentifierCache.prototype, "addNodeToCache", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (node, lastCacheUpdate) {
            if (lastCacheUpdate === void 0) { lastCacheUpdate = true; }
            if (node.identifierAttribute) {
                var identifier = node.identifier;
                if (!this.cache.has(identifier)) {
                    this.cache.set(identifier, observable.array([], mobxShallow));
                }
                var set = this.cache.get(identifier);
                if (set.indexOf(node) !== -1)
                    throw new MstError("Already registered");
                set.push(node);
                if (lastCacheUpdate) {
                    this.updateLastCacheModificationPerId(identifier);
                }
            }
        }
    });
    Object.defineProperty(IdentifierCache.prototype, "mergeCache", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (node) {
            var _this = this;
            values(node.identifierCache.cache).forEach(function (nodes) {
                return nodes.forEach(function (child) {
                    _this.addNodeToCache(child);
                });
            });
        }
    });
    Object.defineProperty(IdentifierCache.prototype, "notifyDied", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (node) {
            if (node.identifierAttribute) {
                var id = node.identifier;
                var set = this.cache.get(id);
                if (set) {
                    set.remove(node);
                    // remove empty sets from cache
                    if (!set.length) {
                        this.cache.delete(id);
                    }
                    this.updateLastCacheModificationPerId(node.identifier);
                }
            }
        }
    });
    Object.defineProperty(IdentifierCache.prototype, "splitCache", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (splitNode) {
            var _this = this;
            var newCache = new IdentifierCache();
            // The slash is added here so we only match children of the splitNode. In version 5.1.8 and
            // earlier there was no trailing slash, so non children that started with the same path string
            // were being matched incorrectly.
            var basePath = splitNode.path + "/";
            entries(this.cache).forEach(function (_a) {
                var _b = __read(_a, 2), id = _b[0], nodes = _b[1];
                var modified = false;
                for (var i = nodes.length - 1; i >= 0; i--) {
                    var node = nodes[i];
                    if (node === splitNode || node.path.indexOf(basePath) === 0) {
                        newCache.addNodeToCache(node, false); // no need to update lastUpdated since it is a whole new cache
                        nodes.splice(i, 1);
                        // remove empty sets from cache
                        if (!nodes.length) {
                            _this.cache.delete(id);
                        }
                        modified = true;
                    }
                }
                if (modified) {
                    _this.updateLastCacheModificationPerId(id);
                }
            });
            return newCache;
        }
    });
    Object.defineProperty(IdentifierCache.prototype, "has", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (type, identifier) {
            var set = this.cache.get(identifier);
            if (!set)
                return false;
            return set.some(function (candidate) { return type.isAssignableFrom(candidate.type); });
        }
    });
    Object.defineProperty(IdentifierCache.prototype, "resolve", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (type, identifier) {
            var set = this.cache.get(identifier);
            if (!set)
                return null;
            var matches = set.filter(function (candidate) { return type.isAssignableFrom(candidate.type); });
            switch (matches.length) {
                case 0:
                    return null;
                case 1:
                    return matches[0];
                default:
                    throw new MstError("Cannot resolve a reference to type '".concat(type.name, "' with id: '").concat(identifier, "' unambigously, there are multiple candidates: ").concat(matches
                        .map(function (n) { return n.path; })
                        .join(", ")));
            }
        }
    });
    return IdentifierCache;
}());

/**
 * @internal
 * @hidden
 */
function createObjectNode(type, parent, subpath, environment, initialValue) {
    var existingNode = getStateTreeNodeSafe(initialValue);
    if (existingNode) {
        if (existingNode.parent) {
            // istanbul ignore next
            throw new MstError("Cannot add an object to a state tree if it is already part of the same or another state tree. Tried to assign an object to '".concat(parent ? parent.path : "", "/").concat(subpath, "', but it lives already at '").concat(existingNode.path, "'"));
        }
        if (parent) {
            existingNode.setParent(parent, subpath);
        }
        // else it already has no parent since it is a pre-requisite
        return existingNode;
    }
    // not a node, a snapshot
    return new ObjectNode(type, parent, subpath, environment, initialValue);
}
/**
 * @internal
 * @hidden
 */
function createScalarNode(type, parent, subpath, environment, initialValue) {
    return new ScalarNode(type, parent, subpath, environment, initialValue);
}
/**
 * @internal
 * @hidden
 */
function isNode(value) {
    return value instanceof ScalarNode || value instanceof ObjectNode;
}

/**
 * @internal
 * @hidden
 */
var NodeLifeCycle;
(function (NodeLifeCycle) {
    NodeLifeCycle[NodeLifeCycle["INITIALIZING"] = 0] = "INITIALIZING";
    NodeLifeCycle[NodeLifeCycle["CREATED"] = 1] = "CREATED";
    NodeLifeCycle[NodeLifeCycle["FINALIZED"] = 2] = "FINALIZED";
    NodeLifeCycle[NodeLifeCycle["DETACHING"] = 3] = "DETACHING";
    NodeLifeCycle[NodeLifeCycle["DEAD"] = 4] = "DEAD"; // no coming back from this one
})(NodeLifeCycle || (NodeLifeCycle = {}));
/**
 * Returns true if the given value is a node in a state tree.
 * More precisely, that is, if the value is an instance of a
 * `types.model`, `types.array` or `types.map`.
 *
 * @param value
 * @returns true if the value is a state tree node.
 */
function isStateTreeNode(value) {
    return !!(value && value.$treenode);
}
/**
 * @internal
 * @hidden
 */
function assertIsStateTreeNode(value, argNumber) {
    assertArg(value, isStateTreeNode, "mobx-state-tree node", argNumber);
}
/**
 * @internal
 * @hidden
 */
function getStateTreeNode(value) {
    if (!isStateTreeNode(value)) {
        // istanbul ignore next
        throw new MstError("Value ".concat(value, " is no MST Node"));
    }
    return value.$treenode;
}
/**
 * @internal
 * @hidden
 */
function getStateTreeNodeSafe(value) {
    return (value && value.$treenode) || null;
}
/**
 * @internal
 * @hidden
 */
function toJSON() {
    return getStateTreeNode(this).snapshot;
}
/**
 * @internal
 * @hidden
 */
function resolveNodeByPathParts(base, pathParts, failIfResolveFails) {
    if (failIfResolveFails === void 0) { failIfResolveFails = true; }
    var current = base;
    try {
        for (var i = 0; i < pathParts.length; i++) {
            var part = pathParts[i];
            if (part === "..") {
                current = current.parent;
                if (current)
                    continue; // not everything has a parent
            }
            else if (part === ".") {
                continue;
            }
            else if (current) {
                if (current instanceof ScalarNode) {
                    // check if the value of a scalar resolves to a state tree node (e.g. references)
                    // then we can continue resolving...
                    var value = current.value;
                    if (isStateTreeNode(value)) {
                        current = getStateTreeNode(value);
                        // fall through
                    }
                }
                if (current instanceof ObjectNode) {
                    var subType = current.getChildType(part);
                    if (subType) {
                        current = current.getChildNode(part);
                        if (current)
                            continue;
                    }
                }
            }
            throw new MstError("Could not resolve '".concat(part, "' in path '").concat(joinJsonPath(pathParts.slice(0, i)) || "/", "' while resolving '").concat(joinJsonPath(pathParts), "'"));
        }
    }
    catch (e) {
        if (!failIfResolveFails) {
            return undefined;
        }
        throw e;
    }
    return current;
}
/**
 * @internal
 * @hidden
 */
function convertChildNodesToArray(childNodes) {
    if (!childNodes)
        return EMPTY_ARRAY;
    var keys = Object.keys(childNodes);
    if (!keys.length)
        return EMPTY_ARRAY;
    var result = new Array(keys.length);
    keys.forEach(function (key, index) {
        result[index] = childNodes[key];
    });
    return result;
}

var plainObjectString = Object.toString();
/**
 * @internal
 * @hidden
 */
var EMPTY_ARRAY = Object.freeze([]);
/**
 * @internal
 * @hidden
 */
var EMPTY_OBJECT = Object.freeze({});
/**
 * @internal
 * @hidden
 */
var mobxShallow = getGlobalState().useProxies
    ? { deep: false }
    : { deep: false, proxy: false };
Object.freeze(mobxShallow);
/**
 * @internal
 * @hidden
 */
var MstError = /** @class */ (function (_super) {
    __extends(MstError, _super);
    function MstError(message) {
        if (message === void 0) { message = "Illegal state"; }
        return _super.call(this, "[mobx-state-tree] ".concat(message)) || this;
    }
    return MstError;
}(Error));
/**
 * @internal
 * @hidden
 */
function identity(_) {
    return _;
}
/**
 * @internal
 * @hidden
 */
var isInteger = Number.isInteger;
/**
 * @internal
 * @hidden
 */
function isFloat(val) {
    return Number(val) === val && val % 1 !== 0;
}
/**
 * @internal
 * @hidden
 */
function isFinite(val) {
    return Number.isFinite(val);
}
/**
 * @internal
 * @hidden
 */
function isArray(val) {
    return Array.isArray(val) || isObservableArray(val);
}
/**
 * @internal
 * @hidden
 */
function asArray(val) {
    if (!val)
        return EMPTY_ARRAY;
    if (isArray(val))
        return val;
    return [val];
}
/**
 * @internal
 * @hidden
 */
function extend(a) {
    var b = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        b[_i - 1] = arguments[_i];
    }
    for (var i = 0; i < b.length; i++) {
        var current = b[i];
        for (var key in current)
            a[key] = current[key];
    }
    return a;
}
/**
 * @internal
 * @hidden
 */
function isPlainObject(value) {
    var _a;
    if (value === null || typeof value !== "object")
        return false;
    var proto = Object.getPrototypeOf(value);
    if (proto == null)
        return true;
    return ((_a = proto.constructor) === null || _a === void 0 ? void 0 : _a.toString()) === plainObjectString;
}
/**
 * @internal
 * @hidden
 */
function isMutable(value) {
    return (value !== null &&
        typeof value === "object" &&
        !(value instanceof Date) &&
        !(value instanceof RegExp));
}
/**
 * @internal
 * @hidden
 */
function isPrimitive(value, includeDate) {
    if (includeDate === void 0) { includeDate = true; }
    return (value === null ||
        value === undefined ||
        typeof value === "string" ||
        typeof value === "number" ||
        typeof value === "boolean" ||
        (includeDate && value instanceof Date));
}
/**
 * @internal
 * @hidden
 * Freeze a value and return it (if not in production)
 */
function freeze(value) {
    if (!devMode())
        return value;
    return isPrimitive(value) || isObservableArray(value) ? value : Object.freeze(value);
}
/**
 * @internal
 * @hidden
 * Recursively freeze a value (if not in production)
 */
function deepFreeze(value) {
    if (!devMode())
        return value;
    freeze(value);
    if (isPlainObject(value)) {
        Object.keys(value).forEach(function (propKey) {
            if (!isPrimitive(value[propKey]) &&
                !Object.isFrozen(value[propKey])) {
                deepFreeze(value[propKey]);
            }
        });
    }
    return value;
}
/**
 * @internal
 * @hidden
 */
function isSerializable(value) {
    return typeof value !== "function";
}
/**
 * @internal
 * @hidden
 */
function defineProperty(object, key, descriptor) {
    isObservableObject(object)
        ? apiDefineProperty(object, key, descriptor)
        : Object.defineProperty(object, key, descriptor);
}
/**
 * @internal
 * @hidden
 */
function addHiddenFinalProp(object, propName, value) {
    defineProperty(object, propName, {
        enumerable: false,
        writable: false,
        configurable: true,
        value: value
    });
}
/**
 * @internal
 * @hidden
 */
function addHiddenWritableProp(object, propName, value) {
    defineProperty(object, propName, {
        enumerable: false,
        writable: true,
        configurable: true,
        value: value
    });
}
/**
 * @internal
 * @hidden
 */
var EventHandler = /** @class */ (function () {
    function EventHandler() {
        Object.defineProperty(this, "handlers", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
    }
    Object.defineProperty(EventHandler.prototype, "hasSubscribers", {
        get: function () {
            return this.handlers.length > 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EventHandler.prototype, "register", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (fn, atTheBeginning) {
            var _this = this;
            if (atTheBeginning === void 0) { atTheBeginning = false; }
            if (atTheBeginning) {
                this.handlers.unshift(fn);
            }
            else {
                this.handlers.push(fn);
            }
            return function () {
                _this.unregister(fn);
            };
        }
    });
    Object.defineProperty(EventHandler.prototype, "has", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (fn) {
            return this.handlers.indexOf(fn) >= 0;
        }
    });
    Object.defineProperty(EventHandler.prototype, "unregister", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (fn) {
            var index = this.handlers.indexOf(fn);
            if (index >= 0) {
                this.handlers.splice(index, 1);
            }
        }
    });
    Object.defineProperty(EventHandler.prototype, "clear", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            this.handlers.length = 0;
        }
    });
    Object.defineProperty(EventHandler.prototype, "emit", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            // make a copy just in case it changes
            var handlers = this.handlers.slice();
            handlers.forEach(function (f) { return f.apply(void 0, __spreadArray([], __read(args), false)); });
        }
    });
    return EventHandler;
}());
/**
 * @internal
 * @hidden
 */
var EventHandlers = /** @class */ (function () {
    function EventHandlers() {
        Object.defineProperty(this, "eventHandlers", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
    Object.defineProperty(EventHandlers.prototype, "hasSubscribers", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (event) {
            var handler = this.eventHandlers && this.eventHandlers[event];
            return !!handler && handler.hasSubscribers;
        }
    });
    Object.defineProperty(EventHandlers.prototype, "register", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (event, fn, atTheBeginning) {
            if (atTheBeginning === void 0) { atTheBeginning = false; }
            if (!this.eventHandlers) {
                this.eventHandlers = {};
            }
            var handler = this.eventHandlers[event];
            if (!handler) {
                handler = this.eventHandlers[event] = new EventHandler();
            }
            return handler.register(fn, atTheBeginning);
        }
    });
    Object.defineProperty(EventHandlers.prototype, "has", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (event, fn) {
            var handler = this.eventHandlers && this.eventHandlers[event];
            return !!handler && handler.has(fn);
        }
    });
    Object.defineProperty(EventHandlers.prototype, "unregister", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (event, fn) {
            var handler = this.eventHandlers && this.eventHandlers[event];
            if (handler) {
                handler.unregister(fn);
            }
        }
    });
    Object.defineProperty(EventHandlers.prototype, "clear", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (event) {
            if (this.eventHandlers) {
                delete this.eventHandlers[event];
            }
        }
    });
    Object.defineProperty(EventHandlers.prototype, "clearAll", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            this.eventHandlers = undefined;
        }
    });
    Object.defineProperty(EventHandlers.prototype, "emit", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (event) {
            var _a;
            var args = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args[_i - 1] = arguments[_i];
            }
            var handler = this.eventHandlers && this.eventHandlers[event];
            if (handler) {
                (_a = handler).emit.apply(_a, __spreadArray([], __read(args), false));
            }
        }
    });
    return EventHandlers;
}());
/**
 * @internal
 * @hidden
 */
function argsToArray(args) {
    var res = new Array(args.length);
    for (var i = 0; i < args.length; i++)
        res[i] = args[i];
    return res;
}
/**
 * @internal
 * @hidden
 */
function stringStartsWith(str, beginning) {
    return str.indexOf(beginning) === 0;
}
/**
 * @internal
 * @hidden
 */
function warnError(msg) {
    console.warn(new Error("[mobx-state-tree] ".concat(msg)));
}
/**
 * @internal
 * @hidden
 */
function isTypeCheckingEnabled() {
    return (devMode() ||
        (typeof process !== "undefined" && process.env && process.env.ENABLE_TYPE_CHECK === "true"));
}
/**
 * @internal
 * @hidden
 */
function devMode() {
    return process.env.NODE_ENV !== "production";
}
/**
 * @internal
 * @hidden
 */
function assertArg(value, fn, typeName, argNumber) {
    if (devMode()) {
        if (!fn(value)) {
            // istanbul ignore next
            throw new MstError("expected ".concat(typeName, " as argument ").concat(asArray(argNumber).join(" or "), ", got ").concat(value, " instead"));
        }
    }
}
/**
 * @internal
 * @hidden
 */
function assertIsFunction(value, argNumber) {
    assertArg(value, function (fn) { return typeof fn === "function"; }, "function", argNumber);
}
/**
 * @internal
 * @hidden
 */
function assertIsNumber(value, argNumber, min, max) {
    assertArg(value, function (n) { return typeof n === "number"; }, "number", argNumber);
    {
        assertArg(value, function (n) { return n >= min; }, "number greater than ".concat(min), argNumber);
    }
}
/**
 * @internal
 * @hidden
 */
function assertIsString(value, argNumber, canBeEmpty) {
    if (canBeEmpty === void 0) { canBeEmpty = true; }
    assertArg(value, function (s) { return typeof s === "string"; }, "string", argNumber);
    if (!canBeEmpty) {
        assertArg(value, function (s) { return s !== ""; }, "not empty string", argNumber);
    }
}

/**
 * @internal
 * @hidden
 */
function splitPatch(patch) {
    if (!("oldValue" in patch))
        throw new MstError("Patches without `oldValue` field cannot be inversed");
    return [stripPatch(patch), invertPatch(patch)];
}
/**
 * @internal
 * @hidden
 */
function stripPatch(patch) {
    // strips `oldvalue` information from the patch, so that it becomes a patch conform the json-patch spec
    // this removes the ability to undo the patch
    switch (patch.op) {
        case "add":
            return { op: "add", path: patch.path, value: patch.value };
        case "remove":
            return { op: "remove", path: patch.path };
        case "replace":
            return { op: "replace", path: patch.path, value: patch.value };
    }
}
function invertPatch(patch) {
    switch (patch.op) {
        case "add":
            return {
                op: "remove",
                path: patch.path
            };
        case "remove":
            return {
                op: "add",
                path: patch.path,
                value: patch.oldValue
            };
        case "replace":
            return {
                op: "replace",
                path: patch.path,
                value: patch.oldValue
            };
    }
}
/**
 * Simple simple check to check it is a number.
 */
function isNumber(x) {
    return typeof x === "number";
}
/**
 * Escape slashes and backslashes.
 *
 * http://tools.ietf.org/html/rfc6901
 */
function escapeJsonPath(path) {
    if (isNumber(path) === true) {
        return "" + path;
    }
    if (path.indexOf("/") === -1 && path.indexOf("~") === -1)
        return path;
    return path.replace(/~/g, "~0").replace(/\//g, "~1");
}
/**
 * Unescape slashes and backslashes.
 */
function unescapeJsonPath(path) {
    return path.replace(/~1/g, "/").replace(/~0/g, "~");
}
/**
 * Generates a json-path compliant json path from path parts.
 *
 * @param path
 * @returns
 */
function joinJsonPath(path) {
    // `/` refers to property with an empty name, while `` refers to root itself!
    if (path.length === 0)
        return "";
    var getPathStr = function (p) { return p.map(escapeJsonPath).join("/"); };
    if (path[0] === "." || path[0] === "..") {
        // relative
        return getPathStr(path);
    }
    else {
        // absolute
        return "/" + getPathStr(path);
    }
}
/**
 * Splits and decodes a json path into several parts.
 *
 * @param path
 * @returns
 */
function splitJsonPath(path) {
    // `/` refers to property with an empty name, while `` refers to root itself!
    var parts = path.split("/").map(unescapeJsonPath);
    var valid = path === "" ||
        path === "." ||
        path === ".." ||
        stringStartsWith(path, "/") ||
        stringStartsWith(path, "./") ||
        stringStartsWith(path, "../");
    if (!valid) {
        throw new MstError("a json path must be either rooted, empty or relative, but got '".concat(path, "'"));
    }
    // '/a/b/c' -> ["a", "b", "c"]
    // '../../b/c' -> ["..", "..", "b", "c"]
    // '' -> []
    // '/' -> ['']
    // './a' -> [".", "a"]
    // /./a' -> [".", "a"] equivalent to './a'
    if (parts[0] === "") {
        parts.shift();
    }
    return parts;
}

/** @hidden */
var $preProcessorFailed = Symbol("$preProcessorFailed");
var SnapshotProcessor = /** @class */ (function (_super) {
    __extends(SnapshotProcessor, _super);
    function SnapshotProcessor(_subtype, _processors, name) {
        var _this = _super.call(this, name || _subtype.name) || this;
        Object.defineProperty(_this, "_subtype", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _subtype
        });
        Object.defineProperty(_this, "_processors", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _processors
        });
        return _this;
    }
    Object.defineProperty(SnapshotProcessor.prototype, "flags", {
        get: function () {
            return this._subtype.flags | TypeFlags.SnapshotProcessor;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SnapshotProcessor.prototype, "describe", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return "snapshotProcessor(".concat(this._subtype.describe(), ")");
        }
    });
    Object.defineProperty(SnapshotProcessor.prototype, "preProcessSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (sn) {
            if (this._processors.preProcessor) {
                return this._processors.preProcessor.call(null, sn);
            }
            return sn;
        }
    });
    Object.defineProperty(SnapshotProcessor.prototype, "preProcessSnapshotSafe", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (sn) {
            try {
                return this.preProcessSnapshot(sn);
            }
            catch (e) {
                return $preProcessorFailed;
            }
        }
    });
    Object.defineProperty(SnapshotProcessor.prototype, "postProcessSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (sn, node) {
            if (this._processors.postProcessor) {
                return this._processors.postProcessor.call(null, sn, node.storedValue);
            }
            return sn;
        }
    });
    Object.defineProperty(SnapshotProcessor.prototype, "_fixNode", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (node) {
            var _this = this;
            // the node has to use these methods rather than the original type ones
            proxyNodeTypeMethods(node.type, this, "create");
            if (node instanceof ObjectNode) {
                node.hasSnapshotPostProcessor = !!this._processors.postProcessor;
            }
            var oldGetSnapshot = node.getSnapshot;
            node.getSnapshot = function () { return _this.postProcessSnapshot(oldGetSnapshot.call(node), node); };
            if (!isUnionType(this._subtype)) {
                node.getReconciliationType = function () {
                    return _this;
                };
            }
        }
    });
    Object.defineProperty(SnapshotProcessor.prototype, "instantiate", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parent, subpath, environment, initialValue) {
            var processedInitialValue = isStateTreeNode(initialValue)
                ? initialValue
                : this.preProcessSnapshot(initialValue);
            var node = this._subtype.instantiate(parent, subpath, environment, processedInitialValue);
            this._fixNode(node);
            return node;
        }
    });
    Object.defineProperty(SnapshotProcessor.prototype, "reconcile", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (current, newValue, parent, subpath) {
            var node = this._subtype.reconcile(current, isStateTreeNode(newValue) ? newValue : this.preProcessSnapshot(newValue), parent, subpath);
            if (node !== current) {
                this._fixNode(node);
            }
            return node;
        }
    });
    Object.defineProperty(SnapshotProcessor.prototype, "getSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (node, applyPostProcess) {
            if (applyPostProcess === void 0) { applyPostProcess = true; }
            var sn = this._subtype.getSnapshot(node);
            return applyPostProcess ? this.postProcessSnapshot(sn, node) : sn;
        }
    });
    Object.defineProperty(SnapshotProcessor.prototype, "isValidSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (value, context) {
            var processedSn = this.preProcessSnapshotSafe(value);
            if (processedSn === $preProcessorFailed) {
                return typeCheckFailure(context, value, "Failed to preprocess value");
            }
            return this._subtype.validate(processedSn, context);
        }
    });
    Object.defineProperty(SnapshotProcessor.prototype, "getSubTypes", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return this._subtype;
        }
    });
    /**
     * MST considers a given value to "be" of a subtype is the value is either:
     *
     * 1. And instance of the subtype
     * 2. A valid snapshot *in* of the subtype
     *
     * Before v7, we used to also consider processed models (as in, SnapshotOut values of this).
     * This is no longer the case, and is more in line with our overall "is" philosophy, which you can
     * see in `src/core/type/type.ts:104` (assuming lines don't change too much).
     *
     * For additonal commentary, see discussion in https://github.com/mobxjs/mobx-state-tree/pull/2182
     *
     * The `is` function specifically checks for `SnapshotIn` or `Instance` of a given type.
     *
     * @param thing
     * @returns
     */
    Object.defineProperty(SnapshotProcessor.prototype, "is", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (thing) {
            var value = isType(thing)
                ? this._subtype
                : isStateTreeNode(thing)
                    ? thing
                    : this.preProcessSnapshotSafe(thing);
            if (value === $preProcessorFailed) {
                return false;
            }
            return this._subtype.validate(value, [{ path: "", type: this._subtype }]).length === 0;
        }
    });
    Object.defineProperty(SnapshotProcessor.prototype, "isAssignableFrom", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (type) {
            return this._subtype.isAssignableFrom(type);
        }
    });
    Object.defineProperty(SnapshotProcessor.prototype, "isMatchingSnapshotId", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (current, snapshot) {
            if (!(this._subtype instanceof ComplexType)) {
                return false;
            }
            var processedSn = this.preProcessSnapshot(snapshot);
            return this._subtype.isMatchingSnapshotId(current, processedSn);
        }
    });
    return SnapshotProcessor;
}(BaseType));
function proxyNodeTypeMethods(nodeType, snapshotProcessorType) {
    var e_1, _a;
    var methods = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        methods[_i - 2] = arguments[_i];
    }
    try {
        for (var methods_1 = __values(methods), methods_1_1 = methods_1.next(); !methods_1_1.done; methods_1_1 = methods_1.next()) {
            var method = methods_1_1.value;
            nodeType[method] = snapshotProcessorType[method].bind(snapshotProcessorType);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (methods_1_1 && !methods_1_1.done && (_a = methods_1.return)) _a.call(methods_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
}
/**
 * `types.snapshotProcessor` - Runs a pre/post snapshot processor before/after serializing a given type.
 *
 * Example:
 * ```ts
 * const Todo1 = types.model({ text: types.string })
 * // in the backend the text type must be null when empty
 * interface BackendTodo {
 *     text: string | null
 * }
 *
 * const Todo2 = types.snapshotProcessor(Todo1, {
 *     // from snapshot to instance
 *     preProcessor(snapshot: BackendTodo) {
 *         return {
 *             text: sn.text || "";
 *         }
 *     },
 *
 *     // from instance to snapshot
 *     postProcessor(snapshot, node): BackendTodo {
 *         return {
 *             text: !sn.text ? null : sn.text
 *         }
 *     }
 * })
 * ```
 *
 * @param type Type to run the processors over.
 * @param processors Processors to run.
 * @param name Type name, or undefined to inherit the inner type one.
 * @returns
 */
function snapshotProcessor(type, processors, name) {
    assertIsType(type, 1);
    if (devMode()) {
        if (processors.postProcessor && typeof processors.postProcessor !== "function") {
            // istanbul ignore next
            throw new MstError("postSnapshotProcessor must be a function");
        }
        if (processors.preProcessor && typeof processors.preProcessor !== "function") {
            // istanbul ignore next
            throw new MstError("preSnapshotProcessor must be a function");
        }
    }
    return new SnapshotProcessor(type, processors, name);
}

var needsIdentifierError = "Map.put can only be used to store complex values that have an identifier type attribute";
function tryCollectModelTypes(type, modelTypes) {
    var e_1, _a;
    var subtypes = type.getSubTypes();
    if (subtypes === cannotDetermineSubtype) {
        return false;
    }
    if (subtypes) {
        var subtypesArray = asArray(subtypes);
        try {
            for (var subtypesArray_1 = __values(subtypesArray), subtypesArray_1_1 = subtypesArray_1.next(); !subtypesArray_1_1.done; subtypesArray_1_1 = subtypesArray_1.next()) {
                var subtype = subtypesArray_1_1.value;
                if (!tryCollectModelTypes(subtype, modelTypes))
                    return false;
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (subtypesArray_1_1 && !subtypesArray_1_1.done && (_a = subtypesArray_1.return)) _a.call(subtypesArray_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
    }
    if (type instanceof ModelType) {
        modelTypes.push(type);
    }
    return true;
}
/**
 * @internal
 * @hidden
 */
var MapIdentifierMode;
(function (MapIdentifierMode) {
    MapIdentifierMode[MapIdentifierMode["UNKNOWN"] = 0] = "UNKNOWN";
    MapIdentifierMode[MapIdentifierMode["YES"] = 1] = "YES";
    MapIdentifierMode[MapIdentifierMode["NO"] = 2] = "NO";
})(MapIdentifierMode || (MapIdentifierMode = {}));
var MSTMap = /** @class */ (function (_super) {
    __extends(MSTMap, _super);
    function MSTMap(initialData, name) {
        return _super.call(this, initialData, observable.ref.enhancer, name) || this;
    }
    Object.defineProperty(MSTMap.prototype, "get", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (key) {
            // maybe this is over-enthousiastic? normalize numeric keys to strings
            return _super.prototype.get.call(this, "" + key);
        }
    });
    Object.defineProperty(MSTMap.prototype, "has", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (key) {
            return _super.prototype.has.call(this, "" + key);
        }
    });
    Object.defineProperty(MSTMap.prototype, "delete", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (key) {
            return _super.prototype.delete.call(this, "" + key);
        }
    });
    Object.defineProperty(MSTMap.prototype, "set", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (key, value) {
            return _super.prototype.set.call(this, "" + key, value);
        }
    });
    Object.defineProperty(MSTMap.prototype, "put", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (value) {
            if (!value)
                throw new MstError("Map.put cannot be used to set empty values");
            if (isStateTreeNode(value)) {
                var node = getStateTreeNode(value);
                if (devMode()) {
                    if (!node.identifierAttribute) {
                        throw new MstError(needsIdentifierError);
                    }
                }
                if (node.identifier === null) {
                    throw new MstError(needsIdentifierError);
                }
                this.set(node.identifier, value);
                return value;
            }
            else if (!isMutable(value)) {
                throw new MstError("Map.put can only be used to store complex values");
            }
            else {
                var mapNode = getStateTreeNode(this);
                var mapType = mapNode.type;
                if (mapType.identifierMode !== MapIdentifierMode.YES) {
                    throw new MstError(needsIdentifierError);
                }
                var idAttr = mapType.mapIdentifierAttribute;
                var id = value[idAttr];
                if (!isValidIdentifier(id)) {
                    // try again but this time after creating a node for the value
                    // since it might be an optional identifier
                    var newNode = this.put(mapType.getChildType().create(value, mapNode.environment));
                    return this.put(getSnapshot(newNode));
                }
                var key = normalizeIdentifier(id);
                this.set(key, value);
                return this.get(key);
            }
        }
    });
    return MSTMap;
}(ObservableMap));
/**
 * @internal
 * @hidden
 */
var MapType = /** @class */ (function (_super) {
    __extends(MapType, _super);
    function MapType(name, _subType, hookInitializers) {
        if (hookInitializers === void 0) { hookInitializers = []; }
        var _this = _super.call(this, name) || this;
        Object.defineProperty(_this, "_subType", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _subType
        });
        Object.defineProperty(_this, "identifierMode", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: MapIdentifierMode.UNKNOWN
        });
        Object.defineProperty(_this, "mapIdentifierAttribute", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: undefined
        });
        Object.defineProperty(_this, "flags", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: TypeFlags.Map
        });
        Object.defineProperty(_this, "hookInitializers", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        _this._determineIdentifierMode();
        _this.hookInitializers = hookInitializers;
        return _this;
    }
    Object.defineProperty(MapType.prototype, "hooks", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (hooks) {
            var hookInitializers = this.hookInitializers.length > 0 ? this.hookInitializers.concat(hooks) : [hooks];
            return new MapType(this.name, this._subType, hookInitializers);
        }
    });
    Object.defineProperty(MapType.prototype, "instantiate", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parent, subpath, environment, initialValue) {
            this._determineIdentifierMode();
            return createObjectNode(this, parent, subpath, environment, initialValue);
        }
    });
    Object.defineProperty(MapType.prototype, "_determineIdentifierMode", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            if (this.identifierMode !== MapIdentifierMode.UNKNOWN) {
                return;
            }
            var modelTypes = [];
            if (tryCollectModelTypes(this._subType, modelTypes)) {
                var identifierAttribute = modelTypes.reduce(function (current, type) {
                    if (!type.identifierAttribute)
                        return current;
                    if (current && current !== type.identifierAttribute) {
                        throw new MstError("The objects in a map should all have the same identifier attribute, expected '".concat(current, "', but child of type '").concat(type.name, "' declared attribute '").concat(type.identifierAttribute, "' as identifier"));
                    }
                    return type.identifierAttribute;
                }, undefined);
                if (identifierAttribute) {
                    this.identifierMode = MapIdentifierMode.YES;
                    this.mapIdentifierAttribute = identifierAttribute;
                }
                else {
                    this.identifierMode = MapIdentifierMode.NO;
                }
            }
        }
    });
    Object.defineProperty(MapType.prototype, "initializeChildNodes", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (objNode, initialSnapshot) {
            if (initialSnapshot === void 0) { initialSnapshot = {}; }
            var subType = objNode.type._subType;
            var result = {};
            Object.keys(initialSnapshot).forEach(function (name) {
                result[name] = subType.instantiate(objNode, name, undefined, initialSnapshot[name]);
            });
            return result;
        }
    });
    Object.defineProperty(MapType.prototype, "createNewInstance", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (childNodes) {
            return new MSTMap(childNodes, this.name);
        }
    });
    Object.defineProperty(MapType.prototype, "finalizeNewInstance", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (node, instance) {
            interceptReads(instance, node.unbox);
            var type = node.type;
            type.hookInitializers.forEach(function (initializer) {
                var hooks = initializer(instance);
                Object.keys(hooks).forEach(function (name) {
                    var hook = hooks[name];
                    var actionInvoker = createActionInvoker(instance, name, hook);
                    (!devMode() ? addHiddenFinalProp : addHiddenWritableProp)(instance, name, actionInvoker);
                });
            });
            intercept(instance, this.willChange);
            observe(instance, this.didChange);
        }
    });
    Object.defineProperty(MapType.prototype, "describe", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return this.name;
        }
    });
    Object.defineProperty(MapType.prototype, "getChildren", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (node) {
            // return (node.storedValue as ObservableMap<any>).values()
            return values(node.storedValue);
        }
    });
    Object.defineProperty(MapType.prototype, "getChildNode", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (node, key) {
            var childNode = node.storedValue.get("" + key);
            if (!childNode)
                throw new MstError("Not a child " + key);
            return childNode;
        }
    });
    Object.defineProperty(MapType.prototype, "willChange", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (change) {
            var node = getStateTreeNode(change.object);
            var key = change.name;
            node.assertWritable({ subpath: key });
            var mapType = node.type;
            var subType = mapType._subType;
            switch (change.type) {
                case "update":
                    {
                        var newValue = change.newValue;
                        var oldValue = change.object.get(key);
                        if (newValue === oldValue)
                            return null;
                        typecheckInternal(subType, newValue);
                        change.newValue = subType.reconcile(node.getChildNode(key), change.newValue, node, key);
                        mapType.processIdentifier(key, change.newValue);
                    }
                    break;
                case "add":
                    {
                        typecheckInternal(subType, change.newValue);
                        change.newValue = subType.instantiate(node, key, undefined, change.newValue);
                        mapType.processIdentifier(key, change.newValue);
                    }
                    break;
            }
            return change;
        }
    });
    Object.defineProperty(MapType.prototype, "processIdentifier", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (expected, node) {
            if (this.identifierMode === MapIdentifierMode.YES && node instanceof ObjectNode) {
                var identifier = node.identifier;
                if (identifier !== expected)
                    throw new MstError("A map of objects containing an identifier should always store the object under their own identifier. Trying to store key '".concat(identifier, "', but expected: '").concat(expected, "'"));
            }
        }
    });
    Object.defineProperty(MapType.prototype, "getSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (node) {
            var res = {};
            node.getChildren().forEach(function (childNode) {
                res[childNode.subpath] = childNode.snapshot;
            });
            return res;
        }
    });
    Object.defineProperty(MapType.prototype, "processInitialSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (childNodes) {
            var processed = {};
            Object.keys(childNodes).forEach(function (key) {
                processed[key] = childNodes[key].getSnapshot();
            });
            return processed;
        }
    });
    Object.defineProperty(MapType.prototype, "didChange", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (change) {
            var node = getStateTreeNode(change.object);
            switch (change.type) {
                case "update":
                    return void node.emitPatch({
                        op: "replace",
                        path: escapeJsonPath(change.name),
                        value: change.newValue.snapshot,
                        oldValue: change.oldValue ? change.oldValue.snapshot : undefined
                    }, node);
                case "add":
                    return void node.emitPatch({
                        op: "add",
                        path: escapeJsonPath(change.name),
                        value: change.newValue.snapshot,
                        oldValue: undefined
                    }, node);
                case "delete":
                    // a node got deleted, get the old snapshot and make the node die
                    var oldSnapshot = change.oldValue.snapshot;
                    change.oldValue.die();
                    // emit the patch
                    return void node.emitPatch({
                        op: "remove",
                        path: escapeJsonPath(change.name),
                        oldValue: oldSnapshot
                    }, node);
            }
        }
    });
    Object.defineProperty(MapType.prototype, "applyPatchLocally", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (node, subpath, patch) {
            var target = node.storedValue;
            switch (patch.op) {
                case "add":
                case "replace":
                    target.set(subpath, patch.value);
                    break;
                case "remove":
                    target.delete(subpath);
                    break;
            }
        }
    });
    Object.defineProperty(MapType.prototype, "applySnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (node, snapshot) {
            typecheckInternal(this, snapshot);
            var target = node.storedValue;
            var currentKeys = {};
            Array.from(target.keys()).forEach(function (key) {
                currentKeys[key] = false;
            });
            if (snapshot) {
                // Don't use target.replace, as it will throw away all existing items first
                for (var key in snapshot) {
                    target.set(key, snapshot[key]);
                    currentKeys["" + key] = true;
                }
            }
            Object.keys(currentKeys).forEach(function (key) {
                if (currentKeys[key] === false)
                    target.delete(key);
            });
        }
    });
    Object.defineProperty(MapType.prototype, "getChildType", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return this._subType;
        }
    });
    Object.defineProperty(MapType.prototype, "isValidSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (value, context) {
            var _this = this;
            if (!isPlainObject(value)) {
                return typeCheckFailure(context, value, "Value is not a plain object");
            }
            return flattenTypeErrors(Object.keys(value).map(function (path) {
                return _this._subType.validate(value[path], getContextForPath(context, path, _this._subType));
            }));
        }
    });
    Object.defineProperty(MapType.prototype, "getDefaultSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return EMPTY_OBJECT;
        }
    });
    Object.defineProperty(MapType.prototype, "removeChild", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (node, subpath) {
            node.storedValue.delete(subpath);
        }
    });
    return MapType;
}(ComplexType));
MapType.prototype.applySnapshot = action(MapType.prototype.applySnapshot);
/**
 * `types.map` - Creates a key based collection type who's children are all of a uniform declared type.
 * If the type stored in a map has an identifier, it is mandatory to store the child under that identifier in the map.
 *
 * This type will always produce [observable maps](https://mobx.js.org/api.html#observablemap)
 *
 * Example:
 * ```ts
 * const Todo = types.model({
 *   id: types.identifier,
 *   task: types.string
 * })
 *
 * const TodoStore = types.model({
 *   todos: types.map(Todo)
 * })
 *
 * const s = TodoStore.create({ todos: {} })
 * unprotect(s)
 * s.todos.set(17, { task: "Grab coffee", id: 17 })
 * s.todos.put({ task: "Grab cookie", id: 18 }) // put will infer key from the identifier
 * console.log(s.todos.get(17).task) // prints: "Grab coffee"
 * ```
 *
 * @param subtype
 * @returns
 */
function map(subtype) {
    return new MapType("Map<string, ".concat(subtype.name, ">"), subtype);
}

/**
 * @internal
 * @hidden
 */
var ArrayType = /** @class */ (function (_super) {
    __extends(ArrayType, _super);
    function ArrayType(name, _subType, hookInitializers) {
        if (hookInitializers === void 0) { hookInitializers = []; }
        var _this = _super.call(this, name) || this;
        Object.defineProperty(_this, "_subType", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _subType
        });
        Object.defineProperty(_this, "flags", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: TypeFlags.Array
        });
        Object.defineProperty(_this, "hookInitializers", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        _this.hookInitializers = hookInitializers;
        return _this;
    }
    Object.defineProperty(ArrayType.prototype, "hooks", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (hooks) {
            var hookInitializers = this.hookInitializers.length > 0 ? this.hookInitializers.concat(hooks) : [hooks];
            return new ArrayType(this.name, this._subType, hookInitializers);
        }
    });
    Object.defineProperty(ArrayType.prototype, "instantiate", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parent, subpath, environment, initialValue) {
            return createObjectNode(this, parent, subpath, environment, initialValue);
        }
    });
    Object.defineProperty(ArrayType.prototype, "initializeChildNodes", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (objNode, snapshot) {
            if (snapshot === void 0) { snapshot = []; }
            var subType = objNode.type._subType;
            var result = {};
            snapshot.forEach(function (item, index) {
                var subpath = "" + index;
                result[subpath] = subType.instantiate(objNode, subpath, undefined, item);
            });
            return result;
        }
    });
    Object.defineProperty(ArrayType.prototype, "createNewInstance", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (childNodes) {
            var options = __assign(__assign({}, mobxShallow), { name: this.name });
            return observable.array(convertChildNodesToArray(childNodes), options);
        }
    });
    Object.defineProperty(ArrayType.prototype, "finalizeNewInstance", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (node, instance) {
            getAdministration(instance).dehancer = node.unbox;
            var type = node.type;
            type.hookInitializers.forEach(function (initializer) {
                var hooks = initializer(instance);
                Object.keys(hooks).forEach(function (name) {
                    var hook = hooks[name];
                    var actionInvoker = createActionInvoker(instance, name, hook);
                    (!devMode() ? addHiddenFinalProp : addHiddenWritableProp)(instance, name, actionInvoker);
                });
            });
            intercept(instance, this.willChange);
            observe(instance, this.didChange);
        }
    });
    Object.defineProperty(ArrayType.prototype, "describe", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return this.name;
        }
    });
    Object.defineProperty(ArrayType.prototype, "getChildren", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (node) {
            return node.storedValue.slice();
        }
    });
    Object.defineProperty(ArrayType.prototype, "getChildNode", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (node, key) {
            var index = Number(key);
            if (index < node.storedValue.length)
                return node.storedValue[index];
            throw new MstError("Not a child: " + key);
        }
    });
    Object.defineProperty(ArrayType.prototype, "willChange", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (change) {
            var node = getStateTreeNode(change.object);
            node.assertWritable({ subpath: "" + change.index });
            var subType = node.type._subType;
            var childNodes = node.getChildren();
            switch (change.type) {
                case "update":
                    {
                        if (change.newValue === change.object[change.index])
                            return null;
                        var updatedNodes = reconcileArrayChildren(node, subType, [childNodes[change.index]], [change.newValue], [change.index]);
                        if (!updatedNodes) {
                            return null;
                        }
                        change.newValue = updatedNodes[0];
                    }
                    break;
                case "splice":
                    {
                        var index_1 = change.index, removedCount = change.removedCount, added = change.added;
                        var addedNodes = reconcileArrayChildren(node, subType, childNodes.slice(index_1, index_1 + removedCount), added, added.map(function (_, i) { return index_1 + i; }));
                        if (!addedNodes) {
                            return null;
                        }
                        change.added = addedNodes;
                        // update paths of remaining items
                        for (var i = index_1 + removedCount; i < childNodes.length; i++) {
                            childNodes[i].setParent(node, "" + (i + added.length - removedCount));
                        }
                    }
                    break;
            }
            return change;
        }
    });
    Object.defineProperty(ArrayType.prototype, "getSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (node) {
            return node.getChildren().map(function (childNode) { return childNode.snapshot; });
        }
    });
    Object.defineProperty(ArrayType.prototype, "processInitialSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (childNodes) {
            var processed = [];
            Object.keys(childNodes).forEach(function (key) {
                processed.push(childNodes[key].getSnapshot());
            });
            return processed;
        }
    });
    Object.defineProperty(ArrayType.prototype, "didChange", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (change) {
            var node = getStateTreeNode(change.object);
            switch (change.type) {
                case "update":
                    return void node.emitPatch({
                        op: "replace",
                        path: "" + change.index,
                        value: change.newValue.snapshot,
                        oldValue: change.oldValue ? change.oldValue.snapshot : undefined
                    }, node);
                case "splice":
                    // Perf: emit one patch for clear and replace ops.
                    if (change.removedCount && change.addedCount === change.object.length) {
                        return void node.emitPatch({
                            op: "replace",
                            path: "",
                            value: node.snapshot,
                            oldValue: change.removed.map(function (node) { return node.snapshot; })
                        }, node);
                    }
                    for (var i = change.removedCount - 1; i >= 0; i--)
                        node.emitPatch({
                            op: "remove",
                            path: "" + (change.index + i),
                            oldValue: change.removed[i].snapshot
                        }, node);
                    for (var i = 0; i < change.addedCount; i++)
                        node.emitPatch({
                            op: "add",
                            path: "" + (change.index + i),
                            value: change.added[i].snapshot,
                            oldValue: undefined
                        }, node);
                    return;
            }
        }
    });
    Object.defineProperty(ArrayType.prototype, "applyPatchLocally", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (node, subpath, patch) {
            var target = node.storedValue;
            var index = subpath === "-" ? target.length : Number(subpath);
            switch (patch.op) {
                case "replace":
                    target[index] = patch.value;
                    break;
                case "add":
                    target.splice(index, 0, patch.value);
                    break;
                case "remove":
                    target.splice(index, 1);
                    break;
            }
        }
    });
    Object.defineProperty(ArrayType.prototype, "applySnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (node, snapshot) {
            typecheckInternal(this, snapshot);
            var target = node.storedValue;
            target.replace(snapshot);
        }
    });
    Object.defineProperty(ArrayType.prototype, "getChildType", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return this._subType;
        }
    });
    Object.defineProperty(ArrayType.prototype, "isValidSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (value, context) {
            var _this = this;
            if (!isArray(value)) {
                return typeCheckFailure(context, value, "Value is not an array");
            }
            return flattenTypeErrors(value.map(function (item, index) {
                return _this._subType.validate(item, getContextForPath(context, "" + index, _this._subType));
            }));
        }
    });
    Object.defineProperty(ArrayType.prototype, "getDefaultSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return EMPTY_ARRAY;
        }
    });
    Object.defineProperty(ArrayType.prototype, "removeChild", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (node, subpath) {
            node.storedValue.splice(Number(subpath), 1);
        }
    });
    return ArrayType;
}(ComplexType));
ArrayType.prototype.applySnapshot = action(ArrayType.prototype.applySnapshot);
/**
 * `types.array` - Creates an index based collection type who's children are all of a uniform declared type.
 *
 * This type will always produce [observable arrays](https://mobx.js.org/api.html#observablearray)
 *
 * Example:
 * ```ts
 * const Todo = types.model({
 *   task: types.string
 * })
 *
 * const TodoStore = types.model({
 *   todos: types.array(Todo)
 * })
 *
 * const s = TodoStore.create({ todos: [] })
 * unprotect(s) // needed to allow modifying outside of an action
 * s.todos.push({ task: "Grab coffee" })
 * console.log(s.todos[0]) // prints: "Grab coffee"
 * ```
 *
 * @param subtype
 * @returns
 */
function array(subtype) {
    assertIsType(subtype, 1);
    return new ArrayType("".concat(subtype.name, "[]"), subtype);
}
function reconcileArrayChildren(parent, childType, oldNodes, newValues, newPaths) {
    var nothingChanged = true;
    for (var i = 0;; i++) {
        var hasNewNode = i <= newValues.length - 1;
        var oldNode = oldNodes[i];
        var newValue = hasNewNode ? newValues[i] : undefined;
        var newPath = "" + newPaths[i];
        // for some reason, instead of newValue we got a node, fallback to the storedValue
        // TODO: https://github.com/mobxjs/mobx-state-tree/issues/340#issuecomment-325581681
        if (isNode(newValue))
            newValue = newValue.storedValue;
        if (!oldNode && !hasNewNode) {
            // both are empty, end
            break;
        }
        else if (!hasNewNode) {
            // new one does not exists
            nothingChanged = false;
            oldNodes.splice(i, 1);
            if (oldNode instanceof ObjectNode) {
                // since it is going to be returned by pop/splice/shift better create it before killing it
                // so it doesn't end up in an undead state
                oldNode.createObservableInstanceIfNeeded();
            }
            oldNode.die();
            i--;
        }
        else if (!oldNode) {
            // there is no old node, create it
            // check if already belongs to the same parent. if so, avoid pushing item in. only swapping can occur.
            if (isStateTreeNode(newValue) && getStateTreeNode(newValue).parent === parent) {
                // this node is owned by this parent, but not in the reconcilable set, so it must be double
                throw new MstError("Cannot add an object to a state tree if it is already part of the same or another state tree. Tried to assign an object to '".concat(parent.path, "/").concat(newPath, "', but it lives already at '").concat(getStateTreeNode(newValue).path, "'"));
            }
            nothingChanged = false;
            var newNode = valueAsNode(childType, parent, newPath, newValue);
            oldNodes.splice(i, 0, newNode);
        }
        else if (areSame(oldNode, newValue)) {
            // both are the same, reconcile
            oldNodes[i] = valueAsNode(childType, parent, newPath, newValue, oldNode);
        }
        else {
            // nothing to do, try to reorder
            var oldMatch = undefined;
            // find a possible candidate to reuse
            for (var j = i; j < oldNodes.length; j++) {
                if (areSame(oldNodes[j], newValue)) {
                    oldMatch = oldNodes.splice(j, 1)[0];
                    break;
                }
            }
            nothingChanged = false;
            var newNode = valueAsNode(childType, parent, newPath, newValue, oldMatch);
            oldNodes.splice(i, 0, newNode);
        }
    }
    return nothingChanged ? null : oldNodes;
}
/**
 * Convert a value to a node at given parent and subpath. Attempts to reuse old node if possible and given.
 */
function valueAsNode(childType, parent, subpath, newValue, oldNode) {
    // ensure the value is valid-ish
    typecheckInternal(childType, newValue);
    function getNewNode() {
        // the new value has a MST node
        if (isStateTreeNode(newValue)) {
            var childNode = getStateTreeNode(newValue);
            childNode.assertAlive(EMPTY_OBJECT);
            // the node lives here
            if (childNode.parent !== null && childNode.parent === parent) {
                childNode.setParent(parent, subpath);
                return childNode;
            }
        }
        // there is old node and new one is a value/snapshot
        if (oldNode) {
            return childType.reconcile(oldNode, newValue, parent, subpath);
        }
        // nothing to do, create from scratch
        return childType.instantiate(parent, subpath, undefined, newValue);
    }
    var newNode = getNewNode();
    if (oldNode && oldNode !== newNode) {
        if (oldNode instanceof ObjectNode) {
            // since it is going to be returned by pop/splice/shift better create it before killing it
            // so it doesn't end up in an undead state
            oldNode.createObservableInstanceIfNeeded();
        }
        oldNode.die();
    }
    return newNode;
}
/**
 * Check if a node holds a value.
 */
function areSame(oldNode, newValue) {
    // never consider dead old nodes for reconciliation
    if (!oldNode.isAlive) {
        return false;
    }
    // the new value has the same node
    if (isStateTreeNode(newValue)) {
        var newNode = getStateTreeNode(newValue);
        return newNode.isAlive && newNode === oldNode;
    }
    // the provided value is the snapshot of the old node
    if (oldNode.snapshot === newValue) {
        return true;
    }
    // Non object nodes don't get reconciled
    if (!(oldNode instanceof ObjectNode)) {
        return false;
    }
    var oldNodeType = oldNode.getReconciliationType();
    // new value is a snapshot with the correct identifier
    return (oldNode.identifier !== null &&
        oldNode.identifierAttribute &&
        isPlainObject(newValue) &&
        oldNodeType.is(newValue) &&
        oldNodeType.isMatchingSnapshotId(oldNode, newValue));
}

var PRE_PROCESS_SNAPSHOT = "preProcessSnapshot";
var POST_PROCESS_SNAPSHOT = "postProcessSnapshot";
function objectTypeToString() {
    return getStateTreeNode(this).toString();
}
var defaultObjectOptions = {
    name: "AnonymousModel",
    properties: {},
    initializers: EMPTY_ARRAY
};
function toPropertiesObject(declaredProps) {
    var keysList = Object.keys(declaredProps);
    var alreadySeenKeys = new Set();
    keysList.forEach(function (key) {
        if (alreadySeenKeys.has(key)) {
            throw new MstError("".concat(key, " is declared twice in the model. Model should not contain the same keys"));
        }
        alreadySeenKeys.add(key);
    });
    // loop through properties and ensures that all items are types
    return keysList.reduce(function (props, key) {
        // warn if user intended a HOOK
        if (key in Hook) {
            throw new MstError("Hook '".concat(key, "' was defined as property. Hooks should be defined as part of the actions"));
        }
        // the user intended to use a view
        var descriptor = Object.getOwnPropertyDescriptor(declaredProps, key);
        if ("get" in descriptor) {
            throw new MstError("Getters are not supported as properties. Please use views instead");
        }
        // undefined and null are not valid
        var value = descriptor.value;
        if (value === null || value === undefined) {
            throw new MstError("The default value of an attribute cannot be null or undefined as the type cannot be inferred. Did you mean `types.maybe(someType)`?");
        }
        // its a primitive, convert to its type
        else if (isPrimitive(value)) {
            props[key] = optional(getPrimitiveFactoryFromValue(value), value);
        }
        // map defaults to empty object automatically for models
        else if (value instanceof MapType) {
            props[key] = optional(value, {});
        }
        else if (value instanceof ArrayType) {
            props[key] = optional(value, []);
        }
        // its already a type
        else if (isType(value)) ;
        // its a function, maybe the user wanted a view?
        else if (devMode() && typeof value === "function") {
            throw new MstError("Invalid type definition for property '".concat(key, "', it looks like you passed a function. Did you forget to invoke it, or did you intend to declare a view / action?"));
        }
        // no other complex values
        else if (devMode() && typeof value === "object") {
            throw new MstError("Invalid type definition for property '".concat(key, "', it looks like you passed an object. Try passing another model type or a types.frozen."));
        }
        else {
            throw new MstError("Invalid type definition for property '".concat(key, "', cannot infer a type from a value like '").concat(value, "' (").concat(typeof value, ")"));
        }
        return props;
    }, __assign({}, declaredProps));
}
/**
 * @internal
 * @hidden
 */
var ModelType = /** @class */ (function (_super) {
    __extends(ModelType, _super);
    function ModelType(opts) {
        var _this = _super.call(this, opts.name || defaultObjectOptions.name) || this;
        Object.defineProperty(_this, "flags", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: TypeFlags.Object
        });
        /*
         * The original object definition
         */
        Object.defineProperty(_this, "initializers", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(_this, "properties", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(_this, "preProcessor", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(_this, "postProcessor", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(_this, "propertyNames", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(_this, "named", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function (name) {
                return _this.cloneAndEnhance({ name: name });
            }
        });
        Object.defineProperty(_this, "props", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function (properties) {
                return _this.cloneAndEnhance({ properties: properties });
            }
        });
        Object.defineProperty(_this, "preProcessSnapshot", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function (preProcessor) {
                var currentPreprocessor = _this.preProcessor;
                if (!currentPreprocessor)
                    return _this.cloneAndEnhance({ preProcessor: preProcessor });
                else
                    return _this.cloneAndEnhance({
                        preProcessor: function (snapshot) { return currentPreprocessor(preProcessor(snapshot)); }
                    });
            }
        });
        Object.defineProperty(_this, "postProcessSnapshot", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function (postProcessor) {
                var currentPostprocessor = _this.postProcessor;
                if (!currentPostprocessor)
                    return _this.cloneAndEnhance({ postProcessor: postProcessor });
                else
                    return _this.cloneAndEnhance({
                        postProcessor: function (snapshot) { return postProcessor(currentPostprocessor(snapshot)); }
                    });
            }
        });
        Object.assign(_this, defaultObjectOptions, opts);
        // ensures that any default value gets converted to its related type
        _this.properties = toPropertiesObject(_this.properties);
        freeze(_this.properties); // make sure nobody messes with it
        _this.propertyNames = Object.keys(_this.properties);
        _this.identifierAttribute = _this._getIdentifierAttribute();
        return _this;
    }
    Object.defineProperty(ModelType.prototype, "_getIdentifierAttribute", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var identifierAttribute = undefined;
            this.forAllProps(function (propName, propType) {
                if (propType.flags & TypeFlags.Identifier) {
                    if (identifierAttribute)
                        throw new MstError("Cannot define property '".concat(propName, "' as object identifier, property '").concat(identifierAttribute, "' is already defined as identifier property"));
                    identifierAttribute = propName;
                }
            });
            return identifierAttribute;
        }
    });
    Object.defineProperty(ModelType.prototype, "cloneAndEnhance", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (opts) {
            return new ModelType({
                name: opts.name || this.name,
                properties: Object.assign({}, this.properties, opts.properties),
                initializers: this.initializers.concat(opts.initializers || []),
                preProcessor: opts.preProcessor || this.preProcessor,
                postProcessor: opts.postProcessor || this.postProcessor
            });
        }
    });
    Object.defineProperty(ModelType.prototype, "actions", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (fn) {
            var _this = this;
            var actionInitializer = function (self) {
                _this.instantiateActions(self, fn(self));
                return self;
            };
            return this.cloneAndEnhance({ initializers: [actionInitializer] });
        }
    });
    Object.defineProperty(ModelType.prototype, "instantiateActions", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (self, actions) {
            var _this = this;
            // check if return is correct
            if (!isPlainObject(actions)) {
                throw new MstError("actions initializer should return a plain object containing actions");
            }
            // bind actions to the object created
            Object.getOwnPropertyNames(actions).forEach(function (name) {
                if (name in _this.properties) {
                    throw new MstError("'".concat(name, "' is a property and cannot be declared as an action"));
                }
                // warn if preprocessor was given
                if (name === PRE_PROCESS_SNAPSHOT)
                    throw new MstError("Cannot define action '".concat(PRE_PROCESS_SNAPSHOT, "', it should be defined using 'type.preProcessSnapshot(fn)' instead"));
                // warn if postprocessor was given
                if (name === POST_PROCESS_SNAPSHOT)
                    throw new MstError("Cannot define action '".concat(POST_PROCESS_SNAPSHOT, "', it should be defined using 'type.postProcessSnapshot(fn)' instead"));
                var action2 = actions[name];
                // apply hook composition
                var baseAction = self[name];
                if (name in Hook && baseAction) {
                    var specializedAction_1 = action2;
                    action2 = function () {
                        baseAction.apply(null, arguments);
                        specializedAction_1.apply(null, arguments);
                    };
                }
                // the goal of this is to make sure actions using "this" can call themselves,
                // while still allowing the middlewares to register them
                var middlewares = action2.$mst_middleware; // make sure middlewares are not lost
                var boundAction = action2.bind(actions);
                boundAction._isFlowAction = action2._isFlowAction || false;
                boundAction.$mst_middleware = middlewares;
                var actionInvoker = createActionInvoker(self, name, boundAction);
                actions[name] = actionInvoker;
                (!devMode() ? addHiddenFinalProp : addHiddenWritableProp)(self, name, actionInvoker);
            });
        }
    });
    Object.defineProperty(ModelType.prototype, "volatile", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (fn) {
            var _this = this;
            if (typeof fn !== "function") {
                throw new MstError("You passed an ".concat(typeof fn, " to volatile state as an argument, when function is expected"));
            }
            var stateInitializer = function (self) {
                _this.instantiateVolatileState(self, fn(self));
                return self;
            };
            return this.cloneAndEnhance({ initializers: [stateInitializer] });
        }
    });
    Object.defineProperty(ModelType.prototype, "instantiateVolatileState", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (self, state) {
            var _this = this;
            // check views return
            if (!isPlainObject(state)) {
                throw new MstError("volatile state initializer should return a plain object containing state");
            }
            Object.getOwnPropertyNames(state).forEach(function (name) {
                if (name in _this.properties) {
                    throw new MstError("'".concat(name, "' is a property and cannot be declared as volatile state"));
                }
                set(self, name, state[name]);
            });
        }
    });
    Object.defineProperty(ModelType.prototype, "extend", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (fn) {
            var _this = this;
            var initializer = function (self) {
                var _a = fn(self), actions = _a.actions, views = _a.views, state = _a.state, rest = __rest(_a, ["actions", "views", "state"]);
                for (var key in rest)
                    throw new MstError("The `extend` function should return an object with a subset of the fields 'actions', 'views' and 'state'. Found invalid key '".concat(key, "'"));
                if (state)
                    _this.instantiateVolatileState(self, state);
                if (views)
                    _this.instantiateViews(self, views);
                if (actions)
                    _this.instantiateActions(self, actions);
                return self;
            };
            return this.cloneAndEnhance({ initializers: [initializer] });
        }
    });
    Object.defineProperty(ModelType.prototype, "views", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (fn) {
            var _this = this;
            var viewInitializer = function (self) {
                _this.instantiateViews(self, fn(self));
                return self;
            };
            return this.cloneAndEnhance({ initializers: [viewInitializer] });
        }
    });
    Object.defineProperty(ModelType.prototype, "instantiateViews", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (self, views) {
            var _this = this;
            // check views return
            if (!isPlainObject(views)) {
                throw new MstError("views initializer should return a plain object containing views");
            }
            Object.getOwnPropertyNames(views).forEach(function (name) {
                var _a;
                if (name in _this.properties) {
                    throw new MstError("'".concat(name, "' is a property and cannot be declared as a view"));
                }
                // is this a computed property?
                var descriptor = Object.getOwnPropertyDescriptor(views, name);
                if ("get" in descriptor) {
                    apiDefineProperty(self, name, descriptor);
                    makeObservable(self, (_a = {}, _a[name] = computed, _a));
                }
                else if (typeof descriptor.value === "function") {
                    (!devMode() ? addHiddenFinalProp : addHiddenWritableProp)(self, name, descriptor.value);
                }
                else {
                    throw new MstError("A view member should either be a function or getter based property");
                }
            });
        }
    });
    Object.defineProperty(ModelType.prototype, "instantiate", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parent, subpath, environment, initialValue) {
            var value = isStateTreeNode(initialValue)
                ? initialValue
                : this.applySnapshotPreProcessor(initialValue);
            return createObjectNode(this, parent, subpath, environment, value);
            // Optimization: record all prop- view- and action names after first construction, and generate an optimal base class
            // that pre-reserves all these fields for fast object-member lookups
        }
    });
    Object.defineProperty(ModelType.prototype, "initializeChildNodes", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (objNode, initialSnapshot) {
            if (initialSnapshot === void 0) { initialSnapshot = {}; }
            var type = objNode.type;
            var result = {};
            type.forAllProps(function (name, childType) {
                result[name] = childType.instantiate(objNode, name, undefined, initialSnapshot[name]);
            });
            return result;
        }
    });
    Object.defineProperty(ModelType.prototype, "createNewInstance", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (childNodes) {
            var options = __assign(__assign({}, mobxShallow), { name: this.name });
            return observable.object(childNodes, EMPTY_OBJECT, options);
        }
    });
    Object.defineProperty(ModelType.prototype, "finalizeNewInstance", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (node, instance) {
            addHiddenFinalProp(instance, "toString", objectTypeToString);
            this.forAllProps(function (name) {
                interceptReads(instance, name, node.unbox);
            });
            this.initializers.reduce(function (self, fn) { return fn(self); }, instance);
            intercept(instance, this.willChange);
            observe(instance, this.didChange);
        }
    });
    Object.defineProperty(ModelType.prototype, "willChange", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (chg) {
            // TODO: mobx typings don't seem to take into account that newValue can be set even when removing a prop
            var change = chg;
            var node = getStateTreeNode(change.object);
            var subpath = change.name;
            node.assertWritable({ subpath: subpath });
            var childType = node.type.properties[subpath];
            // only properties are typed, state are stored as-is references
            if (childType) {
                typecheckInternal(childType, change.newValue);
                change.newValue = childType.reconcile(node.getChildNode(subpath), change.newValue, node, subpath);
            }
            return change;
        }
    });
    Object.defineProperty(ModelType.prototype, "didChange", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (chg) {
            // TODO: mobx typings don't seem to take into account that newValue can be set even when removing a prop
            var change = chg;
            var childNode = getStateTreeNode(change.object);
            var childType = childNode.type.properties[change.name];
            if (!childType) {
                // don't emit patches for volatile state
                return;
            }
            var oldChildValue = change.oldValue ? change.oldValue.snapshot : undefined;
            childNode.emitPatch({
                op: "replace",
                path: escapeJsonPath(change.name),
                value: change.newValue.snapshot,
                oldValue: oldChildValue
            }, childNode);
        }
    });
    Object.defineProperty(ModelType.prototype, "getChildren", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (node) {
            var _this = this;
            var res = [];
            this.forAllProps(function (name) {
                res.push(_this.getChildNode(node, name));
            });
            return res;
        }
    });
    Object.defineProperty(ModelType.prototype, "getChildNode", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (node, key) {
            var _a;
            if (!(key in this.properties))
                throw new MstError("Not a value property: " + key);
            var adm = getAdministration(node.storedValue, key);
            var childNode = (_a = adm.raw) === null || _a === void 0 ? void 0 : _a.call(adm);
            if (!childNode)
                throw new MstError("Node not available for property " + key);
            return childNode;
        }
    });
    Object.defineProperty(ModelType.prototype, "getSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (node, applyPostProcess) {
            var _this = this;
            if (applyPostProcess === void 0) { applyPostProcess = true; }
            var res = {};
            this.forAllProps(function (name, type) {
                // TODO: FIXME, make sure the observable ref is used!
                var atom = getAtom(node.storedValue, name);
                atom.reportObserved();
                res[name] = _this.getChildNode(node, name).snapshot;
            });
            if (applyPostProcess) {
                return this.applySnapshotPostProcessor(res);
            }
            return res;
        }
    });
    Object.defineProperty(ModelType.prototype, "processInitialSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (childNodes) {
            var processed = {};
            Object.keys(childNodes).forEach(function (key) {
                processed[key] = childNodes[key].getSnapshot();
            });
            return this.applySnapshotPostProcessor(processed);
        }
    });
    Object.defineProperty(ModelType.prototype, "applyPatchLocally", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (node, subpath, patch) {
            if (!(patch.op === "replace" || patch.op === "add")) {
                throw new MstError("object does not support operation ".concat(patch.op));
            }
            node.storedValue[subpath] = patch.value;
        }
    });
    Object.defineProperty(ModelType.prototype, "applySnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (node, snapshot) {
            typecheckInternal(this, snapshot);
            var preProcessedSnapshot = this.applySnapshotPreProcessor(snapshot);
            this.forAllProps(function (name) {
                node.storedValue[name] = preProcessedSnapshot[name];
            });
        }
    });
    Object.defineProperty(ModelType.prototype, "applySnapshotPreProcessor", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (snapshot) {
            var processor = this.preProcessor;
            return processor ? processor.call(null, snapshot) : snapshot;
        }
    });
    Object.defineProperty(ModelType.prototype, "applySnapshotPostProcessor", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (snapshot) {
            var postProcessor = this.postProcessor;
            if (postProcessor)
                return postProcessor.call(null, snapshot);
            return snapshot;
        }
    });
    Object.defineProperty(ModelType.prototype, "getChildType", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (propertyName) {
            assertIsString(propertyName, 1);
            return this.properties[propertyName];
        }
    });
    Object.defineProperty(ModelType.prototype, "isValidSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (value, context) {
            var _this = this;
            var snapshot = this.applySnapshotPreProcessor(value);
            if (!isPlainObject(snapshot)) {
                return typeCheckFailure(context, snapshot, "Value is not a plain object");
            }
            return flattenTypeErrors(this.propertyNames.map(function (key) {
                return _this.properties[key].validate(snapshot[key], getContextForPath(context, key, _this.properties[key]));
            }));
        }
    });
    Object.defineProperty(ModelType.prototype, "forAllProps", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (fn) {
            var _this = this;
            this.propertyNames.forEach(function (key) { return fn(key, _this.properties[key]); });
        }
    });
    Object.defineProperty(ModelType.prototype, "describe", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _this = this;
            // optimization: cache
            return ("{ " +
                this.propertyNames.map(function (key) { return key + ": " + _this.properties[key].describe(); }).join("; ") +
                " }");
        }
    });
    Object.defineProperty(ModelType.prototype, "getDefaultSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return EMPTY_OBJECT;
        }
    });
    Object.defineProperty(ModelType.prototype, "removeChild", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (node, subpath) {
            node.storedValue[subpath] = undefined;
        }
    });
    return ModelType;
}(ComplexType));
ModelType.prototype.applySnapshot = action(ModelType.prototype.applySnapshot);
/**
 * `types.model` - Creates a new model type by providing a name, properties, volatile state and actions.
 *
 * See the [model type](/concepts/trees#creating-models) description or the [getting started](intro/getting-started.md#getting-started-1) tutorial.
 */
function model() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    if (devMode() && typeof args[0] !== "string" && args[1]) {
        throw new MstError("Model creation failed. First argument must be a string when two arguments are provided");
    }
    var name = typeof args[0] === "string" ? args.shift() : "AnonymousModel";
    var properties = args.shift() || {};
    return new ModelType({ name: name, properties: properties });
}
/**
 * `types.compose` - Composes a new model from one or more existing model types.
 * This method can be invoked in two forms:
 * Given 2 or more model types, the types are composed into a new Type.
 * Given first parameter as a string and 2 or more model types,
 * the types are composed into a new Type with the given name
 */
function compose() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    // TODO: just join the base type names if no name is provided
    var hasTypename = typeof args[0] === "string";
    var typeName = hasTypename ? args[0] : "AnonymousModel";
    if (hasTypename) {
        args.shift();
    }
    // check all parameters
    if (devMode()) {
        args.forEach(function (type, i) {
            assertArg(type, isModelType, "mobx-state-tree model type", hasTypename ? i + 2 : i + 1);
        });
    }
    return args
        .reduce(function (prev, cur) {
        return prev.cloneAndEnhance({
            name: prev.name + "_" + cur.name,
            properties: cur.properties,
            initializers: cur.initializers,
            preProcessor: function (snapshot) {
                return cur.applySnapshotPreProcessor(prev.applySnapshotPreProcessor(snapshot));
            },
            postProcessor: function (snapshot) {
                return cur.applySnapshotPostProcessor(prev.applySnapshotPostProcessor(snapshot));
            }
        });
    })
        .named(typeName);
}
/**
 * Returns if a given value represents a model type.
 *
 * @param type
 * @returns
 */
function isModelType(type) {
    return isType(type) && (type.flags & TypeFlags.Object) > 0;
}

// TODO: implement CoreType using types.custom ?
/**
 * @internal
 * @hidden
 */
var CoreType = /** @class */ (function (_super) {
    __extends(CoreType, _super);
    function CoreType(name, flags, checker, initializer) {
        if (initializer === void 0) { initializer = identity; }
        var _this = _super.call(this, name) || this;
        Object.defineProperty(_this, "flags", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: flags
        });
        Object.defineProperty(_this, "checker", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: checker
        });
        Object.defineProperty(_this, "initializer", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: initializer
        });
        _this.flags = flags;
        return _this;
    }
    Object.defineProperty(CoreType.prototype, "describe", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return this.name;
        }
    });
    Object.defineProperty(CoreType.prototype, "instantiate", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parent, subpath, environment, initialValue) {
            return createScalarNode(this, parent, subpath, environment, initialValue);
        }
    });
    Object.defineProperty(CoreType.prototype, "createNewInstance", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (snapshot) {
            return this.initializer(snapshot);
        }
    });
    Object.defineProperty(CoreType.prototype, "isValidSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (value, context) {
            if (isPrimitive(value) && this.checker(value)) {
                return typeCheckSuccess();
            }
            var typeName = this.name === "Date" ? "Date or a unix milliseconds timestamp" : this.name;
            return typeCheckFailure(context, value, "Value is not a ".concat(typeName));
        }
    });
    return CoreType;
}(SimpleType));
/**
 * `types.string` - Creates a type that can only contain a string value.
 * This type is used for string values by default
 *
 * Example:
 * ```ts
 * const Person = types.model({
 *   firstName: types.string,
 *   lastName: "Doe"
 * })
 * ```
 */
// tslint:disable-next-line:variable-name
var string = new CoreType("string", TypeFlags.String, function (v) { return typeof v === "string"; });
/**
 * `types.number` - Creates a type that can only contain a numeric value.
 * This type is used for numeric values by default
 *
 * Example:
 * ```ts
 * const Vector = types.model({
 *   x: types.number,
 *   y: 1.5
 * })
 * ```
 */
// tslint:disable-next-line:variable-name
var number = new CoreType("number", TypeFlags.Number, function (v) { return typeof v === "number"; });
/**
 * `types.integer` - Creates a type that can only contain an integer value.
 *
 * Example:
 * ```ts
 * const Size = types.model({
 *   width: types.integer,
 *   height: 10
 * })
 * ```
 */
// tslint:disable-next-line:variable-name
var integer = new CoreType("integer", TypeFlags.Integer, function (v) { return isInteger(v); });
/**
 * `types.float` - Creates a type that can only contain an float value.
 *
 * Example:
 * ```ts
 * const Size = types.model({
 *   width: types.float,
 *   height: 10
 * })
 * ```
 */
// tslint:disable-next-line:variable-name
var float = new CoreType("float", TypeFlags.Float, function (v) { return isFloat(v); });
/**
 * `types.finite` - Creates a type that can only contain an finite value.
 *
 * Example:
 * ```ts
 * const Size = types.model({
 *   width: types.finite,
 *   height: 10
 * })
 * ```
 */
// tslint:disable-next-line:variable-name
var finite = new CoreType("finite", TypeFlags.Finite, function (v) { return isFinite(v); });
/**
 * `types.boolean` - Creates a type that can only contain a boolean value.
 * This type is used for boolean values by default
 *
 * Example:
 * ```ts
 * const Thing = types.model({
 *   isCool: types.boolean,
 *   isAwesome: false
 * })
 * ```
 */
// tslint:disable-next-line:variable-name
var boolean = new CoreType("boolean", TypeFlags.Boolean, function (v) { return typeof v === "boolean"; });
/**
 * `types.null` - The type of the value `null`
 */
var nullType = new CoreType("null", TypeFlags.Null, function (v) { return v === null; });
/**
 * `types.undefined` - The type of the value `undefined`
 */
var undefinedType = new CoreType("undefined", TypeFlags.Undefined, function (v) { return v === undefined; });
var _DatePrimitive = new CoreType("Date", TypeFlags.Date, function (v) { return typeof v === "number" || v instanceof Date; }, function (v) { return (v instanceof Date ? v : new Date(v)); });
_DatePrimitive.getSnapshot = function (node) {
    return node.storedValue.getTime();
};
/**
 * `types.Date` - Creates a type that can only contain a javascript Date value.
 *
 * Example:
 * ```ts
 * const LogLine = types.model({
 *   timestamp: types.Date,
 * })
 *
 * LogLine.create({ timestamp: new Date() })
 * ```
 */
var DatePrimitive = _DatePrimitive;
/**
 * @internal
 * @hidden
 */
function getPrimitiveFactoryFromValue(value) {
    switch (typeof value) {
        case "string":
            return string;
        case "number":
            return number; // In the future, isInteger(value) ? integer : number would be interesting, but would be too breaking for now
        case "boolean":
            return boolean;
        case "object":
            if (value instanceof Date)
                return DatePrimitive;
    }
    throw new MstError("Cannot determine primitive type from value " + value);
}
/**
 * Returns if a given value represents a primitive type.
 *
 * @param type
 * @returns
 */
function isPrimitiveType(type) {
    return (isType(type) &&
        (type.flags &
            (TypeFlags.String |
                TypeFlags.Number |
                TypeFlags.Integer |
                TypeFlags.Boolean |
                TypeFlags.Date)) >
            0);
}

/**
 * @internal
 * @hidden
 */
var Literal = /** @class */ (function (_super) {
    __extends(Literal, _super);
    function Literal(value) {
        var _this = _super.call(this, JSON.stringify(value)) || this;
        Object.defineProperty(_this, "value", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(_this, "flags", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: TypeFlags.Literal
        });
        _this.value = value;
        return _this;
    }
    Object.defineProperty(Literal.prototype, "instantiate", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parent, subpath, environment, initialValue) {
            return createScalarNode(this, parent, subpath, environment, initialValue);
        }
    });
    Object.defineProperty(Literal.prototype, "describe", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return JSON.stringify(this.value);
        }
    });
    Object.defineProperty(Literal.prototype, "isValidSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (value, context) {
            if (isPrimitive(value) && value === this.value) {
                return typeCheckSuccess();
            }
            return typeCheckFailure(context, value, "Value is not a literal ".concat(JSON.stringify(this.value)));
        }
    });
    return Literal;
}(SimpleType));
/**
 * `types.literal` - The literal type will return a type that will match only the exact given type.
 * The given value must be a primitive, in order to be serialized to a snapshot correctly.
 * You can use literal to match exact strings for example the exact male or female string.
 *
 * Example:
 * ```ts
 * const Person = types.model({
 *     name: types.string,
 *     gender: types.union(types.literal('male'), types.literal('female'))
 * })
 * ```
 *
 * @param value The value to use in the strict equal check
 * @returns
 */
function literal(value) {
    // check that the given value is a primitive
    assertArg(value, isPrimitive, "primitive", 1);
    return new Literal(value);
}

var Refinement = /** @class */ (function (_super) {
    __extends(Refinement, _super);
    function Refinement(name, _subtype, _predicate, _message) {
        var _this = _super.call(this, name) || this;
        Object.defineProperty(_this, "_subtype", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _subtype
        });
        Object.defineProperty(_this, "_predicate", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _predicate
        });
        Object.defineProperty(_this, "_message", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _message
        });
        return _this;
    }
    Object.defineProperty(Refinement.prototype, "flags", {
        get: function () {
            return this._subtype.flags | TypeFlags.Refinement;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Refinement.prototype, "describe", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return this.name;
        }
    });
    Object.defineProperty(Refinement.prototype, "instantiate", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parent, subpath, environment, initialValue) {
            // create the child type
            return this._subtype.instantiate(parent, subpath, environment, initialValue);
        }
    });
    Object.defineProperty(Refinement.prototype, "isAssignableFrom", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (type) {
            return this._subtype.isAssignableFrom(type);
        }
    });
    Object.defineProperty(Refinement.prototype, "isValidSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (value, context) {
            var subtypeErrors = this._subtype.validate(value, context);
            if (subtypeErrors.length > 0)
                return subtypeErrors;
            var snapshot = isStateTreeNode(value) ? getStateTreeNode(value).snapshot : value;
            if (!this._predicate(snapshot)) {
                return typeCheckFailure(context, value, this._message(value));
            }
            return typeCheckSuccess();
        }
    });
    Object.defineProperty(Refinement.prototype, "reconcile", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (current, newValue, parent, subpath) {
            return this._subtype.reconcile(current, newValue, parent, subpath);
        }
    });
    Object.defineProperty(Refinement.prototype, "getSubTypes", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return this._subtype;
        }
    });
    return Refinement;
}(BaseType));
/**
 * `types.refinement` - Creates a type that is more specific than the base type, e.g. `types.refinement(types.string, value => value.length > 5)` to create a type of strings that can only be longer then 5.
 *
 * @param name
 * @param type
 * @param predicate
 * @returns
 */
function refinement() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var name = typeof args[0] === "string" ? args.shift() : isType(args[0]) ? args[0].name : null;
    var type = args[0];
    var predicate = args[1];
    var message = args[2]
        ? args[2]
        : function (v) { return "Value does not respect the refinement predicate"; };
    // ensures all parameters are correct
    assertIsType(type, [1, 2]);
    assertIsString(name, 1);
    assertIsFunction(predicate, [2, 3]);
    assertIsFunction(message, [3, 4]);
    return new Refinement(name, type, predicate, message);
}

/**
 * `types.enumeration` - Can be used to create an string based enumeration.
 * (note: this methods is just sugar for a union of string literals)
 *
 * Example:
 * ```ts
 * const TrafficLight = types.model({
 *   color: types.enumeration("Color", ["Red", "Orange", "Green"])
 * })
 * ```
 *
 * @param name descriptive name of the enumeration (optional)
 * @param options possible values this enumeration can have
 * @returns
 */
function enumeration(name, options) {
    var realOptions = typeof name === "string" ? options : name;
    // check all options
    if (devMode()) {
        realOptions.forEach(function (option, i) {
            assertIsString(option, i + 1);
        });
    }
    var type = union.apply(void 0, __spreadArray([], __read(realOptions.map(function (option) { return literal("" + option); })), false));
    if (typeof name === "string")
        type.name = name;
    return type;
}

/**
 * @internal
 * @hidden
 */
var Union = /** @class */ (function (_super) {
    __extends(Union, _super);
    function Union(name, _types, options) {
        var _this = _super.call(this, name) || this;
        Object.defineProperty(_this, "_types", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _types
        });
        Object.defineProperty(_this, "_dispatcher", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(_this, "_eager", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: true
        });
        options = __assign({ eager: true, dispatcher: undefined }, options);
        _this._dispatcher = options.dispatcher;
        if (!options.eager)
            _this._eager = false;
        return _this;
    }
    Object.defineProperty(Union.prototype, "flags", {
        get: function () {
            var result = TypeFlags.Union;
            this._types.forEach(function (type) {
                result |= type.flags;
            });
            return result;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Union.prototype, "isAssignableFrom", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (type) {
            return this._types.some(function (subType) { return subType.isAssignableFrom(type); });
        }
    });
    Object.defineProperty(Union.prototype, "describe", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return "(" + this._types.map(function (factory) { return factory.describe(); }).join(" | ") + ")";
        }
    });
    Object.defineProperty(Union.prototype, "instantiate", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parent, subpath, environment, initialValue) {
            var type = this.determineType(initialValue, undefined);
            if (!type)
                throw new MstError("No matching type for union " + this.describe()); // can happen in prod builds
            return type.instantiate(parent, subpath, environment, initialValue);
        }
    });
    Object.defineProperty(Union.prototype, "reconcile", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (current, newValue, parent, subpath) {
            var type = this.determineType(newValue, current.getReconciliationType());
            if (!type)
                throw new MstError("No matching type for union " + this.describe()); // can happen in prod builds
            return type.reconcile(current, newValue, parent, subpath);
        }
    });
    Object.defineProperty(Union.prototype, "determineType", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (value, reconcileCurrentType) {
            // try the dispatcher, if defined
            if (this._dispatcher) {
                return this._dispatcher(value);
            }
            // find the most accommodating type
            // if we are using reconciliation try the current node type first (fix for #1045)
            if (reconcileCurrentType) {
                if (reconcileCurrentType.is(value)) {
                    return reconcileCurrentType;
                }
                return this._types.filter(function (t) { return t !== reconcileCurrentType; }).find(function (type) { return type.is(value); });
            }
            else {
                return this._types.find(function (type) { return type.is(value); });
            }
        }
    });
    Object.defineProperty(Union.prototype, "isValidSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (value, context) {
            if (this._dispatcher) {
                return this._dispatcher(value).validate(value, context);
            }
            var allErrors = [];
            var applicableTypes = 0;
            for (var i = 0; i < this._types.length; i++) {
                var type = this._types[i];
                var errors = type.validate(value, context);
                if (errors.length === 0) {
                    if (this._eager)
                        return typeCheckSuccess();
                    else
                        applicableTypes++;
                }
                else {
                    allErrors.push(errors);
                }
            }
            if (applicableTypes === 1)
                return typeCheckSuccess();
            return typeCheckFailure(context, value, "No type is applicable for the union").concat(flattenTypeErrors(allErrors));
        }
    });
    Object.defineProperty(Union.prototype, "getSubTypes", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return this._types;
        }
    });
    return Union;
}(BaseType));
/**
 * `types.union` - Create a union of multiple types. If the correct type cannot be inferred unambiguously from a snapshot, provide a dispatcher function of the form `(snapshot) => Type`.
 *
 * @param optionsOrType
 * @param otherTypes
 * @returns
 */
function union(optionsOrType) {
    var otherTypes = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        otherTypes[_i - 1] = arguments[_i];
    }
    var options = isType(optionsOrType) ? undefined : optionsOrType;
    var types = (isType(optionsOrType) ? __spreadArray([optionsOrType], __read(otherTypes), false) : otherTypes);
    var name = "(" + types.map(function (type) { return type.name; }).join(" | ") + ")";
    // check all options
    if (devMode()) {
        if (options) {
            assertArg(options, function (o) { return isPlainObject(o); }, "object { eager?: boolean, dispatcher?: Function }", 1);
        }
        types.forEach(function (type, i) {
            assertIsType(type, options ? i + 2 : i + 1);
        });
    }
    return new Union(name, types, options);
}
/**
 * Returns if a given value represents a union type.
 *
 * @param type
 * @returns
 */
function isUnionType(type) {
    return isType(type) && (type.flags & TypeFlags.Union) > 0;
}

/**
 * @hidden
 * @internal
 */
var OptionalValue = /** @class */ (function (_super) {
    __extends(OptionalValue, _super);
    function OptionalValue(_subtype, _defaultValue, optionalValues) {
        var _this = _super.call(this, _subtype.name) || this;
        Object.defineProperty(_this, "_subtype", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _subtype
        });
        Object.defineProperty(_this, "_defaultValue", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _defaultValue
        });
        Object.defineProperty(_this, "optionalValues", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: optionalValues
        });
        return _this;
    }
    Object.defineProperty(OptionalValue.prototype, "flags", {
        get: function () {
            return this._subtype.flags | TypeFlags.Optional;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(OptionalValue.prototype, "describe", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return this._subtype.describe() + "?";
        }
    });
    Object.defineProperty(OptionalValue.prototype, "instantiate", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parent, subpath, environment, initialValue) {
            if (this.optionalValues.indexOf(initialValue) >= 0) {
                var defaultInstanceOrSnapshot = this.getDefaultInstanceOrSnapshot();
                return this._subtype.instantiate(parent, subpath, environment, defaultInstanceOrSnapshot);
            }
            return this._subtype.instantiate(parent, subpath, environment, initialValue);
        }
    });
    Object.defineProperty(OptionalValue.prototype, "reconcile", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (current, newValue, parent, subpath) {
            return this._subtype.reconcile(current, this.optionalValues.indexOf(newValue) < 0 && this._subtype.is(newValue)
                ? newValue
                : this.getDefaultInstanceOrSnapshot(), parent, subpath);
        }
    });
    Object.defineProperty(OptionalValue.prototype, "getDefaultInstanceOrSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var defaultInstanceOrSnapshot = typeof this._defaultValue === "function"
                ? this._defaultValue()
                : this._defaultValue;
            // while static values are already snapshots and checked on types.optional
            // generator functions must always be rechecked just in case
            if (typeof this._defaultValue === "function") {
                typecheckInternal(this, defaultInstanceOrSnapshot);
            }
            return defaultInstanceOrSnapshot;
        }
    });
    Object.defineProperty(OptionalValue.prototype, "isValidSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (value, context) {
            // defaulted values can be skipped
            if (this.optionalValues.indexOf(value) >= 0) {
                return typeCheckSuccess();
            }
            // bounce validation to the sub-type
            return this._subtype.validate(value, context);
        }
    });
    Object.defineProperty(OptionalValue.prototype, "isAssignableFrom", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (type) {
            return this._subtype.isAssignableFrom(type);
        }
    });
    Object.defineProperty(OptionalValue.prototype, "getSubTypes", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return this._subtype;
        }
    });
    return OptionalValue;
}(BaseType));
function checkOptionalPreconditions(type, defaultValueOrFunction) {
    // make sure we never pass direct instances
    if (typeof defaultValueOrFunction !== "function" && isStateTreeNode(defaultValueOrFunction)) {
        throw new MstError("default value cannot be an instance, pass a snapshot or a function that creates an instance/snapshot instead");
    }
    assertIsType(type, 1);
    if (devMode()) {
        // we only check default values if they are passed directly
        // if they are generator functions they will be checked once they are generated
        // we don't check generator function results here to avoid generating a node just for type-checking purposes
        // which might generate side-effects
        if (typeof defaultValueOrFunction !== "function") {
            typecheckInternal(type, defaultValueOrFunction);
        }
    }
}
/**
 * `types.optional` - Can be used to create a property with a default value.
 *
 * Depending on the third argument (`optionalValues`) there are two ways of operation:
 * - If the argument is not provided, then if a value is not provided in the snapshot (`undefined` or missing),
 *   it will default to the provided `defaultValue`
 * - If the argument is provided, then if the value in the snapshot matches one of the optional values inside the array then it will
 *   default to the provided `defaultValue`. Additionally, if one of the optional values inside the array is `undefined` then a missing
 *   property is also valid.
 *
 *   Note that it is also possible to include values of the same type as the intended subtype as optional values,
 *   in this case the optional value will be transformed into the `defaultValue` (e.g. `types.optional(types.string, "unnamed", [undefined, ""])`
 *   will transform the snapshot values `undefined` (and therefore missing) and empty strings into the string `"unnamed"` when it gets
 *   instantiated).
 *
 * If `defaultValue` is a function, the function will be invoked for every new instance.
 * Applying a snapshot in which the optional value is one of the optional values (or `undefined`/_not_ present if none are provided) causes the
 * value to be reset.
 *
 * Example:
 * ```ts
 * const Todo = types.model({
 *   title: types.string,
 *   subtitle1: types.optional(types.string, "", [null]),
 *   subtitle2: types.optional(types.string, "", [null, undefined]),
 *   done: types.optional(types.boolean, false),
 *   created: types.optional(types.Date, () => new Date()),
 * })
 *
 * // if done is missing / undefined it will become false
 * // if created is missing / undefined it will get a freshly generated timestamp
 * // if subtitle1 is null it will default to "", but it cannot be missing or undefined
 * // if subtitle2 is null or undefined it will default to ""; since it can be undefined it can also be missing
 * const todo = Todo.create({ title: "Get coffee", subtitle1: null })
 * ```
 *
 * @param type
 * @param defaultValueOrFunction
 * @param optionalValues an optional array with zero or more primitive values (string, number, boolean, null or undefined)
 *                       that will be converted into the default. `[ undefined ]` is assumed when none is provided
 * @returns
 */
function optional(type, defaultValueOrFunction, optionalValues) {
    checkOptionalPreconditions(type, defaultValueOrFunction);
    return new OptionalValue(type, defaultValueOrFunction, optionalValues ? optionalValues : undefinedAsOptionalValues);
}
var undefinedAsOptionalValues = [undefined];

var optionalUndefinedType = optional(undefinedType, undefined);
var optionalNullType = optional(nullType, null);
/**
 * `types.maybe` - Maybe will make a type nullable, and also optional.
 * The value `undefined` will be used to represent nullability.
 *
 * @param type
 * @returns
 */
function maybe(type) {
    assertIsType(type, 1);
    return union(type, optionalUndefinedType);
}
/**
 * `types.maybeNull` - Maybe will make a type nullable, and also optional.
 * The value `null` will be used to represent no value.
 *
 * @param type
 * @returns
 */
function maybeNull(type) {
    assertIsType(type, 1);
    return union(type, optionalNullType);
}

var Late = /** @class */ (function (_super) {
    __extends(Late, _super);
    function Late(name, _definition) {
        var _this = _super.call(this, name) || this;
        Object.defineProperty(_this, "_definition", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _definition
        });
        Object.defineProperty(_this, "_subType", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        return _this;
    }
    Object.defineProperty(Late.prototype, "flags", {
        get: function () {
            return (this._subType ? this._subType.flags : 0) | TypeFlags.Late;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Late.prototype, "getSubType", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (mustSucceed) {
            if (!this._subType) {
                var t = undefined;
                try {
                    t = this._definition();
                }
                catch (e) {
                    if (e instanceof ReferenceError)
                        // can happen in strict ES5 code when a definition is self refering
                        t = undefined;
                    else
                        throw e;
                }
                if (mustSucceed && t === undefined)
                    throw new MstError("Late type seems to be used too early, the definition (still) returns undefined");
                if (t) {
                    if (devMode() && !isType(t))
                        throw new MstError("Failed to determine subtype, make sure types.late returns a type definition.");
                    this._subType = t;
                }
            }
            return this._subType;
        }
    });
    Object.defineProperty(Late.prototype, "instantiate", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parent, subpath, environment, initialValue) {
            return this.getSubType(true).instantiate(parent, subpath, environment, initialValue);
        }
    });
    Object.defineProperty(Late.prototype, "reconcile", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (current, newValue, parent, subpath) {
            return this.getSubType(true).reconcile(current, newValue, parent, subpath);
        }
    });
    Object.defineProperty(Late.prototype, "describe", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var t = this.getSubType(false);
            return t ? t.name : "<uknown late type>";
        }
    });
    Object.defineProperty(Late.prototype, "isValidSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (value, context) {
            var t = this.getSubType(false);
            if (!t) {
                // See #916; the variable the definition closure is pointing to wasn't defined yet, so can't be evaluted yet here
                return typeCheckSuccess();
            }
            return t.validate(value, context);
        }
    });
    Object.defineProperty(Late.prototype, "isAssignableFrom", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (type) {
            var t = this.getSubType(false);
            return t ? t.isAssignableFrom(type) : false;
        }
    });
    Object.defineProperty(Late.prototype, "getSubTypes", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var subtype = this.getSubType(false);
            return subtype ? subtype : cannotDetermineSubtype;
        }
    });
    return Late;
}(BaseType));
/**
 * `types.late` - Defines a type that gets implemented later. This is useful when you have to deal with circular dependencies.
 * Please notice that when defining circular dependencies TypeScript isn't smart enough to inference them.
 *
 * Example:
 * ```ts
 *   // TypeScript isn't smart enough to infer self referencing types.
 *  const Node = types.model({
 *       children: types.array(types.late((): IAnyModelType => Node)) // then typecast each array element to Instance<typeof Node>
 *  })
 * ```
 *
 * @param name The name to use for the type that will be returned.
 * @param type A function that returns the type that will be defined.
 * @returns
 */
function late(nameOrType, maybeType) {
    var name = typeof nameOrType === "string" ? nameOrType : "late(".concat(nameOrType.toString(), ")");
    var type = typeof nameOrType === "string" ? maybeType : nameOrType;
    // checks that the type is actually a late type
    if (devMode()) {
        if (!(typeof type === "function" && type.length === 0))
            throw new MstError("Invalid late type, expected a function with zero arguments that returns a type, got: " +
                type);
    }
    return new Late(name, type);
}

function lazy(name, options) {
    // TODO: fix this unknown casting to be stricter
    return new Lazy(name, options);
}
/**
 * @internal
 * @hidden
 */
var Lazy = /** @class */ (function (_super) {
    __extends(Lazy, _super);
    function Lazy(name, options) {
        var _this = _super.call(this, name) || this;
        Object.defineProperty(_this, "options", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: options
        });
        Object.defineProperty(_this, "flags", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: TypeFlags.Lazy
        });
        Object.defineProperty(_this, "loadedType", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(_this, "pendingNodeList", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: observable.array()
        });
        when(function () {
            return _this.pendingNodeList.length > 0 &&
                _this.pendingNodeList.some(function (node) {
                    return node.isAlive &&
                        _this.options.shouldLoadPredicate(node.parent ? node.parent.value : null);
                });
        }, function () {
            _this.options.loadType().then(action(function (type) {
                _this.loadedType = type;
                _this.pendingNodeList.forEach(function (node) {
                    if (!node.parent)
                        return;
                    if (!_this.loadedType)
                        return;
                    node.parent.applyPatches([
                        {
                            op: "replace",
                            path: "/".concat(node.subpath),
                            value: node.snapshot
                        }
                    ]);
                });
            }));
        });
        return _this;
    }
    Object.defineProperty(Lazy.prototype, "describe", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return "<lazy ".concat(this.name, ">");
        }
    });
    Object.defineProperty(Lazy.prototype, "instantiate", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parent, subpath, environment, value) {
            var _this = this;
            if (this.loadedType) {
                return this.loadedType.instantiate(parent, subpath, environment, value);
            }
            var node = createScalarNode(this, parent, subpath, environment, deepFreeze(value));
            this.pendingNodeList.push(node);
            when(function () { return !node.isAlive; }, function () { return _this.pendingNodeList.splice(_this.pendingNodeList.indexOf(node), 1); });
            return node;
        }
    });
    Object.defineProperty(Lazy.prototype, "isValidSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (value, context) {
            if (this.loadedType) {
                return this.loadedType.validate(value, context);
            }
            if (!isSerializable(value)) {
                return typeCheckFailure(context, value, "Value is not serializable and cannot be lazy");
            }
            return typeCheckSuccess();
        }
    });
    Object.defineProperty(Lazy.prototype, "reconcile", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (current, value, parent, subpath) {
            if (this.loadedType) {
                current.die();
                return this.loadedType.instantiate(parent, subpath, parent.environment, value);
            }
            return _super.prototype.reconcile.call(this, current, value, parent, subpath);
        }
    });
    return Lazy;
}(SimpleType));

/**
 * @internal
 * @hidden
 */
var Frozen = /** @class */ (function (_super) {
    __extends(Frozen, _super);
    function Frozen(subType) {
        var _this = _super.call(this, subType ? "frozen(".concat(subType.name, ")") : "frozen") || this;
        Object.defineProperty(_this, "subType", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: subType
        });
        Object.defineProperty(_this, "flags", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: TypeFlags.Frozen
        });
        return _this;
    }
    Object.defineProperty(Frozen.prototype, "describe", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return "<any immutable value>";
        }
    });
    Object.defineProperty(Frozen.prototype, "instantiate", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parent, subpath, environment, value) {
            // create the node
            return createScalarNode(this, parent, subpath, environment, deepFreeze(value));
        }
    });
    Object.defineProperty(Frozen.prototype, "isValidSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (value, context) {
            if (!isSerializable(value)) {
                return typeCheckFailure(context, value, "Value is not serializable and cannot be frozen");
            }
            if (this.subType)
                return this.subType.validate(value, context);
            return typeCheckSuccess();
        }
    });
    return Frozen;
}(SimpleType));
var untypedFrozenInstance = new Frozen();
/**
 * `types.frozen` - Frozen can be used to store any value that is serializable in itself (that is valid JSON).
 * Frozen values need to be immutable or treated as if immutable. They need be serializable as well.
 * Values stored in frozen will snapshotted as-is by MST, and internal changes will not be tracked.
 *
 * This is useful to store complex, but immutable values like vectors etc. It can form a powerful bridge to parts of your application that should be immutable, or that assume data to be immutable.
 *
 * Note: if you want to store free-form state that is mutable, or not serializeable, consider using volatile state instead.
 *
 * Frozen properties can be defined in three different ways
 * 1. `types.frozen(SubType)` - provide a valid MST type and frozen will check if the provided data conforms the snapshot for that type
 * 2. `types.frozen({ someDefaultValue: true})` - provide a primitive value, object or array, and MST will infer the type from that object, and also make it the default value for the field
 * 3. `types.frozen<TypeScriptType>()` - provide a typescript type, to help in strongly typing the field (design time only)
 *
 * Example:
 * ```ts
 * const GameCharacter = types.model({
 *   name: string,
 *   location: types.frozen({ x: 0, y: 0})
 * })
 *
 * const hero = GameCharacter.create({
 *   name: "Mario",
 *   location: { x: 7, y: 4 }
 * })
 *
 * hero.location = { x: 10, y: 2 } // OK
 * hero.location.x = 7 // Not ok!
 * ```
 *
 * ```ts
 * type Point = { x: number, y: number }
 *    const Mouse = types.model({
 *         loc: types.frozen<Point>()
 *    })
 * ```
 *
 * @param defaultValueOrType
 * @returns
 */
function frozen(arg) {
    if (arguments.length === 0)
        return untypedFrozenInstance;
    else if (isType(arg))
        return new Frozen(arg);
    else
        return optional(untypedFrozenInstance, arg);
}

function getInvalidationCause(hook) {
    switch (hook) {
        case Hook.beforeDestroy:
            return "destroy";
        case Hook.beforeDetach:
            return "detach";
        default:
            return undefined;
    }
}
var StoredReference = /** @class */ (function () {
    function StoredReference(value, targetType) {
        Object.defineProperty(this, "targetType", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: targetType
        });
        Object.defineProperty(this, "identifier", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "node", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "resolvedReference", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        if (isValidIdentifier(value)) {
            this.identifier = value;
        }
        else if (isStateTreeNode(value)) {
            var targetNode = getStateTreeNode(value);
            if (!targetNode.identifierAttribute)
                throw new MstError("Can only store references with a defined identifier attribute.");
            var id = targetNode.unnormalizedIdentifier;
            if (id === null || id === undefined) {
                throw new MstError("Can only store references to tree nodes with a defined identifier.");
            }
            this.identifier = id;
        }
        else {
            throw new MstError("Can only store references to tree nodes or identifiers, got: '".concat(value, "'"));
        }
    }
    Object.defineProperty(StoredReference.prototype, "updateResolvedReference", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (node) {
            var normalizedId = normalizeIdentifier(this.identifier);
            var root = node.root;
            var lastCacheModification = root.identifierCache.getLastCacheModificationPerId(normalizedId);
            if (!this.resolvedReference ||
                this.resolvedReference.lastCacheModification !== lastCacheModification) {
                var targetType = this.targetType;
                // reference was initialized with the identifier of the target
                var target = root.identifierCache.resolve(targetType, normalizedId);
                if (!target) {
                    throw new InvalidReferenceError("[mobx-state-tree] Failed to resolve reference '".concat(this.identifier, "' to type '").concat(this.targetType.name, "' (from node: ").concat(node.path, ")"));
                }
                this.resolvedReference = {
                    node: target,
                    lastCacheModification: lastCacheModification
                };
            }
        }
    });
    Object.defineProperty(StoredReference.prototype, "resolvedValue", {
        get: function () {
            this.updateResolvedReference(this.node);
            return this.resolvedReference.node.value;
        },
        enumerable: false,
        configurable: true
    });
    return StoredReference;
}());
/**
 * @internal
 * @hidden
 */
var InvalidReferenceError = /** @class */ (function (_super) {
    __extends(InvalidReferenceError, _super);
    function InvalidReferenceError(m) {
        var _this = _super.call(this, m) || this;
        Object.setPrototypeOf(_this, InvalidReferenceError.prototype);
        return _this;
    }
    return InvalidReferenceError;
}(Error));
/**
 * @internal
 * @hidden
 */
var BaseReferenceType = /** @class */ (function (_super) {
    __extends(BaseReferenceType, _super);
    function BaseReferenceType(targetType, onInvalidated) {
        var _this = _super.call(this, "reference(".concat(targetType.name, ")")) || this;
        Object.defineProperty(_this, "targetType", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: targetType
        });
        Object.defineProperty(_this, "onInvalidated", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: onInvalidated
        });
        Object.defineProperty(_this, "flags", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: TypeFlags.Reference
        });
        return _this;
    }
    Object.defineProperty(BaseReferenceType.prototype, "describe", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return this.name;
        }
    });
    Object.defineProperty(BaseReferenceType.prototype, "isAssignableFrom", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (type) {
            return this.targetType.isAssignableFrom(type);
        }
    });
    Object.defineProperty(BaseReferenceType.prototype, "isValidSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (value, context) {
            return isValidIdentifier(value)
                ? typeCheckSuccess()
                : typeCheckFailure(context, value, "Value is not a valid identifier, which is a string or a number");
        }
    });
    Object.defineProperty(BaseReferenceType.prototype, "fireInvalidated", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (cause, storedRefNode, referenceId, refTargetNode) {
            // to actually invalidate a reference we need an alive parent,
            // since it is a scalar value (immutable-ish) and we need to change it
            // from the parent
            var storedRefParentNode = storedRefNode.parent;
            if (!storedRefParentNode || !storedRefParentNode.isAlive) {
                return;
            }
            var storedRefParentValue = storedRefParentNode.storedValue;
            if (!storedRefParentValue) {
                return;
            }
            this.onInvalidated({
                cause: cause,
                parent: storedRefParentValue,
                invalidTarget: refTargetNode ? refTargetNode.storedValue : undefined,
                invalidId: referenceId,
                replaceRef: function (newRef) {
                    applyPatch(storedRefNode.root.storedValue, {
                        op: "replace",
                        value: newRef,
                        path: storedRefNode.path
                    });
                },
                removeRef: function () {
                    if (isModelType(storedRefParentNode.type)) {
                        this.replaceRef(undefined);
                    }
                    else {
                        applyPatch(storedRefNode.root.storedValue, {
                            op: "remove",
                            path: storedRefNode.path
                        });
                    }
                }
            });
        }
    });
    Object.defineProperty(BaseReferenceType.prototype, "addTargetNodeWatcher", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (storedRefNode, referenceId) {
            var _this = this;
            // this will make sure the target node becomes created
            var refTargetValue = this.getValue(storedRefNode);
            if (!refTargetValue) {
                return undefined;
            }
            var refTargetNode = getStateTreeNode(refTargetValue);
            var hookHandler = function (_, refTargetNodeHook) {
                var cause = getInvalidationCause(refTargetNodeHook);
                if (!cause) {
                    return;
                }
                _this.fireInvalidated(cause, storedRefNode, referenceId, refTargetNode);
            };
            var refTargetDetachHookDisposer = refTargetNode.registerHook(Hook.beforeDetach, hookHandler);
            var refTargetDestroyHookDisposer = refTargetNode.registerHook(Hook.beforeDestroy, hookHandler);
            return function () {
                refTargetDetachHookDisposer();
                refTargetDestroyHookDisposer();
            };
        }
    });
    Object.defineProperty(BaseReferenceType.prototype, "watchTargetNodeForInvalidations", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (storedRefNode, identifier, customGetSet) {
            var _this = this;
            if (!this.onInvalidated) {
                return;
            }
            var onRefTargetDestroyedHookDisposer;
            // get rid of the watcher hook when the stored ref node is destroyed
            // detached is ignored since scalar nodes (where the reference resides) cannot be detached
            storedRefNode.registerHook(Hook.beforeDestroy, function () {
                if (onRefTargetDestroyedHookDisposer) {
                    onRefTargetDestroyedHookDisposer();
                }
            });
            var startWatching = function (sync) {
                // re-create hook in case the stored ref gets reattached
                if (onRefTargetDestroyedHookDisposer) {
                    onRefTargetDestroyedHookDisposer();
                }
                // make sure the target node is actually there and initialized
                var storedRefParentNode = storedRefNode.parent;
                var storedRefParentValue = storedRefParentNode && storedRefParentNode.storedValue;
                if (storedRefParentNode && storedRefParentNode.isAlive && storedRefParentValue) {
                    var refTargetNodeExists = void 0;
                    if (customGetSet) {
                        refTargetNodeExists = !!customGetSet.get(identifier, storedRefParentValue);
                    }
                    else {
                        refTargetNodeExists = storedRefNode.root.identifierCache.has(_this.targetType, normalizeIdentifier(identifier));
                    }
                    if (!refTargetNodeExists) {
                        // we cannot change the reference in sync mode
                        // since we are in the middle of a reconciliation/instantiation and the change would be overwritten
                        // for those cases just let the wrong reference be assigned and fail upon usage
                        // (like current references do)
                        // this means that effectively this code will only run when it is created from a snapshot
                        if (!sync) {
                            _this.fireInvalidated("invalidSnapshotReference", storedRefNode, identifier, null);
                        }
                    }
                    else {
                        onRefTargetDestroyedHookDisposer = _this.addTargetNodeWatcher(storedRefNode, identifier);
                    }
                }
            };
            if (storedRefNode.state === NodeLifeCycle.FINALIZED) {
                // already attached, so the whole tree is ready
                startWatching(true);
            }
            else {
                if (!storedRefNode.isRoot) {
                    // start watching once the whole tree is ready
                    storedRefNode.root.registerHook(Hook.afterCreationFinalization, function () {
                        // make sure to attach it so it can start listening
                        if (storedRefNode.parent) {
                            storedRefNode.parent.createObservableInstanceIfNeeded();
                        }
                    });
                }
                // start watching once the node is attached somewhere / parent changes
                storedRefNode.registerHook(Hook.afterAttach, function () {
                    startWatching(false);
                });
            }
        }
    });
    return BaseReferenceType;
}(SimpleType));
/**
 * @internal
 * @hidden
 */
var IdentifierReferenceType = /** @class */ (function (_super) {
    __extends(IdentifierReferenceType, _super);
    function IdentifierReferenceType(targetType, onInvalidated) {
        return _super.call(this, targetType, onInvalidated) || this;
    }
    Object.defineProperty(IdentifierReferenceType.prototype, "getValue", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (storedRefNode) {
            if (!storedRefNode.isAlive)
                return undefined;
            var storedRef = storedRefNode.storedValue;
            return storedRef.resolvedValue;
        }
    });
    Object.defineProperty(IdentifierReferenceType.prototype, "getSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (storedRefNode) {
            var ref = storedRefNode.storedValue;
            return ref.identifier;
        }
    });
    Object.defineProperty(IdentifierReferenceType.prototype, "instantiate", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parent, subpath, environment, initialValue) {
            var identifier = isStateTreeNode(initialValue)
                ? getIdentifier(initialValue)
                : initialValue;
            var storedRef = new StoredReference(initialValue, this.targetType);
            var storedRefNode = createScalarNode(this, parent, subpath, environment, storedRef);
            storedRef.node = storedRefNode;
            this.watchTargetNodeForInvalidations(storedRefNode, identifier, undefined);
            return storedRefNode;
        }
    });
    Object.defineProperty(IdentifierReferenceType.prototype, "reconcile", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (current, newValue, parent, subpath) {
            if (!current.isDetaching && current.type === this) {
                var compareByValue = isStateTreeNode(newValue);
                var ref = current.storedValue;
                if ((!compareByValue && ref.identifier === newValue) ||
                    (compareByValue && ref.resolvedValue === newValue)) {
                    current.setParent(parent, subpath);
                    return current;
                }
            }
            var newNode = this.instantiate(parent, subpath, undefined, newValue);
            current.die(); // noop if detaching
            return newNode;
        }
    });
    return IdentifierReferenceType;
}(BaseReferenceType));
/**
 * @internal
 * @hidden
 */
var CustomReferenceType = /** @class */ (function (_super) {
    __extends(CustomReferenceType, _super);
    function CustomReferenceType(targetType, options, onInvalidated) {
        var _this = _super.call(this, targetType, onInvalidated) || this;
        Object.defineProperty(_this, "options", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: options
        });
        return _this;
    }
    Object.defineProperty(CustomReferenceType.prototype, "getValue", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (storedRefNode) {
            if (!storedRefNode.isAlive)
                return undefined;
            var referencedNode = this.options.get(storedRefNode.storedValue, storedRefNode.parent ? storedRefNode.parent.storedValue : null);
            return referencedNode;
        }
    });
    Object.defineProperty(CustomReferenceType.prototype, "getSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (storedRefNode) {
            return storedRefNode.storedValue;
        }
    });
    Object.defineProperty(CustomReferenceType.prototype, "instantiate", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parent, subpath, environment, newValue) {
            var identifier = isStateTreeNode(newValue)
                ? this.options.set(newValue, parent ? parent.storedValue : null)
                : newValue;
            var storedRefNode = createScalarNode(this, parent, subpath, environment, identifier);
            this.watchTargetNodeForInvalidations(storedRefNode, identifier, this.options);
            return storedRefNode;
        }
    });
    Object.defineProperty(CustomReferenceType.prototype, "reconcile", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (current, newValue, parent, subpath) {
            var newIdentifier = isStateTreeNode(newValue)
                ? this.options.set(newValue, current ? current.storedValue : null)
                : newValue;
            if (!current.isDetaching &&
                current.type === this &&
                current.storedValue === newIdentifier) {
                current.setParent(parent, subpath);
                return current;
            }
            var newNode = this.instantiate(parent, subpath, undefined, newIdentifier);
            current.die(); // noop if detaching
            return newNode;
        }
    });
    return CustomReferenceType;
}(BaseReferenceType));
/**
 * `types.reference` - Creates a reference to another type, which should have defined an identifier.
 * See also the [reference and identifiers](https://github.com/mobxjs/mobx-state-tree#references-and-identifiers) section.
 */
function reference(subType, options) {
    assertIsType(subType, 1);
    if (devMode()) {
        if (arguments.length === 2 && typeof arguments[1] === "string") {
            // istanbul ignore next
            throw new MstError("References with base path are no longer supported. Please remove the base path.");
        }
    }
    var getSetOptions = options ? options : undefined;
    var onInvalidated = options
        ? options.onInvalidated
        : undefined;
    if (getSetOptions && (getSetOptions.get || getSetOptions.set)) {
        if (devMode()) {
            if (!getSetOptions.get || !getSetOptions.set) {
                throw new MstError("reference options must either contain both a 'get' and a 'set' method or none of them");
            }
        }
        return new CustomReferenceType(subType, {
            get: getSetOptions.get,
            set: getSetOptions.set
        }, onInvalidated);
    }
    else {
        return new IdentifierReferenceType(subType, onInvalidated);
    }
}
/**
 * `types.safeReference` - A safe reference is like a standard reference, except that it accepts the undefined value by default
 * and automatically sets itself to undefined (when the parent is a model) / removes itself from arrays and maps
 * when the reference it is pointing to gets detached/destroyed.
 *
 * The optional options parameter object accepts a parameter named `acceptsUndefined`, which is set to true by default, so it is suitable
 * for model properties.
 * When used inside collections (arrays/maps), it is recommended to set this option to false so it can't take undefined as value,
 * which is usually the desired in those cases.
 * Additionally, the optional options parameter object accepts a parameter named `onInvalidated`, which will be called when the reference target node that the reference is pointing to is about to be detached/destroyed
 *
 * Strictly speaking it is a `types.maybe(types.reference(X))` (when `acceptsUndefined` is set to true, the default) and
 * `types.reference(X)` (when `acceptsUndefined` is set to false), both of them with a customized `onInvalidated` option.
 *
 * @param subType
 * @param options
 * @returns
 */
function safeReference(subType, options) {
    var refType = reference(subType, __assign(__assign({}, options), { onInvalidated: function (ev) {
            if (options && options.onInvalidated) {
                options.onInvalidated(ev);
            }
            ev.removeRef();
        } }));
    if (options && options.acceptsUndefined === false) {
        return refType;
    }
    else {
        return maybe(refType);
    }
}

var BaseIdentifierType = /** @class */ (function (_super) {
    __extends(BaseIdentifierType, _super);
    function BaseIdentifierType(name, validType) {
        var _this = _super.call(this, name) || this;
        Object.defineProperty(_this, "validType", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: validType
        });
        Object.defineProperty(_this, "flags", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: TypeFlags.Identifier
        });
        return _this;
    }
    Object.defineProperty(BaseIdentifierType.prototype, "instantiate", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parent, subpath, environment, initialValue) {
            if (!parent || !(parent.type instanceof ModelType))
                throw new MstError("Identifier types can only be instantiated as direct child of a model type");
            return createScalarNode(this, parent, subpath, environment, initialValue);
        }
    });
    Object.defineProperty(BaseIdentifierType.prototype, "reconcile", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (current, newValue, parent, subpath) {
            // we don't consider detaching here since identifier are scalar nodes, and scalar nodes cannot be detached
            if (current.storedValue !== newValue)
                throw new MstError("Tried to change identifier from '".concat(current.storedValue, "' to '").concat(newValue, "'. Changing identifiers is not allowed."));
            current.setParent(parent, subpath);
            return current;
        }
    });
    Object.defineProperty(BaseIdentifierType.prototype, "isValidSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (value, context) {
            if (typeof value !== this.validType) {
                return typeCheckFailure(context, value, "Value is not a valid ".concat(this.describe(), ", expected a ").concat(this.validType));
            }
            return typeCheckSuccess();
        }
    });
    return BaseIdentifierType;
}(SimpleType));
/**
 * @internal
 * @hidden
 */
var IdentifierType = /** @class */ (function (_super) {
    __extends(IdentifierType, _super);
    function IdentifierType() {
        var _this = _super.call(this, "identifier", "string") || this;
        Object.defineProperty(_this, "flags", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: TypeFlags.Identifier
        });
        return _this;
    }
    Object.defineProperty(IdentifierType.prototype, "describe", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return "identifier";
        }
    });
    return IdentifierType;
}(BaseIdentifierType));
/**
 * @internal
 * @hidden
 */
var IdentifierNumberType = /** @class */ (function (_super) {
    __extends(IdentifierNumberType, _super);
    function IdentifierNumberType() {
        return _super.call(this, "identifierNumber", "number") || this;
    }
    Object.defineProperty(IdentifierNumberType.prototype, "getSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (node) {
            return node.storedValue;
        }
    });
    Object.defineProperty(IdentifierNumberType.prototype, "describe", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return "identifierNumber";
        }
    });
    return IdentifierNumberType;
}(BaseIdentifierType));
/**
 * `types.identifier` - Identifiers are used to make references, lifecycle events and reconciling works.
 * Inside a state tree, for each type can exist only one instance for each given identifier.
 * For example there couldn't be 2 instances of user with id 1. If you need more, consider using references.
 * Identifier can be used only as type property of a model.
 * This type accepts as parameter the value type of the identifier field that can be either string or number.
 *
 * Example:
 * ```ts
 *  const Todo = types.model("Todo", {
 *      id: types.identifier,
 *      title: types.string
 *  })
 * ```
 *
 * @returns
 */
var identifier = new IdentifierType();
/**
 * `types.identifierNumber` - Similar to `types.identifier`. This one will serialize from / to a number when applying snapshots
 *
 * Example:
 * ```ts
 *  const Todo = types.model("Todo", {
 *      id: types.identifierNumber,
 *      title: types.string
 *  })
 * ```
 *
 * @returns
 */
var identifierNumber = new IdentifierNumberType();
/**
 * @internal
 * @hidden
 */
function normalizeIdentifier(id) {
    return "" + id;
}
/**
 * @internal
 * @hidden
 */
function isValidIdentifier(id) {
    return typeof id === "string" || typeof id === "number";
}

/**
 * `types.custom` - Creates a custom type. Custom types can be used for arbitrary immutable values, that have a serializable representation. For example, to create your own Date representation, Decimal type etc.
 *
 * The signature of the options is:
 * ```ts
 * export interface CustomTypeOptions<S, T> {
 *     // Friendly name
 *     name: string
 *     // given a serialized value and environment, how to turn it into the target type
 *     fromSnapshot(snapshot: S, env: any): T
 *     // return the serialization of the current value
 *     toSnapshot(value: T): S
 *     // if true, this is a converted value, if false, it's a snapshot
 *     isTargetType(value: T | S): value is T
 *     // a non empty string is assumed to be a validation error
 *     getValidationMessage?(snapshot: S): string
 * }
 * ```
 *
 * Example:
 * ```ts
 * const DecimalPrimitive = types.custom<string, Decimal>({
 *     name: "Decimal",
 *     fromSnapshot(value: string) {
 *         return new Decimal(value)
 *     },
 *     toSnapshot(value: Decimal) {
 *         return value.toString()
 *     },
 *     isTargetType(value: string | Decimal): boolean {
 *         return value instanceof Decimal
 *     },
 *     getValidationMessage(value: string): string {
 *         if (/^-?\d+\.\d+$/.test(value)) return "" // OK
 *         return `'${value}' doesn't look like a valid decimal number`
 *     }
 * })
 *
 * const Wallet = types.model({
 *     balance: DecimalPrimitive
 * })
 * ```
 *
 * @param options
 * @returns
 */
function custom(options) {
    return new CustomType(options);
}
/**
 * @internal
 * @hidden
 */
var CustomType = /** @class */ (function (_super) {
    __extends(CustomType, _super);
    function CustomType(options) {
        var _this = _super.call(this, options.name) || this;
        Object.defineProperty(_this, "options", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: options
        });
        Object.defineProperty(_this, "flags", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: TypeFlags.Custom
        });
        return _this;
    }
    Object.defineProperty(CustomType.prototype, "describe", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return this.name;
        }
    });
    Object.defineProperty(CustomType.prototype, "isValidSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (value, context) {
            if (this.options.isTargetType(value))
                return typeCheckSuccess();
            var typeError = this.options.getValidationMessage(value);
            if (typeError) {
                return typeCheckFailure(context, value, "Invalid value for type '".concat(this.name, "': ").concat(typeError));
            }
            return typeCheckSuccess();
        }
    });
    Object.defineProperty(CustomType.prototype, "getSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (node) {
            return this.options.toSnapshot(node.storedValue);
        }
    });
    Object.defineProperty(CustomType.prototype, "instantiate", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parent, subpath, environment, initialValue) {
            var valueToStore = this.options.isTargetType(initialValue)
                ? initialValue
                : this.options.fromSnapshot(initialValue, parent && parent.root.environment);
            return createScalarNode(this, parent, subpath, environment, valueToStore);
        }
    });
    Object.defineProperty(CustomType.prototype, "reconcile", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (current, value, parent, subpath) {
            var isSnapshot = !this.options.isTargetType(value);
            // in theory customs use scalar nodes which cannot be detached, but still...
            if (!current.isDetaching) {
                var unchanged = current.type === this &&
                    (isSnapshot ? value === current.snapshot : value === current.storedValue);
                if (unchanged) {
                    current.setParent(parent, subpath);
                    return current;
                }
            }
            var valueToStore = isSnapshot
                ? this.options.fromSnapshot(value, parent.root.environment)
                : value;
            var newNode = this.instantiate(parent, subpath, undefined, valueToStore);
            current.die(); // noop if detaching
            return newNode;
        }
    });
    return CustomType;
}(SimpleType));

// we import the types to re-export them inside types.
var types = {
    enumeration: enumeration,
    model: model,
    compose: compose,
    custom: custom,
    reference: reference,
    safeReference: safeReference,
    union: union,
    optional: optional,
    literal: literal,
    maybe: maybe,
    maybeNull: maybeNull,
    refinement: refinement,
    string: string,
    boolean: boolean,
    number: number,
    integer: integer,
    float: float,
    finite: finite,
    Date: DatePrimitive,
    map: map,
    array: array,
    frozen: frozen,
    identifier: identifier,
    identifierNumber: identifierNumber,
    late: late,
    lazy: lazy,
    undefined: undefinedType,
    null: nullType,
    snapshotProcessor: snapshotProcessor
};

class Point2D {
    x;
    y;
    constructor(payload) {
        this.x = payload.x;
        this.y = payload.y;
    }
}
const point2d = types.custom({
    name: 'Point 2D',
    fromSnapshot: (snapshot) => new Point2D(snapshot),
    toSnapshot: (value) => ({
        x: value.x,
        y: value.y,
    }),
    isTargetType: (value) => value instanceof Point2D,
    getValidationMessage: (snapshot) => {
        if (snapshot.x == null || snapshot.y == null) {
            return '.x and .y are required params';
        }
        return '';
    },
});

// TODO: refactor with types.custom
const boundingBox = types
    .model({
    topLeft: point2d,
    bottomRight: point2d,
})
    .views((self) => ({
    get width() {
        return self.bottomRight.x - self.topLeft.x;
    },
    get height() {
        return self.bottomRight.y - self.topLeft.y;
    },
    get size() {
        return {
            x: self.bottomRight.x - self.topLeft.x,
            y: self.bottomRight.y - self.topLeft.y,
        };
    },
    get center() {
        return {
            x: self.topLeft.x + (self.bottomRight.x - self.topLeft.x) / 2,
            y: self.topLeft.y + (self.bottomRight.y - self.topLeft.y) / 2,
        };
    },
}));

const color$1 = types.refinement(types.number, (value) => value >= 0 && value <= 255, (value) => `[color] "${value}" out of range`);

class LetterSpacing {
    value = 0;
    unit;
    constructor(payload) {
        this.value = payload.value;
        this.unit = payload.unit;
    }
}
const letterSpacing = types.custom({
    name: 'LineHeight',
    fromSnapshot: (snapshot) => new LetterSpacing(snapshot),
    toSnapshot: (value) => ({
        value: value.value,
        unit: value.unit,
    }),
    isTargetType: (value) => value instanceof LetterSpacing,
    getValidationMessage: (snapshot) => {
        if (snapshot.value == null || snapshot.unit == null) {
            return '.value and .unit are required params';
        }
        return '';
    },
});

class LineHeight {
    value = 1;
    unit;
    constructor(payload) {
        if (payload.unit !== 'AUTO') {
            this.value = payload.value;
        }
        this.unit = payload.unit;
    }
}
const lineHeight = types.custom({
    name: 'LineHeight',
    fromSnapshot: (snapshot) => new LineHeight(snapshot),
    toSnapshot: (value) => ({
        value: value.value,
        unit: value.unit,
    }),
    isTargetType: (value) => value instanceof LineHeight,
    getValidationMessage: (snapshot) => {
        if (snapshot.unit == null) {
            return '.unit are required params';
        }
        return '';
    },
});

const matrixTransform = types.optional(types.array(types.array(types.number)), [
    [0, 0, 0],
    [0, 0, 0],
]);

const percent$1 = types.refinement(types.number, (value) => value >= 0 && value <= 1, (value) => `[alpha] "${value}" out of range`);

function preProcessSnapshotIdentity(left, right) {
    return right;
}
function applyPropertyTransition(key, left, right, options, preProcessValue = (preProcessSnapshotIdentity)) {
    const { timeStart, timeEnd, timingCurve, springCurve } = options;
    const selfToApply = left;
    const modelToApply = right;
    if (JSON.stringify(selfToApply[key].getValue(timeStart)) ===
        JSON.stringify(modelToApply[key].getValue(timeEnd))) {
        return;
    }
    let startKeyframe = selfToApply[key].keyframes.find((keyframe) => keyframe.time === timeStart);
    if (startKeyframe == null) {
        startKeyframe = selfToApply[key].createKeyframe(timeStart);
    }
    const prevValue = selfToApply[key].getValue(timeEnd);
    selfToApply[key].updateValue(timeEnd, preProcessValue(prevValue, modelToApply[key].getValue(timeEnd)));
    const endKeyframe = selfToApply[key].keyframes.find((keyframe) => keyframe.time === timeEnd);
    if (startKeyframe == null || endKeyframe == null) {
        throw new TypeError('Something went wrong');
    }
    if (springCurve != null) {
        if (timeStart < timeEnd) {
            startKeyframe.updateSpringCurve(springCurve);
        }
        else {
            endKeyframe.updateSpringCurve(springCurve);
        }
    }
    // @NOTE: required to properly handle cases when timeStart > timeEnd
    if (timingCurve != null) {
        if (timeStart < timeEnd) {
            startKeyframe.updateTimingCurve({
                out: {
                    x: timingCurve.out.x,
                    y: timingCurve.out.y,
                },
            });
            endKeyframe.updateTimingCurve({
                in: {
                    x: timingCurve.in.x,
                    y: timingCurve.in.y,
                },
            });
        }
        else {
            startKeyframe.updateTimingCurve({
                in: {
                    x: timingCurve.in.x,
                    y: timingCurve.in.y,
                },
            });
            endKeyframe.updateTimingCurve({
                out: {
                    x: timingCurve.out.x,
                    y: timingCurve.out.y,
                },
            });
        }
    }
}

function bezierInterpolation$1(payload) {
    const { t, left, leftTangent, rightTangent, right } = payload;
    const p0 = { x: left.x, y: left.y };
    const p1 = { x: leftTangent.x, y: leftTangent.y };
    const p2 = { x: rightTangent.x, y: rightTangent.y };
    const p3 = { x: right.x, y: right.y };
    const isLinear = p0.x === p1.x && p0.y === p1.y && p2.x === p3.x && p2.y === p3.y;
    if (isLinear) {
        const x = (1 - t) * p0.x + t * p3.x;
        const y = (1 - t) * p0.y + t * p3.y;
        return { x, y };
    }
    const x = (1 - t) * (1 - t) * (1 - t) * p0.x +
        3 * (1 - t) * (1 - t) * t * p1.x +
        3 * (1 - t) * t * t * p2.x +
        t * t * t * p3.x;
    const y = (1 - t) * (1 - t) * (1 - t) * p0.y +
        3 * (1 - t) * (1 - t) * t * p1.y +
        3 * (1 - t) * t * t * p2.y +
        t * t * t * p3.y;
    return { x, y };
}

function bezierSpeedInterpolation(payload) {
    const { t, left, leftTangent, rightTangent, right } = payload;
    const p0 = { x: left.x, y: left.y };
    const p1 = { x: leftTangent.x, y: leftTangent.y };
    const p2 = { x: rightTangent.x, y: rightTangent.y };
    const p3 = { x: right.x, y: right.y };
    const isLinear = p0.x === p1.x && p0.y === p1.y && p2.x === p3.x && p2.y === p3.y;
    if (isLinear) {
        const x = (1 - t) * p0.x + t * p3.x;
        const y = (1 - t) * p0.y + t * p3.y;
        return { x, y };
    }
    const x = (-3 * t * t + 6 * t - 3) * p0.x +
        (9 * t * t - 12 * t + 3) * p1.x +
        (-9 * t * t + 6 * t) * p2.x +
        3 * t * t * p3.x;
    const y = (-3 * t * t + 6 * t - 3) * p0.y +
        (9 * t * t - 12 * t + 3) * p1.y +
        (-9 * t * t + 6 * t) * p2.y +
        3 * t * t * p3.y;
    return { x, y };
}

/**
 * @description optimized version of rounding
 */
function round(number, options = { fixed: 4 }) {
    if (options.fixed === 0) {
        return (number + 0.5) | 0; // Use bitwise OR to perform a fast flooring operation
    }
    const multiplier = 10 ** options.fixed;
    const rounded = (number * multiplier + 0.5) | 0; // Fast rounding using bitwise OR
    return rounded / multiplier;
}

// http://dev.w3.org/csswg/css3-2d-transforms/#matrix-decomposition
// http://www.maths-informatique-jeux.com/blog/frederic/?post/2013/12/01/Decomposition-of-2D-transform-matrices
// https://github.com/wisec/DOMinator/blob/master/layout/style/nsStyleAnimation.cpp#L946
function decomposedMatrix(matrix) {
    const a = matrix[0][0];
    const b = matrix[0][1];
    const c = matrix[1][0];
    const d = matrix[1][1];
    const det = a * d - b * c;
    const sqrt = Math.sqrt;
    const atan2 = Math.atan2;
    const degrees = 180 / Math.PI;
    let rotate;
    let scale;
    let skew;
    if (a !== 0 || b !== 0) {
        const r = sqrt(a * a + b * b);
        rotate = Math.acos(a / r) * (b > 0 ? 1 : -1);
        scale = [r, det / r];
        skew = [atan2(a * c + b * d, r * r), 0];
        // skew = [atan2(a * c + b * d, det), 0]
    }
    else if (c !== 0 || d !== 0) {
        const s = sqrt(c * c + d * d);
        // rotate = Math.PI / 2 - (d > 0 ? Math.acos(-c / s) : -Math.acos(c / s))
        rotate = Math.asin(c / s) * (d > 0 ? 1 : -1);
        scale = [det / s, s];
        skew = [0, atan2(a * c + b * d, s * s)];
        // skew = [0, atan2(a * c + b * d, det)]
    }
    else {
        // a = b = c = d = 0
        rotate = 0;
        skew = scale = [0, 0];
    }
    return {
        translation: {
            x: round(matrix[0][2]),
            y: round(matrix[1][2]),
        },
        rotation: {
            x: round(rotate * degrees),
        },
        scaling: {
            x: round(scale[0]),
            y: round(scale[1]),
        },
        skewing: {
            x: round(skew[0] * degrees),
            y: round(skew[1] * degrees),
        },
    };
}

function generateId() {
    const part1 = Date.now().toString(36);
    const part2 = Math.random().toString(36).substring(2);
    return `${part1}${part2}`;
}

/**
 * Used to check if we need to bump versions in model.
 * Bumping required to update cache and add interactivity.
 * But we don't need this when creating transitions and projects.
 */
const bumpVersions = {
    value: true,
    on() {
        this.value = true;
        return this;
    },
    off() {
        this.value = false;
        return this;
    },
};
const mixed = 'Mixed';
exports.ValueType = void 0;
(function (ValueType) {
    ValueType["Generic"] = "GENERIC";
    ValueType["Number"] = "NUMBER";
    ValueType["Point1D"] = "POINT_1D";
    ValueType["Point2D"] = "POINT_2D";
    ValueType["SpatialPoint2D"] = "SPATIAL_POINT_2D";
    ValueType["RGBA"] = "RGBA";
    ValueType["Boolean"] = "BOOLEAN";
    ValueType["BlendMode"] = "BLEND_MODE";
    ValueType["PaintType"] = "PAINT_TYPE";
    ValueType["String"] = "STRING";
    ValueType["BooleanOperation"] = "BOOLEAN_OPERATION";
    ValueType["TextCase"] = "TEXT_CASE";
    ValueType["TextDecoration"] = "TEXT_DECORATION";
    ValueType["Unit"] = "UNIT";
    ValueType["VectorPath"] = "VECTOR_PATH";
    ValueType["FillRule"] = "FILL_RULE";
    ValueType["VectorPathMirroring"] = "VECTOR_PATH_MIRRORING";
    ValueType["ImageData"] = "IMAGE_DATA";
    ValueType["ImageUrl"] = "IMAGE_URL";
    ValueType["ScaleMode"] = "SCALE_MODE";
    ValueType["StrokeAlign"] = "STROKE_ALIGN";
    ValueType["StrokeCap"] = "STROKE_CAP";
    ValueType["StrokeJoin"] = "STROKE_JOIN";
    ValueType["EffectType"] = "EFFECT_TYPE";
    ValueType["MatrixTransform"] = "MATRIX_TRANSFORM";
})(exports.ValueType || (exports.ValueType = {}));
/**
 * @description used to determine locked state of the node or property
 */
exports.LockType = void 0;
(function (LockType) {
    LockType["Normal"] = "NORMAL";
    LockType["Locked"] = "LOCKED";
})(exports.LockType || (exports.LockType = {}));
/**
 * @description used to determine state of the node or property in viewport
 * @deprecated we are using boolean values now
 */
exports.VisibilityType = void 0;
(function (VisibilityType) {
    VisibilityType["Visible"] = "VISIBLE";
    VisibilityType["Hidden"] = "HIDDEN";
})(exports.VisibilityType || (exports.VisibilityType = {}));
exports.NodeType = void 0;
(function (NodeType) {
    NodeType["Generic"] = "GENERIC";
    NodeType["BooleanOperation"] = "BOOLEAN_OPERATION";
    // Component = 'COMPONENT',
    // ComponentSet = 'COMPONENT_SET',
    // Document = 'DOCUMENT',
    NodeType["Ellipse"] = "ELLIPSE";
    NodeType["Instance"] = "INSTANCE";
    NodeType["Frame"] = "FRAME";
    NodeType["Group"] = "GROUP";
    // Instance = 'INSTANCE',
    NodeType["Line"] = "LINE";
    // Page = 'PAGE',
    NodeType["Polygon"] = "POLYGON";
    NodeType["Rectangle"] = "RECTANGLE";
    // Slice = 'SLICE',
    NodeType["Star"] = "STAR";
    NodeType["Text"] = "TEXT";
    NodeType["Vector"] = "VECTOR";
})(exports.NodeType || (exports.NodeType = {}));
/**
 * Previously has name `ModelType`
 */
exports.EntityType = void 0;
(function (EntityType) {
    EntityType["Root"] = "root";
    EntityType["Node"] = "node";
    EntityType["Keyframe"] = "keyframe";
    /**
     * Previously has name `property-group`
     */
    EntityType["Effect"] = "effect";
    /**
     * Previously has name `property-group`
     */
    EntityType["Paint"] = "paint";
    EntityType["ExportPreset"] = "export-preset";
})(exports.EntityType || (exports.EntityType = {}));
exports.PropertyGroupSetType = void 0;
(function (PropertyGroupSetType) {
    PropertyGroupSetType["Generic"] = "GENERIC";
    PropertyGroupSetType["Effect"] = "EFFECT";
    PropertyGroupSetType["Paint"] = "PAINT";
    PropertyGroupSetType["ColorStops"] = "COLOR_STOPS";
    PropertyGroupSetType["Fill"] = "FILL";
    PropertyGroupSetType["Stroke"] = "STROKE";
})(exports.PropertyGroupSetType || (exports.PropertyGroupSetType = {}));
exports.PropertyGroupType = void 0;
(function (PropertyGroupType) {
    PropertyGroupType["Generic"] = "GENERIC";
    PropertyGroupType["DropShadow"] = "DROP_SHADOW";
    PropertyGroupType["LayerBlur"] = "LAYER_BLUR";
    PropertyGroupType["BackgroundBlur"] = "BACKGROUND_BLUR";
    PropertyGroupType["InnerShadow"] = "INNER_SHADOW";
    PropertyGroupType["Image"] = "IMAGE";
    PropertyGroupType["Solid"] = "SOLID";
    PropertyGroupType["Gradient"] = "GRADIENT";
    PropertyGroupType["ColorStop"] = "COLOR_STOP";
})(exports.PropertyGroupType || (exports.PropertyGroupType = {}));
exports.PropertyType = void 0;
(function (PropertyType) {
    PropertyType["Generic"] = "GENERIC";
    PropertyType["AnchorPoint"] = "ANCHOR_POINT";
    PropertyType["Opacity"] = "OPACITY";
    PropertyType["Rotation"] = "ROTATION";
    PropertyType["Position"] = "POSITION";
    PropertyType["Scale"] = "SCALE";
    PropertyType["Size"] = "SIZE";
    PropertyType["Skew"] = "SKEW";
    PropertyType["BlendMode"] = "BLEND_MODE";
    PropertyType["Color"] = "COLOR";
    PropertyType["CornerRadius"] = "CORNER_RADIUS";
    PropertyType["TopLeftRadius"] = "TOP_LEFT_RADIUS";
    PropertyType["TopRightRadius"] = "TOP_RIGHT_RADIUS";
    PropertyType["BottomLeftRadius"] = "BOTTOM_LEFT_RADIUS";
    PropertyType["BottomRightRadius"] = "BOTTOM_RIGHT_RADIUS";
    PropertyType["Visible"] = "VISIBLE";
    PropertyType["StrokeWeight"] = "STROKE_WEIGHT";
    PropertyType["StrokeTopWeight"] = "STROKE_TOP_WEIGHT";
    PropertyType["StrokeBottomWeight"] = "STROKE_BOTTOM_WEIGHT";
    PropertyType["StrokeLeftWeight"] = "STROKE_LEFT_WEIGHT";
    PropertyType["StrokeRightWeight"] = "STROKE_RIGHT_WEIGHT";
    PropertyType["GradientTransform"] = "GRADIENT_TRANSFORM";
    PropertyType["Offset"] = "OFFSET";
    PropertyType["Radius"] = "RADIUS";
    PropertyType["Spread"] = "SPREAD";
    PropertyType["Angle"] = "ANGLE";
    // @NOTE: in range 0...1
    PropertyType["Percent"] = "PERCENT";
    // @NOTE: in range -1...1
    PropertyType["PercentNegative"] = "PERCENT_NEGATIVE";
    PropertyType["Dash"] = "DASH";
    PropertyType["Gap"] = "GAP";
    PropertyType["DashOffset"] = "DASH_OFFSET";
    PropertyType["TrimStart"] = "TRIM_START";
    PropertyType["TrimEnd"] = "TRIM_END";
    PropertyType["TrimOffset"] = "TRIM_OFFSET";
    PropertyType["PointCount"] = "POINT_COUNT";
    PropertyType["InnerRadius"] = "INNER_RADIUS";
})(exports.PropertyType || (exports.PropertyType = {}));
exports.PropertyKeyframesType = void 0;
(function (PropertyKeyframesType) {
    PropertyKeyframesType["Active"] = "ACTIVE";
    PropertyKeyframesType["HasKeyframes"] = "HAS_KEYFRAMES";
    PropertyKeyframesType["Empty"] = "EMPTY";
})(exports.PropertyKeyframesType || (exports.PropertyKeyframesType = {}));
/**
 * @description predefined list of available layer colors
 */
exports.LayerColor = void 0;
(function (LayerColor) {
    LayerColor["Blue"] = "BLUE";
    LayerColor["Purple"] = "PURPLE";
    LayerColor["Pink"] = "PINK";
    LayerColor["Green"] = "GREEN";
    LayerColor["Turqouise"] = "TURQOUISE";
    LayerColor["Red"] = "RED";
    LayerColor["Orange"] = "ORANGE";
    LayerColor["Yellow"] = "YELLOW";
    LayerColor["Grey"] = "GREY";
    LayerColor["None"] = "NONE";
})(exports.LayerColor || (exports.LayerColor = {}));
exports.RenderType = void 0;
(function (RenderType) {
    RenderType["mp4"] = "mp4";
    RenderType["webm"] = "webm";
    RenderType["ogv"] = "ogv";
    // lottie json file
    RenderType["lottie"] = "lottie";
    // dotLottie file
    RenderType["dotLottie"] = "dotlottie";
    // telegram stickers
    RenderType["tgs"] = "tgs";
    // animated svg
    RenderType["svg"] = "svg";
    // animated gif
    RenderType["gif"] = "gif";
    // png sequence
    RenderType["png"] = "png";
})(exports.RenderType || (exports.RenderType = {}));
exports.RenderScaleType = void 0;
(function (RenderScaleType) {
    RenderScaleType["0.5x"] = "0.5x";
    RenderScaleType["0.75x"] = "0.75x";
    RenderScaleType["1x"] = "1x";
    RenderScaleType["1.5x"] = "1.5x";
    RenderScaleType["2x"] = "2x";
    RenderScaleType["3x"] = "3x";
    RenderScaleType["4x"] = "4x";
})(exports.RenderScaleType || (exports.RenderScaleType = {}));
/**
 * @description used to determine where node should be set to solo
 * None – solo disabled
 * Viewport – node will be isolated in viewport only
 * Timeline – node will be isolated on timeline only
 * Both – node will be isolaterd in viewport and on timeline
 */
exports.NodeSoloType = void 0;
(function (NodeSoloType) {
    NodeSoloType["None"] = "NONE";
    NodeSoloType["Viewport"] = "VIEWPORT";
    NodeSoloType["Timeline"] = "TIMELINE";
    NodeSoloType["Both"] = "BOTH";
})(exports.NodeSoloType || (exports.NodeSoloType = {}));
exports.PaintType = void 0;
(function (PaintType) {
    PaintType["Solid"] = "SOLID";
    PaintType["GradientLinear"] = "GRADIENT_LINEAR";
    PaintType["GradientRadial"] = "GRADIENT_RADIAL";
    // GradientAngular = 'GRADIENT_ANGULAR',
    // GradientDiamond = 'GRADIENT_DIAMOND',
    PaintType["Image"] = "IMAGE";
})(exports.PaintType || (exports.PaintType = {}));
exports.ScaleType = void 0;
(function (ScaleType) {
    ScaleType["Fill"] = "FILL";
    ScaleType["Fit"] = "FIT";
    ScaleType["Crop"] = "CROP";
    ScaleType["Tile"] = "TILE";
})(exports.ScaleType || (exports.ScaleType = {}));
exports.EffectType = void 0;
(function (EffectType) {
    EffectType["DropShadow"] = "DROP_SHADOW";
    EffectType["LayerBlur"] = "LAYER_BLUR";
    EffectType["BackgroundBlur"] = "BACKGROUND_BLUR";
    EffectType["InnerShadow"] = "INNER_SHADOW";
})(exports.EffectType || (exports.EffectType = {}));
exports.BlendModeType = void 0;
(function (BlendModeType) {
    BlendModeType["PassThrough"] = "PASS_THROUGH";
    BlendModeType["Normal"] = "NORMAL";
    BlendModeType["Darken"] = "DARKEN";
    BlendModeType["Multiply"] = "MULTIPLY";
    BlendModeType["LinearBurn"] = "LINEAR_BURN";
    BlendModeType["ColorBurn"] = "COLOR_BURN";
    BlendModeType["Lighten"] = "LIGHTEN";
    BlendModeType["Screen"] = "SCREEN";
    BlendModeType["LinearDodge"] = "LINEAR_DODGE";
    BlendModeType["ColorDodge"] = "COLOR_DODGE";
    BlendModeType["Overlay"] = "OVERLAY";
    BlendModeType["SoftLight"] = "SOFT_LIGHT";
    BlendModeType["HardLight"] = "HARD_LIGHT";
    BlendModeType["Difference"] = "DIFFERENCE";
    BlendModeType["Exclusion"] = "EXCLUSION";
    BlendModeType["Hue"] = "HUE";
    BlendModeType["Saturation"] = "SATURATION";
    BlendModeType["Color"] = "COLOR";
    BlendModeType["Luminosity"] = "LUMINOSITY";
})(exports.BlendModeType || (exports.BlendModeType = {}));
exports.ProjectType = void 0;
(function (ProjectType) {
    /**
     * @description projects based in figma
     */
    ProjectType["Local"] = "LOCAL";
    /**
     * @description projects uploaded to our servers
     */
    ProjectType["Remote"] = "REMOTE";
})(exports.ProjectType || (exports.ProjectType = {}));
exports.StrokeAlign = void 0;
(function (StrokeAlign) {
    StrokeAlign["Center"] = "CENTER";
    StrokeAlign["Inside"] = "INSIDE";
    StrokeAlign["Outside"] = "OUTSIDE";
})(exports.StrokeAlign || (exports.StrokeAlign = {}));
exports.StrokeCap = void 0;
(function (StrokeCap) {
    StrokeCap["None"] = "NONE";
    StrokeCap["Round"] = "ROUND";
    StrokeCap["Square"] = "SQUARE";
    StrokeCap["ArrowLines"] = "ARROW_LINES";
    StrokeCap["ArrowEquilateral"] = "ARROW_EQUILATERAL";
    StrokeCap["TriangleFilled"] = "TRIANGLE_FILLED";
    StrokeCap["DiamondFilled"] = "DIAMOND_FILLED";
    StrokeCap["CircleFilled"] = "CIRCLE_FILLED";
})(exports.StrokeCap || (exports.StrokeCap = {}));
exports.StrokeJoin = void 0;
(function (StrokeJoin) {
    StrokeJoin["Miter"] = "MITER";
    StrokeJoin["Bevel"] = "BEVEL";
    StrokeJoin["Round"] = "ROUND";
})(exports.StrokeJoin || (exports.StrokeJoin = {}));
exports.BooleanOperationType = void 0;
(function (BooleanOperationType) {
    BooleanOperationType["Union"] = "UNION";
    BooleanOperationType["Intersect"] = "INTERSECT";
    BooleanOperationType["Subtract"] = "SUBTRACT";
    BooleanOperationType["Exclude"] = "EXCLUDE";
})(exports.BooleanOperationType || (exports.BooleanOperationType = {}));
exports.CurveType = void 0;
(function (CurveType) {
    CurveType["Spring"] = "SPRING";
    CurveType["Timing"] = "TIMING";
})(exports.CurveType || (exports.CurveType = {}));
exports.NodeSizeBehaviour = void 0;
(function (NodeSizeBehaviour) {
    /**
     * @description fill all available space
     */
    NodeSizeBehaviour["Fill"] = "FILL";
    /**
     * @description not react on size changes
     */
    NodeSizeBehaviour["Ignore"] = "IGNORE";
})(exports.NodeSizeBehaviour || (exports.NodeSizeBehaviour = {}));

function getProgress({ t: time, segment }) {
    const [firstKeyframe, lastKeyframe] = segment;
    const t = (() => {
        const timeDiff = time - firstKeyframe.time;
        const duration = lastKeyframe.time - firstKeyframe.time;
        if (firstKeyframe.time === lastKeyframe.time) {
            return timeDiff;
        }
        return timeDiff / duration;
    })();
    const curve = firstKeyframe.getCurveStyleValue();
    if (firstKeyframe.hasAppliedCurveStyle() === false &&
        curve.type === exports.CurveType.Timing) {
        const currentCurve = timingCurve.create({
            out: firstKeyframe.timingCurve.out,
            in: lastKeyframe.timingCurve.in,
        });
        return currentCurve.applyCurve(t);
    }
    return curve.applyCurve(t);
}

/**
 * @description default bezier interpolation for segment
 * @param payload.t – current progress
 * @param payload.segment – segment of spatial interpolated keyframes
 */
function bezierInterpolation({ t, segment, }) {
    const [leftKey, rightKey] = segment;
    return bezierInterpolation$1({
        t,
        left: { x: leftKey.x, y: leftKey.y },
        leftTangent: { x: leftKey.tx2, y: leftKey.ty2 },
        rightTangent: { x: rightKey.tx1, y: rightKey.ty1 },
        right: { x: rightKey.x, y: rightKey.y },
    });
}

function lerp(t, min, max) {
    return min + (max - min) * t;
}
function lerpClamped(t, min, max) {
    const newValue = min + (max - min) * t;
    return R__namespace.clamp(min, max, newValue);
}
function lerpRange(value, minValue, maxValue, min, max) {
    if (maxValue === minValue || value === minValue) {
        return min;
    }
    const t = (value - minValue) / (maxValue - minValue);
    return (max - min) * t + min;
}
function lerpRangeClamped(value, minValue, maxValue, min, max) {
    if (maxValue === minValue || value === minValue) {
        return min;
    }
    const t = (value - minValue) / (maxValue - minValue);
    const newValue = (max - min) * t + min;
    return R__namespace.clamp(min, max, newValue);
}

const defaultSamples = 100;
function lutByEqualLengthFromTimingCurve(timingCurve, samples = defaultSamples) {
    const bezier = new bezierJs.Bezier([
        0,
        0,
        timingCurve.start.x,
        timingCurve.start.y,
        timingCurve.end.x,
        timingCurve.end.y,
        1,
        1,
    ]);
    let ox = bezier.get(0).x;
    let oy = bezier.get(0).y;
    let clen = 0;
    let arcLengths = [0];
    for (let i = 1; i <= samples; i += 1) {
        const x = bezier.get(i / samples).x;
        const y = bezier.get(i / samples).y;
        const dx = ox - x;
        const dy = oy - y;
        clen += Math.sqrt(dx * dx + dy * dy);
        arcLengths[i] = clen;
        ox = x;
        oy = y;
    }
    return arcLengths;
}
function lutByEqualLengthFromSpatialPoints(left, right, samples = defaultSamples) {
    const bezier = new bezierJs.Bezier([
        left.x,
        left.y,
        left.tx2,
        left.ty2,
        right.tx1,
        right.ty1,
        right.x,
        right.y,
    ]);
    let ox = bezier.get(0).x;
    let oy = bezier.get(0).y;
    let clen = 0;
    let arcLengths = [0];
    for (let i = 1; i <= samples; i += 1) {
        const x = bezier.get(i / samples).x;
        const y = bezier.get(i / samples).y;
        const dx = ox - x;
        const dy = oy - y;
        clen += Math.sqrt(dx * dx + dy * dy);
        arcLengths[i] = clen;
        ox = x;
        oy = y;
    }
    return arcLengths;
}
// @NOTE: taken from https://gamedev.stackexchange.com/a/5427
function tFromProgressByLut(progress, lut) {
    const n = lut.length - 1;
    const targetLength = progress * lut[n];
    let low = 0;
    let high = n;
    let index = 0;
    while (low < high) {
        index = low + (((high - low) / 2) | 0);
        if (lut[index] < targetLength) {
            low = index + 1;
        }
        else {
            high = index;
        }
    }
    if (lut[index] > targetLength) {
        index--;
    }
    const lengthBefore = lut[index];
    if (lengthBefore === targetLength) {
        return index / n;
    }
    else {
        return ((index +
            (targetLength - lengthBefore) / (lut[index + 1] - lengthBefore)) /
            n);
    }
}
function getValueSpatialPoint2D(payload) {
    const { t, segment } = payload;
    const progress = getProgress({ t, segment });
    const leftKeyframe = segment[0];
    const rightKeyframe = segment[1];
    if (leftKeyframe.value.x === rightKeyframe.value.x &&
        leftKeyframe.value.y === rightKeyframe.value.y) {
        return {
            x: round(leftKeyframe.value.x, { fixed: 2 }),
            y: round(leftKeyframe.value.y, { fixed: 2 }),
        };
    }
    const isLinear = leftKeyframe.value.x === leftKeyframe.value.tx1 &&
        leftKeyframe.value.x === leftKeyframe.value.tx2 &&
        leftKeyframe.value.y === leftKeyframe.value.ty1 &&
        leftKeyframe.value.y === leftKeyframe.value.ty2 &&
        rightKeyframe.value.x === rightKeyframe.value.tx1 &&
        rightKeyframe.value.x === rightKeyframe.value.tx2 &&
        rightKeyframe.value.y === rightKeyframe.value.ty1 &&
        rightKeyframe.value.y === rightKeyframe.value.ty2;
    if (isLinear) {
        return {
            x: lerp(progress, leftKeyframe.value.x, rightKeyframe.value.x),
            y: lerp(progress, leftKeyframe.value.y, rightKeyframe.value.y),
        };
    }
    if (progress === 0) {
        return leftKeyframe.value;
    }
    const lutByLength = lutByEqualLengthFromSpatialPoints(leftKeyframe.value, rightKeyframe.value);
    const newT = tFromProgressByLut(progress, lutByLength);
    const { x, y } = bezierInterpolation({
        t: newT,
        segment: [leftKeyframe.value, rightKeyframe.value],
    });
    return {
        x: round(x, { fixed: 2 }),
        y: round(y, { fixed: 2 }),
    };
}

const isSegment = (left, right) => {
    // @NOTE: required check to handle error when plugin crashed after paste of the keyframes.
    // @TODO: make correct handling.
    try {
        if (left.getProperty().id !== right.getProperty().id) {
            return false;
        }
    }
    catch (err) {
        console.error('[isSegment]', err);
        return false;
    }
    if (left.time === right.time) {
        return false;
    }
    if (left.isEqual(right)) {
        return false;
    }
    const allKeyframeIds = left
        .getProperty()
        .keyframes.map((keyframe) => keyframe.id);
    const leftIdx = allKeyframeIds.indexOf(left.id);
    const rightIdx = allKeyframeIds.indexOf(right.id);
    return Math.abs(rightIdx - leftIdx) === 1;
};

const multiplyMatrices = (...matrices) => {
    return matrices.reduce((result, matrix) => {
        const [a, b, c, d, e, f] = result;
        const [g, h, i, j, k, l] = matrix;
        result[0] = a * g + b * i;
        result[1] = a * h + b * j;
        result[2] = c * g + d * i;
        result[3] = c * h + d * j;
        result[4] = e * g + f * i + k;
        result[5] = e * h + f * j + l;
        return result;
    }, [1, 0, 0, 1, 0, 0]);
};

class Pair {
    data;
    constructor(data) {
        this.data = data;
    }
}
/**
 * Used to convert prototypes to Aninix projects properly
 * @todo check where used and optimize only for used cases
 */
function nodesToPairs(initialPair, options = {}) {
    const stack = [initialPair];
    const pairs = [];
    const { isReversed = false } = options;
    while (stack.length > 0) {
        const pair = stack.pop();
        // @NOTE: ignore text type for now
        if (pair.data.left?.type === 'VECTOR' && pair.data.right?.type === 'TEXT') {
            pairs.push(pair);
        }
        else if (pair.data.left != null &&
            pair.data.right != null &&
            pair.data.left?.type !== pair.data.right?.type) {
            pairs.push(new Pair({
                left: pair.data.left,
                right: null,
                parent: pair.data.parent,
            }));
            pairs.push(new Pair({
                left: null,
                right: pair.data.right,
                parent: pair.data.parent,
            }));
        }
        else {
            pairs.push(pair);
        }
        if (pair.data.left?.children != null && pair.data.right?.children != null) {
            const leftChildren = isReversed
                ? [...R__namespace.reverse(pair.data.left.children)]
                : [...pair.data.left.children];
            let rightChildren = isReversed
                ? [...R__namespace.reverse(pair.data.right.children)]
                : [...pair.data.right.children];
            for (let i = 0; i < leftChildren.length; i += 1) {
                const leftChild = leftChildren[i];
                const rightChildIdx = rightChildren.findIndex((child) => leftChild.name === child.name);
                if (rightChildIdx === -1) {
                    stack.push(new Pair({
                        left: leftChild,
                        right: null,
                        parent: pair.data.left,
                    }));
                    continue;
                }
                const [rightChild] = rightChildren.splice(rightChildIdx, 1);
                stack.push(new Pair({
                    left: leftChild,
                    right: rightChild,
                    parent: pair.data.left,
                }));
            }
            for (const rightChild of rightChildren) {
                stack.push(new Pair({
                    left: null,
                    right: rightChild,
                    parent: pair.data.left,
                }));
            }
        }
    }
    return pairs;
}

/**
 * @description protect number from divide by zero
 */
function protect(number) {
    if (number === 0) {
        return 1;
    }
    return number;
}

const showNodeOnTimeline = (node) => {
    if (node.isRoot) {
        return;
    }
    node.showOnTimeline();
    // node.showOnTimeline()
    const parent = node.getParent();
    if (parent == null) {
        return;
    }
    // @NOTE: required to expand neighbors of current node in the tree like figma does
    // @ts-ignore
    if (parent.children != null) {
        // @ts-ignore
        parent.expandChildren();
    }
    if (parent.isRoot === false) {
        showNodeOnTimeline(parent);
    }
};

class PercentPoint2D {
    x;
    y;
    constructor(payload) {
        this.x = round(payload.x);
        this.y = round(payload.y);
    }
}
types.custom({
    name: 'Percent Point 2D',
    fromSnapshot: (snapshot) => new PercentPoint2D(snapshot),
    toSnapshot: (value) => ({
        x: value.x,
        y: value.y,
    }),
    isTargetType: (value) => value instanceof PercentPoint2D,
    getValidationMessage: (snapshot) => {
        if (snapshot.x == null || snapshot.y == null) {
            return '.x and .y are required params';
        }
        return '';
    },
});

class Point1D {
    x;
    constructor(payload) {
        this.x = payload.x;
    }
}
const point1d = types.custom({
    name: 'Point 1D',
    fromSnapshot: (snapshot) => new Point1D({ x: snapshot.x }),
    toSnapshot: (value) => ({
        x: value.x,
    }),
    isTargetType: (value) => value instanceof Point1D,
    getValidationMessage: (snapshot) => {
        if (snapshot.x == null) {
            return '.x is required param';
        }
        return '';
    },
});

class Rgba {
    r;
    g;
    b;
    a;
    constructor(payload) {
        this.r = color$1.create(R__namespace.clamp(0, 255, payload.r));
        this.g = color$1.create(R__namespace.clamp(0, 255, payload.g));
        this.b = color$1.create(R__namespace.clamp(0, 255, payload.b));
        this.a =
            payload.a != null
                ? percent$1.create(R__namespace.clamp(0, 1, payload.a))
                : percent$1.create(1);
    }
}
const rgba = types.custom({
    name: 'RGBA',
    fromSnapshot: (snapshot) => new Rgba(snapshot),
    toSnapshot: (value) => ({
        r: value.r,
        g: value.g,
        b: value.b,
        a: value.a,
    }),
    isTargetType: (value) => value instanceof Rgba,
    getValidationMessage: (snapshot) => {
        if (snapshot.r == null || snapshot.g == null || snapshot.b == null) {
            return '.r and .g and .b are required params';
        }
        return '';
    },
});

class SpatialPoint2D {
    x;
    y;
    tx1;
    tx2;
    ty1;
    ty2;
    constructor(payload) {
        this.x = payload.x;
        this.y = payload.y;
        this.tx1 = payload.tx1 || payload.x;
        this.tx2 = payload.tx2 || payload.x;
        this.ty1 = payload.ty1 || payload.y;
        this.ty2 = payload.ty2 || payload.y;
    }
}
const spatialPoint2d = types.custom({
    name: 'Spatial Point 2D',
    fromSnapshot: (snapshot) => new SpatialPoint2D(snapshot),
    toSnapshot: (value) => ({
        x: value.x,
        y: value.y,
        tx1: value.tx1,
        tx2: value.tx2,
        ty1: value.ty1,
        ty2: value.ty2,
    }),
    isTargetType: (value) => typeof value.x === 'number' &&
        typeof value.y === 'number' &&
        typeof value.tx1 === 'number' &&
        typeof value.tx2 === 'number' &&
        typeof value.ty1 === 'number' &&
        typeof value.ty2 === 'number',
    getValidationMessage: (snapshot) => '',
});

const MAX_SAMPLES = 250;
class SpringCurve {
    type = exports.CurveType.Spring;
    /**
     * @description Spring stiffness, in kg / s^2
     */
    stiffness = 100;
    /**
     * @description Damping constant, in kg / s
     */
    damping = 10;
    /**
     * @description Mass in kg
     */
    mass = 1;
    /**
     * @description time sample
     */
    timeInterval = 2 / MAX_SAMPLES;
    /**
     * @description max samples to prevent infinite loop
     */
    maxSamples = MAX_SAMPLES;
    deltaAccuracy = 0.005;
    /**
     * @description how much digits after dot should be kept
     */
    roundAccuracy = 5;
    /**
     * @description internal cached values
     */
    _cache = [];
    constructor(payload) {
        if (payload.stiffness <= 0) {
            throw new Error('.stiffness should be greater than 0');
        }
        if (payload.damping <= 0) {
            throw new Error('.damping should be greater than 0');
        }
        if (payload.mass <= 0) {
            throw new Error('.mass should be greater than 0');
        }
        this.stiffness = payload.stiffness;
        this.damping = payload.damping;
        this.mass = payload.mass;
    }
    applyCurve(t) {
        const time = R__namespace.clamp(0, 1, t);
        const result = this.getCache();
        const actualSamplesCount = result.length - 1;
        const idx = time * actualSamplesCount;
        const prevIdx = Math.floor(idx);
        const nextIdx = R__namespace.min(actualSamplesCount, Math.floor(idx) + 1);
        if (t === 0) {
            return R__namespace.head(result).value;
        }
        if (t === 1) {
            return R__namespace.last(result).value;
        }
        const value = R__namespace.mean([result[nextIdx].value, result[prevIdx].value]);
        return value;
    }
    getCache() {
        if (this._cache.length === 0) {
            this.generateCache();
        }
        const length = this._cache.length;
        return this._cache.map((item, idx) => ({
            progress: idx / length,
            value: item.value,
        }));
    }
    isEqual(to) {
        if (to.type === exports.CurveType.Timing) {
            return false;
        }
        const valueToCompare = to;
        return (this.stiffness === valueToCompare.stiffness &&
            this.damping === valueToCompare.damping &&
            this.mass === valueToCompare.mass);
    }
    updateCache(newCache) {
        this._cache = newCache;
        return this;
    }
    generateCache = () => {
        const cache = this._cache;
        // @NOTE: check if value was cached. If so then just return cache
        if (cache.length !== 0) {
            return cache;
        }
        // @NOTE: Object position and velocity.
        let value = 1;
        let velocity = 0;
        let acceleration = 0;
        // @NOTE: current sample index
        let i = 0;
        // @NOTE: final array of values
        let values = [
            {
                value: 0,
                time: 0,
            },
        ];
        // @NOTE: previous value of X to compare. It allows to skip error when X somehow set to 1.
        // For example x0 === 0.99, x1 === 1, x2 === 1.1 etc
        let roundedValue = 1 - value;
        while (i < this.maxSamples &&
            R__namespace.any((item) => Math.abs(1 - item.value) > this.deltaAccuracy, R__namespace.takeLast(5, values))) {
            i += 1;
            const fSpring = -this.stiffness * value;
            const fDamping = -this.damping * velocity;
            acceleration = (fSpring + fDamping) / this.mass;
            velocity = round(velocity + acceleration * this.timeInterval, {
                fixed: this.roundAccuracy,
            });
            value = round(value + velocity * this.timeInterval, {
                fixed: this.roundAccuracy,
            });
            roundedValue = round(1 - value, { fixed: this.roundAccuracy });
            values.push({
                value: roundedValue,
                time: i * this.timeInterval,
            });
        }
        this.updateCache(values);
        return values;
    };
}
const springCurve = types.custom({
    name: 'Spring Curve',
    fromSnapshot: (snapshot) => new SpringCurve(snapshot),
    toSnapshot: (value) => ({
        stiffness: value.stiffness,
        damping: value.damping,
        mass: value.mass,
    }),
    isTargetType: (value) => value instanceof SpringCurve,
    getValidationMessage: (snapshot) => {
        if (snapshot.stiffness == null ||
            snapshot.damping == null ||
            snapshot.mass == null) {
            return '.stiffness, .damping and .mass are required params';
        }
        return '';
    },
});

/* eslint-disable */
// @ts-nocheck
/**
 * https://github.com/gre/bezier-easing
 * BezierEasing - use bezier curve for transition easing function
 * by Gaëtan Renaudeau 2014 - 2015 – MIT License
 */
// These values are established by empiricism with tests (tradeoff: performance VS precision)
var NEWTON_ITERATIONS = 4;
var NEWTON_MIN_SLOPE = 0.001;
var SUBDIVISION_PRECISION = 0.0000001;
var SUBDIVISION_MAX_ITERATIONS = 10;
var kSplineTableSize = 11;
var kSampleStepSize = 1.0 / (kSplineTableSize - 1.0);
var float32ArraySupported = typeof Float32Array === 'function';
function A(aA1, aA2) {
    return 1.0 - 3.0 * aA2 + 3.0 * aA1;
}
function B(aA1, aA2) {
    return 3.0 * aA2 - 6.0 * aA1;
}
function C(aA1) {
    return 3.0 * aA1;
}
// Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
function calcBezier(aT, aA1, aA2) {
    return ((A(aA1, aA2) * aT + B(aA1, aA2)) * aT + C(aA1)) * aT;
}
// Returns dx/dt given t, x1, and x2, or dy/dt given t, y1, and y2.
function getSlope(aT, aA1, aA2) {
    return 3.0 * A(aA1, aA2) * aT * aT + 2.0 * B(aA1, aA2) * aT + C(aA1);
}
function binarySubdivide(aX, aA, aB, mX1, mX2) {
    var currentX, currentT, i = 0;
    do {
        currentT = aA + (aB - aA) / 2.0;
        currentX = calcBezier(currentT, mX1, mX2) - aX;
        if (currentX > 0.0) {
            aB = currentT;
        }
        else {
            aA = currentT;
        }
    } while (Math.abs(currentX) > SUBDIVISION_PRECISION &&
        ++i < SUBDIVISION_MAX_ITERATIONS);
    return currentT;
}
function newtonRaphsonIterate(aX, aGuessT, mX1, mX2) {
    for (var i = 0; i < NEWTON_ITERATIONS; ++i) {
        var currentSlope = getSlope(aGuessT, mX1, mX2);
        if (currentSlope === 0.0) {
            return aGuessT;
        }
        var currentX = calcBezier(aGuessT, mX1, mX2) - aX;
        aGuessT -= currentX / currentSlope;
    }
    return aGuessT;
}
function LinearEasing(x) {
    return x;
}
function bezier(mX1, mY1, mX2, mY2) {
    if (!(0 <= mX1 && mX1 <= 1 && 0 <= mX2 && mX2 <= 1)) {
        throw new Error('bezier x values must be in [0, 1] range');
    }
    if (mX1 === mY1 && mX2 === mY2) {
        return LinearEasing;
    }
    // Precompute samples table
    var sampleValues = float32ArraySupported
        ? new Float32Array(kSplineTableSize)
        : new Array(kSplineTableSize);
    for (var i = 0; i < kSplineTableSize; ++i) {
        sampleValues[i] = calcBezier(i * kSampleStepSize, mX1, mX2);
    }
    function getTForX(aX) {
        var intervalStart = 0.0;
        var currentSample = 1;
        var lastSample = kSplineTableSize - 1;
        for (; currentSample !== lastSample && sampleValues[currentSample] <= aX; ++currentSample) {
            intervalStart += kSampleStepSize;
        }
        --currentSample;
        // Interpolate to provide an initial guess for t
        var dist = (aX - sampleValues[currentSample]) /
            (sampleValues[currentSample + 1] - sampleValues[currentSample]);
        var guessForT = intervalStart + dist * kSampleStepSize;
        var initialSlope = getSlope(guessForT, mX1, mX2);
        if (initialSlope >= NEWTON_MIN_SLOPE) {
            return newtonRaphsonIterate(aX, guessForT, mX1, mX2);
        }
        else if (initialSlope === 0.0) {
            return guessForT;
        }
        else {
            return binarySubdivide(aX, intervalStart, intervalStart + kSampleStepSize, mX1, mX2);
        }
    }
    return function BezierEasing(x) {
        // Because JavaScript number are imprecise, we should guarantee the extremes are right.
        if (x === 0 || x === 1) {
            return x;
        }
        return calcBezier(getTForX(x), mY1, mY2);
    };
}

const GRAPH_DETAILS = 25;
class TimingCurve {
    type = exports.CurveType.Timing;
    out = {
        x: 0,
        y: 0,
    };
    in = {
        x: 1,
        y: 1,
    };
    /**
     * @description internal cached values
     */
    _cache = [];
    constructor(payload) {
        this.out = new PercentPoint2D(payload.out);
        this.in = new PercentPoint2D(payload.in);
    }
    applyCurve(t) {
        const time = R__namespace.clamp(0, 1, t);
        const ax = this.out.x;
        const ay = this.out.y;
        const bx = this.in.x;
        const by = this.in.y;
        const easing = bezier(ax, ay, bx, by);
        const newT = easing(time);
        return newT;
    }
    getCache() {
        if (this._cache.length === 0) {
            this.generateCache();
        }
        return this._cache;
    }
    isEqual(to) {
        if (to.type === exports.CurveType.Spring) {
            return false;
        }
        const valueToCompare = to;
        return (this.out.x === valueToCompare.out.x &&
            this.out.y === valueToCompare.out.y &&
            this.in.x === valueToCompare.in.x &&
            this.in.y === valueToCompare.in.y);
    }
    generateCache() {
        const range = R__namespace.range(0, GRAPH_DETAILS + 1).map((idx) => idx / GRAPH_DETAILS);
        const previewPoints = range.map((progress) => {
            const result = bezierInterpolation$1({
                t: progress,
                left: { x: 0, y: 0 },
                leftTangent: this.out,
                rightTangent: this.in,
                right: { x: 1, y: 1 },
            });
            return {
                progress: result.x,
                value: result.y,
            };
        });
        this._cache = previewPoints;
    }
}
const timingCurve = types.custom({
    name: 'Timing Curve',
    fromSnapshot: (snapshot) => new TimingCurve(snapshot),
    toSnapshot: (value) => ({
        out: {
            x: value.out.x,
            y: value.out.y,
        },
        in: {
            x: value.in.x,
            y: value.in.y,
        },
    }),
    isTargetType: (value) => value instanceof TimingCurve,
    getValidationMessage: (snapshot) => {
        if (snapshot.out == null || snapshot.in == null) {
            return '.out and .in are required params';
        }
        return '';
    },
});

const baseKeyframe = types
    .model('Base Keyframe', {
    id: types.optional(types.identifier, () => generateId()),
    time: types.number,
    type: types.optional(types.enumeration(Object.values(exports.ValueType)), exports.ValueType.Generic),
    /**
     * @description connected preset id
     */
    presetId: types.maybeNull(types.string),
    /**
     * @description connected timing curve style id
     */
    curveStyleId: types.maybeNull(types.string),
    /**
     * @description currently active curve type
     */
    activeCurveType: types.optional(types.enumeration(Object.values(exports.CurveType)), exports.CurveType.Timing),
    /**
     * @description spring curve values. If timingCurveStyleId applied then this value should be locked
     */
    springCurve: types.optional(springCurve, {
        stiffness: 100,
        damping: 10,
        mass: 1,
    }),
    /**
     * @description timing curve values. If timingCurveStyleId applied then this value should be locked
     */
    timingCurve: types.optional(timingCurve, {
        out: {
            x: 0.5,
            y: 0.35,
        },
        in: {
            x: 0.15,
            y: 1,
        },
    }),
    modelType: 'keyframe',
})
    .actions((self) => {
    const getProject = (model) => {
        const parent = getParent(model);
        // @ts-ignore
        if (parent.modelType === 'project') {
            return parent;
        }
        else {
            return getProject(parent);
        }
    };
    const getCurveStyle = () => {
        if (self.curveStyleId != null) {
            const project = getProject(self);
            const curveStyle = project.getCurveStyleById(self.curveStyleId);
            return curveStyle;
        }
        return undefined;
    };
    const getCurveStyleValue = () => {
        const curveStyle = getCurveStyle();
        if (curveStyle != null) {
            return curveStyle.value;
        }
        if (self.activeCurveType === exports.CurveType.Timing) {
            return self.timingCurve;
        }
        return self.springCurve;
    };
    return {
        updateTime: (time) => {
            // @NOTE: required to make sure we have correct type in runtime
            if (typeof time !== 'number') {
                self.time = 0;
                return self;
            }
            self.time = round(time, { fixed: 4 });
            return self;
        },
        attachToPreset: (presetId) => {
            self.presetId = presetId;
            return self;
        },
        clone: () => {
            const snapshot = getSnapshot(self);
            const snapshotWithNewId = R__namespace.assoc('id', generateId(), snapshot);
            return keyframe.create(snapshotWithNewId);
        },
        updateCurveType: (curveType) => {
            self.activeCurveType = curveType;
            return self;
        },
        updateSpringCurve: (payload) => {
            self.activeCurveType = exports.CurveType.Spring;
            if (payload.stiffness != null) {
                self.springCurve = springCurve.create({
                    stiffness: payload.stiffness,
                    damping: self.springCurve.damping,
                    mass: self.springCurve.mass,
                });
            }
            if (payload.damping != null) {
                self.springCurve = springCurve.create({
                    stiffness: self.springCurve.stiffness,
                    damping: payload.damping,
                    mass: self.springCurve.mass,
                });
            }
            if (payload.mass != null) {
                self.springCurve = springCurve.create({
                    stiffness: self.springCurve.stiffness,
                    damping: self.springCurve.damping,
                    mass: payload.mass,
                });
            }
            return self;
        },
        updateTimingCurve: (payload) => {
            self.activeCurveType = exports.CurveType.Timing;
            if (payload.out != null) {
                self.timingCurve = timingCurve.create({
                    out: payload.out,
                    in: self.timingCurve.in,
                });
            }
            if (payload.in != null) {
                self.timingCurve = timingCurve.create({
                    out: self.timingCurve.out,
                    in: payload.in,
                });
            }
            return self;
        },
        updateCurveStyleId: (payload) => {
            self.activeCurveType = payload.type;
            self.curveStyleId = payload.curveStyleId;
            return self;
        },
        // @TODO: refactor and move logic to common place
        attachCurveStyle: (curveStyle) => {
            self.curveStyleId = curveStyle.id;
            if (curveStyle.type === exports.CurveType.Timing) {
                self.activeCurveType = exports.CurveType.Timing;
                if (curveStyle.value.out != null) {
                    self.timingCurve = timingCurve.create({
                        out: curveStyle.value.out,
                        in: self.timingCurve.in,
                    });
                }
                if (curveStyle.value.in != null) {
                    self.timingCurve = timingCurve.create({
                        out: self.timingCurve.out,
                        in: curveStyle.value.in,
                    });
                }
                return self;
            }
            if (curveStyle.type === exports.CurveType.Spring) {
                self.activeCurveType = exports.CurveType.Spring;
                if (curveStyle.value.stiffness != null) {
                    self.springCurve = springCurve.create({
                        stiffness: curveStyle.value.stiffness,
                        damping: self.springCurve.damping,
                        mass: self.springCurve.mass,
                    });
                }
                if (curveStyle.value.damping != null) {
                    self.springCurve = springCurve.create({
                        stiffness: self.springCurve.stiffness,
                        damping: curveStyle.value.damping,
                        mass: self.springCurve.mass,
                    });
                }
                if (curveStyle.value.mass != null) {
                    self.springCurve = springCurve.create({
                        stiffness: self.springCurve.stiffness,
                        damping: self.springCurve.damping,
                        mass: curveStyle.value.mass,
                    });
                }
                return self;
            }
            return self;
        },
        detachCurveStyle: () => {
            const curveStyle = getCurveStyle();
            const value = getCurveStyleValue();
            if (curveStyle.type === exports.CurveType.Timing) {
                self.activeCurveType = exports.CurveType.Timing;
                self.timingCurve = value;
            }
            else {
                self.activeCurveType = exports.CurveType.Spring;
                self.springCurve = value;
            }
            self.curveStyleId = null;
            return value;
        },
        copyCurveStyleFrom: (keyframe) => {
            self.activeCurveType = keyframe.activeCurveType;
            self.springCurve = keyframe.springCurve;
            self.timingCurve = keyframe.timingCurve;
            self.curveStyleId = keyframe.curveStyleId ?? null;
            return self;
        },
    };
})
    .views((self) => {
    const getProject = (model) => {
        const parent = getParent(model);
        // @ts-ignore
        if (parent.modelType === 'project') {
            return parent;
        }
        else {
            return getProject(parent);
        }
    };
    const getNode = (model) => {
        const parent = getParent(model);
        // @ts-ignore
        if (parent.modelType === 'node') {
            return parent;
        }
        else {
            return getNode(parent);
        }
    };
    const getProperty = (model) => {
        const parent = getParent(model);
        // @ts-ignore
        if (parent.modelType === 'property') {
            return parent;
        }
        else {
            return getProperty(parent);
        }
    };
    const getCurveStyle = () => {
        if (self.curveStyleId != null) {
            const project = getProject(self);
            const curveStyle = project.getCurveStyleById(self.curveStyleId);
            return curveStyle;
        }
        return undefined;
    };
    return {
        getNode: () => getNode(self),
        getProperty: () => getProperty(self),
        getPath: () => {
            const property = getProperty(self);
            const node = getNode(self);
            return `${node.id}/${property.id}/${self.id}`;
        },
        hasAppliedCurveStyle: () => getCurveStyle() != null,
        getCurveStyleType: () => {
            const activeStyle = getCurveStyle();
            if (activeStyle == null) {
                return self.activeCurveType;
            }
            return getCurveStyle().type;
        },
        getCurveStyle,
        getCurveStyleValue: () => {
            const curveStyle = getCurveStyle();
            if (curveStyle != null) {
                return curveStyle.value;
            }
            if (self.activeCurveType === exports.CurveType.Timing) {
                return self.timingCurve;
            }
            return self.springCurve;
        },
    };
});

const numberKeyframe = baseKeyframe
    .named('Number Keyframe')
    .props({
    type: exports.ValueType.Number,
    value: types.number,
})
    .actions((self) => ({
    updateValue: (value) => {
        self.value = round(value);
    },
}))
    .views((self) => ({
    isEqual: (keyframe) => {
        return (round(self.value, { fixed: 2 }) === round(keyframe.value, { fixed: 2 }));
    },
}));

const point1dKeyframe = baseKeyframe
    .named('Point 1D Keyframe')
    .props({
    type: exports.ValueType.Point1D,
    value: point1d,
})
    .actions((self) => ({
    updateValue: (value) => {
        self.value = {
            x: round(value.x),
        };
    },
}))
    .views((self) => ({
    isEqual: (keyframe) => {
        return (round(self.value.x, { fixed: 2 }) ===
            round(keyframe.value.x, { fixed: 2 }));
    },
}));

const point2dKeyframe = baseKeyframe
    .named('Point 2D Keyframe')
    .props({
    type: exports.ValueType.Point2D,
    value: point2d,
})
    .actions((self) => ({
    updateValue: (value) => {
        if (value.x != null) {
            self.value = {
                x: round(value.x),
                y: self.value.y,
            };
        }
        if (value.y != null) {
            self.value = {
                x: self.value.x,
                y: round(value.y),
            };
        }
    },
}))
    .views((self) => ({
    isEqual: (keyframe) => {
        const pairsToCompare = [
            [self.value.x, keyframe.value.x],
            [self.value.y, keyframe.value.y],
        ];
        return R__namespace.all(([left, right]) => round(left, { fixed: 2 }) === round(right, { fixed: 2 }), pairsToCompare);
    },
}));

const rgbaKeyframe = baseKeyframe
    .named('RGBA Keyframe')
    .props({
    type: exports.ValueType.RGBA,
    value: rgba,
})
    .actions((self) => ({
    updateValue: (value) => {
        if (value.r != null) {
            self.value = {
                r: round(value.r, { fixed: 0 }),
                g: self.value.g,
                b: self.value.b,
                a: self.value.a,
            };
        }
        if (value.g != null) {
            self.value = {
                r: self.value.r,
                g: round(value.g, { fixed: 0 }),
                b: self.value.b,
                a: self.value.a,
            };
        }
        if (value.b != null) {
            self.value = {
                r: self.value.r,
                g: self.value.g,
                b: round(value.b, { fixed: 0 }),
                a: self.value.a,
            };
        }
        if (value.a != null) {
            self.value = {
                r: self.value.r,
                g: self.value.g,
                b: self.value.b,
                a: round(value.a),
            };
        }
    },
}))
    .views((self) => ({
    isEqual: (keyframe) => {
        const pairsToCompare = [
            [self.value.r, keyframe.value.r],
            [self.value.g, keyframe.value.g],
            [self.value.b, keyframe.value.b],
            [self.value.a, keyframe.value.a],
        ];
        return R__namespace.all(([left, right]) => round(left, { fixed: 2 }) === round(right, { fixed: 2 }), pairsToCompare);
    },
}));

const spatialPoint2dKeyframe = baseKeyframe
    .named('Spatial Point 2D Keyframe')
    .props({
    type: exports.ValueType.SpatialPoint2D,
    value: spatialPoint2d,
})
    .actions((self) => ({
    updateValue: (value) => {
        const newX = round(value.x);
        const newY = round(value.y);
        const offsetX = newX - self.value.x;
        const offsetY = newY - self.value.y;
        self.value = {
            x: newX,
            y: newY,
            tx1: self.value.tx1 + offsetX,
            tx2: self.value.tx2 + offsetX,
            ty1: self.value.ty1 + offsetY,
            ty2: self.value.ty2 + offsetY,
        };
    },
    updateTangents: (value) => {
        self.value = {
            x: self.value.x,
            y: self.value.y,
            tx1: value.tx1 == null ? self.value.tx1 : round(value.tx1),
            tx2: value.tx2 == null ? self.value.tx2 : round(value.tx2),
            ty1: value.ty1 == null ? self.value.ty1 : round(value.ty1),
            ty2: value.ty2 == null ? self.value.ty2 : round(value.ty2),
        };
    },
}))
    .views((self) => ({
    isEqual: (keyframe) => {
        const pairsToCompare = [
            [self.value.x, keyframe.value.x],
            [self.value.y, keyframe.value.y],
            [self.value.tx1, keyframe.value.tx1],
            [self.value.tx2, keyframe.value.tx2],
            [self.value.ty1, keyframe.value.ty1],
            [self.value.ty2, keyframe.value.ty2],
        ];
        return R__namespace.all(([left, right]) => round(left, { fixed: 2 }) === round(right, { fixed: 2 }), pairsToCompare);
    },
}));

const keyframe = types.custom({
    name: 'Keyframe',
    fromSnapshot: (snapshot) => {
        if (snapshot.type === exports.ValueType.Number) {
            const snapshotToApply = snapshot;
            return numberKeyframe.create(snapshotToApply);
        }
        if (snapshot.type === exports.ValueType.Point1D) {
            const snapshotToApply = snapshot;
            return point1dKeyframe.create(snapshotToApply);
        }
        if (snapshot.type === exports.ValueType.Point2D) {
            const snapshotToApply = snapshot;
            return point2dKeyframe.create(snapshotToApply);
        }
        if (snapshot.type === exports.ValueType.RGBA) {
            const snapshotToApply = snapshot;
            return rgbaKeyframe.create(snapshotToApply);
        }
        if (snapshot.type === exports.ValueType.SpatialPoint2D) {
            const snapshotToApply = snapshot;
            return spatialPoint2dKeyframe.create(snapshotToApply);
        }
        throw new TypeError(`Type: ${snapshot.type} is not supporting yet`);
    },
    toSnapshot: (value) => getSnapshot(value),
    isTargetType: (value) => false,
    getValidationMessage: (snapshot) => '',
});

const matrixTransformKeyframe = baseKeyframe
    .named('Matrix Transform Keyframe')
    .props({
    type: exports.ValueType.MatrixTransform,
    value: matrixTransform,
})
    .actions((self) => ({
    updateValue: (value) => {
        self.value = value;
    },
}))
    .views((self) => ({
    isEqual: (keyframe) => {
        return R__namespace.equals(self.value, keyframe.value);
    },
}));

const visibleOnTimeline = types
    .model('Visible on Timeline', {
    visibilityOnTimeline: types.optional(types.enumeration(Object.values(exports.VisibilityType)), exports.VisibilityType.Hidden),
})
    .actions((self) => {
    return {
        showOnTimeline: () => {
            self.visibilityOnTimeline = exports.VisibilityType.Visible;
        },
        hideOnTimeline: () => {
            self.visibilityOnTimeline = exports.VisibilityType.Hidden;
        },
        updateVisibleOnTimelineStructure: (model, options) => {
            self.visibilityOnTimeline = model.visibilityOnTimeline;
        },
    };
})
    .views((self) => ({
    get visibleOnTimeline() {
        return self.visibilityOnTimeline === exports.VisibilityType.Visible;
    },
}));

const shouldUseCache = (node) => {
    const hasBgBlur = node.effects.children.find((effect) => effect.type === exports.PropertyGroupType.BackgroundBlur) != null;
    return hasBgBlur === false && node.hasAnimation === false;
};
const baseNodeProperties = types
    .model('Base Node Properties', {
    id: types.optional(types.identifier, () => generateId()),
    name: 'Untitled',
    modelType: 'node',
    _version: types.optional(types.number, 0),
})
    .actions((self) => {
    const bumpParentsVersion = (node) => {
        const parent = node.getParent();
        if (parent == null) {
            return;
        }
        if (shouldUseCache(parent) === false) {
            return;
        }
        parent.bumpVersion();
        bumpParentsVersion(parent);
    };
    /**
     * @param payload.triggeredFromParent when true then version of parents are not bumped.
     * Usually used when toggling visibility/lock/colors on parents
     */
    const bumpVersion = (payload) => {
        if (bumpVersions.value === false) {
            return self;
        }
        const triggeredFromParent = payload?.triggeredFromParent ?? false;
        self._version += 1;
        if (triggeredFromParent === false) {
            // @ts-ignore
            bumpParentsVersion(self);
        }
        return self;
    };
    return {
        delete: () => {
            // @TODO: provide correct type
            const parent = getParent(getParent(self));
            parent.removeChild(self.id);
            return self;
        },
        updateName: (name) => {
            self.name = name;
            return self;
        },
        updateBaseStructure: (model, options) => {
            self.name = model.name;
            bumpVersion();
            return self;
        },
        reloadBaseKeyframeIds: () => { },
        bumpVersion,
        // @ts-ignore
        bumpParentsVersion: () => bumpParentsVersion(self),
    };
})
    .views((self) => {
    /**
     * @description return array of animated properties
     */
    const getAnimatedProperties = (payload) => {
        const ignoreChildren = payload?.ignoreChildren ?? false;
        const animatedProperties = [];
        const stack = [self];
        const propertiesStack = [];
        while (stack.length > 0) {
            const node = stack.pop();
            if (node == null) {
                break;
            }
            const requiredProperties = R__namespace.values(node);
            propertiesStack.push(...requiredProperties);
            while (propertiesStack.length > 0) {
                const property = propertiesStack.pop();
                // @NOTE: guard from not existing properties
                if (property == null) {
                    continue;
                }
                const length = property._keyframes?.size || 0;
                if (property.modelType === 'property') {
                    if (length === 0) {
                        continue;
                    }
                    animatedProperties.push(property);
                }
                if (property.modelType === 'property-group-set') {
                    property.children.forEach((child) => {
                        const requiredChildrenProperties = Object.values(child);
                        propertiesStack.push(...requiredChildrenProperties);
                    });
                }
            }
            // @ts-ignore
            if (ignoreChildren === false && node.children) {
                // @ts-ignore
                stack.push(...node.children);
            }
        }
        return animatedProperties;
    };
    /**
     * @description return array of animated properties
     */
    const getPropertiesByType = (type) => {
        const foundProperties = [];
        const stack = [self];
        const propertiesStack = [];
        while (stack.length > 0) {
            const node = stack.pop();
            if (node == null) {
                break;
            }
            const requiredProperties = R__namespace.values(node);
            propertiesStack.push(...requiredProperties);
            while (propertiesStack.length > 0) {
                const property = propertiesStack.pop();
                // @NOTE: guard from not existing properties
                if (property == null) {
                    continue;
                }
                if (property.modelType === 'property' && property.type === type) {
                    foundProperties.push(property);
                }
                if (property.modelType === 'property-group-set') {
                    property.children.forEach((child) => {
                        const requiredChildrenProperties = Object.values(child);
                        propertiesStack.push(...requiredChildrenProperties);
                    });
                }
            }
        }
        return foundProperties;
    };
    const getProject = (model) => {
        return getRoot(model);
    };
    // @NOTE: have to use double getParent here because first one returns array of parent.children
    const getParentFn = () => {
        try {
            return getParent(getParent(self));
        }
        catch (err) {
            return null;
        }
    };
    /**
     * @description calculate depth level for current node
     */
    const getDepthLevel = (_node, acc = 0) => {
        const parent = _node.getParent();
        if (parent == null) {
            return acc;
        }
        return getDepthLevel(parent, acc + 1);
    };
    return {
        getProject: () => getProject(self),
        /**
         * @deprecated use .getParent instead
         */
        get parent() {
            return getParentFn();
        },
        getParent: getParentFn,
        get depthLevel() {
            return getDepthLevel(self);
        },
        get zIndex() {
            const flattenNodes = getProject(self).getFlattenNodes();
            return flattenNodes.map((n) => n.id).indexOf(self.id);
        },
        get isRoot() {
            return getParentFn() == null;
        },
        getAnimatedProperties,
        getGroupOfSegments() {
            const animatedProperties = getAnimatedProperties();
            const sortedKeyframesByProperties = animatedProperties.flatMap((property) => property.keyframes);
            const sortedKeyframesByTime = R__namespace.sort((left, right) => left.time - right.time, sortedKeyframesByProperties);
            const currentGroupsOfSegmentsTime = (() => {
                // 1. get sorted segments
                const segments = R__namespace.pipe(R__namespace.aperture(2), 
                // @ts-ignore
                R__namespace.filter(([left, right]) => isSegment(left, right)), 
                // @ts-ignore
                R__namespace.uniqBy(([left, right]) => `${left.time}-${right.time}`), 
                // @ts-ignore
                R__namespace.sort(([leftLeft], [leftRight]) => leftLeft.time - leftRight.time))(sortedKeyframesByProperties);
                if (segments.length === 0) {
                    return [];
                }
                // @ts-ignore
                if (self.isRoot) {
                    if (sortedKeyframesByProperties.length < 2) {
                        return [];
                    }
                    return [
                        [
                            R__namespace.head(sortedKeyframesByTime).time,
                            R__namespace.last(sortedKeyframesByTime).time,
                        ],
                    ];
                }
                // 2. find intersected times
                let startIdx = 0;
                let endIdx = 1;
                let startTime = segments[startIdx][0].time;
                let endTime = segments[startIdx][1].time;
                let currentIntersectedSegmentsByTime = [];
                while (startIdx < segments.length) {
                    const nextSegment = segments[endIdx];
                    if (nextSegment == null) {
                        currentIntersectedSegmentsByTime.push([startTime, endTime]);
                        break;
                    }
                    const isIntersected = nextSegment[0].time <= endTime;
                    if (isIntersected) {
                        endTime = R__namespace.max(endTime, nextSegment[1].time);
                        endIdx += 1;
                        continue;
                    }
                    currentIntersectedSegmentsByTime.push([startTime, endTime]);
                    startIdx = endIdx;
                    endIdx = startIdx + 1;
                    startTime = segments[startIdx][0].time;
                    endTime = segments[startIdx][1].time;
                }
                return currentIntersectedSegmentsByTime;
            })();
            const preparedGroupOfSegments = currentGroupsOfSegmentsTime.map((groupOfSegments) => ({
                keyframes: sortedKeyframesByTime.filter((keyframe) => keyframe.time >= groupOfSegments[0] &&
                    keyframe.time <= groupOfSegments[1]),
                start: groupOfSegments[0],
                end: groupOfSegments[1],
            }));
            return preparedGroupOfSegments;
        },
        getPropertiesByType,
        /**
         * @description true when any of children has animation too
         */
        get hasAnimation() {
            return getAnimatedProperties().length > 0;
        },
        /**
         * @description true only when current node has animation
         */
        get hasOwnAnimation() {
            return getAnimatedProperties({ ignoreChildren: true }).length > 0;
        },
        hasAnimationAtTime(time) {
            const animatedProperties = getAnimatedProperties();
            if (animatedProperties.length === 0) {
                return false;
            }
            const keyframesByProperty = animatedProperties.map((property) => property.keyframes());
            const numberOfProperties = keyframesByProperty.length;
            for (let i = 0; i < numberOfProperties; i += 1) {
                const keyframes = keyframesByProperty[i];
                if (keyframes.length === 1) {
                    continue;
                }
                const first = R__namespace.head(keyframes);
                const last = R__namespace.last(keyframes);
                if (first.time <= time && time <= last.time) {
                    return true;
                }
            }
            return false;
        },
        get version() {
            // @ts-ignore
            return self._version + (getParentFn()?.version ?? 0);
        },
        get shouldUseCache() {
            return shouldUseCache(self);
        },
    };
});

function getValuePoint2D(payload) {
    const { t, segment } = payload;
    const progress = getProgress({ t, segment });
    const leftKeyframe = segment[0];
    const rightKeyframe = segment[1];
    const x = lerp(progress, leftKeyframe.value.x, rightKeyframe.value.x);
    const y = lerp(progress, leftKeyframe.value.y, rightKeyframe.value.y);
    return { x: round(x), y: round(y) };
}

function getValueMatrixTransform(payload) {
    const { t, segment } = payload;
    const progress = getProgress({ t, segment });
    const leftKeyframe = segment[0];
    const rightKeyframe = segment[1];
    const newMatrix = [
        [
            lerp(progress, leftKeyframe.value[0][0], rightKeyframe.value[0][0]),
            lerp(progress, leftKeyframe.value[0][1], rightKeyframe.value[0][1]),
            lerp(progress, leftKeyframe.value[0][2], rightKeyframe.value[0][2]),
        ],
        [
            lerp(progress, leftKeyframe.value[1][0], rightKeyframe.value[1][0]),
            lerp(progress, leftKeyframe.value[1][1], rightKeyframe.value[1][1]),
            lerp(progress, leftKeyframe.value[1][2], rightKeyframe.value[1][2]),
        ],
    ];
    const roundedMatrix = [
        [round(newMatrix[0][0]), round(newMatrix[0][1]), round(newMatrix[0][2])],
        [round(newMatrix[1][0]), round(newMatrix[1][1]), round(newMatrix[1][2])],
    ];
    return roundedMatrix;
}

function getValueNumber(payload) {
    const { t, segment } = payload;
    const progress = getProgress({ t, segment });
    const [leftKeyframe, rightKeyframe] = segment;
    const x = lerp(progress, leftKeyframe.value, rightKeyframe.value);
    return round(x, { fixed: 4 });
}

function getValuePoint1D(payload) {
    const { t, segment } = payload;
    const progress = getProgress({ t, segment });
    const leftKeyframe = segment[0];
    const rightKeyframe = segment[1];
    const x = lerp(progress, leftKeyframe.value.x, rightKeyframe.value.x);
    return { x: round(x, { fixed: 2 }) };
}

function getValueRgba(payload) {
    const { t, segment } = payload;
    const progress = getProgress({ t, segment });
    const leftKeyframe = segment[0];
    const rightKeyframe = segment[1];
    const r = lerp(progress, leftKeyframe.value.r, rightKeyframe.value.r);
    const g = lerp(progress, leftKeyframe.value.g, rightKeyframe.value.g);
    const b = lerp(progress, leftKeyframe.value.b, rightKeyframe.value.b);
    const a = lerp(progress, leftKeyframe.value.a, rightKeyframe.value.a);
    return {
        r: round(r, { fixed: 0 }),
        g: round(g, { fixed: 0 }),
        b: round(b, { fixed: 0 }),
        a: round(a),
    };
}

function getValue(payload) {
    const { segment: [firstKeyframe], } = payload;
    if (firstKeyframe.type === exports.ValueType.Number) {
        return getValueNumber(payload);
    }
    if (firstKeyframe.type === exports.ValueType.MatrixTransform) {
        return getValueMatrixTransform(payload);
    }
    if (firstKeyframe.type === exports.ValueType.Point1D) {
        return getValuePoint1D(payload);
    }
    if (firstKeyframe.type === exports.ValueType.Point2D) {
        return getValuePoint2D(payload);
    }
    if (firstKeyframe.type === exports.ValueType.RGBA) {
        return getValueRgba(payload);
    }
    if (firstKeyframe.type === exports.ValueType.SpatialPoint2D) {
        return getValueSpatialPoint2D(payload);
    }
    throw new Error(`Value with type "${firstKeyframe.type}" not supporting yet`);
}

function mapSpringKeyframesToTimingCurve(payload) {
    const { segment: [left, right], } = payload;
    let newKeyframes = [];
    const items = left.getCurveStyleValue().getCache();
    newKeyframes.push(keyframe.create({
        type: left.type,
        time: left.time,
        activeCurveType: exports.CurveType.Timing,
        timingCurve: {
            out: {
                x: 0.33,
                y: 0,
            },
            in: {
                x: 0.67,
                y: 1,
            },
        },
        value: left.value,
    }));
    for (let i = 2; i < items.length; i += 1) {
        const leftItem = items[i - 2];
        const middleItem = items[i - 1];
        const rightItem = items[i];
        // x - x
        // - x -
        const bounceFromBottom = leftItem.value >= middleItem.value && middleItem.value <= rightItem.value;
        // - x -
        // x - x
        const bounceFromTop = leftItem.value <= middleItem.value && middleItem.value >= rightItem.value;
        const shouldChangeDirection = bounceFromTop || bounceFromBottom;
        if (shouldChangeDirection === false) {
            continue;
        }
        const time = lerp(middleItem.progress, left.time, right.time);
        const value = getValue({ t: time, segment: [left, right] });
        newKeyframes.push(keyframe.create({
            type: left.type,
            time,
            activeCurveType: exports.CurveType.Timing,
            timingCurve: {
                out: {
                    x: 0.33,
                    y: 0,
                },
                in: {
                    x: 0.67,
                    y: 1,
                },
            },
            value,
        }));
    }
    const shouldSplit = newKeyframes.length === 1;
    if (shouldSplit) {
        for (let i = 0; i < items.length; i += 10) {
            const item = items[i];
            const time = lerp(item.progress, left.time, right.time);
            const value = getValue({ t: time, segment: [left, right] });
            newKeyframes.push(keyframe.create({
                type: left.type,
                time,
                activeCurveType: exports.CurveType.Timing,
                timingCurve: {
                    out: {
                        x: 0,
                        y: 0,
                    },
                    in: {
                        x: 1,
                        y: 1,
                    },
                },
                value,
            }));
        }
    }
    newKeyframes.push(keyframe.create({
        type: right.type,
        time: right.time,
        activeCurveType: exports.CurveType.Timing,
        timingCurve: {
            out: {
                x: 0.33,
                y: 0,
            },
            in: {
                x: 0.67,
                y: 1,
            },
        },
        value: right.value,
    }));
    return newKeyframes;
}

const base$1 = types
    .model('Static Property', {
    id: types.optional(types.identifier, () => generateId()),
    type: types.optional(types.enumeration(Object.values(exports.PropertyType)), exports.PropertyType.Generic),
    valueType: types.optional(types.enumeration(Object.values(exports.ValueType)), exports.ValueType.Generic),
    modelType: 'property',
})
    .views((self) => {
    const getNode = (model) => {
        const parent = getParent(model);
        // @ts-ignore
        if (parent.modelType === 'node') {
            return parent;
        }
        return getNode(parent);
    };
    const getPropertyGroup = (model) => {
        const parent = getParent(model);
        // @ts-ignore
        if (parent.isRoot) {
            return null;
        }
        // @ts-ignore
        if (parent.modelType === 'property-group') {
            return parent;
        }
        return getPropertyGroup(parent);
    };
    return {
        getNode: () => getNode(self),
        get hasAnimation() {
            return false;
        },
        getPropertyGroup: () => getPropertyGroup(self),
    };
})
    .actions((self) => ({
    /**
     * @description bump version of the current node
     */
    updateNodeVersion: () => {
        self.getNode().bumpVersion();
    },
}));
const staticProperty = types.compose(visibleOnTimeline, base$1);

/**
 * Converts the provided array of keyframes into keyframes of a curve with explicit timing.
 * It includes a segment-only check, so we can safely pass any array.
 */
function getTimingCurveKeyframes(keyframes) {
    const byTwos = R__namespace.aperture(2, keyframes);
    const segmentsOnly = byTwos.filter(([left, right]) => isSegment(left, right));
    // @NOTE: required in cases when we have no segments but it has multiple keyframes.
    // Usually it is not valid state.
    if (segmentsOnly.length === 0 && keyframes.length === 1) {
        return keyframes;
    }
    const mappedSegments = segmentsOnly.map(([left, right]) => {
        if (left.activeCurveType === exports.CurveType.Timing) {
            return [left, right];
        }
        return mapSpringKeyframesToTimingCurve({ segment: [left, right] });
    });
    const flattenKeyframes = R__namespace.flatten(mappedSegments);
    return R__namespace.uniqBy(R__namespace.prop('time'), flattenKeyframes);
}
const animatableProperty = staticProperty
    .props({
    _keyframes: types.map(keyframe),
})
    .views((self) => ({
    /**
     * @description return sorted keyframes
     */
    get keyframes() {
        const keyframes = Array.from(self._keyframes.values());
        return R__namespace.sort((left, right) => left.time - right.time, keyframes);
    },
}))
    .actions((self) => {
    return {
        createKeyframe: (time) => {
            const keyframe$1 = keyframe.create({
                time,
                // @ts-ignore
                value: self.getValue(time),
                type: self.valueType,
            });
            self._keyframes.set(keyframe$1.id, keyframe$1);
            self.getNode().bumpVersion();
            return keyframe$1;
        },
        addKeyframe: (keyframe) => {
            if (keyframe.type !== self.valueType) {
                throw new TypeError(`[Property] You are trying to add keyframe of wrong type (Keyframe of type "${keyframe.type}" into property of type "${self.valueType}")`);
            }
            // @NOTE: remove keyframes at current time so we don't have 2 keyframes at the same time
            // @ts-ignore
            const keyframes = self.keyframes;
            const keyframeAtTime = keyframes.find((_keyframe) => _keyframe.time === keyframe.time);
            if (keyframeAtTime != null) {
                self._keyframes.delete(keyframeAtTime.id);
            }
            self._keyframes.set(keyframe.id, keyframe);
            self.getNode().bumpVersion();
        },
        removeKeyframe: (keyframeId) => {
            self._keyframes.delete(keyframeId);
            self.getNode().bumpVersion();
        },
        /**
         * @description remove all keyframes
         */
        removeAllKeyframes: () => {
            self._keyframes.clear();
            self.getNode().bumpVersion();
        },
        shiftOnTimeline: (delta) => {
            self._keyframes.forEach((keyframe) => {
                keyframe.time += delta;
            });
            self.getNode().bumpVersion();
        },
        /**
         * @description remove duplicated keyframes by time
         */
        cleanupKeyframes: () => {
            const uniqKeyframes = {};
            const duplicatedKeyframeIds = [];
            self._keyframes.forEach((keyframe) => {
                if (uniqKeyframes[keyframe.time]) {
                    uniqKeyframes[keyframe.time].push(keyframe.id);
                    return;
                }
                uniqKeyframes[keyframe.time] = [keyframe.id];
            });
            self._keyframes.forEach((keyframe) => {
                if (uniqKeyframes[keyframe.time].length > 1) {
                    duplicatedKeyframeIds.push(...R__namespace.dropLast(1, uniqKeyframes[keyframe.time]));
                }
            });
            duplicatedKeyframeIds.forEach((keyframeId) => {
                self._keyframes.delete(keyframeId);
            });
            self.getNode().bumpVersion();
            return self;
        },
        /**
         * @description bump version of the current node
         */
        updateNodeVersion: () => {
            self.getNode().bumpVersion();
        },
    };
})
    .views((self) => ({
    /**
     * @description receive array of keyframes and return closest 2 for provided time
     * @example
     * xX – keys, o – current time
     * 1. -o--x1----x2----x3---- -> return [x1, x1]
     * 2. ----x1----x2-o--x3---- -> return [x2, x3]
     * 3. ----x1-o--x2----x3---- -> return [x1, x2]
     * 4. ----x1----x2----x3-o-- -> return [x3, x3]
     */
    getClosestSegment: (time) => {
        const length = self._keyframes.size;
        const hasNoKeyframes = length === 0;
        // console.log(self._keyframes, Object.keys(self._keyframes), self.keyframes)
        // console.log('!!', length, self.keyframes.length)
        if (hasNoKeyframes) {
            throw new TypeError('getClosestSegment require at least 1 provided keyframe');
        }
        // @ts-ignore
        const keyframes = self.keyframes;
        const isOneKeyframe = length === 1;
        const isBeforeFirst = time < keyframes[0].time;
        const isFirst = time === keyframes[0].time;
        const isLast = time === keyframes[length - 1].time;
        const isAfterLast = time > keyframes[length - 1].time;
        if (isOneKeyframe) {
            const leftKey = keyframes[0];
            const rightKey = keyframes[0];
            return [leftKey, rightKey];
        }
        if (isBeforeFirst) {
            const leftKey = keyframes[0];
            const rightKey = keyframes[0];
            return [leftKey, rightKey];
        }
        if (isFirst) {
            const leftKey = keyframes[0];
            const rightKey = keyframes[1];
            return [leftKey, rightKey];
        }
        if (isLast) {
            const leftKey = keyframes[keyframes.length - 1];
            const rightKey = keyframes[keyframes.length - 1];
            return [leftKey, rightKey];
        }
        if (isAfterLast) {
            const leftKey = keyframes[keyframes.length - 1];
            const rightKey = keyframes[keyframes.length - 1];
            return [leftKey, rightKey];
        }
        let leftKey;
        let rightKey;
        for (let i = 0; i < length - 1; i += 1) {
            const currentKey = keyframes[i];
            const nextKey = keyframes[i + 1];
            if (currentKey.time <= time && nextKey.time > time) {
                leftKey = currentKey;
                rightKey = nextKey;
                break;
            }
        }
        return [
            // @ts-ignore
            leftKey,
            // @ts-ignore
            rightKey,
        ];
    },
    getKeyframesType(time) {
        // @ts-ignore
        const keyframes = self.keyframes;
        const hasKeyframeAtTime = keyframes.find((keyframe) => keyframe.time === time) != null;
        const hasKeyframes = keyframes.length > 0;
        if (hasKeyframeAtTime) {
            return exports.PropertyKeyframesType.Active;
        }
        if (hasKeyframes) {
            return exports.PropertyKeyframesType.HasKeyframes;
        }
        return exports.PropertyKeyframesType.Empty;
    },
    get hasAnimation() {
        return self._keyframes.size > 0;
    },
    get visibleOnTimeline() {
        return (self.visibilityOnTimeline === exports.VisibilityType.Visible &&
            self._keyframes.size > 0);
    },
    /**
     * @description convert all existing keyframes to timing curve
     */
    getTimingCurveKeyframes: () => {
        // @ts-ignore
        return getTimingCurveKeyframes(self.keyframes);
    },
    isCleanupAvailable: () => {
        const uniqKeyframes = {};
        const duplicatedKeyframeIds = [];
        self._keyframes.forEach((keyframe) => {
            if (uniqKeyframes[keyframe.time]) {
                uniqKeyframes[keyframe.time].push(keyframe.id);
                return;
            }
            uniqKeyframes[keyframe.time] = [keyframe.id];
        });
        self._keyframes.forEach((keyframe) => {
            if (uniqKeyframes[keyframe.time].length > 1) {
                duplicatedKeyframeIds.push(...R__namespace.dropLast(1, uniqKeyframes[keyframe.time]));
            }
        });
        return duplicatedKeyframeIds.length > 0;
    },
}));

const point2dProperty = animatableProperty
    .props({
    valueType: exports.ValueType.Point2D,
    value: types.optional(point2d, point2d.create({
        x: 0,
        y: 0,
    })),
    _keyframes: types.map(point2dKeyframe),
})
    .actions((self) => ({
    updateValue: (time, value) => {
        self.updateNodeVersion();
        const keyframes = self.keyframes;
        const length = keyframes.length;
        const newValue = {
            x: round(value.x),
            y: round(value.y),
        };
        if (time < 0 || length === 0) {
            self.value = point2d.create(newValue);
            return;
        }
        const currentKeyframeIdx = keyframes.findIndex((_keyframe) => _keyframe.time === time);
        const currentKeyframe = keyframes[currentKeyframeIdx];
        const shouldUpdateKeyframe = currentKeyframe != null;
        const shouldAddKeyframe = shouldUpdateKeyframe === false && length !== 0;
        if (shouldAddKeyframe) {
            self.addKeyframe(point2dKeyframe.create({
                time,
                value: newValue,
            }));
            return;
        }
        if (shouldUpdateKeyframe) {
            // @TODO: add correct type here
            // @ts-ignore
            currentKeyframe.updateValue(newValue);
            return;
        }
    },
}))
    .views((self) => ({
    getValue: (t) => {
        const keyframes = self.keyframes;
        const length = keyframes.length;
        if (length === 0) {
            return self.value;
        }
        if (length === 1) {
            // @TODO: add correct type here
            // @ts-ignore
            return keyframes[0].value;
        }
        const segment = self.getClosestSegment(t);
        return getValuePoint2D({ t, segment });
    },
    equals: (right) => {
        return self.value.x === right.value.x && self.value.y === right.value.y;
    },
}));

const anchorPoint = point2dProperty
    .named('Anchor Point')
    .props({
    type: exports.PropertyType.AnchorPoint,
});

const numberProperty = animatableProperty
    .props({
    valueType: exports.ValueType.Number,
    value: types.optional(types.number, 0),
    _keyframes: types.map(numberKeyframe),
    min: types.maybeNull(types.number),
    max: types.maybeNull(types.number),
})
    .postProcessSnapshot((snapshot) => ({
    valueType: snapshot.valueType,
    value: snapshot.value,
    _keyframes: snapshot._keyframes,
}))
    .actions((self) => ({
    updateValue: (time, value) => {
        self.updateNodeVersion();
        const keyframes = self.keyframes;
        const length = keyframes.length;
        const newValue = (() => {
            const currentNewValue = round(value);
            const clampedMin = self.min != null ? R__namespace.max(self.min, currentNewValue) : currentNewValue;
            const clampedMax = self.max != null ? R__namespace.min(self.max, clampedMin) : clampedMin;
            return clampedMax;
        })();
        if (time < 0 || length === 0) {
            self.value = newValue;
            return;
        }
        const currentKeyframeIdx = keyframes.findIndex((_keyframe) => _keyframe.time === time);
        const currentKeyframe = keyframes[currentKeyframeIdx];
        const shouldUpdateKeyframe = currentKeyframe != null;
        const shouldAddKeyframe = shouldUpdateKeyframe === false && length !== 0;
        if (shouldAddKeyframe) {
            self.addKeyframe(numberKeyframe.create({
                time,
                value: newValue,
            }));
            return;
        }
        if (shouldUpdateKeyframe) {
            // @TODO: add correct type here
            // @ts-ignore
            currentKeyframe.updateValue(newValue);
            return;
        }
    },
}))
    .views((self) => ({
    getValue: (t) => {
        const keyframes = self.keyframes;
        const length = keyframes.length;
        if (length === 0) {
            return self.value;
        }
        if (length === 1) {
            // @TODO: add correct type here
            // @ts-ignore
            return keyframes[0].value;
        }
        const segment = self.getClosestSegment(t);
        return getValueNumber({ t, segment });
    },
    equals: (right) => {
        return self.value === right.value;
    },
}));

const angle = numberProperty.named('Angle').props({
    type: exports.PropertyType.Angle,
    value: types.optional(types.number, 0),
});

const blendMode = staticProperty
    .named('Blend Mode')
    .props({
    type: exports.PropertyType.BlendMode,
    valueType: exports.ValueType.BlendMode,
    value: types.optional(types.enumeration(Object.values(exports.BlendModeType)), exports.BlendModeType.Normal),
})
    .actions((self) => ({
    updateValue: (value) => {
        self.updateNodeVersion();
        self.value = value;
    },
}));

const bottomLeftRadius = numberProperty
    .named('Top Left Radius')
    .props({
    type: exports.PropertyType.BottomLeftRadius,
    min: 0,
});

const bottomRightRadius = numberProperty
    .named('Top Right Radius')
    .props({
    type: exports.PropertyType.BottomRightRadius,
    min: 0,
});

const rgbaProperty = animatableProperty
    .props({
    type: exports.PropertyType.Color,
    valueType: exports.ValueType.RGBA,
    value: rgba,
    _keyframes: types.map(rgbaKeyframe),
})
    .actions((self) => ({
    updateValue: (time, value) => {
        self.updateNodeVersion();
        const keyframes = self.keyframes;
        const length = keyframes.length;
        const newValue = {
            r: round(value.r, { fixed: 0 }),
            g: round(value.g, { fixed: 0 }),
            b: round(value.b, { fixed: 0 }),
            a: round(value.a || 0),
        };
        if (time < 0 || length === 0) {
            self.value = rgba.create(newValue);
            return;
        }
        const currentKeyframeIdx = keyframes.findIndex((_keyframe) => _keyframe.time === time);
        const currentKeyframe = keyframes[currentKeyframeIdx];
        const shouldUpdateKeyframe = currentKeyframe != null;
        const shouldAddKeyframe = shouldUpdateKeyframe === false && length !== 0;
        if (shouldAddKeyframe) {
            self.addKeyframe(rgbaKeyframe.create({
                time,
                value: newValue,
            }));
            return;
        }
        if (shouldUpdateKeyframe) {
            // @TODO: add correct type here
            // @ts-ignore
            currentKeyframe.updateValue(newValue);
            return;
        }
    },
}))
    .views((self) => ({
    getValue: (t) => {
        const keyframes = self.keyframes;
        const length = keyframes.length;
        if (length === 0) {
            return self.value;
        }
        if (length === 1) {
            // @TODO: add correct type here
            // @ts-ignore
            return keyframes[0].value;
        }
        const segment = self.getClosestSegment(t);
        return getValueRgba({ t, segment });
    },
    equals: (right) => {
        return (self.value.r === right.value.r &&
            self.value.g === right.value.g &&
            self.value.b === right.value.b &&
            self.value.a === right.value.a);
    },
}));

const color = rgbaProperty.named('Color').props({
    type: exports.PropertyType.Color,
});

const cornerRadius = numberProperty
    .named('Corner Radius')
    .props({
    type: exports.PropertyType.CornerRadius,
    min: 0,
});

const dash = numberProperty.named('Dash').props({
    type: exports.PropertyType.Dash,
    value: types.optional(types.number, 0),
});

const dashOffset = numberProperty.named('Dash Offset').props({
    type: exports.PropertyType.DashOffset,
    value: types.optional(types.number, 0),
});

const gap = numberProperty.named('Gap').props({
    type: exports.PropertyType.Gap,
    value: types.optional(types.number, 0),
});

const matrixTransformProperty = animatableProperty
    .props({
    valueType: exports.ValueType.MatrixTransform,
    value: matrixTransform,
    _keyframes: types.map(matrixTransformKeyframe),
})
    .actions((self) => ({
    updateValue: (time, value) => {
        self.updateNodeVersion();
        // @NOTE: required to round to those small amounts because sometimes rounding was cause determinant matrices issue
        // @ts-ignore
        const newValue = matrixTransform.create([
            [
                round(value[0][0], { fixed: 12 }),
                round(value[0][1], { fixed: 12 }),
                round(value[0][2], { fixed: 12 }),
            ],
            [
                round(value[1][0], { fixed: 12 }),
                round(value[1][1], { fixed: 12 }),
                round(value[1][2], { fixed: 12 }),
            ],
        ]);
        if (time < 0 || self.keyframes.length === 0) {
            self.value = newValue;
            return;
        }
        const currentKeyframeIdx = self.keyframes.findIndex((_keyframe) => _keyframe.time === time);
        const currentKeyframe = self.keyframes[currentKeyframeIdx];
        const shouldUpdateKeyframe = currentKeyframe != null;
        const shouldAddKeyframe = shouldUpdateKeyframe === false && self.keyframes.length !== 0;
        if (shouldAddKeyframe) {
            self.addKeyframe(matrixTransformKeyframe.create({
                time,
                value: newValue,
            }));
            return;
        }
        if (shouldUpdateKeyframe) {
            // @TODO: add correct type here
            // @ts-ignore
            currentKeyframe.updateValue(newValue);
            return;
        }
    },
}))
    .views((self) => ({
    getValue: (t) => {
        const keyframes = self.keyframes;
        const length = keyframes.length;
        if (length === 0) {
            return self.value;
        }
        if (length === 1) {
            // @TODO: add correct type here
            // @ts-ignore
            return keyframes[0].value;
        }
        const segment = self.getClosestSegment(t);
        return getValueMatrixTransform({ t, segment });
    },
    equals: (right) => {
        return (self.value[0][0] === right.value[0][0] &&
            self.value[0][1] === right.value[0][1] &&
            self.value[0][2] === right.value[0][2] &&
            self.value[1][0] === right.value[1][0] &&
            self.value[1][1] === right.value[1][1] &&
            self.value[1][2] === right.value[1][2]);
    },
}));

const gradientTransform = matrixTransformProperty
    .named('gradient-transform')
    .props({
    type: exports.PropertyType.GradientTransform,
});

const innerRadius = numberProperty.named('Percent').props({
    type: exports.PropertyType.InnerRadius,
    value: types.optional(types.number, 0),
    min: 0,
    max: 1,
});

// constants
var BlendModeType;
(function (BlendModeType) {
    BlendModeType["PassThrough"] = "PASS_THROUGH";
    BlendModeType["Normal"] = "NORMAL";
    BlendModeType["Darken"] = "DARKEN";
    BlendModeType["Multiply"] = "MULTIPLY";
    BlendModeType["LinearBurn"] = "LINEAR_BURN";
    BlendModeType["ColorBurn"] = "COLOR_BURN";
    BlendModeType["Lighten"] = "LIGHTEN";
    BlendModeType["Screen"] = "SCREEN";
    BlendModeType["LinearDodge"] = "LINEAR_DODGE";
    BlendModeType["ColorDodge"] = "COLOR_DODGE";
    BlendModeType["Overlay"] = "OVERLAY";
    BlendModeType["SoftLight"] = "SOFT_LIGHT";
    BlendModeType["HardLight"] = "HARD_LIGHT";
    BlendModeType["Difference"] = "DIFFERENCE";
    BlendModeType["Exclusion"] = "EXCLUSION";
    BlendModeType["Hue"] = "HUE";
    BlendModeType["Saturation"] = "SATURATION";
    BlendModeType["Color"] = "COLOR";
    BlendModeType["Luminosity"] = "LUMINOSITY";
})(BlendModeType || (BlendModeType = {}));
var ValueType;
(function (ValueType) {
    ValueType["Generic"] = "GENERIC";
    ValueType["Number"] = "NUMBER";
    ValueType["Point1D"] = "POINT_1D";
    ValueType["Point2D"] = "POINT_2D";
    ValueType["SpatialPoint2D"] = "SPATIAL_POINT_2D";
    ValueType["RGBA"] = "RGBA";
    ValueType["Boolean"] = "BOOLEAN";
    ValueType["BlendMode"] = "BLEND_MODE";
    ValueType["PaintType"] = "PAINT_TYPE";
    ValueType["String"] = "STRING";
    ValueType["BooleanOperation"] = "BOOLEAN_OPERATION";
    ValueType["TextCase"] = "TEXT_CASE";
    ValueType["TextDecoration"] = "TEXT_DECORATION";
    ValueType["Unit"] = "UNIT";
    ValueType["VectorPath"] = "VECTOR_PATH";
    ValueType["FillRule"] = "FILL_RULE";
    ValueType["VectorPathMirroring"] = "VECTOR_PATH_MIRRORING";
    ValueType["ImageData"] = "IMAGE_DATA";
    ValueType["ImageUrl"] = "IMAGE_URL";
    ValueType["ScaleMode"] = "SCALE_MODE";
    ValueType["StrokeAlign"] = "STROKE_ALIGN";
    ValueType["StrokeCap"] = "STROKE_CAP";
    ValueType["StrokeJoin"] = "STROKE_JOIN";
    ValueType["EffectType"] = "EFFECT_TYPE";
    ValueType["MatrixTransform"] = "MATRIX_TRANSFORM";
})(ValueType || (ValueType = {}));
/**
 * @description used to determine locked state of the node or property
 */
var LockType;
(function (LockType) {
    LockType["Normal"] = "NORMAL";
    LockType["Locked"] = "LOCKED";
})(LockType || (LockType = {}));
/**
 * @description used to determine state of the node or property in viewport
 * @deprecated we are using boolean values now
 */
var VisibilityType;
(function (VisibilityType) {
    VisibilityType["Visible"] = "VISIBLE";
    VisibilityType["Hidden"] = "HIDDEN";
})(VisibilityType || (VisibilityType = {}));
var NodeType;
(function (NodeType) {
    NodeType["Generic"] = "GENERIC";
    NodeType["BooleanOperation"] = "BOOLEAN_OPERATION";
    // Component = 'COMPONENT',
    // ComponentSet = 'COMPONENT_SET',
    // Document = 'DOCUMENT',
    NodeType["Ellipse"] = "ELLIPSE";
    NodeType["Instance"] = "INSTANCE";
    NodeType["Frame"] = "FRAME";
    NodeType["Group"] = "GROUP";
    // Instance = 'INSTANCE',
    NodeType["Line"] = "LINE";
    // Page = 'PAGE',
    NodeType["Polygon"] = "POLYGON";
    NodeType["Rectangle"] = "RECTANGLE";
    // Slice = 'SLICE',
    NodeType["Star"] = "STAR";
    NodeType["Text"] = "TEXT";
    NodeType["Vector"] = "VECTOR";
})(NodeType || (NodeType = {}));
var PropertyType;
(function (PropertyType) {
    PropertyType["Generic"] = "GENERIC";
    PropertyType["AnchorPoint"] = "ANCHOR_POINT";
    PropertyType["Opacity"] = "OPACITY";
    PropertyType["Rotation"] = "ROTATION";
    PropertyType["Position"] = "POSITION";
    PropertyType["Scale"] = "SCALE";
    PropertyType["Size"] = "SIZE";
    PropertyType["Skew"] = "SKEW";
    PropertyType["BlendMode"] = "BLEND_MODE";
    PropertyType["Color"] = "COLOR";
    PropertyType["CornerRadius"] = "CORNER_RADIUS";
    PropertyType["TopLeftRadius"] = "TOP_LEFT_RADIUS";
    PropertyType["TopRightRadius"] = "TOP_RIGHT_RADIUS";
    PropertyType["BottomLeftRadius"] = "BOTTOM_LEFT_RADIUS";
    PropertyType["BottomRightRadius"] = "BOTTOM_RIGHT_RADIUS";
    PropertyType["Visible"] = "VISIBLE";
    PropertyType["StrokeWeight"] = "STROKE_WEIGHT";
    PropertyType["StrokeTopWeight"] = "STROKE_TOP_WEIGHT";
    PropertyType["StrokeBottomWeight"] = "STROKE_BOTTOM_WEIGHT";
    PropertyType["StrokeLeftWeight"] = "STROKE_LEFT_WEIGHT";
    PropertyType["StrokeRightWeight"] = "STROKE_RIGHT_WEIGHT";
    PropertyType["GradientTransform"] = "GRADIENT_TRANSFORM";
    PropertyType["Offset"] = "OFFSET";
    PropertyType["Radius"] = "RADIUS";
    PropertyType["Spread"] = "SPREAD";
    PropertyType["Angle"] = "ANGLE";
    // @NOTE: in range 0...1
    PropertyType["Percent"] = "PERCENT";
    // @NOTE: in range -1...1
    PropertyType["PercentNegative"] = "PERCENT_NEGATIVE";
    PropertyType["Dash"] = "DASH";
    PropertyType["Gap"] = "GAP";
    PropertyType["DashOffset"] = "DASH_OFFSET";
    PropertyType["TrimStart"] = "TRIM_START";
    PropertyType["TrimEnd"] = "TRIM_END";
    PropertyType["TrimOffset"] = "TRIM_OFFSET";
    PropertyType["PointCount"] = "POINT_COUNT";
    PropertyType["InnerRadius"] = "INNER_RADIUS";
})(PropertyType || (PropertyType = {}));
var PropertyKeyframesType;
(function (PropertyKeyframesType) {
    PropertyKeyframesType["Active"] = "ACTIVE";
    PropertyKeyframesType["HasKeyframes"] = "HAS_KEYFRAMES";
    PropertyKeyframesType["Empty"] = "EMPTY";
})(PropertyKeyframesType || (PropertyKeyframesType = {}));
/**
 * @description predefined list of available layer colors
 */
var LayerColor;
(function (LayerColor) {
    LayerColor["Blue"] = "BLUE";
    LayerColor["Purple"] = "PURPLE";
    LayerColor["Pink"] = "PINK";
    LayerColor["Green"] = "GREEN";
    LayerColor["Turqouise"] = "TURQOUISE";
    LayerColor["Red"] = "RED";
    LayerColor["Orange"] = "ORANGE";
    LayerColor["Yellow"] = "YELLOW";
    LayerColor["Grey"] = "GREY";
    LayerColor["None"] = "NONE";
})(LayerColor || (LayerColor = {}));
/**
 * @description used to determine where node should be set to solo
 * None – solo disabled
 * Viewport – node will be isolated in viewport only
 * Timeline – node will be isolated on timeline only
 * Both – node will be isolaterd in viewport and on timeline
 */
var NodeSoloType;
(function (NodeSoloType) {
    NodeSoloType["None"] = "NONE";
    NodeSoloType["Viewport"] = "VIEWPORT";
    NodeSoloType["Timeline"] = "TIMELINE";
    NodeSoloType["Both"] = "BOTH";
})(NodeSoloType || (NodeSoloType = {}));
var ScaleType;
(function (ScaleType) {
    ScaleType["Fill"] = "FILL";
    ScaleType["Fit"] = "FIT";
    ScaleType["Crop"] = "CROP";
    ScaleType["Tile"] = "TILE";
})(ScaleType || (ScaleType = {}));
var StrokeAlign;
(function (StrokeAlign) {
    StrokeAlign["Center"] = "CENTER";
    StrokeAlign["Inside"] = "INSIDE";
    StrokeAlign["Outside"] = "OUTSIDE";
})(StrokeAlign || (StrokeAlign = {}));
var StrokeCap;
(function (StrokeCap) {
    StrokeCap["None"] = "NONE";
    StrokeCap["Round"] = "ROUND";
    StrokeCap["Square"] = "SQUARE";
    StrokeCap["ArrowLines"] = "ARROW_LINES";
    StrokeCap["ArrowEquilateral"] = "ARROW_EQUILATERAL";
    StrokeCap["TriangleFilled"] = "TRIANGLE_FILLED";
    StrokeCap["DiamondFilled"] = "DIAMOND_FILLED";
    StrokeCap["CircleFilled"] = "CIRCLE_FILLED";
})(StrokeCap || (StrokeCap = {}));
var StrokeJoin;
(function (StrokeJoin) {
    StrokeJoin["Miter"] = "MITER";
    StrokeJoin["Bevel"] = "BEVEL";
    StrokeJoin["Round"] = "ROUND";
})(StrokeJoin || (StrokeJoin = {}));
var BooleanOperationType;
(function (BooleanOperationType) {
    BooleanOperationType["Union"] = "UNION";
    BooleanOperationType["Intersect"] = "INTERSECT";
    BooleanOperationType["Subtract"] = "SUBTRACT";
    BooleanOperationType["Exclude"] = "EXCLUDE";
})(BooleanOperationType || (BooleanOperationType = {}));
var CurveType;
(function (CurveType) {
    CurveType["Spring"] = "SPRING";
    CurveType["Timing"] = "TIMING";
})(CurveType || (CurveType = {}));
var NodeSizeBehaviour;
(function (NodeSizeBehaviour) {
    /**
     * @description fill all available space
     */
    NodeSizeBehaviour["Fill"] = "FILL";
    /**
     * @description not react on size changes
     */
    NodeSizeBehaviour["Ignore"] = "IGNORE";
})(NodeSizeBehaviour || (NodeSizeBehaviour = {}));

const offset = point2dProperty.named('Offset').props({
    type: PropertyType.Offset,
});

const opacity = numberProperty.named('Opacity').props({
    type: exports.PropertyType.Opacity,
    value: types.optional(types.number, 1),
    min: 0,
    max: 1,
});

const percent = numberProperty.named('Percent').props({
    type: exports.PropertyType.Percent,
    value: types.optional(types.number, 0),
});

const percentNegative = numberProperty
    .named('Percent Negative')
    .props({
    type: exports.PropertyType.PercentNegative,
    value: types.optional(types.number, 0),
});

const pointCount = numberProperty.named('Point Count').props({
    type: exports.PropertyType.PointCount,
    value: types.optional(types.number, 0),
    min: 0,
});

const spatialPoint2dProperty = animatableProperty
    .props({
    valueType: exports.ValueType.SpatialPoint2D,
    value: types.optional(spatialPoint2d, spatialPoint2d.create({
        x: 0,
        y: 0,
    })),
    _keyframes: types.map(spatialPoint2dKeyframe),
})
    .actions((self) => ({
    updateValue: (time, value) => {
        self.updateNodeVersion();
        const keyframes = self.keyframes;
        const length = keyframes.length;
        const newValue = {
            x: round(value.x),
            y: round(value.y),
        };
        if (time < 0 || length === 0) {
            self.value = spatialPoint2d.create(newValue);
            return;
        }
        const currentKeyframeIdx = keyframes.findIndex((_keyframe) => _keyframe.time === time);
        const currentKeyframe = keyframes[currentKeyframeIdx];
        const shouldUpdateKeyframe = currentKeyframe != null;
        const shouldAddKeyframe = shouldUpdateKeyframe === false && length !== 0;
        if (shouldAddKeyframe) {
            self.addKeyframe(spatialPoint2dKeyframe.create({
                time,
                value: newValue,
            }));
            return;
        }
        if (shouldUpdateKeyframe) {
            // NOTE: logic to handle tangents
            applySnapshot(currentKeyframe, {
                ...getSnapshot(currentKeyframe),
                value: {
                    x: newValue.x,
                    y: newValue.y,
                    tx1: -currentKeyframe.value.x + newValue.x + currentKeyframe.value.tx1,
                    tx2: -currentKeyframe.value.x + newValue.x + currentKeyframe.value.tx2,
                    ty1: -currentKeyframe.value.y + newValue.y + currentKeyframe.value.ty1,
                    ty2: -currentKeyframe.value.y + newValue.y + currentKeyframe.value.ty2,
                },
            });
            return;
        }
    },
}))
    .views((self) => ({
    getValue: (t) => {
        const keyframes = self.keyframes;
        const length = keyframes.length;
        if (length === 0) {
            return self.value;
        }
        if (length === 1) {
            // @TODO: add correct type here
            // @ts-ignore
            return keyframes[0].value;
        }
        const segment = self.getClosestSegment(t);
        return getValueSpatialPoint2D({ t, segment });
    },
    equals: (right) => {
        return (self.value.x === right.value.x &&
            self.value.tx1 === right.value.tx1 &&
            self.value.tx2 === right.value.tx2 &&
            self.value.y === right.value.y &&
            self.value.ty1 === right.value.ty1 &&
            self.value.ty2 === right.value.ty2);
    },
}));

const position = spatialPoint2dProperty
    .named('Position')
    .props({
    type: exports.PropertyType.Position,
});

const radius = numberProperty.named('Radius').props({
    type: exports.PropertyType.Radius,
});

const point1dProperty = animatableProperty
    .props({
    valueType: exports.ValueType.Point1D,
    value: types.optional(point1d, point1d.create({
        x: 0,
    })),
    _keyframes: types.map(point1dKeyframe),
})
    .actions((self) => ({
    updateValue: (time, value) => {
        self.updateNodeVersion();
        const keyframes = self.keyframes;
        const length = keyframes.length;
        const newValue = {
            x: round(value.x),
        };
        if (time < 0 || length === 0) {
            self.value = point1d.create(newValue);
            return;
        }
        const currentKeyframeIdx = keyframes.findIndex((_keyframe) => _keyframe.time === time);
        const currentKeyframe = keyframes[currentKeyframeIdx];
        const shouldUpdateKeyframe = currentKeyframe != null;
        const shouldAddKeyframe = shouldUpdateKeyframe === false && length !== 0;
        if (shouldAddKeyframe) {
            self.addKeyframe(point1dKeyframe.create({
                time,
                value: newValue,
            }));
            return;
        }
        if (shouldUpdateKeyframe) {
            // @TODO: add correct type here
            // @ts-ignore
            currentKeyframe.updateValue(newValue);
            return;
        }
    },
}))
    .views((self) => ({
    getValue: (t) => {
        const keyframes = self.keyframes;
        const length = keyframes.length;
        if (length === 0) {
            return self.value;
        }
        if (length === 1) {
            // @TODO: add correct type here
            // @ts-ignore
            return keyframes[0].value;
        }
        const segment = self.getClosestSegment(t);
        return getValuePoint1D({ t, segment });
    },
    equals: (right) => {
        return self.value.x === right.value.x;
    },
}));

const rotation = point1dProperty.named('Rotation').props({
    type: exports.PropertyType.Rotation,
});

const lockablePoint2dProperty = point2dProperty
    .named('Lockable Point 2D')
    .props({
    lockType: types.optional(types.enumeration(Object.values(exports.LockType)), exports.LockType.Locked),
})
    .actions((self) => ({
    lock: () => (self.lockType = exports.LockType.Locked),
    unlock: () => (self.lockType = exports.LockType.Normal),
    updateValue: (time, value) => {
        self.updateNodeVersion();
        if (value != null && value.x == null && value.y == null) {
            throw new TypeError(`.x or .y are required. Received: "${JSON.stringify(value)}"`);
        }
        const keyframes = self.keyframes;
        const length = keyframes.length;
        const newValue = (() => {
            // @NOTE: if value is 0 and we drag and drop value it provide undefined here.
            // @TODO: check why this happen.
            // To reproduce: disable this "if", put 0 into scale (when value is locked) and drag and drop.
            if (value == null) {
                return {
                    x: 0.01,
                    y: 0.01,
                };
            }
            if (value.x == null) {
                const newY = round(value.y);
                const offset = (() => {
                    if (self.value.y === 0) {
                        return newY - self.value.y;
                    }
                    const multiplier = self.value.x / protect(self.value.y);
                    return (newY - self.value.y) * multiplier;
                })();
                return {
                    x: self.value.x + offset,
                    y: newY,
                };
            }
            if (value.y == null) {
                const newX = round(value.x);
                if (self.value.x === 0) {
                    return {
                        x: newX,
                        y: self.value.y,
                    };
                }
                const offset = (() => {
                    if (self.value.x === 0) {
                        return value.x - self.value.x;
                    }
                    const multiplier = self.value.y / protect(self.value.x);
                    return (value.x - self.value.x) * multiplier;
                })();
                return {
                    x: newX,
                    y: self.value.y + offset,
                };
            }
            return {
                x: round(value.x),
                y: round(value.y),
            };
        })();
        if (time < 0 || length === 0) {
            self.value = point2d.create(newValue);
            return;
        }
        const currentKeyframeIdx = keyframes.findIndex((_keyframe) => _keyframe.time === time);
        const currentKeyframe = keyframes[currentKeyframeIdx];
        const shouldUpdateKeyframe = currentKeyframe != null;
        const shouldAddKeyframe = shouldUpdateKeyframe === false && length !== 0;
        if (shouldAddKeyframe) {
            self.addKeyframe(point2dKeyframe.create({
                time,
                value: newValue,
            }));
            return;
        }
        if (shouldUpdateKeyframe) {
            // @TODO: add correct type here
            // @ts-ignore
            currentKeyframe.updateValue(newValue);
            return;
        }
    },
}))
    .views((self) => ({
    get locked() {
        return self.lockType === exports.LockType.Locked;
    },
}));

const scale = lockablePoint2dProperty.named('Scale').props({
    type: PropertyType.Scale,
    value: types.optional(point2d, point2d.create({
        x: 1,
        y: 1,
    })),
});

const size = lockablePoint2dProperty.named('Size').props({
    type: exports.PropertyType.Size,
});

const skew = point2dProperty.named('Skew').props({
    type: exports.PropertyType.Skew,
});

const spread = numberProperty.named('Spread').props({
    type: exports.PropertyType.Spread,
});

const strokeBottomWeight = numberProperty
    .named('Stroke Bottom Weight')
    .props({
    type: exports.PropertyType.StrokeBottomWeight,
    value: 1,
    min: 0,
});

const strokeLeftWeight = numberProperty
    .named('Stroke Left Weight')
    .props({
    type: exports.PropertyType.StrokeLeftWeight,
    value: 1,
    min: 0,
});

const strokeRightWeight = numberProperty
    .named('Stroke Right Weight')
    .props({
    type: exports.PropertyType.StrokeRightWeight,
    value: 1,
    min: 0,
});

const strokeTopWeight = numberProperty
    .named('Stroke Top Weight')
    .props({
    type: exports.PropertyType.StrokeTopWeight,
    value: 1,
    min: 0,
});

const strokeWeight = numberProperty
    .named('Stroke Weight')
    .props({
    type: exports.PropertyType.StrokeWeight,
    value: types.optional(types.number, 1),
    min: 0,
});

const topLeftRadius = numberProperty
    .named('Top Left Radius')
    .props({
    type: exports.PropertyType.TopLeftRadius,
    min: 0,
});

const topRightRadius = numberProperty
    .named('Top Right Radius')
    .props({
    type: exports.PropertyType.TopRightRadius,
    min: 0,
});

const trimEnd = numberProperty.named('Trim End').props({
    type: exports.PropertyType.TrimEnd,
    value: types.optional(types.number, 1),
    min: 0,
    max: 1,
});

const trimOffset = numberProperty.named('Trim Offset').props({
    type: exports.PropertyType.TrimOffset,
    value: types.optional(types.number, 0),
    min: -1,
    max: 1,
});

const trimStart = numberProperty.named('Trim Start').props({
    type: exports.PropertyType.TrimStart,
    value: types.optional(types.number, 0),
    min: 0,
    max: 1,
});

const visible = staticProperty
    .named('Visible')
    .props({
    type: exports.PropertyType.Visible,
    valueType: exports.ValueType.Boolean,
    value: true,
})
    .actions((self) => ({
    updateValue: (value) => {
        self.updateNodeVersion();
        self.value = value;
    },
}));

const base = types
    .model('Base PropertyGroup', {
    id: types.optional(types.identifier, () => generateId()),
    type: types.optional(types.enumeration(Object.values(exports.PropertyGroupType)), exports.PropertyGroupType.Generic),
    modelType: 'property-group',
    blendMode: types.optional(blendMode, () => blendMode.create({})),
    visible: types.optional(visible, () => visible.create({})),
})
    .actions((self) => ({
    expand: () => {
        self.blendMode.showOnTimeline();
        self.visible.showOnTimeline();
    },
    collapse: () => {
        self.blendMode.hideOnTimeline();
        self.visible.hideOnTimeline();
    },
    applyTransition: (model, options) => { },
    getPropertyGroupSet: () => getParent(self, 2),
}))
    .views((self) => {
    const getNode = (model) => {
        const parent = getParent(model);
        // @ts-ignore
        if (parent.modelType === 'node') {
            return parent;
        }
        else {
            return getNode(parent);
        }
    };
    return {
        getSortedKeyframes: () => {
            return [];
        },
        getKeyframes: () => {
            return [];
        },
        getNode: () => getNode(self),
        get parent() {
            return getParent(getParent(self));
        },
    };
});
const basePropertyGroup = types
    .compose('Base PropertyGroup', visibleOnTimeline, base)
    .views((self) => ({
    get visibleOnTimeline() {
        return (self.visibilityOnTimeline === exports.VisibilityType.Visible &&
            self.getKeyframes().length > 0);
    },
}));

const backgroundBlurPropertyGroup = basePropertyGroup
    .named('Background Blur')
    .props({
    type: exports.PropertyGroupType.BackgroundBlur,
    radius: types.optional(radius, () => radius.create({ value: 4 })),
})
    .actions((self) => {
    const superSelfExpand = self.expand;
    const superSelfCollapse = self.collapse;
    const superSelfApplyTransition = self.applyTransition;
    return {
        shiftOnTimeline: (delta) => {
            self.radius.shiftOnTimeline(delta);
        },
        expand: () => {
            superSelfExpand();
            self.radius.showOnTimeline();
        },
        collapse: () => {
            superSelfCollapse();
            self.radius.hideOnTimeline();
        },
        applyTransition: (model, options) => {
            superSelfApplyTransition(model, options);
            applyPropertyTransition('radius', self, model, options);
        },
        updateStructure: (model, options) => {
            self.radius.updateValue(-1, model.radius.value);
        },
    };
})
    .views((self) => ({
    getSortedKeyframes: () => {
        return [...self.radius.keyframes];
    },
    getKeyframes: () => {
        return [...Array.from(self.radius._keyframes.values())];
    },
    equals: (right) => {
        return self.radius.equals(right.radius);
    },
}));

const dropShadowPropertyGroup = basePropertyGroup
    .named('Drop Shadow')
    .props({
    type: exports.PropertyGroupType.DropShadow,
    color: types.optional(color, () => color.create({ value: { r: 0, g: 0, b: 0, a: 0.25 } })),
    offset: types.optional(offset, () => offset.create({ value: { x: 0, y: 4 } })),
    radius: types.optional(radius, () => radius.create({ value: 4 })),
    spread: types.optional(spread, () => spread.create({ value: 0 })),
})
    .actions((self) => {
    const superSelfExpand = self.expand;
    const superSelfCollapse = self.collapse;
    const superSelfApplyTransition = self.applyTransition;
    return {
        shiftOnTimeline: (delta) => {
            self.color.shiftOnTimeline(delta);
            self.offset.shiftOnTimeline(delta);
            self.radius.shiftOnTimeline(delta);
            self.spread.shiftOnTimeline(delta);
        },
        expand: () => {
            superSelfExpand();
            self.color.showOnTimeline();
            self.offset.showOnTimeline();
            self.radius.showOnTimeline();
            self.spread.showOnTimeline();
        },
        collapse: () => {
            superSelfCollapse();
            self.color.hideOnTimeline();
            self.offset.hideOnTimeline();
            self.radius.hideOnTimeline();
            self.spread.hideOnTimeline();
        },
        applyTransition: (model, options) => {
            superSelfApplyTransition(model, options);
            applyPropertyTransition('color', self, model, options);
            applyPropertyTransition('offset', self, model, options);
            applyPropertyTransition('radius', self, model, options);
            applyPropertyTransition('spread', self, model, options);
            return self;
        },
        updateStructure: (model, options) => {
            self.color.updateValue(-1, model.color.value);
            self.offset.updateValue(-1, model.offset.value);
            self.radius.updateValue(-1, model.radius.value);
            self.spread.updateValue(-1, model.spread.value);
        },
    };
})
    .views((self) => ({
    getSortedKeyframes: () => {
        return [
            ...self.color.keyframes,
            ...self.offset.keyframes,
            ...self.radius.keyframes,
            ...self.spread.keyframes,
        ];
    },
    getKeyframes: () => {
        return [
            ...Array.from(self.color._keyframes.values()),
            ...Array.from(self.offset._keyframes.values()),
            ...Array.from(self.radius._keyframes.values()),
            ...Array.from(self.spread._keyframes.values()),
        ];
    },
    equals: (right) => {
        return (self.color.equals(right.color) &&
            self.offset.equals(right.offset) &&
            self.radius.equals(right.radius) &&
            self.spread.equals(right.spread));
    },
}));

const imageFillPropertyGroup = basePropertyGroup
    .named('Image Fill')
    .props({
    type: exports.PropertyGroupType.Image,
    valueType: exports.PaintType.Image,
    hash: types.optional(types.string, ''),
    scaleMode: types.optional(types.enumeration(['FILL', 'FIT', 'CROP', 'TILE']), 'FILL'),
    imageTransform: types.optional(types.array(types.array(types.number)), [
        [0, 0, 0],
        [0, 0, 0],
    ]),
    scalingFactor: types.optional(types.number, 0),
    rotation: types.optional(types.number, 0),
    opacity: types.optional(opacity, () => opacity.create({})),
})
    .actions((self) => {
    const superSelfApplyTransition = self.applyTransition;
    return {
        shiftOnTimeline: (delta) => {
            self.opacity.shiftOnTimeline(delta);
        },
        applyTransition: (model, options) => {
            superSelfApplyTransition(model, options);
            applyPropertyTransition('opacity', self, model, options);
            return self;
        },
        updateStructure: (model, options) => {
            self.opacity.updateValue(-1, model.opacity.value);
            self.hash = model.hash;
            self.scaleMode = model.scaleMode;
            // @ts-ignore
            self.imageTransform.replace(getSnapshot(model.imageTransform));
            self.scalingFactor = model.scalingFactor;
            self.rotation = model.rotation;
        },
    };
})
    .views((self) => ({
    getSortedKeyframes: () => {
        return [...self.opacity.keyframes];
    },
    getKeyframes: () => {
        return [...Array.from(self.opacity._keyframes.values())];
    },
    equals: (right) => {
        return (self.hash === right.hash &&
            self.scaleMode === right.scaleMode &&
            self.imageTransform[0][0] === right.imageTransform[0][0] &&
            self.imageTransform[0][1] === right.imageTransform[0][1] &&
            self.imageTransform[0][2] === right.imageTransform[0][2] &&
            self.imageTransform[1][0] === right.imageTransform[1][0] &&
            self.imageTransform[1][1] === right.imageTransform[1][1] &&
            self.imageTransform[1][2] === right.imageTransform[1][2] &&
            self.scalingFactor === right.scalingFactor &&
            self.rotation === right.rotation &&
            self.opacity.equals(right.opacity));
    },
}));

const innerShadowPropertyGroup = basePropertyGroup
    .named('Inner Shadow')
    .props({
    type: exports.PropertyGroupType.InnerShadow,
    color: types.optional(color, () => color.create({ value: { r: 0, g: 0, b: 0, a: 0.25 } })),
    offset: types.optional(offset, () => offset.create({ value: { x: 0, y: 4 } })),
    radius: types.optional(radius, () => radius.create({ value: 4 })),
    spread: types.optional(spread, () => spread.create({ value: 0 })),
})
    .actions((self) => {
    const superSelfExpand = self.expand;
    const superSelfCollapse = self.collapse;
    const superSelfApplyTransition = self.applyTransition;
    return {
        shiftOnTimeline: (delta) => {
            self.color.shiftOnTimeline(delta);
            self.offset.shiftOnTimeline(delta);
            self.radius.shiftOnTimeline(delta);
            self.spread.shiftOnTimeline(delta);
        },
        expand: () => {
            superSelfExpand();
            self.color.showOnTimeline();
            self.offset.showOnTimeline();
            self.radius.showOnTimeline();
            self.spread.showOnTimeline();
        },
        collapse: () => {
            superSelfCollapse();
            self.color.hideOnTimeline();
            self.offset.hideOnTimeline();
            self.radius.hideOnTimeline();
            self.spread.hideOnTimeline();
        },
        applyTransition: (model, options) => {
            superSelfApplyTransition(model, options);
            applyPropertyTransition('color', self, model, options);
            applyPropertyTransition('offset', self, model, options);
            applyPropertyTransition('radius', self, model, options);
            applyPropertyTransition('spread', self, model, options);
            return self;
        },
        updateStructure: (model, options) => {
            self.color.updateValue(-1, model.color.value);
            self.offset.updateValue(-1, model.offset.value);
            self.radius.updateValue(-1, model.radius.value);
            self.spread.updateValue(-1, model.spread.value);
        },
    };
})
    .views((self) => ({
    getSortedKeyframes: () => {
        return [
            ...self.color.keyframes,
            ...self.offset.keyframes,
            ...self.radius.keyframes,
            ...self.spread.keyframes,
        ];
    },
    getKeyframes: () => {
        return [
            ...Array.from(self.color._keyframes.values()),
            ...Array.from(self.offset._keyframes.values()),
            ...Array.from(self.radius._keyframes.values()),
            ...Array.from(self.spread._keyframes.values()),
        ];
    },
    equals: (right) => {
        return (self.color.equals(right.color) &&
            self.offset.equals(right.offset) &&
            self.radius.equals(right.radius) &&
            self.spread.equals(right.spread));
    },
}));

const layerBlurPropertyGroup = basePropertyGroup
    .named('Layer Blur')
    .props({
    type: exports.PropertyGroupType.LayerBlur,
    radius: types.optional(radius, () => radius.create({ value: 4 })),
})
    .actions((self) => {
    const superSelfExpand = self.expand;
    const superSelfCollapse = self.collapse;
    const superSelfApplyTransition = self.applyTransition;
    return {
        shiftOnTimeline: (delta) => {
            self.radius.shiftOnTimeline(delta);
        },
        expand: () => {
            superSelfExpand();
            self.radius.showOnTimeline();
        },
        collapse: () => {
            superSelfCollapse();
            self.radius.hideOnTimeline();
        },
        applyTransition: (model, options) => {
            superSelfApplyTransition(model, options);
            applyPropertyTransition('radius', self, model, options);
            return self;
        },
        updateStructure: (model, options) => {
            self.radius.updateValue(-1, model.radius.value);
        },
    };
})
    .views((self) => ({
    getSortedKeyframes: () => {
        return [...self.radius.keyframes];
    },
    getKeyframes: () => {
        return [...Array.from(self.radius._keyframes.values())];
    },
    equals: (right) => {
        return self.radius.equals(right.radius);
    },
}));

const solidFillPropertyGroup = basePropertyGroup
    .named('Solid Fill')
    .props({
    type: exports.PropertyGroupType.Solid,
    valueType: exports.PaintType.Solid,
    color: types.optional(color, () => color.create({ value: { r: 0, g: 0, b: 0, a: 1 } })),
})
    .actions((self) => {
    const superSelfExpand = self.expand;
    const superSelfCollapse = self.collapse;
    const superSelfApplyTransition = self.applyTransition;
    return {
        expand: () => {
            superSelfExpand();
            self.color.showOnTimeline();
        },
        collapse: () => {
            superSelfCollapse();
            self.color.hideOnTimeline();
        },
        shiftOnTimeline: (delta) => {
            self.color.shiftOnTimeline(delta);
        },
        applyTransition: (model, options) => {
            superSelfApplyTransition(model, options);
            applyPropertyTransition('color', self, model, options);
        },
        updateStructure: (model, options) => {
            self.color.updateValue(-1, model.color.value);
        },
    };
})
    .views((self) => ({
    getSortedKeyframes: () => {
        return [...self.color.keyframes];
    },
    getKeyframes: () => {
        return [...Array.from(self.color._keyframes.values())];
    },
    equals: (right) => {
        return self.color.equals(right.color);
    },
}));

const propertyGroup$3 = types.custom({
    name: 'Property Group',
    fromSnapshot: (snapshot) => {
        if (snapshot.type === exports.PropertyGroupType.DropShadow) {
            const snapshotToApply = snapshot;
            return dropShadowPropertyGroup.create(snapshotToApply);
        }
        if (snapshot.type === exports.PropertyGroupType.LayerBlur) {
            const snapshotToApply = snapshot;
            return layerBlurPropertyGroup.create(snapshotToApply);
        }
        if (snapshot.type === exports.PropertyGroupType.BackgroundBlur) {
            const snapshotToApply = snapshot;
            return backgroundBlurPropertyGroup.create(snapshotToApply);
        }
        if (snapshot.type === exports.PropertyGroupType.InnerShadow) {
            const snapshotToApply = snapshot;
            return innerShadowPropertyGroup.create(snapshotToApply);
        }
        if (snapshot.type === exports.PropertyGroupType.Image) {
            const snapshotToApply = snapshot;
            return imageFillPropertyGroup.create(snapshotToApply);
        }
        if (snapshot.type === exports.PropertyGroupType.Solid) {
            const snapshotToApply = snapshot;
            return solidFillPropertyGroup.create(snapshotToApply);
        }
        throw new TypeError(`[propertyGroup] Type: ${snapshot.type} is not supporting yet`);
    },
    toSnapshot: (value) => getSnapshot(value),
    isTargetType: (value) => false,
    getValidationMessage: (snapshot) => '',
});

const colorStopPropertyGroup = basePropertyGroup
    .named('Color Stop Property Group')
    .props({
    type: exports.PropertyGroupType.ColorStop,
    color: types.optional(rgbaProperty, {
        value: { r: 127, g: 127, b: 127, a: 1 },
    }),
    position: types.optional(numberProperty, { value: 0 }),
})
    .actions((self) => ({
    shiftOnTimeline: (delta) => {
        self.color.shiftOnTimeline(delta);
        self.position.shiftOnTimeline(delta);
    },
    updateStructure: (model) => {
        self.color.updateValue(-1, model.color.value);
        self.position.updateValue(-1, model.position.value);
    },
}))
    .views((self) => ({
    getSortedKeyframes: () => {
        return [...self.color.keyframes, ...self.position.keyframes];
    },
    getKeyframes: () => {
        return [
            ...Array.from(self.color._keyframes.values()),
            ...Array.from(self.position._keyframes.values()),
        ];
    },
    equals: (right) => {
        return (self.color.equals(right.color) && self.position.equals(right.position));
    },
}));

const colorStopsPropertyGroupSet = types
    .model({
    type: exports.PropertyGroupSetType.ColorStops,
    _children: types.optional(types.map(colorStopPropertyGroup), {
        first: getSnapshot(colorStopPropertyGroup.create({
            id: 'first',
            position: {
                value: 0,
            },
            color: {
                value: {
                    r: 0,
                    g: 0,
                    b: 0,
                    a: 1,
                },
            },
        })),
        second: getSnapshot(colorStopPropertyGroup.create({
            id: 'second',
            position: {
                value: 1,
            },
            color: {
                value: {
                    r: 255,
                    g: 255,
                    b: 255,
                    a: 1,
                },
            },
        })),
    }),
    version: 2,
})
    .preProcessSnapshot((snapshot) => {
    // @NOTE: handle previous version of gradients.
    // We had array of children instead of _children map.
    if (snapshot.version == null || snapshot.version < 2) {
        // @ts-ignore
        const children = snapshot.children ?? [];
        if (children != null) {
            const map = Object.fromEntries(children.map((colorStop) => {
                const id = colorStop.id ?? generateId();
                colorStop.id = id;
                return [id, colorStop];
            }));
            // @ts-ignore
            return R__namespace.dissoc('children', R__namespace.assoc('_children', map, children));
        }
    }
    return snapshot;
})
    .views((self) => ({
    get children() {
        return Array.from(self._children.values());
    },
    getSortedChildren(time) {
        const keyframes = Array.from(self._children.values());
        return R__namespace.sort((left, right) => left.position.getValue(time) - right.position.getValue(time), keyframes);
    },
}))
    .actions((self) => ({
    addChild: (payload) => {
        // @TODO: add proper color mixing here
        const colorStop = colorStopPropertyGroup.create({
            id: generateId(),
            position: {
                value: payload.position,
            },
            color: {
                value: {
                    r: 0,
                    g: 0,
                    b: 0,
                    a: 1,
                },
            },
        });
        self._children.set(colorStop.id, colorStop);
        return colorStop;
    },
    removeChild: (id) => {
        self._children.delete(id);
    },
    shiftOnTimeline: (delta) => {
        self._children.forEach((child) => child.shiftOnTimeline(delta));
    },
    // @TODO: implement
    applyTransition: (model) => { },
    // @TODO: make cooler by mixing new color stops values with old ones
    updateStructure: (model, options) => {
        const leftChildren = Array.from(self._children.values());
        const rightChildren = Array.from(model._children.values());
        if (leftChildren.length > rightChildren.length) {
            for (let i = rightChildren.length; i < leftChildren.length; i += 1) {
                const item = leftChildren[i];
                self._children.delete(item.id);
            }
        }
        if (leftChildren.length < rightChildren.length) {
            for (let i = leftChildren.length; i < rightChildren.length; i += 1) {
                const item = getSnapshot(rightChildren[i]);
                // @ts-ignore
                self._children.set(item.id, item);
            }
        }
        // @NOTE: both exists. Merge them.
        Array.from(self._children.values()).forEach((colorStop, idx) => {
            const right = Array.from(model._children.values())[idx];
            colorStop.updateStructure(right, options);
        });
    },
}))
    .views((self) => ({
    getKeyframes: () => {
        const colorStops = Array.from(self._children.values());
        return R__namespace.flatten(colorStops.map((child) => child.getKeyframes()));
    },
    equals: (right) => {
        for (let i = 0; i < self.children.length; i += 1) {
            const leftColorStop = self.children[i];
            const rightColorStop = right.children[i];
            if (rightColorStop == null) {
                return false;
            }
            if (!leftColorStop.equals(rightColorStop)) {
                return false;
            }
        }
        return true;
    },
}));

const gradientPropertyGroup = basePropertyGroup
    .named('Gradient Property Group')
    .props({
    type: exports.PropertyGroupType.Gradient,
    valueType: types.optional(types.enumeration([exports.PaintType.GradientLinear, exports.PaintType.GradientRadial]), exports.PaintType.GradientLinear),
    gradientTransform: types.optional(gradientTransform, getSnapshot(gradientTransform.create({
        value: [
            [1, 0, 0],
            [0, 1, 0],
        ],
    }))),
    colorStops: types.optional(colorStopsPropertyGroupSet, getSnapshot(colorStopsPropertyGroupSet.create({ version: 2 }))),
    opacity: types.optional(percent, getSnapshot(percent.create({
        value: 1,
    }))),
})
    .preProcessSnapshot((snapshot) => {
    if (snapshot.gradientTransform.value != null) {
        return {
            ...snapshot,
            gradientTransform: {
                ...snapshot.gradientTransform,
                value: snapshot.gradientTransform.value.map((row) => row.map((item) => item ?? 0)),
            },
        };
    }
    return snapshot;
})
    .actions((self) => {
    const superSelfExpand = self.expand;
    const superSelfCollapse = self.collapse;
    return {
        expand: () => {
            superSelfExpand();
            self.gradientTransform.showOnTimeline();
            self.colorStops._children.forEach((colorStop) => {
                colorStop.position.showOnTimeline();
                colorStop.color.showOnTimeline();
            });
            self.opacity.showOnTimeline();
        },
        collapse: () => {
            superSelfCollapse();
            self.gradientTransform.hideOnTimeline();
            self.colorStops._children.forEach((colorStop) => {
                colorStop.position.hideOnTimeline();
                colorStop.color.hideOnTimeline();
            });
            self.opacity.hideOnTimeline();
        },
        // @TODO: implement
        applyTransition: (model) => { },
        updateStructure: (model) => {
            self.valueType = model.valueType;
            self.gradientTransform.updateValue(-1, model.gradientTransform.value);
            self.colorStops.updateStructure(model.colorStops);
            self.opacity.updateValue(-1, model.opacity.value);
        },
        shiftOnTimeline: (delta) => {
            self.gradientTransform.shiftOnTimeline(delta);
            self.colorStops.shiftOnTimeline(delta);
            self.opacity.shiftOnTimeline(delta);
        },
    };
})
    .views((self) => ({
    getSortedKeyframes: () => {
        return [
            ...self.gradientTransform.keyframes,
            ...self.colorStops.children.flatMap((colorStop) => [
                ...colorStop.position.keyframes,
                ...colorStop.color.keyframes,
            ]),
            ...self.opacity.keyframes,
        ];
    },
    getKeyframes: () => {
        return [
            ...Array.from(self.gradientTransform._keyframes.values()),
            ...self.colorStops.children.flatMap((colorStop) => [
                ...Array.from(colorStop.position._keyframes.values()),
                ...Array.from(colorStop.color._keyframes.values()),
            ]),
            ...Array.from(self.opacity._keyframes.values()),
        ];
    },
    equals: (right) => {
        return (self.gradientTransform.equals(right.gradientTransform) &&
            self.colorStops.equals(right.colorStops) &&
            self.opacity.equals(right.opacity));
    },
}));

const propertyGroup$2 = types.union({
    dispatcher: (snapshot) => {
        if (snapshot.type === exports.PropertyGroupType.DropShadow) {
            return dropShadowPropertyGroup;
        }
        if (snapshot.type === exports.PropertyGroupType.LayerBlur) {
            return layerBlurPropertyGroup;
        }
        if (snapshot.type === exports.PropertyGroupType.BackgroundBlur) {
            return backgroundBlurPropertyGroup;
        }
        if (snapshot.type === exports.PropertyGroupType.InnerShadow) {
            return innerShadowPropertyGroup;
        }
        if (snapshot.type === exports.PropertyGroupType.Solid) {
            return solidFillPropertyGroup;
        }
        if (snapshot.type === exports.PropertyGroupType.Image) {
            return imageFillPropertyGroup;
        }
        if (snapshot.type === exports.PropertyGroupType.ColorStop) {
            return colorStopPropertyGroup;
        }
        return null;
    },
}, dropShadowPropertyGroup, layerBlurPropertyGroup, backgroundBlurPropertyGroup, innerShadowPropertyGroup, solidFillPropertyGroup, imageFillPropertyGroup, colorStopPropertyGroup);
const basePropertyGroupSet = types
    .model({
    id: types.optional(types.identifier, () => generateId()),
    type: types.optional(types.enumeration(Object.values(exports.PropertyGroupSetType)), exports.PropertyGroupSetType.Generic),
    modelType: 'property-group-set',
    children: types.array(propertyGroup$2),
})
    .views((self) => {
    const getNode = (model) => {
        try {
            const parent = getParent(model);
            // @ts-ignore
            if (parent.modelType === 'node') {
                return parent;
            }
            else {
                return getNode(parent);
            }
            // @NOTE: somehow on first launch there is no parent and we have to skip node finding
        }
        catch (err) {
            // console.warn(err)
        }
    };
    return {
        getNode: () => getNode(self),
    };
})
    .actions((self) => ({
    addChild: (child) => {
        if (child == null) {
            throw new TypeError('Child should be provided');
        }
        self.children.push(child);
        self.getNode()?.bumpVersion();
    },
    prependChild: (child) => {
        if (child == null) {
            throw new TypeError('Child should be provided');
        }
        self.children.unshift(child);
        self.getNode()?.bumpVersion();
    },
    removeChild: (childId) => {
        const childIdx = self.children.findIndex((_child) => _child.id === childId);
        if (childId == null) {
            return;
        }
        self.children.splice(childIdx, 1);
        self.getNode()?.bumpVersion();
    },
    expand: () => {
        self.children.forEach((child) => {
            child.showOnTimeline();
            child.expand();
        });
    },
    collapse: () => {
        self.children.forEach((child) => {
            child.hideOnTimeline();
            child.collapse();
        });
    },
}))
    .views((self) => ({
    getKeyframes: () => {
        return R__namespace.flatten(self.children.map((child) => child.getKeyframes()));
    },
}));

const propertyGroup$1 = types.union({
    dispatcher: (snapshot) => {
        if (snapshot.type === exports.PropertyGroupType.DropShadow) {
            return dropShadowPropertyGroup;
        }
        if (snapshot.type === exports.PropertyGroupType.LayerBlur) {
            return layerBlurPropertyGroup;
        }
        if (snapshot.type === exports.PropertyGroupType.BackgroundBlur) {
            return backgroundBlurPropertyGroup;
        }
        if (snapshot.type === exports.PropertyGroupType.InnerShadow) {
            return innerShadowPropertyGroup;
        }
        throw new TypeError(`Property group with type "${snapshot.type}" is not supported yet`);
    },
}, dropShadowPropertyGroup, layerBlurPropertyGroup, backgroundBlurPropertyGroup, innerShadowPropertyGroup);
const effectPropertyGroupSet = basePropertyGroupSet
    .named('Effect Property Group Set')
    .props({
    type: exports.PropertyGroupSetType.Effect,
    children: types.array(propertyGroup$1),
})
    .actions((self) => ({
    shiftOnTimeline: (delta) => {
        self.children.forEach((child) => child.shiftOnTimeline(delta));
    },
    applyTransition: (model, options) => {
        const { timeStart, timeEnd, timingCurve, springCurve } = options;
        // @NOTE: indexes of groups which exists in both models
        const inBoth = R__namespace.intersection(self.children.map((child, idx) => `${idx}-${child.type}`), model.children.map((child, idx) => `${idx}-${child.type}`));
        // @NOTE: indexes of groups which exists in left model
        const inLeftOnly = R__namespace.without(inBoth, self.children.map((child, idx) => `${idx}-${child.type}`));
        // @NOTE: indexes of groups which exists in right model
        const inRightOnly = R__namespace.without(inBoth, model.children.map((child, idx) => `${idx}-${child.type}`));
        inLeftOnly.forEach((id) => {
            const idx = parseInt(id.split('-')[0], 10);
            const child = self.children[idx];
            if (child == null) {
                throw new TypeError('Something went wrong');
            }
            if (child.type === exports.PropertyGroupType.DropShadow ||
                child.type === exports.PropertyGroupType.InnerShadow) {
                const finalValue = {
                    ...child.color.getValue(timeStart),
                    a: 0,
                };
                // @NOTE: create animation if not exists
                let keyframeAtTime = child.color.keyframes.find((keyframe) => keyframe.time === timeStart);
                // @NOTE: stop processing if group is already hidden
                if (keyframeAtTime != null && keyframeAtTime.value === finalValue) {
                    return;
                }
                if (keyframeAtTime == null) {
                    keyframeAtTime = child.color.createKeyframe(timeStart);
                }
                // @NOTE: add time shift
                // @NOTE: set value to 0 at end time
                child.color.updateValue(timeEnd, finalValue);
                // @NOTE: required to properly handle cases when timeStart > timeEnd
                if (timingCurve != null) {
                    if (timeStart < timeEnd) {
                        keyframeAtTime.updateTimingCurve({
                            out: {
                                x: timingCurve.out.x,
                                y: timingCurve.out.y,
                            },
                        });
                    }
                    else {
                        keyframeAtTime.updateTimingCurve({
                            in: {
                                x: timingCurve.in.x,
                                y: timingCurve.in.y,
                            },
                        });
                    }
                }
            }
            if (child.type === exports.PropertyGroupType.BackgroundBlur ||
                child.type === exports.PropertyGroupType.LayerBlur) {
                const finalValue = 0;
                // @NOTE: create animation if not exists
                let keyframeAtTime = child.radius.keyframes.find((keyframe) => keyframe.time === timeStart);
                // @NOTE: stop processing if group is already hidden
                if (keyframeAtTime != null && keyframeAtTime.value === finalValue) {
                    return;
                }
                if (keyframeAtTime == null) {
                    keyframeAtTime = child.radius.createKeyframe(timeStart);
                }
                // @NOTE: add time shift
                // @NOTE: set value to 0 at end time
                child.radius.updateValue(timeEnd, finalValue);
                // @NOTE: required to properly handle cases when timeStart > timeEnd
                if (timingCurve != null) {
                    if (timeStart < timeEnd) {
                        keyframeAtTime.updateTimingCurve({
                            out: {
                                x: timingCurve.out.x,
                                y: timingCurve.out.y,
                            },
                        });
                    }
                    else {
                        keyframeAtTime.updateTimingCurve({
                            in: {
                                x: timingCurve.in.x,
                                y: timingCurve.in.y,
                            },
                        });
                    }
                }
            }
        });
        inBoth.forEach((id) => {
            const idx = parseInt(id.split('-')[0], 10);
            const left = self.children[idx];
            const right = model.children[idx];
            if (left == null || right == null) {
                throw new TypeError('Something went wrong');
            }
            left.applyTransition(right, options);
        });
        inRightOnly.forEach((id) => {
            const idx = parseInt(id.split('-')[0], 10);
            const child = model.children[idx];
            if (child == null) {
                throw new TypeError('Something went wrong');
            }
            const clonedChild = clone(child);
            self.children.push(clonedChild);
            if (clonedChild.type === exports.PropertyGroupType.DropShadow ||
                clonedChild.type === exports.PropertyGroupType.InnerShadow) {
                const startValue = {
                    ...child.color.getValue(timeStart),
                    a: 0,
                };
                // @NOTE: create animation if not exists
                let keyframeAtTime = clonedChild.color.keyframes.find((keyframe) => keyframe.time === timeEnd);
                // @NOTE: stop processing if group is already hidden
                if (keyframeAtTime != null && keyframeAtTime.value === startValue) {
                    return;
                }
                if (keyframeAtTime == null) {
                    keyframeAtTime = clonedChild.color.createKeyframe(timeEnd);
                }
                // @NOTE: set value to 0 at start time
                clonedChild.color.updateValue(timeStart, startValue);
                // @NOTE: required to properly handle cases when timeStart > timeEnd
                if (timingCurve != null) {
                    if (timeStart < timeEnd) {
                        keyframeAtTime.updateTimingCurve({
                            in: {
                                x: timingCurve.in.x,
                                y: timingCurve.in.y,
                            },
                        });
                    }
                    else {
                        keyframeAtTime.updateTimingCurve({
                            out: {
                                x: timingCurve.out.x,
                                y: timingCurve.out.y,
                            },
                        });
                    }
                }
                if (springCurve != null) {
                    keyframeAtTime.updateSpringCurve(springCurve);
                }
                return;
            }
            if (clonedChild.type === exports.PropertyGroupType.BackgroundBlur ||
                clonedChild.type === exports.PropertyGroupType.LayerBlur) {
                const startValue = 0;
                // @NOTE: create animation if not exists
                let keyframeAtTime = clonedChild.radius.keyframes.find((keyframe) => keyframe.time === timeEnd);
                // @NOTE: stop processing if group is already hidden
                if (keyframeAtTime != null && keyframeAtTime.value === startValue) {
                    return;
                }
                if (keyframeAtTime == null) {
                    keyframeAtTime = clonedChild.radius.createKeyframe(timeEnd);
                }
                // @NOTE: set value to 0 at start time
                clonedChild.radius.updateValue(timeStart, startValue);
                // @NOTE: required to properly handle cases when timeStart > timeEnd
                if (timingCurve != null) {
                    if (timeStart < timeEnd) {
                        keyframeAtTime.updateTimingCurve({
                            in: {
                                x: timingCurve.in.x,
                                y: timingCurve.in.y,
                            },
                        });
                    }
                    else {
                        keyframeAtTime.updateTimingCurve({
                            out: {
                                x: timingCurve.out.x,
                                y: timingCurve.out.y,
                            },
                        });
                    }
                }
                if (springCurve != null) {
                    keyframeAtTime.updateSpringCurve(springCurve);
                }
                return;
            }
        });
    },
    updateStructure: (model, options) => {
        for (let i = 0; i < Math.max(self.children.length, model.children.length); i += 1) {
            const left = self.children.length > i ? self.children[i] : undefined;
            const right = model.children.length > i ? model.children[i] : undefined;
            if (left == null) {
                self.addChild(getSnapshot(right));
                continue;
            }
            if (right == null) {
                self.removeChild(left.id);
                i -= 1;
                continue;
            }
            // @NOTE: if provided child has different type then we keep provided child
            if (left.type !== right.type) {
                const newArray = R__namespace.update(i, getSnapshot(right), self.children.map((item) => item.toJSON()));
                const newArrayOfModels = newArray.map((item) => propertyGroup$1.create(item));
                // @ts-ignore
                self.children.replace(newArrayOfModels);
                continue;
            }
            left.updateStructure(right, options);
        }
    },
    expand: () => {
        self.children.forEach((child) => child.showOnTimeline());
    },
    collapse: () => {
        self.children.forEach((child) => child.hideOnTimeline());
    },
}))
    .views((self) => ({
    getSortedKeyframes: () => {
        return R__namespace.flatten(self.children.map((child) => child.getSortedKeyframes()));
    },
    getKeyframes: () => {
        return R__namespace.flatten(self.children.map((child) => child.getKeyframes()));
    },
    equals: (right) => {
        for (let i = 0; i < self.children.length; i += 1) {
            const leftEffect = self.children[i];
            const rightEffect = right.children[i];
            if (rightEffect == null) {
                return false;
            }
            if (!leftEffect.equals(rightEffect)) {
                return false;
            }
        }
        return true;
    },
}));

const propertyGroup = types.union({
    dispatcher: (snapshot) => {
        if (snapshot.type === exports.PropertyGroupType.Solid) {
            return solidFillPropertyGroup;
        }
        if (snapshot.type === exports.PropertyGroupType.Image) {
            return imageFillPropertyGroup;
        }
        if (snapshot.type === exports.PropertyGroupType.Gradient) {
            return gradientPropertyGroup;
        }
        throw new TypeError(`Property group with type "${snapshot.type}" is not supported yet`);
    },
}, solidFillPropertyGroup, imageFillPropertyGroup, gradientPropertyGroup);
const paintPropertyGroupSet = basePropertyGroupSet
    .named('Paint Property Group Set')
    .props({
    type: exports.PropertyGroupSetType.Paint,
    children: types.array(propertyGroup),
})
    .actions((self) => ({
    shiftOnTimeline: (delta) => {
        self.children.forEach((child) => child.shiftOnTimeline(delta));
    },
    applyTransition: (model, options) => {
        const { timeStart, timeEnd, timingCurve, springCurve } = options;
        const selfIds = self.children.map((child, idx) => `${idx}-${child.type}`);
        const modelIds = model.children.map((child, idx) => `${idx}-${child.type}`);
        // @NOTE: indexes of groups which exists in both models
        const inBoth = R__namespace.intersection(selfIds, modelIds);
        // @NOTE: indexes of groups which exists in left model
        const inLeftOnly = R__namespace.without(inBoth, selfIds);
        // @NOTE: indexes of groups which exists in right model
        const inRightOnly = R__namespace.without(inBoth, modelIds);
        for (const id of inLeftOnly) {
            const idx = parseInt(id.split('-')[0], 10);
            const child = self.children[idx];
            if (child == null) {
                throw new TypeError('Something went wrong');
            }
            if (child.type === exports.PropertyGroupType.Image) {
                const finalValue = 0;
                // @NOTE: create animation if not exists
                let keyframeAtTime = child.opacity.keyframes.find((keyframe) => keyframe.time === timeStart);
                // @NOTE: stop processing if group is already hidden
                if (keyframeAtTime != null && keyframeAtTime.value === finalValue) {
                    return;
                }
                if (keyframeAtTime == null) {
                    keyframeAtTime = child.opacity.createKeyframe(timeStart);
                }
                // @NOTE: add time shift
                // @NOTE: set value to 0 at end time
                child.opacity.updateValue(timeEnd, finalValue);
                // @NOTE: apply beauty timing curve
                if (timingCurve != null) {
                    if (timeStart < timeEnd) {
                        keyframeAtTime.updateTimingCurve({
                            out: {
                                x: timingCurve.out.x,
                                y: timingCurve.out.y,
                            },
                        });
                    }
                    else {
                        keyframeAtTime.updateTimingCurve({
                            in: {
                                x: timingCurve.in.x,
                                y: timingCurve.in.y,
                            },
                        });
                    }
                }
            }
            if (child.type === exports.PropertyGroupType.Solid) {
                const finalValue = {
                    ...child.color.getValue(timeStart),
                    a: 0,
                };
                // @NOTE: create animation if not exists
                let keyframeAtTime = child.color.keyframes.find((keyframe) => keyframe.time === timeStart);
                // @NOTE: stop processing if group is already animated
                if (keyframeAtTime != null &&
                    keyframeAtTime.value.a === finalValue.a) {
                    return;
                }
                if (keyframeAtTime == null) {
                    keyframeAtTime = child.color.createKeyframe(timeStart);
                }
                // @NOTE: add time shift
                // @NOTE: set value to 0 at end time
                child.color.updateValue(timeEnd, finalValue);
                // @NOTE: required to properly handle cases when timeStart > timeEnd
                if (timingCurve != null) {
                    if (timeStart < timeEnd) {
                        keyframeAtTime.updateTimingCurve({
                            out: {
                                x: timingCurve.out.x,
                                y: timingCurve.out.y,
                            },
                        });
                    }
                    else {
                        keyframeAtTime.updateTimingCurve({
                            in: {
                                x: timingCurve.in.x,
                                y: timingCurve.in.y,
                            },
                        });
                    }
                }
            }
            if (child.type === exports.PropertyGroupType.Gradient) ;
        }
        for (const id of inBoth) {
            const idx = parseInt(id.split('-')[0], 10);
            const left = self.children[idx];
            const right = model.children[idx];
            if (left == null || right == null) {
                throw new TypeError('Something went wrong');
            }
            left.applyTransition(right, options);
        }
        for (const id of inRightOnly) {
            const idx = parseInt(id.split('-')[0], 10);
            const child = model.children[idx];
            if (child == null) {
                throw new TypeError('Something went wrong');
            }
            const clonedChild = clone(child);
            self.children.push(clonedChild);
            if (clonedChild.type === exports.PropertyGroupType.Image) {
                const startValue = 0;
                // @NOTE: create animation if not exists
                let keyframeAtTime = clonedChild.opacity.keyframes.find((keyframe) => keyframe.time === timeEnd);
                // @NOTE: stop processing if group is already hidden
                if (keyframeAtTime != null && keyframeAtTime.value === startValue) {
                    return;
                }
                if (keyframeAtTime == null) {
                    keyframeAtTime = clonedChild.opacity.createKeyframe(timeStart);
                }
                // @NOTE: set value to 0 at start time
                clonedChild.opacity.updateValue(timeEnd, startValue);
                // @NOTE: required to properly handle cases when timeStart > timeEnd
                if (timingCurve != null) {
                    if (timeStart < timeEnd) {
                        keyframeAtTime.updateTimingCurve({
                            in: {
                                x: timingCurve.in.x,
                                y: timingCurve.in.y,
                            },
                        });
                    }
                    else {
                        keyframeAtTime.updateTimingCurve({
                            out: {
                                x: timingCurve.out.x,
                                y: timingCurve.out.y,
                            },
                        });
                    }
                }
                if (springCurve != null) {
                    keyframeAtTime.updateSpringCurve(springCurve);
                }
                return;
            }
            if (clonedChild.type === exports.PropertyGroupType.Solid) {
                const startValue = {
                    ...clonedChild.color.getValue(timeEnd),
                    a: 0,
                };
                // @NOTE: create animation if not exists
                let keyframeAtTime = clonedChild.color.keyframes.find((keyframe) => keyframe.time === timeEnd);
                // @NOTE: stop processing if group is already hidden
                if (keyframeAtTime != null &&
                    keyframeAtTime.value.a === startValue.a) {
                    return;
                }
                if (keyframeAtTime == null) {
                    keyframeAtTime = clonedChild.color.createKeyframe(timeEnd);
                }
                // @NOTE: set value to 0 at start time
                clonedChild.color.updateValue(timeStart, startValue);
                // @NOTE: required to properly handle cases when timeStart > timeEnd
                if (timingCurve != null) {
                    if (timeStart < timeEnd) {
                        keyframeAtTime.updateTimingCurve({
                            in: {
                                x: timingCurve.in.x,
                                y: timingCurve.in.y,
                            },
                        });
                    }
                    else {
                        keyframeAtTime.updateTimingCurve({
                            out: {
                                x: timingCurve.out.x,
                                y: timingCurve.out.y,
                            },
                        });
                    }
                }
                if (springCurve != null) {
                    keyframeAtTime.updateSpringCurve(springCurve);
                }
            }
            if (clonedChild.type === exports.PropertyGroupType.Gradient) ;
        }
    },
    updateStructure: (model, options) => {
        // @NOTE: merge
        for (let i = 0; i < Math.max(self.children.length, model.children.length); i += 1) {
            const left = self.children.length > i ? self.children[i] : undefined;
            const right = model.children.length > i ? model.children[i] : undefined;
            if (left == null) {
                self.addChild(right.toJSON());
                continue;
            }
            if (right == null) {
                self.removeChild(left.id);
                i -= 1;
                continue;
            }
            // @NOTE: if provided child has different type then we keep provided child
            if (left.type !== right.type) {
                const newArray = R__namespace.update(i, right.toJSON(), self.children.map((item) => item.toJSON()));
                const newArrayOfModels = newArray.map((item) => propertyGroup.create(item));
                // @ts-ignore
                self.children.replace(newArrayOfModels);
                continue;
            }
            left.updateStructure(right, options);
        }
    },
}))
    .views((self) => ({
    getSortedKeyframes: () => {
        return R__namespace.flatten(self.children.map((child) => child.getSortedKeyframes()));
    },
    getKeyframes: () => {
        return R__namespace.flatten(self.children.map((child) => child.getKeyframes()));
    },
    equals: (right) => {
        for (let i = 0; i < self.children.length; i += 1) {
            const leftPaint = self.children[i];
            const rightPaint = right.children[i];
            if (rightPaint == null) {
                return false;
            }
            if (leftPaint.type !== rightPaint.type) {
                return false;
            }
            if (!leftPaint.equals(rightPaint)) {
                return false;
            }
        }
        return true;
    },
}));

const fillPropertyGroupSet = paintPropertyGroupSet
    .named('Fill Property Group Set')
    .preProcessSnapshot((snapshot) => ({
    ...snapshot,
    type: exports.PropertyGroupSetType.Fill,
}))
    .props({
    type: exports.PropertyGroupSetType.Fill,
});

const genericPropertyGroupSet = types.custom({
    name: 'Property Group Set',
    fromSnapshot: (snapshot) => {
        if (snapshot.type === exports.PropertyGroupSetType.Effect) {
            const snapshotToApply = snapshot;
            return effectPropertyGroupSet.create(snapshotToApply);
        }
        if (snapshot.type === exports.PropertyGroupSetType.Paint) {
            const snapshotToApply = snapshot;
            return paintPropertyGroupSet.create(snapshotToApply);
        }
        throw new TypeError(`[propertyGroupSet] type: "${snapshot.type}" is not supporting yet`);
    },
    toSnapshot: (value) => getSnapshot(value),
    isTargetType: (value) => false,
    getValidationMessage: (snapshot) => '',
});

const strokePropertyGroupSet = paintPropertyGroupSet
    .named('Stroke Property Group Set')
    .preProcessSnapshot((snapshot) => ({
    ...snapshot,
    type: exports.PropertyGroupSetType.Stroke,
}))
    .props({
    type: exports.PropertyGroupSetType.Stroke,
});

const blendProperties = types
    .model('Blend Properties', {
    blendMode: types.optional(blendMode, () => blendMode.create({})),
    isMask: false,
    effects: types.optional(effectPropertyGroupSet, () => getSnapshot(effectPropertyGroupSet.create({}))),
})
    .actions((self) => ({
    expandBlendProperties: () => {
        self.blendMode.showOnTimeline();
        self.effects.children.forEach((group) => {
            group.showOnTimeline();
            group.expand();
        });
    },
    collapseBlendProperties: () => {
        self.blendMode.hideOnTimeline();
        self.effects.children.forEach((group) => {
            group.hideOnTimeline();
            group.collapse();
        });
    },
    shiftOnTimelineBlendProperties: (delta) => {
        self.effects.shiftOnTimeline(delta);
    },
    applyBlendTransition: (model, options) => {
        self.effects.applyTransition(model.effects, options);
    },
    updateBlendStructure: (model, options) => {
        self.blendMode.updateValue(model.blendMode.value);
        self.isMask = model.isMask;
        self.effects.updateStructure(model.effects, options);
    },
    addBackgroundBlur: () => {
        const effect = backgroundBlurPropertyGroup.create({});
        self.effects.addChild(effect);
        return effect;
    },
    addDropShadow: () => {
        const effect = dropShadowPropertyGroup.create({});
        self.effects.addChild(effect);
        return effect;
    },
    addInnerShadow: () => {
        const effect = innerShadowPropertyGroup.create({});
        self.effects.addChild(effect);
        return effect;
    },
    addLayerBlur: () => {
        const effect = layerBlurPropertyGroup.create({});
        self.effects.addChild(effect);
        return effect;
    },
}))
    .views((self) => ({
    getBlendPropertiesSortedKeyframes: () => {
        return [...self.effects.getSortedKeyframes()];
    },
    getBlendPropertiesKeyframes: () => {
        return [...self.effects.getKeyframes()];
    },
    equalsBlendProperties: (right) => {
        return (self.blendMode.value === right.blendMode.value &&
            self.effects.equals(right.effects));
    },
}));

const childrenProperties = types
    .model('Children Properties', {
    children: types.optional(types.array(types.late(() => node)), []),
})
    .actions((self) => ({
    addChild: (child) => {
        self.children.push(child);
    },
    addChildAt: (idx, child) => {
        self.children.splice(idx, 0, child);
    },
    removeChild: (childId) => {
        const index = self.children.findIndex((_child) => _child.id === childId);
        if (index === -1) {
            return;
        }
        self.children.splice(index, 1);
    },
    expandChildren: () => {
        self.children.forEach((child) => {
            child.showOnTimeline();
        });
    },
    collapseChildren: () => {
        self.children.forEach((child) => {
            if ([exports.NodeType.Frame, exports.NodeType.Instance, exports.NodeType.Group].includes(child.type)) {
                child.collapseChildren();
            }
            child.collapseProperties();
            child.hideOnTimeline();
        });
    },
    shiftOnTimelineChildrenProperties: (delta) => {
        self.children.forEach((child) => child.shiftOnTimeline(delta));
    },
    // @NOTE: call when recursive structure update needed
    updateChildrenStructure: (model, options) => {
        // @NOTE: because we are always calling updateStructure on node which don't have children
        // we can skip any reconciliation and push all children from provided model directly.
        applySnapshot(self.children, getSnapshot(model.children));
        return self;
    },
    updateChildrenColor: (color) => {
        self.children.forEach((child) => child.updateColor(color, { triggeredFromParent: true }));
    },
    lockChildren: () => {
        self.children.forEach((child) => child.lock({ triggeredFromParent: true }));
    },
    unlockChildren: () => {
        self.children.forEach((child) => child.unlock({ triggeredFromParent: true }));
    },
    showChildrenInViewport: () => {
        self.children.forEach((child) => child.showInViewport({ triggeredFromParent: true }));
    },
    hideChildrenInViewport: () => {
        self.children.forEach((child) => child.hideInViewport({ triggeredFromParent: true }));
    },
    updateChildrenSolo: (solo) => {
        self.children.forEach((child) => child.updateSolo(solo));
    },
    updateChildrenStartTime: (startTime) => {
        self.children.forEach((child) => child.updateStartTime(startTime, { triggeredFromParent: true }));
    },
    updateChildrenDuration: (duration) => {
        self.children.forEach((child) => child.updateDuration(duration, { triggeredFromParent: true }));
    },
    updateChildrenEndTime: (endTime) => {
        self.children.forEach((child) => child.updateEndTime(endTime, { triggeredFromParent: true }));
    },
}))
    .views((self) => ({
    getChildrenPropertiesSortedKeyframes: () => {
        return R__namespace.flatten(self.children.map((child) => child.getSortedKeyframes()));
    },
    getChildrenPropertiesKeyframes: () => {
        return R__namespace.flatten(self.children.map((child) => child.getKeyframes()));
    },
    hasChildrenTrimLayer: () => {
        return R__namespace.any((child) => child.hasTrimLayer(), self.children);
    },
}));

const cornerProperties = types
    .model('Corner Properties', {
    // @NOTE: common property
    cornerRadius: types.optional(cornerRadius, () => cornerRadius.create({})),
    isSmoothCornersEnabled: types.optional(types.boolean, () => false),
})
    .actions((self) => ({
    expandCornerProperties: () => {
        self.cornerRadius.showOnTimeline();
        return self;
    },
    collapseCornerProperties: () => {
        self.cornerRadius.hideOnTimeline();
        return self;
    },
    shiftOnTimelineCornerProperties: (delta) => {
        self.cornerRadius.shiftOnTimeline(delta);
        return self;
    },
    applyCornerTransition: (model, options) => {
        applyPropertyTransition('cornerRadius', self, model, options);
        return self;
    },
    updateCornerStructure: (model, options) => {
        self.cornerRadius.updateValue(-1, model.cornerRadius.value);
        return self;
    },
    enableSmoothCorners: () => {
        self.isSmoothCornersEnabled = true;
        // @ts-ignore
        self.bumpVersion();
        return self;
    },
    disableSmoothCorners: () => {
        self.isSmoothCornersEnabled = false;
        // @ts-ignore
        self.bumpVersion();
        return self;
    },
    toggleSmoothCorners: () => {
        self.isSmoothCornersEnabled = !self.isSmoothCornersEnabled;
        // @ts-ignore
        self.bumpVersion();
        return self;
    },
}))
    .views((self) => ({
    /**
     * @description return sorted array of all keyframes
     */
    getCornerPropertiesSortedKeyframes: () => {
        return [...self.cornerRadius.keyframes];
    },
    /**
     * @description return array of all keyframes
     */
    getCornerPropertiesKeyframes: () => {
        return [...Array.from(self.cornerRadius._keyframes.values())];
    },
    equalsCornerProperties: (right) => {
        // @NOTE: temporary disabled
        return true;
    },
}));

const geometryProperties = types
    .model('Geometry Properties', {
    fills: types.optional(fillPropertyGroupSet, () => getSnapshot(fillPropertyGroupSet.create({}))),
    strokes: types.optional(strokePropertyGroupSet, () => getSnapshot(strokePropertyGroupSet.create({}))),
    strokeWeight: types.optional(strokeWeight, () => strokeWeight.create({})),
    strokeAlign: types.optional(types.enumeration(Object.values(exports.StrokeAlign)), exports.StrokeAlign.Center),
    strokeCap: types.optional(types.enumeration(Object.values(exports.StrokeCap)), exports.StrokeCap.None),
    strokeCapStart: types.optional(types.enumeration(Object.values(exports.StrokeCap)), exports.StrokeCap.None),
    strokeCapEnd: types.optional(types.enumeration(Object.values(exports.StrokeCap)), exports.StrokeCap.None),
    strokeJoin: types.optional(types.enumeration(Object.values(exports.StrokeJoin)), exports.StrokeJoin.Bevel),
    dashOffset: types.optional(dashOffset, () => dashOffset.create({ value: 0 })),
    dash: types.optional(dash, () => dash.create({ value: 0 })),
    gap: types.optional(gap, () => gap.create({ value: 0 })),
    trimStart: types.maybeNull(trimStart),
    trimEnd: types.maybeNull(trimEnd),
    trimOffset: types.maybeNull(trimOffset),
    /**
     * @description used in trim path to reverse path
     */
    isPathReversed: false,
})
    .preProcessSnapshot((snapshot) => {
    if (snapshot == null) {
        return snapshot;
    }
    if (snapshot.strokeCap != null) {
        // @NOTE: update legacy stroke cap. We used BUTT for SQUARE by mistake.
        const strokeCap = 
        // @ts-ignore
        snapshot.strokeCap === 'BUTT' ? exports.StrokeCap.Square : snapshot.strokeCap;
        return {
            ...snapshot,
            strokeCap,
            strokeCapStart: snapshot.strokeCapStart ?? strokeCap,
            strokeCapEnd: snapshot.strokeCapEnd ?? strokeCap,
        };
    }
    return snapshot;
})
    .actions((self) => ({
    expandGeometryProperties: () => {
        self.fills.children.forEach((group) => {
            group.showOnTimeline();
            group.expand();
        });
        self.strokes.children.forEach((group) => {
            group.showOnTimeline();
            group.expand();
        });
        self.strokeWeight.showOnTimeline();
        self.dash.showOnTimeline();
        self.gap.showOnTimeline();
        self.dashOffset.showOnTimeline();
        self.trimStart?.showOnTimeline();
        self.trimEnd?.showOnTimeline();
        self.trimOffset?.showOnTimeline();
    },
    collapseGeometryProperties: () => {
        self.fills.children.forEach((group) => {
            group.hideOnTimeline();
            group.collapse();
        });
        self.strokes.children.forEach((group) => {
            group.hideOnTimeline();
            group.collapse();
        });
        self.strokeWeight.hideOnTimeline();
        self.dash.hideOnTimeline();
        self.gap.hideOnTimeline();
        self.dashOffset.hideOnTimeline();
        self.trimStart?.hideOnTimeline();
        self.trimEnd?.hideOnTimeline();
        self.trimOffset?.hideOnTimeline();
    },
    shiftOnTimelineGeometryProperties: (delta) => {
        self.fills.shiftOnTimeline(delta);
        self.strokes.shiftOnTimeline(delta);
        self.strokeWeight.shiftOnTimeline(delta);
        self.dash.shiftOnTimeline(delta);
        self.gap.shiftOnTimeline(delta);
        self.dashOffset.shiftOnTimeline(delta);
        self.trimStart?.shiftOnTimeline(delta);
        self.trimEnd?.shiftOnTimeline(delta);
        self.trimOffset?.shiftOnTimeline(delta);
    },
    updateStrokeAlign: (newValue) => {
        self.strokeAlign = newValue;
        // @NOTE: method from base properties
        // @ts-ignore
        self.bumpVersion();
    },
    updateStrokeCapStart: (newValue) => {
        self.strokeCapStart = newValue;
        // @NOTE: method from base properties
        // @ts-ignore
        self.bumpVersion();
    },
    updateStrokeCapEnd: (newValue) => {
        self.strokeCapEnd = newValue;
        // @NOTE: method from base properties
        // @ts-ignore
        self.bumpVersion();
    },
    updateStrokeJoin: (newValue) => {
        self.strokeJoin = newValue;
        // @NOTE: method from base properties
        // @ts-ignore
        self.bumpVersion();
    },
    // @TODO: add transition to dashes and trim paths
    applyGeometryTransition: (model, options) => {
        self.fills.applyTransition(model.fills, options);
        self.strokes.applyTransition(model.strokes, options);
        // @ts-ignore
        applyPropertyTransition('strokeWeight', self, model, options);
        return self;
    },
    updateGeometryStructure: (model, options) => {
        self.fills.updateStructure(model.fills, options);
        self.strokes.updateStructure(model.strokes, options);
        self.strokeWeight.updateValue(-1, model.strokeWeight.value);
        self.strokeAlign = model.strokeAlign;
        self.strokeCapStart = model.strokeCapStart;
        self.strokeCapEnd = model.strokeCapEnd;
        self.strokeJoin = model.strokeJoin;
        self.dash.updateValue(-1, model.dash.value);
        self.gap.updateValue(-1, model.gap.value);
        self.dashOffset.updateValue(-1, model.dashOffset.value);
        if (self.trimStart != null &&
            model.trimStart != null &&
            self.trimEnd != null &&
            model.trimEnd != null &&
            self.trimOffset != null &&
            model.trimEnd != null) {
            self.trimStart.updateValue(-1, model.trimStart.value);
            self.trimEnd.updateValue(-1, model.trimEnd.value);
            self.trimOffset.updateValue(-1, model.trimOffset.value);
        }
    },
    enableTrimPath: () => {
        self.trimStart = trimStart.create();
        self.trimEnd = trimEnd.create();
        self.trimOffset = trimOffset.create();
        // @NOTE: method from base properties
        // @ts-ignore
        self.bumpVersion();
    },
    disableTrimPath: () => {
        self.trimStart = null;
        self.trimEnd = null;
        self.trimOffset = null;
        // @NOTE: method from base properties
        // @ts-ignore
        self.bumpVersion();
    },
    addFill: () => {
        const group = solidFillPropertyGroup.create({});
        group.showOnTimeline();
        group.expand();
        self.fills.addChild(group);
        return self;
    },
    addStroke: () => {
        const group = solidFillPropertyGroup.create({});
        group.showOnTimeline();
        group.expand();
        self.strokes.addChild(group);
        return self;
    },
    reversePath: () => {
        self.isPathReversed = !self.isPathReversed;
        // @NOTE: method from base properties
        // @ts-ignore
        self.bumpVersion();
        return self;
    },
}))
    .views((self) => ({
    getGeometryPropertiesSortedKeyframes: () => {
        const coreKeyframes = [
            ...self.fills.getSortedKeyframes(),
            ...self.strokes.getSortedKeyframes(),
            ...self.strokeWeight.keyframes,
            ...self.dash.keyframes,
            ...self.gap.keyframes,
            ...self.dashOffset.keyframes,
        ];
        const trimPathKeyframes = self.trimStart != null &&
            self.trimEnd != null &&
            self.trimOffset != null
            ? [
                ...self.trimStart.keyframes,
                ...self.trimEnd.keyframes,
                ...self.trimOffset.keyframes,
            ]
            : [];
        return [...coreKeyframes, ...trimPathKeyframes];
    },
    getGeometryPropertiesKeyframes: () => {
        const coreKeyframes = [
            ...self.fills.getKeyframes(),
            ...self.strokes.getKeyframes(),
            ...Array.from(self.strokeWeight._keyframes.values()),
            ...Array.from(self.dash._keyframes.values()),
            ...Array.from(self.gap._keyframes.values()),
            ...Array.from(self.dashOffset._keyframes.values()),
        ];
        const trimPathKeyframes = self.trimStart != null &&
            self.trimEnd != null &&
            self.trimOffset != null
            ? [
                ...Array.from(self.trimStart._keyframes.values()),
                ...Array.from(self.trimEnd._keyframes.values()),
                ...Array.from(self.trimOffset._keyframes.values()),
            ]
            : [];
        return [...coreKeyframes, ...trimPathKeyframes];
    },
    get hasDash() {
        return (self.dash.hasAnimation === true ||
            self.dash.value !== 0 ||
            self.gap.hasAnimation === true ||
            self.gap.value !== 0 ||
            self.dashOffset.hasAnimation === true ||
            self.dashOffset.value !== 0);
    },
    get hasTrimPath() {
        return (self.trimStart != null &&
            self.trimEnd != null &&
            self.trimOffset != null);
    },
    get hasFills() {
        return self.fills.children.length > 0;
    },
    get hasStrokes() {
        return self.strokes.children.length > 0;
    },
    equalsGeometryProperties: (right) => {
        const isStrokeVisible = self.strokes.children.length > 0;
        const strokeWeightEquals = isStrokeVisible
            ? self.strokeWeight.equals(right.strokeWeight)
            : true;
        const strokeAlignEquals = isStrokeVisible
            ? self.strokeAlign === right.strokeAlign
            : true;
        const strokeCapStartEquals = isStrokeVisible
            ? self.strokeCapStart === right.strokeCapStart
            : true;
        const strokeCapEndEquals = isStrokeVisible
            ? self.strokeCapEnd === right.strokeCapEnd
            : true;
        const strokeJoinEquals = isStrokeVisible
            ? self.strokeJoin === right.strokeJoin
            : true;
        const dashOffsetEquals = isStrokeVisible
            ? self.dashOffset.equals(right.dashOffset)
            : true;
        const dashEquals = isStrokeVisible ? self.dash.equals(right.dash) : true;
        const gapEquals = isStrokeVisible ? self.gap.equals(right.gap) : true;
        const trimPathEquals = self.trimStart != null &&
            self.trimEnd != null &&
            self.trimOffset != null
            ? self.trimStart.equals(right.trimStart) &&
                self.trimEnd.equals(right.trimEnd) &&
                self.trimOffset.equals(right.trimOffset)
            : true;
        return (self.fills.equals(right.fills) &&
            self.strokes.equals(right.strokes) &&
            strokeWeightEquals &&
            strokeAlignEquals &&
            strokeCapStartEquals &&
            strokeCapEndEquals &&
            strokeJoinEquals &&
            dashOffsetEquals &&
            dashEquals &&
            gapEquals &&
            trimPathEquals);
    },
}));

function mapAnchorPointToPoint2d({ type, size, }) {
    if (type === 'top-left') {
        return { x: 0, y: 0 };
    }
    if (type === 'top') {
        return { x: size.x / 2, y: 0 };
    }
    if (type === 'top-right') {
        return { x: size.x, y: 0 };
    }
    if (type === 'left') {
        return { x: 0, y: size.y / 2 };
    }
    if (type === 'center') {
        return { x: size.x / 2, y: size.y / 2 };
    }
    if (type === 'right') {
        return { x: size.x, y: size.y / 2 };
    }
    if (type === 'bottom-left') {
        return { x: 0, y: size.y };
    }
    if (type === 'bottom') {
        return { x: size.x / 2, y: size.y };
    }
    if (type === 'bottom-right') {
        return { x: size.x, y: size.y };
    }
    return { x: 0, y: 0 };
}
const layoutProperties = types
    .model('Layout Properties', {
    anchorPoint: types.optional(anchorPoint, () => anchorPoint.create({})),
    position: types.optional(position, () => position.create({})),
    rotation: types.optional(rotation, () => rotation.create({})),
    scale: types.optional(scale, () => scale.create({})),
    size: types.optional(size, () => size.create({})),
    skew: types.optional(skew, () => skew.create({})),
    initialSize: types.optional(point2dProperty, () => point2dProperty.create({})),
    initialRotation: types.optional(point1dProperty, () => point1dProperty.create({})),
    initialScale: types.optional(point2dProperty, () => point2dProperty.create({})),
    opacity: types.optional(opacity, () => opacity.create({})),
    sizeBehaviour: types.optional(types.enumeration(R__namespace.values(exports.NodeSizeBehaviour)), exports.NodeSizeBehaviour.Ignore),
})
    .preProcessSnapshot((snapshot) => {
    if (snapshot == null) {
        return {};
    }
    const size = R__namespace.path(['size', 'value'], snapshot);
    const rotation = R__namespace.path(['rotation', 'value'], snapshot);
    const scale = R__namespace.path(['scale', 'value'], snapshot);
    if (size == null) {
        return snapshot;
    }
    const initialSize = (() => {
        // @NOTE: in case when use set 0 at static value of size
        if (size.x < 1 && size.y < 1) {
            const keyframes = snapshot.size._keyframes;
            if (keyframes == null) {
                return size;
            }
            const sortedKeyframes = R__namespace.sort((left, right) => left.time - right.time, Object.values(keyframes));
            const biggestSize = sortedKeyframes.reduce((acc, keyframe) => {
                if (acc.x < keyframe.value.x && acc.y < keyframe.value.y) {
                    return keyframe.value;
                }
                return acc;
            }, { x: 0, y: 0 });
            return biggestSize;
        }
        return size;
    })();
    const snapshotWithInitialSize = R__namespace.assocPath(['initialSize', 'value'], initialSize, snapshot);
    const snapshotWithInitialScale = R__namespace.assocPath(['initialScale', 'value'], scale, snapshotWithInitialSize);
    return R__namespace.assocPath(['initialRotation', 'value'], rotation, snapshotWithInitialScale);
})
    .postProcessSnapshot((snapshot) => R__namespace.omit(['initialSize', 'initialRotation', 'initialScale'], snapshot))
    .actions((self) => ({
    updateAnchorPoint: (type) => {
        const anchorPoint = self.anchorPoint.value;
        const size = self.initialSize.value;
        const original = type === 'custom'
            ? anchorPoint
            : mapAnchorPointToPoint2d({
                type,
                size: {
                    x: size.x,
                    y: size.y,
                },
            });
        self.anchorPoint.updateValue(-1, original);
        return self;
    },
    expandLayoutProperties: () => {
        self.anchorPoint.showOnTimeline();
        self.position.showOnTimeline();
        self.rotation.showOnTimeline();
        self.scale.showOnTimeline();
        self.size.showOnTimeline();
        self.skew.showOnTimeline();
        self.opacity.showOnTimeline();
    },
    collapseLayoutProperties: () => {
        self.anchorPoint.hideOnTimeline();
        self.position.hideOnTimeline();
        self.rotation.hideOnTimeline();
        self.scale.hideOnTimeline();
        self.size.hideOnTimeline();
        self.skew.hideOnTimeline();
        self.opacity.hideOnTimeline();
    },
    shiftOnTimelineLayoutProperties: (delta) => {
        self.anchorPoint.shiftOnTimeline(delta);
        self.position.shiftOnTimeline(delta);
        self.rotation.shiftOnTimeline(delta);
        self.scale.shiftOnTimeline(delta);
        self.size.shiftOnTimeline(delta);
        self.skew.shiftOnTimeline(delta);
        self.opacity.shiftOnTimeline(delta);
    },
    applyLayoutTransition: (model, options) => {
        applyPropertyTransition('anchorPoint', self, model, options);
        applyPropertyTransition('position', self, model, options);
        applyPropertyTransition('rotation', self, model, options, 
        // Input:  0, 45, 90, 135, 180, -135, -90, -45, 0
        // Output: 0, 45, 90, 135, 180, 225, 270, 315, 360
        (left, right) => {
            const leftSign = Math.sign(left.x);
            const isSwitched = Math.abs(left.x - right.x) > 180;
            if (isSwitched) {
                return {
                    x: 360 * leftSign + right.x,
                };
            }
            return right;
        });
        applyPropertyTransition('skew', self, model, options);
        if (!options.ignoreProperties?.includes('opacity')) {
            applyPropertyTransition('opacity', self, model, options);
        }
        if (
        // @ts-ignore
        (self.type === exports.NodeType.Vector &&
            self.sizeBehaviour === exports.NodeSizeBehaviour.Fill) ||
            // @ts-ignore
            self.type !== exports.NodeType.Vector) {
            applyPropertyTransition('scale', self, model, options);
            applyPropertyTransition('size', self, model, options);
        }
        if (
        // @ts-ignore
        self.type === exports.NodeType.Vector &&
            self.sizeBehaviour === exports.NodeSizeBehaviour.Ignore) {
            const { timeStart, timeEnd, timingCurve, springCurve } = options;
            const selfToApply = self;
            const modelToApply = model;
            if (JSON.stringify(selfToApply.size.getValue(timeStart)) ===
                JSON.stringify(modelToApply.size.getValue(timeEnd))) {
                return self;
            }
            let startKeyframe = selfToApply.scale.keyframes.find((keyframe) => keyframe.time === timeStart);
            if (startKeyframe == null) {
                startKeyframe = selfToApply.scale.createKeyframe(timeStart);
            }
            selfToApply.scale.updateValue(timeEnd, {
                x: modelToApply.size.value.x / selfToApply.size.value.x,
                y: modelToApply.size.value.y / selfToApply.size.value.y,
            });
            const endKeyframe = selfToApply.scale.keyframes.find((keyframe) => keyframe.time === timeEnd);
            if (startKeyframe == null || endKeyframe == null) {
                throw new TypeError('Something went wrong');
            }
            if (springCurve != null) {
                if (timeStart < timeEnd) {
                    startKeyframe.updateSpringCurve(springCurve);
                }
                else {
                    endKeyframe.updateSpringCurve(springCurve);
                }
            }
            // @NOTE: required to properly handle cases when timeStart > timeEnd
            if (timingCurve != null) {
                if (timeStart < timeEnd) {
                    startKeyframe.updateTimingCurve({
                        out: {
                            x: timingCurve.out.x,
                            y: timingCurve.out.y,
                        },
                    });
                    endKeyframe.updateTimingCurve({
                        in: {
                            x: timingCurve.in.x,
                            y: timingCurve.in.y,
                        },
                    });
                }
                else {
                    startKeyframe.updateTimingCurve({
                        in: {
                            x: timingCurve.in.x,
                            y: timingCurve.in.y,
                        },
                    });
                    endKeyframe.updateTimingCurve({
                        out: {
                            x: timingCurve.out.x,
                            y: timingCurve.out.y,
                        },
                    });
                }
            }
            return self;
        }
        return self;
    },
    updateLayoutStructure: (model, options) => {
        // @TODO: refactor
        const updateStructure = (key) => {
            const selfToApply = self;
            const modelToApply = model;
            selfToApply[key].updateValue(-1, modelToApply[key].value);
        };
        updateStructure('position');
        updateStructure('rotation');
        updateStructure('scale');
        updateStructure('size');
        updateStructure('skew');
        updateStructure('opacity');
    },
    updateSizeBehaviour: (newSizeBehaviour) => {
        self.sizeBehaviour = newSizeBehaviour;
        return self;
    },
}))
    .views((self) => {
    const getAbsolutePositionByTime = (time, providedPosition, node) => {
        if (node.isRoot) {
            return providedPosition;
        }
        const currentPosition = node.position.getValue(time);
        const newPosition = {
            x: currentPosition.x + providedPosition.x,
            y: currentPosition.y + providedPosition.y,
        };
        if (node.parent?.isRoot) {
            return newPosition;
        }
        return getAbsolutePositionByTime(time, newPosition, node.parent);
    };
    return {
        getLayoutPropertiesSortedKeyframes: () => {
            return [
                ...self.anchorPoint.keyframes,
                ...self.position.keyframes,
                ...self.rotation.keyframes,
                ...self.scale.keyframes,
                ...self.size.keyframes,
                ...self.skew.keyframes,
                ...self.opacity.keyframes,
            ];
        },
        getLayoutPropertiesKeyframes: () => {
            return [
                ...Array.from(self.anchorPoint._keyframes.values()),
                ...Array.from(self.position._keyframes.values()),
                ...Array.from(self.rotation._keyframes.values()),
                ...Array.from(self.scale._keyframes.values()),
                ...Array.from(self.size._keyframes.values()),
                ...Array.from(self.skew._keyframes.values()),
                ...Array.from(self.opacity._keyframes.values()),
            ];
        },
        getAbsolutePositionByTime: (time) => {
            const zeroPosition = position.create({}).getValue(time);
            return getAbsolutePositionByTime(time, zeroPosition, self);
        },
        // @NOTE: this method used only for prototype node comparisson
        // and currently it's faster to disable layout comparisson here.
        // @TODO: find the better naming
        equalsLayoutProperties: (right) => {
            // @NOTE: check only if opacity of provided nodes not 100%
            return self.opacity.value === 1 && right.opacity.value === 1;
        },
    };
});

const sceneProperties = types
    .model('Scene Properties', {
    color: types.optional(types.enumeration(Object.values(exports.LayerColor)), exports.LayerColor.Blue),
    solo: types.optional(types.enumeration(Object.values(exports.NodeSoloType)), exports.NodeSoloType.None),
    lockType: types.optional(types.enumeration(Object.values(exports.LockType)), exports.LockType.Normal),
    visibilityInViewport: types.optional(types.enumeration(Object.values(exports.VisibilityType)), exports.VisibilityType.Visible),
})
    .actions((self) => ({
    updateColor: (color, options) => {
        self.color = color;
        // @NOTE: method from base properties
        // @ts-ignore
        self.bumpVersion({
            triggeredFromParent: options?.triggeredFromParent ?? false,
        });
    },
    lock: (options) => {
        self.lockType = exports.LockType.Locked;
        // @NOTE: method from base properties
        // @ts-ignore
        self.bumpVersion({
            triggeredFromParent: options?.triggeredFromParent ?? false,
        });
    },
    unlock: (options) => {
        self.lockType = exports.LockType.Normal;
        // @NOTE: method from base properties
        // @ts-ignore
        self.bumpVersion({
            triggeredFromParent: options?.triggeredFromParent ?? false,
        });
    },
    showInViewport: (options) => {
        self.visibilityInViewport = exports.VisibilityType.Visible;
        // @NOTE: method from base properties
        // @ts-ignore
        self.bumpVersion({
            triggeredFromParent: options?.triggeredFromParent ?? false,
        });
    },
    hideInViewport: (options) => {
        self.visibilityInViewport = exports.VisibilityType.Hidden;
        // @NOTE: method from base properties
        // @ts-ignore
        self.bumpVersion({
            triggeredFromParent: options?.triggeredFromParent ?? false,
        });
    },
    updateSolo: (soloType) => {
        self.solo = soloType;
    },
    updateSceneStructure: (model, options) => {
        // @TODO: remove in the next release
        // @NOTE: color shouldn't change
        // self.color = model.color
        self.solo = model.solo;
        self.lockType = model.lockType;
        self.visibilityInViewport = model.visibilityInViewport;
    },
    reloadSceneKeyframeIds: () => { },
}))
    .views((self) => ({
    get locked() {
        return (
        // @ts-ignore
        self.lockType === exports.LockType.Locked || self.getParent()?.locked === true);
    },
    get visibleInViewport() {
        // @ts-ignore
        if (self.getParent()?.visibleInViewport === false) {
            return false;
        }
        return self.visibilityInViewport === exports.VisibilityType.Visible;
    },
}));

const timeProperties = types
    .model('Time Properties', {
    _startTime: types.maybeNull(types.number),
    _duration: types.maybeNull(types.number),
})
    .views((self) => {
    const getStartTime = () => {
        if (self._startTime != null) {
            return self._startTime;
        }
        // @ts-ignore
        const project = self.getProject();
        // @NOTE: can happen when we initiate node without project context.
        // So we provide default value here
        if (project === self) {
            return 0;
        }
        return project.startTime;
    };
    const getDuration = () => {
        if (self._duration != null) {
            return self._duration;
        }
        // @ts-ignore
        const project = self.getProject();
        // @NOTE: can happen when we initiate node without project context.
        // So we provide default value here
        if (project === self) {
            return 100000;
        }
        return project.duration;
    };
    return {
        get startTime() {
            return getStartTime();
        },
        get duration() {
            return getDuration();
        },
        get endTime() {
            return getStartTime() + getDuration();
        },
        hasTrimLayer: () => {
            return self._startTime != null || self._duration != null;
        },
    };
})
    .actions((self) => ({
    updateStartTime: (start, options) => {
        // @NOTE: method from base properties
        // @ts-ignore
        self.bumpVersion({
            triggeredFromParent: options?.triggeredFromParent ?? false,
        });
        if (start == null) {
            self._startTime = null;
            return;
        }
        const startTime = self.startTime;
        const duration = self.duration;
        const newTime = R__namespace.min(start, startTime + duration);
        if (newTime === duration) {
            self._startTime = round(duration - 0.1, { fixed: 2 });
            return;
        }
        self._startTime = round(newTime, { fixed: 2 });
    },
    updateDuration: (duration, options) => {
        // @NOTE: method from base properties
        // @ts-ignore
        self.bumpVersion({
            triggeredFromParent: options?.triggeredFromParent ?? false,
        });
        if (duration == null) {
            self._duration = null;
            return;
        }
        if (duration === 0) {
            self._duration = 0.1;
            return;
        }
        self._duration = round(duration, { fixed: 2 });
    },
    updateEndTime: (end, options) => {
        // @NOTE: method from base properties
        // @ts-ignore
        self.bumpVersion({
            triggeredFromParent: options?.triggeredFromParent ?? false,
        });
        if (end == null) {
            self._duration = null;
            return;
        }
        const startTime = self.startTime;
        const newTime = R__namespace.max(startTime, end);
        const duration = newTime - startTime;
        if (duration === 0) {
            self._duration = 0.1;
            return;
        }
        self._duration = round(duration, { fixed: 2 });
    },
    shiftOnTimelineTimeProperties: (delta) => {
        const startTime = self.startTime;
        if (self._startTime == null) {
            self._startTime = startTime + delta;
            return;
        }
        self._startTime += delta;
    },
    // @TODO: implement if needed
    updateTimeStructure: (model, options) => {
        // self.startTime = model.startTime
        // self.duration = model.duration
    },
    reloadTimeKeyframeIds: () => { },
}));

const booleanOperationProperties = types.model('Boolean Operation Properties', {
    type: exports.NodeType.BooleanOperation,
    booleanOperation: types.optional(types.enumeration(Object.values(exports.BooleanOperationType)), exports.BooleanOperationType.Union),
});
const booleanOperation = types
    .compose('Boolean Operation', booleanOperationProperties, baseNodeProperties, sceneProperties, blendProperties, childrenProperties, cornerProperties, geometryProperties, layoutProperties, timeProperties, 
// @ts-ignore
visibleOnTimeline)
    .actions((self) => {
    const superUpdateStartTime = self.updateStartTime;
    const superUpdateDuration = self.updateDuration;
    const superUpdateEndTime = self.updateEndTime;
    const superUpdateColor = self.updateColor;
    const superLock = self.lock;
    const superUnlock = self.unlock;
    const superUpdateSolo = self.updateSolo;
    return {
        expandProperties: () => {
            self.expandBlendProperties();
            self.expandLayoutProperties();
        },
        collapseProperties: () => {
            self.collapseBlendProperties();
            self.collapseLayoutProperties();
        },
        applyTransition: (model, options) => {
            self.applyBlendTransition(model, options);
            self.applyLayoutTransition(model, options);
        },
        updateStructure: (model, options) => {
            self.updateBaseStructure(model, options);
            self.updateChildrenStructure(model, options);
            self.updateBlendStructure(model, options);
            self.updateLayoutStructure(model, options);
            self.updateSceneStructure(model, options);
            self.updateTimeStructure(model, options);
            self.updateVisibleOnTimelineStructure(model, options);
        },
        updateStartTime: (startTime) => {
            superUpdateStartTime(startTime);
            self.updateChildrenStartTime(startTime);
        },
        updateDuration: (duration) => {
            superUpdateDuration(duration);
            self.updateChildrenDuration(duration);
        },
        updateEndTime: (endTime) => {
            superUpdateEndTime(endTime);
            self.updateChildrenEndTime(endTime);
        },
        updateColor: (color) => {
            superUpdateColor(color);
            self.updateChildrenColor(color);
        },
        lock: () => {
            superLock();
            self.lockChildren();
        },
        unlock: () => {
            superUnlock();
            self.unlockChildren();
        },
        updateSolo: (solo) => {
            superUpdateSolo(solo);
            self.updateChildrenSolo(solo);
        },
    };
})
    .views((self) => {
    const superHasTrimLayer = self.hasTrimLayer;
    return {
        getSortedKeyframes: () => {
            return [
                ...self.getCornerPropertiesSortedKeyframes(),
                ...self.getGeometryPropertiesSortedKeyframes(),
                ...self.getLayoutPropertiesSortedKeyframes(),
                ...self.getChildrenPropertiesSortedKeyframes(),
            ];
        },
        getKeyframes: () => {
            return [
                ...self.getCornerPropertiesKeyframes(),
                ...self.getGeometryPropertiesKeyframes(),
                ...self.getLayoutPropertiesKeyframes(),
                ...self.getChildrenPropertiesKeyframes(),
            ];
        },
        /**
         * @description true when current layer contains animation
         */
        get hasOwnAnimation() {
            const keyframes = [
                ...self.getCornerPropertiesKeyframes(),
                ...self.getGeometryPropertiesKeyframes(),
                ...self.getLayoutPropertiesKeyframes(),
            ];
            return keyframes.length !== 0;
        },
        hasTrimLayer: () => {
            return superHasTrimLayer() || self.hasChildrenTrimLayer();
        },
    };
});

const ellipseProperties = types
    .model('Ellipse Properties', {
    type: exports.NodeType.Ellipse,
    // @NOTE: arc data taken from figma
    // @NOTE: starting angle in degrees
    startingAngle: types.optional(angle, () => angle.create({ value: 0 })),
    // @NOTE: ending angle in percents
    endingAngle: types.optional(percentNegative, () => percentNegative.create({ value: 1 })),
    // @NOTE: inner radius in percents
    innerRadius: types.optional(percent, () => percent.create({ value: 0 })),
})
    .views((self) => ({
    equalsEllipseProperties: (right) => {
        return (self.startingAngle.equals(right.startingAngle) &&
            self.endingAngle.equals(right.endingAngle) &&
            self.innerRadius.equals(right.innerRadius));
    },
}));
const ellipse = types
    .compose('Ellipse', ellipseProperties, baseNodeProperties, sceneProperties, blendProperties, cornerProperties, geometryProperties, layoutProperties, timeProperties, visibleOnTimeline)
    .actions((self) => ({
    expandProperties: () => {
        self.startingAngle.showOnTimeline();
        self.endingAngle.showOnTimeline();
        self.innerRadius.showOnTimeline();
        self.expandBlendProperties();
        self.expandCornerProperties();
        self.expandGeometryProperties();
        self.expandLayoutProperties();
    },
    collapseProperties: () => {
        self.startingAngle.hideOnTimeline();
        self.endingAngle.hideOnTimeline();
        self.innerRadius.hideOnTimeline();
        self.collapseBlendProperties();
        self.collapseCornerProperties();
        self.collapseGeometryProperties();
        self.collapseLayoutProperties();
    },
    shiftOnTimeline: (delta) => {
        self.startingAngle.shiftOnTimeline(delta);
        self.endingAngle.shiftOnTimeline(delta);
        self.innerRadius.shiftOnTimeline(delta);
        self.shiftOnTimelineBlendProperties(delta);
        self.shiftOnTimelineCornerProperties(delta);
        self.shiftOnTimelineGeometryProperties(delta);
        self.shiftOnTimelineLayoutProperties(delta);
        self.shiftOnTimelineTimeProperties(delta);
    },
    applyTransition: (model, options) => {
        applyPropertyTransition('startingAngle', self, model, options);
        applyPropertyTransition('endingAngle', self, model, options);
        applyPropertyTransition('innerRadius', self, model, options);
        self.applyBlendTransition(model, options);
        self.applyCornerTransition(model, options);
        self.applyGeometryTransition(model, options);
        self.applyLayoutTransition(model, options);
    },
    updateStructure: (model, options) => {
        self.startingAngle.updateValue(-1, model.startingAngle.value);
        self.endingAngle.updateValue(-1, model.endingAngle.value);
        self.innerRadius.updateValue(-1, model.innerRadius.value);
        self.updateBaseStructure(model, options);
        self.updateBlendStructure(model, options);
        self.updateCornerStructure(model, options);
        self.updateGeometryStructure(model, options);
        self.updateLayoutStructure(model, options);
        self.updateSceneStructure(model, options);
        self.updateTimeStructure(model, options);
        self.updateVisibleOnTimelineStructure(model, options);
    },
}))
    .views((self) => ({
    /**
     * @description return sorted keyframes
     */
    getSortedKeyframes: () => {
        return [
            ...self.startingAngle.keyframes,
            ...self.innerRadius.keyframes,
            ...self.endingAngle.keyframes,
            ...self.getBlendPropertiesSortedKeyframes(),
            ...self.getCornerPropertiesSortedKeyframes(),
            ...self.getGeometryPropertiesSortedKeyframes(),
            ...self.getLayoutPropertiesSortedKeyframes(),
        ];
    },
    /**
     * @description return keyframes
     */
    getKeyframes: () => {
        return [
            ...Array.from(self.startingAngle._keyframes.values()),
            ...Array.from(self.innerRadius._keyframes.values()),
            ...Array.from(self.endingAngle._keyframes.values()),
            ...self.getBlendPropertiesKeyframes(),
            ...self.getCornerPropertiesKeyframes(),
            ...self.getGeometryPropertiesKeyframes(),
            ...self.getLayoutPropertiesKeyframes(),
        ];
    },
    /**
     * @description true when current layer contains animation
     */
    get hasOwnAnimation() {
        const keyframes = [
            ...Array.from(self.startingAngle._keyframes.values()),
            ...Array.from(self.innerRadius._keyframes.values()),
            ...Array.from(self.endingAngle._keyframes.values()),
            ...self.getBlendPropertiesKeyframes(),
            ...self.getCornerPropertiesKeyframes(),
            ...self.getGeometryPropertiesKeyframes(),
            ...self.getLayoutPropertiesKeyframes(),
        ];
        return keyframes.length !== 0;
    },
    equals: (right) => {
        return (self.equalsEllipseProperties(right) &&
            self.equalsBlendProperties(right) &&
            self.equalsCornerProperties(right) &&
            self.equalsGeometryProperties(right) &&
            self.equalsLayoutProperties(right));
    },
}));

const individualCornersProperties = types
    .model('Individual Corner Properties', {
    individualCornersEnabled: false,
    // @NOTE: individual for rectangle and frame
    topLeftRadius: types.optional(topLeftRadius, () => topLeftRadius.create({})),
    topRightRadius: types.optional(topRightRadius, () => topRightRadius.create({})),
    bottomLeftRadius: types.optional(bottomLeftRadius, () => bottomLeftRadius.create({})),
    bottomRightRadius: types.optional(bottomRightRadius, () => bottomRightRadius.create({})),
})
    .actions((self) => ({
    expandIndividualCornersProperties: () => {
        self.topLeftRadius.showOnTimeline();
        self.topRightRadius.showOnTimeline();
        self.bottomLeftRadius.showOnTimeline();
        self.bottomRightRadius.showOnTimeline();
        return self;
    },
    collapseIndividualCornersProperties: () => {
        self.topLeftRadius.hideOnTimeline();
        self.topRightRadius.hideOnTimeline();
        self.bottomLeftRadius.hideOnTimeline();
        self.bottomRightRadius.hideOnTimeline();
        return self;
    },
    shiftOnTimelineIndividualCornersProperties: (delta) => {
        self.topLeftRadius.shiftOnTimeline(delta);
        self.topRightRadius.shiftOnTimeline(delta);
        self.bottomLeftRadius.shiftOnTimeline(delta);
        self.bottomRightRadius.shiftOnTimeline(delta);
        return self;
    },
    applyIndividualCornersTransition: (model, options) => {
        applyPropertyTransition('topLeftRadius', self, model, options);
        applyPropertyTransition('topRightRadius', self, model, options);
        applyPropertyTransition('bottomLeftRadius', self, model, options);
        applyPropertyTransition('bottomRightRadius', self, model, options);
        return self;
    },
    updateIndividualCornersStructure: (model, options) => {
        self.topLeftRadius.updateValue(-1, model.topLeftRadius.value);
        self.topRightRadius.updateValue(-1, model.topRightRadius.value);
        self.bottomLeftRadius.updateValue(-1, model.bottomLeftRadius.value);
        self.bottomRightRadius.updateValue(-1, model.bottomRightRadius.value);
        return self;
    },
    // @TODO: add setting of default params from cornerRadius value
    enableIndividualCorners: () => {
        self.individualCornersEnabled = true;
        // @ts-ignore
        self.topLeftRadius.value = self.cornerRadius.value;
        // @ts-ignore
        self.topRightRadius.value = self.cornerRadius.value;
        // @ts-ignore
        self.bottomLeftRadius.value = self.cornerRadius.value;
        // @ts-ignore
        self.bottomRightRadius.value = self.cornerRadius.value;
        // @NOTE: method from base properties
        // @ts-ignore
        self.bumpVersion();
        return self;
    },
    disableIndividualCorners: () => {
        self.individualCornersEnabled = false;
        // @NOTE: method from base properties
        // @ts-ignore
        self.bumpVersion();
        return self;
    },
}))
    .views((self) => ({
    getIndividualCornersPropertiesSortedKeyframes: () => {
        return [
            ...self.topLeftRadius.keyframes,
            ...self.topRightRadius.keyframes,
            ...self.bottomLeftRadius.keyframes,
            ...self.bottomRightRadius.keyframes,
        ];
    },
    getIndividualCornersPropertiesKeyframes: () => {
        return [
            ...Array.from(self.topLeftRadius._keyframes.values()),
            ...Array.from(self.topRightRadius._keyframes.values()),
            ...Array.from(self.bottomLeftRadius._keyframes.values()),
            ...Array.from(self.bottomRightRadius._keyframes.values()),
        ];
    },
    equalsIndividualCornersProperties: (right) => {
        // @NOTE: temporary disabled
        return true;
    },
}));

const individualStrokesProperties = types
    .model('Geometry Properties', {
    individualStrokesEnabled: false,
    // @TODO: rename to make it consistent to individual-corner-properties
    // topLeftRadius -> topStrokeWeight
    strokeTopWeight: types.optional(strokeTopWeight, () => strokeTopWeight.create({})),
    strokeBottomWeight: types.optional(strokeBottomWeight, () => strokeBottomWeight.create({})),
    strokeLeftWeight: types.optional(strokeLeftWeight, () => strokeLeftWeight.create({})),
    strokeRightWeight: types.optional(strokeRightWeight, () => strokeRightWeight.create({})),
})
    .actions((self) => ({
    expandIndividualStrokesProperties: () => {
        self.strokeTopWeight.showOnTimeline();
        self.strokeBottomWeight.showOnTimeline();
        self.strokeLeftWeight.showOnTimeline();
        self.strokeRightWeight.showOnTimeline();
        return self;
    },
    collapseIndividualStrokesProperties: () => {
        self.strokeTopWeight.hideOnTimeline();
        self.strokeBottomWeight.hideOnTimeline();
        self.strokeLeftWeight.hideOnTimeline();
        self.strokeRightWeight.hideOnTimeline();
        return self;
    },
    shiftOnTimelineIndividualStrokesProperties: (delta) => {
        self.strokeTopWeight.shiftOnTimeline(delta);
        self.strokeBottomWeight.shiftOnTimeline(delta);
        self.strokeLeftWeight.shiftOnTimeline(delta);
        self.strokeRightWeight.shiftOnTimeline(delta);
        return self;
    },
    applyIndividualStrokesTransition: (model, options) => {
        if (model.strokeTopWeight == null ||
            model.strokeBottomWeight == null ||
            model.strokeLeftWeight == null ||
            model.strokeRightWeight == null) {
            return self;
        }
        applyPropertyTransition('strokeTopWeight', self, model, options);
        applyPropertyTransition('strokeBottomWeight', self, model, options);
        applyPropertyTransition('strokeLeftWeight', self, model, options);
        applyPropertyTransition('strokeRightWeight', self, model, options);
        return self;
    },
    updateIndividualStrokesStructure: (model, options) => {
        self.individualStrokesEnabled = model.individualStrokesEnabled;
        self.strokeTopWeight.updateValue(-1, model.strokeTopWeight.value);
        self.strokeBottomWeight.updateValue(-1, model.strokeBottomWeight.value);
        self.strokeLeftWeight.updateValue(-1, model.strokeLeftWeight.value);
        self.strokeRightWeight.updateValue(-1, model.strokeRightWeight.value);
        return self;
    },
    // @TODO: add setting of default params from strokeWeight value
    enableIndividualStrokes: () => {
        // @ts-ignore
        self.bumpVersion();
        self.individualStrokesEnabled = true;
        return self;
    },
    disableIndividualStrokes: () => {
        // @ts-ignore
        self.bumpVersion();
        self.individualStrokesEnabled = false;
        return self;
    },
}))
    .views((self) => ({
    getIndividualStrokesPropertiesSortedKeyframes: () => {
        return [
            ...self.strokeTopWeight.keyframes,
            ...self.strokeBottomWeight.keyframes,
            ...self.strokeLeftWeight.keyframes,
            ...self.strokeRightWeight.keyframes,
        ];
    },
    getIndividualStrokesPropertiesKeyframes: () => {
        return [
            ...Array.from(self.strokeTopWeight._keyframes.values()),
            ...Array.from(self.strokeBottomWeight._keyframes.values()),
            ...Array.from(self.strokeLeftWeight._keyframes.values()),
            ...Array.from(self.strokeRightWeight._keyframes.values()),
        ];
    },
    equalsIndividualStrokesProperties: (right) => {
        // @NOTE: temporary disabled
        return true;
    },
}));

const frameProperties = types
    .model('Frame Properties', {
    type: exports.NodeType.Frame,
    clipsContent: true,
})
    .actions((self) => ({
    updateClipsContent: (value) => {
        self.clipsContent = value;
        // @ts-ignore
        self.bumpVersion();
    },
}));
const frame = types
    .compose('Frame', frameProperties, baseNodeProperties, blendProperties, childrenProperties, sceneProperties, timeProperties, cornerProperties, individualCornersProperties, 
// @ts-ignore
geometryProperties, 
// @ts-ignore
individualStrokesProperties, 
// @ts-ignore
layoutProperties, 
// @ts-ignore
visibleOnTimeline)
    .actions((s) => {
    const self = s;
    const superUpdateStartTime = self.updateStartTime;
    const superUpdateDuration = self.updateDuration;
    const superUpdateEndTime = self.updateEndTime;
    const superUpdateColor = self.updateColor;
    const superLock = self.lock;
    const superUnlock = self.unlock;
    const superUpdateSolo = self.updateSolo;
    return {
        expandProperties: () => {
            self.expandBlendProperties();
            self.expandCornerProperties();
            self.expandIndividualCornersProperties();
            self.expandGeometryProperties();
            self.expandIndividualStrokesProperties();
            self.expandLayoutProperties();
        },
        collapseProperties: () => {
            self.collapseBlendProperties();
            self.collapseCornerProperties();
            self.collapseIndividualCornersProperties();
            self.collapseGeometryProperties();
            self.collapseIndividualStrokesProperties();
            self.collapseLayoutProperties();
        },
        shiftOnTimeline: (delta) => {
            self.shiftOnTimelineBlendProperties(delta);
            self.shiftOnTimelineChildrenProperties(delta);
            self.shiftOnTimelineCornerProperties(delta);
            self.shiftOnTimelineIndividualCornersProperties(delta);
            self.shiftOnTimelineGeometryProperties(delta);
            self.shiftOnTimelineIndividualStrokesProperties(delta);
            self.shiftOnTimelineLayoutProperties(delta);
            self.shiftOnTimelineTimeProperties(delta);
        },
        applyTransition: (model, options) => {
            if (self.isRoot) {
                self.applyBlendTransition(model, options);
                self.applyGeometryTransition(model, options);
                return;
            }
            self.applyBlendTransition(model, options);
            self.applyCornerTransition(model, options);
            self.applyIndividualCornersTransition(model, options);
            self.applyGeometryTransition(model, options);
            self.applyIndividualStrokesTransition(model, options);
            self.applyLayoutTransition(model, options);
        },
        updateStructure: (model, options) => {
            self.clipsContent = model.clipsContent;
            self.updateBaseStructure(model, options);
            self.updateBlendStructure(model, options);
            self.updateChildrenStructure(model, options);
            self.updateCornerStructure(model, options);
            self.updateIndividualCornersStructure(model, options);
            self.updateGeometryStructure(model, options);
            self.updateIndividualStrokesStructure(model, options);
            self.updateLayoutStructure(model, options);
            self.updateSceneStructure(model, options);
            self.updateTimeStructure(model, options);
            self.updateVisibleOnTimelineStructure(model, options);
        },
        updateStartTime: (startTime) => {
            superUpdateStartTime(startTime);
            self.updateChildrenStartTime(startTime);
        },
        updateDuration: (duration) => {
            superUpdateDuration(duration);
            self.updateChildrenDuration(duration);
        },
        updateEndTime: (endTime) => {
            superUpdateEndTime(endTime);
            self.updateChildrenEndTime(endTime);
        },
        updateColor: (color, options) => {
            superUpdateColor(color, options);
            self.updateChildrenColor(color);
        },
        lock: (options) => {
            superLock(options);
            self.lockChildren();
        },
        unlock: (options) => {
            superUnlock(options);
            self.unlockChildren();
        },
        updateSolo: (solo) => {
            superUpdateSolo(solo);
            self.updateChildrenSolo(solo);
        },
    };
})
    .views((self) => {
    const superHasTrimLayer = self.hasTrimLayer;
    return {
        getSortedKeyframes: () => {
            return [
                ...self.getBlendPropertiesSortedKeyframes(),
                ...self.getCornerPropertiesSortedKeyframes(),
                ...(self.individualCornersEnabled
                    ? self.getIndividualCornersPropertiesSortedKeyframes()
                    : []),
                ...self.getGeometryPropertiesSortedKeyframes(),
                ...self.getIndividualStrokesPropertiesSortedKeyframes(),
                ...self.getLayoutPropertiesSortedKeyframes(),
                ...self.getChildrenPropertiesSortedKeyframes(),
            ];
        },
        getKeyframes: () => {
            return [
                ...self.getBlendPropertiesKeyframes(),
                ...self.getCornerPropertiesKeyframes(),
                ...(self.individualCornersEnabled
                    ? self.getIndividualCornersPropertiesKeyframes()
                    : []),
                ...self.getGeometryPropertiesKeyframes(),
                ...self.getIndividualStrokesPropertiesKeyframes(),
                ...self.getLayoutPropertiesKeyframes(),
                ...self.getChildrenPropertiesKeyframes(),
            ];
        },
        getOwnSortedKeyframes: () => {
            return [
                ...self.getBlendPropertiesSortedKeyframes(),
                ...self.getCornerPropertiesSortedKeyframes(),
                ...(self.individualCornersEnabled
                    ? self.getIndividualCornersPropertiesSortedKeyframes()
                    : []),
                ...self.getGeometryPropertiesSortedKeyframes(),
                ...(self.individualStrokesEnabled
                    ? self.getIndividualStrokesPropertiesSortedKeyframes()
                    : []),
                ...self.getLayoutPropertiesSortedKeyframes(),
            ];
        },
        getOwnKeyframes: () => {
            return [
                ...self.getBlendPropertiesKeyframes(),
                ...self.getCornerPropertiesKeyframes(),
                ...(self.individualCornersEnabled
                    ? self.getIndividualCornersPropertiesKeyframes()
                    : []),
                ...self.getGeometryPropertiesKeyframes(),
                ...(self.individualStrokesEnabled
                    ? self.getIndividualStrokesPropertiesKeyframes()
                    : []),
                ...self.getLayoutPropertiesKeyframes(),
            ];
        },
        /**
         * @description true when current layer contains animation
         */
        get hasOwnAnimation() {
            const keyframes = [
                ...self.getCornerPropertiesKeyframes(),
                ...self.getBlendPropertiesKeyframes(),
                ...(self.individualCornersEnabled
                    ? self.getIndividualCornersPropertiesKeyframes()
                    : []),
                ...self.getGeometryPropertiesKeyframes(),
                ...(self.individualStrokesEnabled
                    ? self.getIndividualStrokesPropertiesKeyframes()
                    : []),
                ...self.getLayoutPropertiesKeyframes(),
            ];
            return keyframes.length !== 0;
        },
        hasChildrenAnimation: () => {
            const keyframes = [...self.getChildrenPropertiesKeyframes()];
            return keyframes.length !== 0;
        },
        hasTrimLayer: () => {
            return superHasTrimLayer() || self.hasChildrenTrimLayer();
        },
        equals: (right) => {
            return (self.equalsBlendProperties(right) &&
                self.equalsCornerProperties(right) &&
                self.equalsIndividualCornersProperties(right) &&
                self.equalsIndividualStrokesProperties(right) &&
                self.equalsGeometryProperties(right) &&
                self.equalsLayoutProperties(right));
        },
    };
});

const groupProperties = types.model('Group Properties', {
    type: exports.NodeType.Group,
});
const group = types
    .compose('Group', groupProperties, baseNodeProperties, childrenProperties, cornerProperties, blendProperties, sceneProperties, timeProperties, layoutProperties, visibleOnTimeline)
    .actions((self) => {
    const superUpdateStartTime = self.updateStartTime;
    const superUpdateDuration = self.updateDuration;
    const superUpdateEndTime = self.updateEndTime;
    const superUpdateColor = self.updateColor;
    const superLock = self.lock;
    const superUnlock = self.unlock;
    const superUpdateSolo = self.updateSolo;
    return {
        expandProperties: () => {
            self.expandBlendProperties();
            self.expandCornerProperties();
            // @ts-ignore
            self.expandLayoutProperties();
        },
        collapseProperties: () => {
            self.collapseBlendProperties();
            self.collapseCornerProperties();
            // @ts-ignore
            self.collapseLayoutProperties();
        },
        shiftOnTimeline: (delta) => {
            self.shiftOnTimelineBlendProperties(delta);
            self.shiftOnTimelineChildrenProperties(delta);
            self.shiftOnTimelineCornerProperties(delta);
            self.shiftOnTimelineLayoutProperties(delta);
            self.shiftOnTimelineTimeProperties(delta);
        },
        applyTransition: (model, options) => {
            self.applyCornerTransition(model, options);
            self.applyLayoutTransition(model, options);
        },
        updateStructure: (model, options) => {
            self.updateBaseStructure(model, options);
            self.updateChildrenStructure(model, options);
            self.updateCornerStructure(model, options);
            self.updateLayoutStructure(model, options);
            self.updateSceneStructure(model, options);
            self.updateTimeStructure(model, options);
            self.updateVisibleOnTimelineStructure(model, options);
        },
        updateStartTime: (startTime) => {
            superUpdateStartTime(startTime);
            self.updateChildrenStartTime(startTime);
        },
        updateDuration: (duration) => {
            superUpdateDuration(duration);
            self.updateChildrenDuration(duration);
        },
        updateEndTime: (endTime) => {
            superUpdateEndTime(endTime);
            self.updateChildrenEndTime(endTime);
        },
        updateColor: (color, options) => {
            superUpdateColor(color, options);
            self.updateChildrenColor(color);
        },
        lock: (options) => {
            superLock(options);
            self.lockChildren();
        },
        unlock: (options) => {
            superUnlock(options);
            self.unlockChildren();
        },
        updateSolo: (solo) => {
            superUpdateSolo(solo);
            self.updateChildrenSolo(solo);
        },
    };
})
    .views((self) => {
    const superHasTrimLayer = self.hasTrimLayer;
    return {
        getSortedKeyframes: () => {
            return [
                ...self.getBlendPropertiesSortedKeyframes(),
                ...self.getCornerPropertiesSortedKeyframes(),
                ...self.getLayoutPropertiesSortedKeyframes(),
                ...self.getChildrenPropertiesSortedKeyframes(),
            ];
        },
        getKeyframes: () => {
            return [
                ...self.getBlendPropertiesKeyframes(),
                ...self.getCornerPropertiesKeyframes(),
                ...self.getLayoutPropertiesKeyframes(),
                ...self.getChildrenPropertiesKeyframes(),
            ];
        },
        getOwnSortedKeyframes: () => {
            return [
                ...self.getBlendPropertiesSortedKeyframes(),
                ...self.getCornerPropertiesSortedKeyframes(),
                ...self.getLayoutPropertiesSortedKeyframes(),
            ];
        },
        getOwnKeyframes: () => {
            return [
                ...self.getBlendPropertiesKeyframes(),
                ...self.getCornerPropertiesKeyframes(),
                ...self.getLayoutPropertiesKeyframes(),
            ];
        },
        /**
         * @description true when current layer contains animation
         */
        get hasOwnAnimation() {
            const keyframes = [
                ...self.getBlendPropertiesKeyframes(),
                ...self.getCornerPropertiesKeyframes(),
                ...self.getLayoutPropertiesKeyframes(),
            ];
            return keyframes.length !== 0;
        },
        hasChildrenAnimation: () => {
            const keyframes = [...self.getChildrenPropertiesKeyframes()];
            return keyframes.length !== 0;
        },
        hasTrimLayer: () => {
            return superHasTrimLayer() || self.hasChildrenTrimLayer();
        },
        equals: (right) => {
            return (self.equalsBlendProperties(right) &&
                self.equalsCornerProperties(right) &&
                self.equalsLayoutProperties(right));
        },
    };
});

const instanceProperties = types
    .model('Instnace Properties', {
    type: exports.NodeType.Instance,
    clipsContent: true,
    figmaInstanceId: types.maybeNull(types.string),
    figmaComponentId: types.maybeNull(types.string),
})
    .actions((self) => ({
    updateClipsContent: (value) => {
        self.clipsContent = value;
        // @ts-ignore
        self.bumpVersion();
    },
}));
const instance = types
    .compose('Instance', instanceProperties, baseNodeProperties, blendProperties, childrenProperties, sceneProperties, timeProperties, cornerProperties, individualCornersProperties, 
// @ts-ignore
geometryProperties, 
// @ts-ignore
individualStrokesProperties, 
// @ts-ignore
layoutProperties, 
// @ts-ignore
visibleOnTimeline)
    .actions((self) => {
    const superUpdateStartTime = self.updateStartTime;
    const superUpdateDuration = self.updateDuration;
    const superUpdateEndTime = self.updateEndTime;
    const superUpdateColor = self.updateColor;
    const superLock = self.lock;
    const superUnlock = self.unlock;
    const superUpdateSolo = self.updateSolo;
    return {
        expandProperties: () => {
            self.expandBlendProperties();
            self.expandCornerProperties();
            self.expandIndividualCornersProperties();
            self.expandGeometryProperties();
            self.expandIndividualStrokesProperties();
            self.expandLayoutProperties();
        },
        collapseProperties: () => {
            self.collapseBlendProperties();
            self.collapseCornerProperties();
            self.collapseIndividualCornersProperties();
            self.collapseGeometryProperties();
            self.collapseIndividualStrokesProperties();
            self.collapseLayoutProperties();
        },
        shiftOnTimeline: (delta) => {
            self.shiftOnTimelineBlendProperties(delta);
            self.shiftOnTimelineChildrenProperties(delta);
            self.shiftOnTimelineCornerProperties(delta);
            self.shiftOnTimelineIndividualCornersProperties(delta);
            self.shiftOnTimelineGeometryProperties(delta);
            self.shiftOnTimelineIndividualStrokesProperties(delta);
            self.shiftOnTimelineLayoutProperties(delta);
            self.shiftOnTimelineTimeProperties(delta);
        },
        applyTransition: (model, options) => {
            self.applyBlendTransition(model, options);
            self.applyCornerTransition(model, options);
            self.applyIndividualCornersTransition(model, options);
            self.applyGeometryTransition(model, options);
            self.applyIndividualStrokesTransition(model, options);
            self.applyLayoutTransition(model, options);
        },
        updateStructure: (model, options) => {
            self.clipsContent = model.clipsContent;
            self.updateBaseStructure(model, options);
            self.updateBlendStructure(model, options);
            self.updateChildrenStructure(model, options);
            self.updateCornerStructure(model, options);
            self.updateIndividualCornersStructure(model, options);
            self.updateGeometryStructure(model, options);
            self.updateIndividualStrokesStructure(model, options);
            self.updateLayoutStructure(model, options);
            self.updateSceneStructure(model, options);
            self.updateTimeStructure(model, options);
            self.updateVisibleOnTimelineStructure(model, options);
        },
        updateStartTime: (startTime) => {
            superUpdateStartTime(startTime);
            self.updateChildrenStartTime(startTime);
        },
        updateDuration: (duration) => {
            superUpdateDuration(duration);
            self.updateChildrenDuration(duration);
        },
        updateEndTime: (endTime) => {
            superUpdateEndTime(endTime);
            self.updateChildrenEndTime(endTime);
        },
        updateColor: (color, options) => {
            superUpdateColor(color, options);
            self.updateChildrenColor(color);
        },
        lock: (options) => {
            superLock(options);
            self.lockChildren();
        },
        unlock: (options) => {
            superUnlock(options);
            self.unlockChildren();
        },
        updateSolo: (solo) => {
            superUpdateSolo(solo);
            self.updateChildrenSolo(solo);
        },
    };
})
    .views((self) => {
    const superHasTrimLayer = self.hasTrimLayer;
    return {
        getSortedKeyframes: () => {
            return [
                ...self.getBlendPropertiesSortedKeyframes(),
                ...self.getCornerPropertiesSortedKeyframes(),
                ...(self.individualCornersEnabled
                    ? self.getIndividualCornersPropertiesSortedKeyframes()
                    : []),
                ...self.getGeometryPropertiesSortedKeyframes(),
                ...self.getIndividualStrokesPropertiesSortedKeyframes(),
                ...self.getLayoutPropertiesSortedKeyframes(),
                ...self.getChildrenPropertiesSortedKeyframes(),
            ];
        },
        getKeyframes: () => {
            return [
                ...self.getBlendPropertiesKeyframes(),
                ...self.getCornerPropertiesKeyframes(),
                ...(self.individualCornersEnabled
                    ? self.getIndividualCornersPropertiesKeyframes()
                    : []),
                ...self.getGeometryPropertiesKeyframes(),
                ...self.getIndividualStrokesPropertiesKeyframes(),
                ...self.getLayoutPropertiesKeyframes(),
                ...self.getChildrenPropertiesKeyframes(),
            ];
        },
        getOwnSortedKeyframes: () => {
            return [
                ...self.getBlendPropertiesSortedKeyframes(),
                ...self.getCornerPropertiesSortedKeyframes(),
                ...(self.individualCornersEnabled
                    ? self.getIndividualCornersPropertiesSortedKeyframes()
                    : []),
                ...self.getGeometryPropertiesSortedKeyframes(),
                ...(self.individualStrokesEnabled
                    ? self.getIndividualStrokesPropertiesSortedKeyframes()
                    : []),
                ...self.getLayoutPropertiesSortedKeyframes(),
            ];
        },
        getOwnKeyframes: () => {
            return [
                ...self.getBlendPropertiesKeyframes(),
                ...self.getCornerPropertiesKeyframes(),
                ...(self.individualCornersEnabled
                    ? self.getIndividualCornersPropertiesKeyframes()
                    : []),
                ...self.getGeometryPropertiesKeyframes(),
                ...(self.individualStrokesEnabled
                    ? self.getIndividualStrokesPropertiesKeyframes()
                    : []),
                ...self.getLayoutPropertiesKeyframes(),
            ];
        },
        /**
         * @description true when current layer contains animation
         */
        get hasOwnAnimation() {
            const keyframes = [
                ...self.getCornerPropertiesKeyframes(),
                ...self.getBlendPropertiesKeyframes(),
                ...(self.individualCornersEnabled
                    ? self.getIndividualCornersPropertiesKeyframes()
                    : []),
                ...self.getGeometryPropertiesKeyframes(),
                ...(self.individualStrokesEnabled
                    ? self.getIndividualStrokesPropertiesKeyframes()
                    : []),
                ...self.getLayoutPropertiesKeyframes(),
            ];
            return keyframes.length !== 0;
        },
        hasChildrenAnimation: () => {
            const keyframes = [...self.getChildrenPropertiesKeyframes()];
            return keyframes.length !== 0;
        },
        hasTrimLayer: () => {
            return superHasTrimLayer() || self.hasChildrenTrimLayer();
        },
        equals: (right) => {
            return (self.equalsBlendProperties(right) &&
                self.equalsCornerProperties(right) &&
                self.equalsIndividualCornersProperties(right) &&
                self.equalsIndividualStrokesProperties(right) &&
                self.equalsGeometryProperties(right) &&
                self.equalsLayoutProperties(right));
        },
    };
});

const lineProperties = types.model('Line Properties', {
    type: exports.NodeType.Line,
});
const line = types
    .compose('Line', lineProperties, baseNodeProperties, sceneProperties, blendProperties, geometryProperties, layoutProperties, timeProperties, visibleOnTimeline)
    .actions((self) => ({
    expandProperties: () => {
        self.expandBlendProperties();
        self.expandGeometryProperties();
        self.expandLayoutProperties();
    },
    collapseProperties: () => {
        self.collapseBlendProperties();
        self.collapseGeometryProperties();
        self.collapseLayoutProperties();
    },
    shiftOnTimeline: (delta) => {
        self.shiftOnTimelineBlendProperties(delta);
        self.shiftOnTimelineGeometryProperties(delta);
        self.shiftOnTimelineLayoutProperties(delta);
        self.shiftOnTimelineTimeProperties(delta);
    },
    applyTransition: (model, options) => {
        self.applyBlendTransition(model, options);
        self.applyGeometryTransition(model, options);
        self.applyLayoutTransition(model, options);
    },
    updateStructure: (model, options) => {
        self.updateBaseStructure(model, options);
        self.updateBlendStructure(model, options);
        self.updateGeometryStructure(model, options);
        self.updateLayoutStructure(model, options);
        self.updateSceneStructure(model, options);
        self.updateTimeStructure(model, options);
        self.updateVisibleOnTimelineStructure(model, options);
    },
}))
    .views((self) => ({
    getSortedKeyframes: () => {
        return [
            ...self.getBlendPropertiesSortedKeyframes(),
            ...self.getGeometryPropertiesSortedKeyframes(),
            ...self.getLayoutPropertiesSortedKeyframes(),
        ];
    },
    getKeyframes: () => {
        return [
            ...self.getBlendPropertiesKeyframes(),
            ...self.getGeometryPropertiesKeyframes(),
            ...self.getLayoutPropertiesKeyframes(),
        ];
    },
    /**
     * @description true when current layer contains animation
     */
    get hasOwnAnimation() {
        const keyframes = [
            ...self.getBlendPropertiesKeyframes(),
            ...self.getGeometryPropertiesKeyframes(),
            ...self.getLayoutPropertiesKeyframes(),
        ];
        return keyframes.length !== 0;
    },
    equals: (right) => {
        return (self.equalsBlendProperties(right) &&
            self.equalsGeometryProperties(right) &&
            self.equalsLayoutProperties(right));
    },
}));

const polygonProperties = types
    .model('Polygon Properties', {
    type: exports.NodeType.Polygon,
    pointCount: types.optional(pointCount, () => pointCount.create({ value: 5 })),
})
    .preProcessSnapshot((snapshot) => ({
    ...snapshot,
    pointCount: {
        ...snapshot.pointCount,
        min: 3,
    },
}))
    .actions((self) => ({
    expandPolygonProperties: () => {
        self.pointCount.showOnTimeline();
    },
    collapsePolygonProperties: () => {
        self.pointCount.hideOnTimeline();
    },
    shiftOnTimelinePolygonProperties: (delta) => {
        self.pointCount.shiftOnTimeline(delta);
    },
}))
    .views((self) => ({
    equalsPolygonProperties: (right) => {
        return self.pointCount.equals(right.pointCount);
    },
}));
const polygon = types
    .compose('Polygon', polygonProperties, baseNodeProperties, sceneProperties, blendProperties, cornerProperties, geometryProperties, layoutProperties, timeProperties, visibleOnTimeline)
    .actions((self) => ({
    expandProperties: () => {
        self.expandPolygonProperties();
        self.expandBlendProperties();
        self.expandCornerProperties();
        self.expandGeometryProperties();
        self.expandLayoutProperties();
    },
    collapseProperties: () => {
        self.collapsePolygonProperties();
        self.collapseBlendProperties();
        self.collapseCornerProperties();
        self.collapseGeometryProperties();
        self.collapseLayoutProperties();
    },
    shiftOnTimeline: (delta) => {
        self.shiftOnTimelinePolygonProperties(delta);
        self.shiftOnTimelineBlendProperties(delta);
        self.shiftOnTimelineCornerProperties(delta);
        self.shiftOnTimelineGeometryProperties(delta);
        self.shiftOnTimelineLayoutProperties(delta);
        self.shiftOnTimelineTimeProperties(delta);
    },
    applyTransition: (model, options) => {
        applyPropertyTransition('pointCount', self, model, options);
        self.applyBlendTransition(model, options);
        self.applyCornerTransition(model, options);
        self.applyGeometryTransition(model, options);
        self.applyLayoutTransition(model, options);
    },
    updateStructure: (model, options) => {
        const startKeyframe = self.pointCount.keyframes[0];
        const time = startKeyframe == null ? 0 : startKeyframe.time;
        self.pointCount.updateValue(time, model.pointCount.value);
        self.updateBaseStructure(model, options);
        self.updateBlendStructure(model, options);
        self.updateCornerStructure(model, options);
        self.updateGeometryStructure(model, options);
        self.updateLayoutStructure(model, options);
        self.updateSceneStructure(model, options);
        self.updateTimeStructure(model, options);
        self.updateVisibleOnTimelineStructure(model, options);
    },
}))
    .views((self) => ({
    getSortedKeyframes: () => {
        return [
            ...Array.from(self.pointCount._keyframes.values()),
            ...self.getBlendPropertiesSortedKeyframes(),
            ...self.getCornerPropertiesSortedKeyframes(),
            ...self.getGeometryPropertiesSortedKeyframes(),
            ...self.getLayoutPropertiesSortedKeyframes(),
        ];
    },
    getKeyframes: () => {
        return [
            ...self.pointCount.keyframes,
            ...self.getBlendPropertiesKeyframes(),
            ...self.getCornerPropertiesKeyframes(),
            ...self.getGeometryPropertiesKeyframes(),
            ...self.getLayoutPropertiesKeyframes(),
        ];
    },
    /**
     * @description true when current layer contains animation
     */
    get hasOwnAnimation() {
        const keyframes = [
            ...self.pointCount.keyframes,
            ...self.getBlendPropertiesKeyframes(),
            ...self.getCornerPropertiesKeyframes(),
            ...self.getGeometryPropertiesKeyframes(),
            ...self.getLayoutPropertiesKeyframes(),
        ];
        return keyframes.length !== 0;
    },
    equals: (right) => {
        return (self.equalsBlendProperties(right) &&
            self.equalsCornerProperties(right) &&
            self.equalsGeometryProperties(right) &&
            self.equalsLayoutProperties(right));
    },
}));

const rectangleProperties = types.model('Rectangle Properties', {
    type: exports.NodeType.Rectangle,
});
const rectangle = types
    .compose('Rectangle', rectangleProperties, baseNodeProperties, sceneProperties, blendProperties, cornerProperties, individualCornersProperties, geometryProperties, individualStrokesProperties, layoutProperties, 
// @ts-ignore
timeProperties, 
// @ts-ignore
visibleOnTimeline)
    .actions((self) => ({
    expandProperties: () => {
        self.expandBlendProperties();
        self.expandCornerProperties();
        self.expandIndividualCornersProperties();
        self.expandGeometryProperties();
        self.expandIndividualStrokesProperties();
        self.expandLayoutProperties();
    },
    collapseProperties: () => {
        self.collapseBlendProperties();
        self.collapseCornerProperties();
        self.collapseIndividualCornersProperties();
        self.collapseGeometryProperties();
        self.collapseIndividualStrokesProperties();
        self.collapseLayoutProperties();
    },
    shiftOnTimeline: (delta) => {
        self.shiftOnTimelineBlendProperties(delta);
        self.shiftOnTimelineCornerProperties(delta);
        self.shiftOnTimelineIndividualCornersProperties(delta);
        self.shiftOnTimelineGeometryProperties(delta);
        self.shiftOnTimelineIndividualStrokesProperties(delta);
        self.shiftOnTimelineLayoutProperties(delta);
        self.shiftOnTimelineTimeProperties(delta);
    },
    applyTransition: (model, options) => {
        self.applyBlendTransition(model, options);
        self.applyCornerTransition(model, options);
        self.applyIndividualCornersTransition(model, options);
        self.applyGeometryTransition(model, options);
        self.applyIndividualStrokesTransition(model, options);
        self.applyLayoutTransition(model, options);
    },
    updateStructure: (model, options) => {
        self.updateBaseStructure(model, options);
        self.updateBlendStructure(model, options);
        self.updateCornerStructure(model, options);
        self.updateIndividualCornersStructure(model, options);
        self.updateGeometryStructure(model, options);
        self.updateIndividualStrokesStructure(model, options);
        self.updateLayoutStructure(model, options);
        self.updateSceneStructure(model, options);
        self.updateTimeStructure(model, options);
        self.updateVisibleOnTimelineStructure(model, options);
    },
}))
    .views((self) => ({
    getSortedKeyframes: () => {
        return [
            ...self.getBlendPropertiesSortedKeyframes(),
            ...self.getCornerPropertiesSortedKeyframes(),
            ...(self.individualCornersEnabled
                ? self.getIndividualCornersPropertiesSortedKeyframes()
                : []),
            ...self.getGeometryPropertiesSortedKeyframes(),
            ...(self.individualStrokesEnabled
                ? self.getIndividualStrokesPropertiesSortedKeyframes()
                : []),
            ...self.getLayoutPropertiesSortedKeyframes(),
        ];
    },
    getKeyframes: () => {
        return [
            ...self.getBlendPropertiesKeyframes(),
            ...self.getCornerPropertiesKeyframes(),
            ...(self.individualCornersEnabled
                ? self.getIndividualCornersPropertiesKeyframes()
                : []),
            ...self.getGeometryPropertiesKeyframes(),
            ...(self.individualStrokesEnabled
                ? self.getIndividualStrokesPropertiesKeyframes()
                : []),
            ...self.getLayoutPropertiesKeyframes(),
        ];
    },
    /**
     * @description true when current layer contains animation
     */
    get hasOwnAnimation() {
        const keyframes = [
            ...self.getBlendPropertiesKeyframes(),
            ...self.getCornerPropertiesKeyframes(),
            ...(self.individualCornersEnabled
                ? self.getIndividualCornersPropertiesKeyframes()
                : []),
            ...self.getGeometryPropertiesKeyframes(),
            ...(self.individualStrokesEnabled
                ? self.getIndividualStrokesPropertiesKeyframes()
                : []),
            ...self.getLayoutPropertiesKeyframes(),
        ];
        return keyframes.length !== 0;
    },
    equals: (right) => {
        return (self.equalsBlendProperties(right) &&
            self.equalsCornerProperties(right) &&
            self.equalsIndividualCornersProperties(right) &&
            self.equalsIndividualStrokesProperties(right) &&
            self.equalsGeometryProperties(right) &&
            self.equalsLayoutProperties(right));
    },
}));

const starProperties = types
    .model('Star Properties', {
    type: exports.NodeType.Star,
    pointCount: types.optional(pointCount, () => pointCount.create({ value: 5 })),
    innerRadius: types.optional(innerRadius, () => innerRadius.create({ value: 0 })),
})
    .preProcessSnapshot((snapshot) => ({
    ...snapshot,
    pointCount: {
        ...snapshot.pointCount,
        min: 3,
    },
}))
    .actions((self) => ({
    expandStarProperties: () => {
        self.pointCount.showOnTimeline();
        self.innerRadius.showOnTimeline();
    },
    collapseStarProperties: () => {
        self.pointCount.hideOnTimeline();
        self.innerRadius.hideOnTimeline();
    },
    shiftOnTimelineStarProperties: (delta) => {
        self.pointCount.shiftOnTimeline(delta);
        self.innerRadius.shiftOnTimeline(delta);
    },
}))
    .views((self) => ({
    equalsStarProperties: (right) => {
        return (self.pointCount.equals(right.pointCount) &&
            self.innerRadius.equals(right.innerRadius));
    },
}));
const star = types
    .compose('Star', starProperties, baseNodeProperties, sceneProperties, blendProperties, cornerProperties, geometryProperties, layoutProperties, timeProperties, visibleOnTimeline)
    .actions((self) => ({
    expandProperties: () => {
        self.expandStarProperties();
        self.expandBlendProperties();
        self.expandCornerProperties();
        self.expandGeometryProperties();
        self.expandLayoutProperties();
    },
    collapseProperties: () => {
        self.collapseStarProperties();
        self.collapseBlendProperties();
        self.collapseCornerProperties();
        self.collapseGeometryProperties();
        self.collapseLayoutProperties();
    },
    shiftOnTimeline: (delta) => {
        self.shiftOnTimelineStarProperties(delta);
        self.shiftOnTimelineBlendProperties(delta);
        self.shiftOnTimelineCornerProperties(delta);
        self.shiftOnTimelineGeometryProperties(delta);
        self.shiftOnTimelineLayoutProperties(delta);
        self.shiftOnTimelineTimeProperties(delta);
    },
    applyTransition: (model, options) => {
        applyPropertyTransition('innerRadius', self, model, options);
        applyPropertyTransition('pointCount', self, model, options);
        self.applyBlendTransition(model, options);
        self.applyCornerTransition(model, options);
        self.applyGeometryTransition(model, options);
        self.applyLayoutTransition(model, options);
    },
    updateStructure: (model, options) => {
        const innerRadiusStartKeyframe = self.innerRadius.keyframes[0];
        const innerRadiusTime = innerRadiusStartKeyframe == null ? 0 : innerRadiusStartKeyframe.time;
        self.innerRadius.updateValue(innerRadiusTime, model.innerRadius.value);
        const pointCountStartKeyframe = self.pointCount.keyframes[0];
        const pointCountTime = pointCountStartKeyframe == null ? 0 : pointCountStartKeyframe.time;
        self.pointCount.updateValue(pointCountTime, model.pointCount.value);
        self.updateBaseStructure(model, options);
        self.updateBlendStructure(model, options);
        self.updateCornerStructure(model, options);
        self.updateGeometryStructure(model, options);
        self.updateLayoutStructure(model, options);
        self.updateSceneStructure(model, options);
        self.updateTimeStructure(model, options);
        self.updateVisibleOnTimelineStructure(model, options);
    },
}))
    .views((self) => ({
    getSortedKeyframes: () => {
        return [
            ...Array.from(self.pointCount._keyframes.values()),
            ...Array.from(self.innerRadius._keyframes.values()),
            ...self.getBlendPropertiesSortedKeyframes(),
            ...self.getCornerPropertiesSortedKeyframes(),
            ...self.getGeometryPropertiesSortedKeyframes(),
            ...self.getLayoutPropertiesSortedKeyframes(),
        ];
    },
    getKeyframes: () => {
        return [
            ...Array.from(self.pointCount._keyframes.values()),
            ...Array.from(self.innerRadius._keyframes.values()),
            ...self.getBlendPropertiesKeyframes(),
            ...self.getCornerPropertiesKeyframes(),
            ...self.getGeometryPropertiesKeyframes(),
            ...self.getLayoutPropertiesKeyframes(),
        ];
    },
    /**
     * @description true when current layer contains animation
     */
    get hasOwnAnimation() {
        const keyframes = [
            ...Array.from(self.pointCount._keyframes.values()),
            ...Array.from(self.innerRadius._keyframes.values()),
            ...self.getBlendPropertiesKeyframes(),
            ...self.getCornerPropertiesKeyframes(),
            ...self.getGeometryPropertiesKeyframes(),
            ...self.getLayoutPropertiesKeyframes(),
        ];
        return keyframes.length !== 0;
    },
    equals: (right) => {
        return (self.equalsStarProperties(right) &&
            self.equalsBlendProperties(right) &&
            self.equalsCornerProperties(right) &&
            self.equalsGeometryProperties(right) &&
            self.equalsLayoutProperties(right));
    },
}));

const textProperties = types.model('Text Properties', {
    type: exports.NodeType.Text,
    textAlignHorizontal: types.optional(types.enumeration(['LEFT', 'CENTER', 'RIGHT', 'JUSTIFIED']), 'CENTER'),
    textAlignVertical: types.optional(types.enumeration(['TOP', 'CENTER', 'BOTTOM']), 'CENTER'),
    textAutoResize: types.optional(types.enumeration(['NONE', 'WIDTH_AND_HEIGHT', 'HEIGHT']), 'NONE'),
    paragraphIndent: types.optional(types.number, 0),
    paragraphSpacing: types.optional(types.number, 0),
});
const textContent = types.model('Text Content', {
    characters: types.optional(types.string, ''),
});
const textAndTextRangeProperties = types
    .model('Text and Text Range Properties', {
    fontSize: types.optional(types.number, 18),
    fontFamily: types.optional(types.string, 'Inter'),
    fontStyle: types.optional(types.string, 'Regular'),
    textCase: types.optional(types.enumeration(['ORIGINAL', 'UPPER', 'LOWER', 'TITLE']), 'ORIGINAL'),
    textDecoration: types.optional(types.enumeration(['NONE', 'UNDERLINE', 'STRIKETHROUGH']), 'NONE'),
    letterSpacing: types.optional(letterSpacing, () => letterSpacing.create({
        value: 0,
        unit: 'PIXELS',
    })),
    lineHeight: types.optional(lineHeight, () => lineHeight.create({
        value: 0,
        unit: 'AUTO',
    })),
})
    .actions((self) => ({
    updateTextAndTextRangeStructure: (model) => {
        self.fontSize = model.fontSize;
        self.fontFamily = model.fontFamily;
        self.fontStyle = model.fontStyle;
        self.textCase = model.textCase;
        self.textDecoration = model.textDecoration;
        self.letterSpacing = model.letterSpacing;
        self.lineHeight = model.lineHeight;
    },
}));
const text = types
    .compose('Text', textProperties, textContent, textAndTextRangeProperties, baseNodeProperties, sceneProperties, blendProperties, geometryProperties, layoutProperties, timeProperties, 
// @ts-ignore
visibleOnTimeline)
    .actions((self) => ({
    expandProperties: () => {
        self.expandBlendProperties();
        self.expandCornerProperties();
        self.expandGeometryProperties();
        self.expandLayoutProperties();
    },
    collapseProperties: () => {
        self.collapseBlendProperties();
        self.collapseCornerProperties();
        self.collapseGeometryProperties();
        self.collapseLayoutProperties();
    },
    shiftOnTimeline: (delta) => {
        self.shiftOnTimelineBlendProperties(delta);
        self.shiftOnTimelineCornerProperties(delta);
        self.shiftOnTimelineGeometryProperties(delta);
        self.shiftOnTimelineLayoutProperties(delta);
        self.shiftOnTimelineTimeProperties(delta);
    },
    applyTransition: (model, options) => {
        self.applyBlendTransition(model, options);
        self.applyGeometryTransition(model, options);
        self.applyLayoutTransition(model, options);
    },
    updateStructure: (model, options) => {
        self.updateBaseStructure(model, options);
        self.updateBlendStructure(model, options);
        self.updateGeometryStructure(model, options);
        self.updateLayoutStructure(model, options);
        self.updateSceneStructure(model, options);
        self.updateTimeStructure(model, options);
        self.updateTextAndTextRangeStructure(model, options);
        self.updateVisibleOnTimelineStructure(model, options);
    },
}))
    .views((self) => ({
    getSortedKeyframes: () => {
        return [
            ...self.getBlendPropertiesSortedKeyframes(),
            ...self.getGeometryPropertiesSortedKeyframes(),
            ...self.getLayoutPropertiesSortedKeyframes(),
        ];
    },
    getKeyframes: () => {
        return [
            ...self.getBlendPropertiesKeyframes(),
            ...self.getGeometryPropertiesKeyframes(),
            ...self.getLayoutPropertiesKeyframes(),
        ];
    },
    /**
     * @description true when current layer contains animation
     */
    get hasOwnAnimation() {
        const keyframes = [
            ...self.getBlendPropertiesKeyframes(),
            ...self.getGeometryPropertiesKeyframes(),
            ...self.getLayoutPropertiesKeyframes(),
        ];
        return keyframes.length !== 0;
    },
    equals: (right) => {
        return (self.equalsBlendProperties(right) &&
            self.equalsCornerProperties(right) &&
            self.equalsGeometryProperties(right) &&
            self.equalsLayoutProperties(right));
    },
}));

function roundSvgPathNumbers(svgPath) {
    const pathCommands = svgPath.match(/[a-zA-Z][^a-zA-Z]*/g);
    if (!pathCommands) {
        return svgPath;
    }
    const roundedPathCommands = pathCommands.map((command) => {
        const commandLetter = R__namespace.head(command);
        if (commandLetter === 'z' || commandLetter === 'Z') {
            return commandLetter;
        }
        const commandNumbers = R__namespace.drop(1, command)
            .trim()
            .split(/\s|,/)
            .map(parseFloat);
        const roundedNumbers = commandNumbers.map((number) => round(number));
        return `${commandLetter}${roundedNumbers.join(' ')}`;
    });
    return roundedPathCommands.join(' ');
}
const vectorPath = types.model('Vector Path', {
    windingRule: types.optional(types.enumeration(['NONZERO', 'EVENODD', 'NONE']), 'NONZERO'),
    data: types.string,
});
const vectorProperties = types
    .model('Vector Properties', {
    type: exports.NodeType.Vector,
    // TODO: add more complex vector representation
    // so we will be able to create animations
    vectorPaths: types.optional(types.array(vectorPath), []),
})
    .views((self) => ({
    equalsVectorProperties: (right) => {
        const roundedPathsLeft = self.vectorPaths.map((path) => ({
            ...path,
            data: roundSvgPathNumbers(path.data),
        }));
        const roundedPathsRight = right.vectorPaths.map((path) => ({
            ...path,
            data: roundSvgPathNumbers(path.data),
        }));
        return R__namespace.equals(JSON.stringify(roundedPathsLeft), JSON.stringify(roundedPathsRight));
    },
}));
const vector = types
    .compose('Vector', vectorProperties, baseNodeProperties, sceneProperties, blendProperties, cornerProperties, geometryProperties, layoutProperties, timeProperties, visibleOnTimeline)
    .actions((self) => ({
    expandProperties: () => {
        self.expandBlendProperties();
        self.expandCornerProperties();
        self.expandGeometryProperties();
        self.expandLayoutProperties();
    },
    collapseProperties: () => {
        self.collapseBlendProperties();
        self.collapseCornerProperties();
        self.collapseGeometryProperties();
        self.collapseLayoutProperties();
    },
    shiftOnTimeline: (delta) => {
        self.shiftOnTimelineBlendProperties(delta);
        self.shiftOnTimelineCornerProperties(delta);
        self.shiftOnTimelineGeometryProperties(delta);
        self.shiftOnTimelineLayoutProperties(delta);
        self.shiftOnTimelineTimeProperties(delta);
    },
    applyTransition: (model, options) => {
        self.applyBlendTransition(model, options);
        self.applyCornerTransition(model, options);
        self.applyGeometryTransition(model, options);
        self.applyLayoutTransition(model, options);
    },
    updateStructure: (model, options) => {
        self.vectorPaths = clone(model.vectorPaths);
        self.updateBaseStructure(model, options);
        self.updateBlendStructure(model, options);
        self.updateCornerStructure(model, options);
        self.updateGeometryStructure(model, options);
        self.updateLayoutStructure(model, options);
        self.updateSceneStructure(model, options);
        self.updateTimeStructure(model, options);
        self.updateVisibleOnTimelineStructure(model, options);
    },
}))
    .views((self) => ({
    getSortedKeyframes: () => {
        return [
            ...self.getBlendPropertiesSortedKeyframes(),
            ...self.getCornerPropertiesSortedKeyframes(),
            ...self.getGeometryPropertiesSortedKeyframes(),
            ...self.getLayoutPropertiesSortedKeyframes(),
        ];
    },
    getKeyframes: () => {
        return [
            ...self.getBlendPropertiesKeyframes(),
            ...self.getCornerPropertiesKeyframes(),
            ...self.getGeometryPropertiesKeyframes(),
            ...self.getLayoutPropertiesKeyframes(),
        ];
    },
    /**
     * @description true when current layer contains animation
     */
    get hasOwnAnimation() {
        const keyframes = [
            ...self.getBlendPropertiesKeyframes(),
            ...self.getCornerPropertiesKeyframes(),
            ...self.getGeometryPropertiesKeyframes(),
            ...self.getLayoutPropertiesKeyframes(),
        ];
        return keyframes.length !== 0;
    },
    equals: (right) => {
        return (self.equalsVectorProperties(right) &&
            self.equalsBlendProperties(right) &&
            self.equalsCornerProperties(right) &&
            self.equalsGeometryProperties(right) &&
            self.equalsLayoutProperties(right));
    },
}));

const node = types.union({
    // @ts-ignore
    dispatcher: (snapshot) => {
        if (snapshot.type === exports.NodeType.BooleanOperation) {
            return booleanOperation;
        }
        if (snapshot.type === exports.NodeType.Ellipse) {
            return ellipse;
        }
        if (snapshot.type === exports.NodeType.Line) {
            return line;
        }
        if (snapshot.type === exports.NodeType.Frame) {
            return frame;
        }
        if (snapshot.type === exports.NodeType.Instance) {
            return instance;
        }
        if (snapshot.type === exports.NodeType.Group) {
            return group;
        }
        if (snapshot.type === exports.NodeType.Polygon) {
            return polygon;
        }
        if (snapshot.type === exports.NodeType.Rectangle) {
            return rectangle;
        }
        if (snapshot.type === exports.NodeType.Star) {
            return star;
        }
        if (snapshot.type === exports.NodeType.Text) {
            return text;
        }
        if (snapshot.type === exports.NodeType.Vector) {
            return vector;
        }
        throw new TypeError(`Node with type: "${snapshot.type}" is not supporting yet. Full snapshot: "${JSON.stringify(snapshot)}"`);
    },
}, booleanOperation, ellipse, line, frame, group, instance, polygon, rectangle, star, text, vector);

const timingCurveStyle = types
    .model('Timing curve style', {
    id: types.optional(types.string, () => generateId()),
    title: types.string,
    type: types.literal(exports.CurveType.Timing),
    value: timingCurve,
})
    .actions((self) => ({
    updateTitle: (title) => {
        self.title = title;
        return self;
    },
    updateValue: (value) => {
        self.value = timingCurve.create({
            out: value.out,
            in: value.in,
        });
        return self;
    },
}));
const springCurveStyle = types
    .model('Spring curve style', {
    id: types.optional(types.string, () => generateId()),
    title: types.string,
    type: types.literal(exports.CurveType.Spring),
    value: springCurve,
})
    .actions((self) => ({
    updateTitle: (title) => {
        self.title = title;
        return self;
    },
    updateValue: (value) => {
        self.value = springCurve.create({
            stiffness: value.stiffness,
            damping: value.damping,
            mass: value.mass,
        });
        return self;
    },
}));
const curveStyle = types.union({
    dispatcher: (snapshot) => {
        if (snapshot.type === exports.CurveType.Timing) {
            return timingCurveStyle;
        }
        if (snapshot.type === exports.CurveType.Spring) {
            return springCurveStyle;
        }
        throw new Error(`curveStyle unkown type provided "${snapshot.type}". Allowed types: "${Object.values(exports.CurveType).join(', ')}"`);
    },
}, timingCurveStyle, springCurveStyle);

const exportPreset = types.model({
    id: types.optional(types.identifier, () => generateId()),
    scale: types.optional(types.enumeration(Object.values(exports.RenderScaleType)), exports.RenderScaleType['1x']),
    suffix: types.optional(types.string, ''),
    type: types.optional(types.enumeration(Object.values(exports.RenderType)), exports.RenderType.mp4),
});

const project = types
    .model('Project', {
    id: types.optional(types.identifier, () => generateId()),
    name: 'Untitled',
    createdAt: types.optional(types.string, new Date().toISOString()),
    ownerId: types.maybeNull(types.string),
    rootNode: frame,
    rootNodeId: types.maybeNull(types.string),
    hasTransition: false,
    fps: 60,
    startTime: 0,
    duration: 2,
    isBackgroundVisible: true,
    backgroundColor: types.optional(rgba, rgba.create({
        r: 245,
        g: 245,
        b: 245,
        a: 1,
    })),
    exportPresets: types.optional(types.array(exportPreset), []),
    modelType: 'project',
    _curveStyles: types.optional(types.map(curveStyle), {}),
})
    .preProcessSnapshot((snapshot) => {
    if (snapshot?.rootNode == null) {
        return snapshot;
    }
    // @NOTE: required to make position of root node as default
    return R__namespace.assoc('rootNode', R__namespace.omit(['anchorPoint', 'position', 'skew', 'opacity'], JSON.parse(JSON.stringify(snapshot.rootNode))), snapshot);
})
    .actions((self) => {
    // @TODO: refactor and move to common logic because the same function using at .actions
    const findNodeParentByNodeId = (id, parent, nodes) => {
        const stack = [...nodes];
        while (stack.length > 0) {
            const currentNode = stack.pop();
            if (currentNode == null) {
                break;
            }
            if (currentNode.id === id) {
                return parent;
            }
            // @ts-ignore
            if (currentNode.children != null) {
                const foundParentInRecursion = findNodeParentByNodeId(id, currentNode, 
                // @ts-ignore
                currentNode.children);
                if (foundParentInRecursion != null) {
                    return foundParentInRecursion;
                }
            }
        }
        return null;
    };
    return {
        updateName: (name) => {
            self.name = name;
        },
        updateFps: (fps) => {
            self.fps = fps;
        },
        updateDuration: (duration) => {
            const newDuration = R__namespace.clamp(0.1, 600, duration);
            self.duration = newDuration;
            return newDuration;
        },
        toggleBackgroundVisibility: () => (self.isBackgroundVisible = !self.isBackgroundVisible),
        updateBackgroundColor: (color) => {
            self.backgroundColor = rgba.create(color);
        },
        addExportPreset: () => {
            const orderedTypes = [
                exports.RenderType.mp4,
                exports.RenderType.lottie,
                exports.RenderType.dotLottie,
                exports.RenderType.gif,
                exports.RenderType.webm,
            ];
            const nextPresetType = (() => {
                const includedTypes = self.exportPresets.map((exportPreset) => exportPreset.type);
                const diff = R__namespace.difference(orderedTypes, includedTypes);
                if (diff.length > 0) {
                    return R__namespace.head(diff);
                }
                return exports.RenderType.mp4;
            })();
            self.exportPresets.push(exportPreset.create({
                type: nextPresetType,
            }));
        },
        updateExportPreset: (presetId, preset) => {
            const index = self.exportPresets
                .map((currentPreset) => currentPreset.id)
                .indexOf(presetId);
            if (index === -1) {
                return;
            }
            self.exportPresets[index] = exportPreset.create(R__namespace.mergeDeepRight(getSnapshot(self.exportPresets[index]), preset));
        },
        deleteExportPreset: (presetId) => {
            const index = self.exportPresets
                .map((preset) => preset.id)
                .indexOf(presetId);
            if (index === -1) {
                return;
            }
            self.exportPresets.splice(index, 1);
        },
        addNode: (targetNode) => {
            self.rootNode.addChild(getSnapshot(targetNode));
        },
        showOnTimelineOnlyAnimatedProperties: () => {
            const showParentOnTimeline = (node) => {
                const parent = findNodeParentByNodeId(node.id, self.rootNode, self.rootNode.children);
                if (parent != null) {
                    parent.showOnTimeline();
                    showParentOnTimeline(parent);
                }
            };
            const showProperties = (properties) => {
                properties
                    // @NOTE: guard from not existing properties
                    .filter((property) => property != null)
                    .forEach((property) => {
                    if (property.modelType === 'property') {
                        // @ts-ignore
                        if (property.keyframes == null) {
                            return;
                        }
                        // @ts-ignore
                        if (property.keyframes.length > 0) {
                            // @ts-ignore
                            property.showOnTimeline();
                            // @ts-ignore
                            property.getNode().showOnTimeline();
                            // @ts-ignore
                            showParentOnTimeline(property.getNode());
                        }
                    }
                    if (property.modelType === 'property-group-set') {
                        // @ts-ignore
                        property.children.forEach((child) => {
                            const requiredChildrenProperties = Object.values(child);
                            showProperties(requiredChildrenProperties);
                        });
                    }
                });
            };
            const showAnimatedProperties = (nodes) => {
                nodes.forEach((currentNode) => {
                    const requiredProperties = Object.values(currentNode);
                    showProperties(requiredProperties);
                    // @ts-ignore
                    if (currentNode.children != null) {
                        showAnimatedProperties(currentNode.children);
                    }
                });
            };
            showAnimatedProperties([self.rootNode]);
        },
        addCurveStyle: (curveStyle) => {
            self._curveStyles.set(curveStyle.id, curveStyle);
            return self;
        },
        updateCurveStyle: (curveStyle) => {
            self._curveStyles.set(curveStyle.id, curveStyle);
            return self;
        },
        setInitialCurveStyles: (curveStyles) => {
            curveStyles.forEach((curveStyle) => {
                self._curveStyles.set(curveStyle.id, curveStyle);
            });
            return self;
        },
        removeCurveStyle: (curveStyleId) => {
            self._curveStyles.delete(curveStyleId);
            return self;
        },
    };
})
    .views((self) => {
    const getPathToNode = (id, parent) => {
        const stack = [[parent, []]];
        while (stack.length) {
            const [node, path] = stack.pop();
            if (node.id === id) {
                return path;
            }
            // @ts-ignore
            if (node.children) {
                stack.push(
                // @ts-ignore
                ...node.children.map((child) => [child, [...path, child.id]]));
            }
        }
        return stack[0][1];
    };
    const findNodeById = (id, node) => {
        const stack = [node];
        while (stack.length > 0) {
            const currentNode = stack.pop();
            if (currentNode.id === id) {
                return currentNode;
            }
            // @ts-ignore
            if (currentNode.children != null) {
                // @ts-ignore
                stack.push(...currentNode.children);
            }
        }
        return null;
    };
    const findPropertyById = (id, node) => {
        const stack = [node];
        while (stack.length > 0) {
            const currentNode = stack.pop();
            const foundProperty = Object.values(currentNode)
                // @NOTE: guard from not existing properties
                .filter((property) => property != null)
                .find((property) => property.id === id);
            if (foundProperty != null) {
                return foundProperty;
            }
            // @ts-ignore
            if (currentNode.fills?.children != null) {
                // @ts-ignore
                stack.push(...currentNode.fills.children);
            }
            // @ts-ignore
            if (currentNode.strokes?.children != null) {
                // @ts-ignore
                stack.push(...currentNode.strokes.children);
            }
            if (currentNode.effects?.children != null) {
                // @ts-ignore
                stack.push(...currentNode.effects.children);
            }
            // @ts-ignore
            if (currentNode.children != null) {
                // @ts-ignore
                stack.push(...currentNode.children);
            }
        }
        return null;
    };
    const findKeyframeById = (id, nodes) => {
        const stack = [...nodes];
        while (stack.length > 0) {
            const node = stack.pop();
            const requiredProperties = Object.values(node)
                // @NOTE: guard from not existing properties
                .filter((property) => property != null);
            for (let i = 0; i < requiredProperties.length; i += 1) {
                const property = requiredProperties[i];
                if (property.modelType === 'property') {
                    if (property.keyframes == null) {
                        continue;
                    }
                    const targetKeyframe = property.keyframes.find((currentKeyframe) => currentKeyframe.id === id);
                    if (targetKeyframe != null) {
                        return targetKeyframe;
                    }
                }
                if (property.modelType === 'property-group-set') {
                    for (let j = 0; j < property.children.length; j += 1) {
                        const child = property.children[j];
                        const requiredChildrenProperties = Object.values(child);
                        for (let o = 0; o < requiredChildrenProperties.length; o += 1) {
                            const childProperty = requiredChildrenProperties[o];
                            if (childProperty.keyframes == null) {
                                continue;
                            }
                            const targetKeyframe = childProperty.keyframes.find((currentKeyframe) => currentKeyframe.id === id);
                            if (targetKeyframe != null) {
                                return targetKeyframe;
                            }
                        }
                    }
                }
            }
            // @ts-ignore
            if (node.children != null) {
                // @ts-ignore
                const foundKeyframe = findKeyframeById(id, node.children);
                if (foundKeyframe != null) {
                    return foundKeyframe;
                }
            }
            // @ts-ignore
            if (node.children) {
                // @ts-ignore
                stack.push(...node.children);
            }
        }
        return null;
    };
    const getImagePaints = (providedNode) => {
        const result = [];
        const stack = [providedNode];
        while (stack.length > 0) {
            const node = stack.pop();
            // @ts-ignore
            const fills = R__namespace.defaultTo([], node.fills?.children).filter((fill) => fill.type === exports.PaintType.Image);
            // @ts-ignore
            const strokes = R__namespace.defaultTo([], node.strokes?.children).filter((stroke) => stroke.type === exports.PaintType.Image);
            result.push([...fills, ...strokes]);
            // @ts-ignore
            if (node.children) {
                // @ts-ignore
                stack.push(...node.children);
            }
        }
        return R__namespace.flatten(result);
    };
    /**
     * @description return array of animated properties
     */
    const getAnimatedProperties = () => {
        const animatedProperties = [];
        const stack = [self.rootNode];
        const propertiesStack = [];
        while (stack.length > 0) {
            const node = stack.pop();
            const requiredProperties = R__namespace.values(node);
            propertiesStack.push(...requiredProperties);
            while (propertiesStack.length > 0) {
                const property = propertiesStack.pop();
                // @NOTE: guard from not existing properties
                if (property == null) {
                    continue;
                }
                const length = property._keyframes?.size || 0;
                if (property.modelType === 'property') {
                    if (length === 0) {
                        continue;
                    }
                    animatedProperties.push(property);
                }
                if (property.modelType === 'property-group-set') {
                    property.children.forEach((child) => {
                        const requiredChildrenProperties = Object.values(child);
                        propertiesStack.push(...requiredChildrenProperties);
                    });
                }
            }
            if (node.children) {
                stack.push(...node.children);
            }
        }
        return animatedProperties;
    };
    const getAnimatedDuration = computed(() => {
        const animatedProperties = getAnimatedProperties();
        if (animatedProperties.length === 0) {
            return self.duration;
        }
        const keyframes = R__namespace.flatten(animatedProperties.map((property) => Array.from(property._keyframes.values())));
        const times = keyframes.map((keyframe) => keyframe.time);
        const max = times.reduce((max, time) => R__namespace.max(max, time), -Infinity);
        return max;
    });
    const getFlattenNodes = () => {
        const flattenNodes = [];
        const stack = [self.rootNode];
        while (stack.length > 0) {
            const currentNode = stack.shift();
            if (currentNode.children != null) {
                stack.unshift(...currentNode.children);
            }
            flattenNodes.push(currentNode);
        }
        return flattenNodes;
    };
    return {
        /**
         * @description get ids path to nod
         */
        getPathToNode(id) {
            const path = getPathToNode(id, self.rootNode);
            return path;
        },
        /**
         * @description looking for required node by whole tree
         */
        findNodeById(id) {
            const requiredNode = findNodeById(id, self.rootNode);
            return requiredNode;
        },
        /**
         * @description looking for required properties by whole nodes tree
         */
        findPropertyById(id) {
            const requiredProperty = findPropertyById(id, self.rootNode);
            return requiredProperty;
        },
        /**
         * @description looking for required keyframe by whole nodes tree
         */
        findKeyframeById(id) {
            const requiredKeyframe = findKeyframeById(id, [self.rootNode]);
            return requiredKeyframe;
        },
        forEachNode(callback) {
            const stack = [self.rootNode];
            while (stack.length > 0) {
                const currentNode = stack.pop();
                if (currentNode.children != null) {
                    stack.push(...currentNode.children);
                }
                if (currentNode.isRoot === false) {
                    callback(currentNode);
                }
            }
        },
        get endTime() {
            return self.startTime + self.duration;
        },
        /**
         * @description return list of paints with images
         */
        getImagePaints: () => {
            return getImagePaints(self.rootNode);
        },
        getAnimatedProperties,
        getVisibleKeyframes: () => {
            const animatedProperties = getAnimatedProperties();
            const keyframes = animatedProperties
                .filter((property) => property.visibleOnTimeline)
                .map((property) => property.keyframes);
            const flattenKeyframes = R__namespace.sort((left, right) => left.time - right.time, R__namespace.flatten(keyframes));
            return flattenKeyframes;
        },
        /**
         * @description returns duration of animated segments only
         */
        getAnimatedDuration: () => getAnimatedDuration.get(),
        get curveStyles() {
            const curveStyles = Array.from(self._curveStyles.values());
            return R__namespace.sort((left, right) => left.title.localeCompare(right.title), curveStyles);
        },
        getCurveStyleById: (curveStyleId) => {
            return self._curveStyles.get(curveStyleId);
        },
        getFlattenNodes,
    };
});

/**
 * @description disable any changes. Can be used to enable view-only mode.
 */
const projectDisableAnyChanges = (store) => {
    let enabled = true;
    addMiddleware(store, (call, next, abort) => {
        if (enabled) {
            abort(store);
            return;
        }
        next(call);
    });
    return {
        enabled,
        updateEnabled: (newEnabled) => {
            enabled = newEnabled;
        },
    };
};

setLivelinessChecking('warn');

exports.Pair = Pair;
exports.SpringCurve = SpringCurve;
exports.TimingCurve = TimingCurve;
exports.anchorPoint = anchorPoint;
exports.angle = angle;
exports.animatableProperty = animatableProperty;
exports.applyPropertyTransition = applyPropertyTransition;
exports.backgroundBlurPropertyGroup = backgroundBlurPropertyGroup;
exports.baseKeyframe = baseKeyframe;
exports.baseNodeProperties = baseNodeProperties;
exports.basePropertyGroup = basePropertyGroup;
exports.basePropertyGroupSet = basePropertyGroupSet;
exports.bezierInterpolation = bezierInterpolation$1;
exports.bezierSpeedInterpolation = bezierSpeedInterpolation;
exports.blendMode = blendMode;
exports.blendProperties = blendProperties;
exports.booleanOperation = booleanOperation;
exports.bottomLeftRadius = bottomLeftRadius;
exports.bottomRightRadius = bottomRightRadius;
exports.boundingBox = boundingBox;
exports.bumpVersions = bumpVersions;
exports.childrenProperties = childrenProperties;
exports.color = color;
exports.colorStopPropertyGroup = colorStopPropertyGroup;
exports.colorStopsPropertyGroupSet = colorStopsPropertyGroupSet;
exports.cornerProperties = cornerProperties;
exports.cornerRadius = cornerRadius;
exports.curveStyle = curveStyle;
exports.dash = dash;
exports.dashOffset = dashOffset;
exports.decomposedMatrix = decomposedMatrix;
exports.dropShadowPropertyGroup = dropShadowPropertyGroup;
exports.effectPropertyGroupSet = effectPropertyGroupSet;
exports.ellipse = ellipse;
exports.exportPreset = exportPreset;
exports.fillPropertyGroupSet = fillPropertyGroupSet;
exports.frame = frame;
exports.gap = gap;
exports.generateId = generateId;
exports.genericKeyframe = keyframe;
exports.genericPropertyGroup = propertyGroup$3;
exports.genericPropertyGroupSet = genericPropertyGroupSet;
exports.geometryProperties = geometryProperties;
exports.getProgress = getProgress;
exports.getTimingCurveKeyframes = getTimingCurveKeyframes;
exports.gradientPropertyGroup = gradientPropertyGroup;
exports.gradientTransform = gradientTransform;
exports.group = group;
exports.imageFillPropertyGroup = imageFillPropertyGroup;
exports.innerRadius = innerRadius;
exports.innerShadowPropertyGroup = innerShadowPropertyGroup;
exports.instance = instance;
exports.isSegment = isSegment;
exports.layerBlurPropertyGroup = layerBlurPropertyGroup;
exports.layoutProperties = layoutProperties;
exports.lerp = lerp;
exports.lerpClamped = lerpClamped;
exports.lerpRange = lerpRange;
exports.lerpRangeClamped = lerpRangeClamped;
exports.line = line;
exports.lutByEqualLength = lutByEqualLengthFromTimingCurve;
exports.matrixTransformKeyframe = matrixTransformKeyframe;
exports.mixed = mixed;
exports.multiplyMatrices = multiplyMatrices;
exports.node = node;
exports.nodesToPairs = nodesToPairs;
exports.numberKeyframe = numberKeyframe;
exports.offset = offset;
exports.opacity = opacity;
exports.paintPropertyGroupSet = paintPropertyGroupSet;
exports.percent = percent;
exports.percentNegative = percentNegative;
exports.point1dKeyframe = point1dKeyframe;
exports.point2dKeyframe = point2dKeyframe;
exports.pointCount = pointCount;
exports.polygon = polygon;
exports.position = position;
exports.project = project;
exports.projectDisableAnyChanges = projectDisableAnyChanges;
exports.protect = protect;
exports.radius = radius;
exports.rectangle = rectangle;
exports.rgbaKeyframe = rgbaKeyframe;
exports.rotation = rotation;
exports.round = round;
exports.scale = scale;
exports.sceneProperties = sceneProperties;
exports.showNodeOnTimeline = showNodeOnTimeline;
exports.size = size;
exports.skew = skew;
exports.solidFillPropertyGroup = solidFillPropertyGroup;
exports.spatialPoint2dKeyframe = spatialPoint2dKeyframe;
exports.spread = spread;
exports.springCurve = springCurve;
exports.star = star;
exports.strokeBottomWeight = strokeBottomWeight;
exports.strokeLeftWeight = strokeLeftWeight;
exports.strokePropertyGroupSet = strokePropertyGroupSet;
exports.strokeRightWeight = strokeRightWeight;
exports.strokeTopWeight = strokeTopWeight;
exports.strokeWeight = strokeWeight;
exports.tFromProgressByLut = tFromProgressByLut;
exports.text = text;
exports.timeProperties = timeProperties;
exports.timingCurve = timingCurve;
exports.topLeftRadius = topLeftRadius;
exports.topRightRadius = topRightRadius;
exports.trimEnd = trimEnd;
exports.trimOffset = trimOffset;
exports.trimStart = trimStart;
exports.vector = vector;
exports.visible = visible;
//# sourceMappingURL=index.js.map
